import { c as commonjsGlobal, f as format, F as FORMATS, D as DateManipulateUnit, a as DateManipulateOperation, s as sortByDate, _ as _cmxDateTime } from './chunks/date-time-IA6Oj6Ns.mjs';
import { c as commonEnums, M as Methods, A as AuthenticationChannelEvents, R as ResourceId, F as FeedbackMeta, T as TimelineStatus$1, b as FeatureSources, d as FeatureTypes, S as SpanLevel, E as EvidenceType, e as AccelerateProcessStatus$1, P as ProcessQAStatus$1, C as ChargeSessionCodeProvenance$1, f as ChargeSessionCodeType$1, g as InvoiceTypes$1, h as ChargeSessionType, i as ChargeSessionProviderRole, j as CaseArtifactTypes$1, k as CodeType, l as commonEnums$1, m as AuthToken, n as ProviderType$1, U as UIViewEnum, o as SugggestedCodeType, p as ConfigurationKeyName, q as ServiceLines, B as BenchMode, r as CaseAccessState, s as MiniTabLabels, t as DictionaryFilterDefault, u as IssueTypeErrors, v as UIModesEnum, w as InvoiceEditorMode, x as CoderNotesLookupType, y as ContentType } from './chunks/enums-C0-kR_MQ.mjs';
import { l as determineServiceLineConfig, a as createAction, e as commonActions, r as requestJSON, s as set$1, h as get, c as createAsyncThunk, _ as _authHandler, n as normalizeDescriptions, E as EventEmitter, U as UserInterface, A as AuthenticatedWindow, C as CaseEdits, u as updateProcessInstance, m as isResourceAllowed, o as determineProcessInstanceId, p as buildCaseDetailUrl, q as isIPC, v as getDocumentsAsHtml, w as fetchProcessInstance, x as isSurgery, y as loadXCaliber, z as getFlagItems, B as fetchProviderRoleTypeConfigurations, D as isPathology, F as getCCICustomClaimCrossCases, G as fetchOrderTypeStatus, H as fetchRelateCaseFilterDictionaries, J as getRelatedCasesInitialFilters, K as getCasesWithEncounter, L as relatedCasesSortablePageable, M as fetchRelatedCodes, b as request, N as CreateCase, f as fetchDictionaryRows, O as toggleChargeableCase, P as amplifyFeedback$2, Q as MergeCases, R as getDocuments, d as fetchActivity, S as AttachDocs, T as firstAvailable, V as documentUtils, W as completeSet, X as isCaseRunV2, Y as submissionSet, Z as defaultSet, $ as inProgressDefaultSet, a0 as isPrior, a1 as isNgram, a2 as isCategorical, a3 as CodableStatus, a4 as isUnknownEvidence, a5 as isIndividualEvidence, a6 as isCPT, a7 as isICD, a8 as isModifier, a9 as getFieldId, aa as artifactSets, ab as buildSorter, ac as DEFAULT_BENCH_EDITABLE, ad as DEFAULT_SUGGESTED_CODES, ae as codeBenchState, af as InvoiceEditor, ag as sequenceGenerator, ah as fetchXcaliberToken, ai as buildDataAccessRequestObject, aj as shouldFetchFromDataAccess, ak as fetchAllInvoices, al as uiActions, am as EMPTY_NOTE, an as enableMapSet, ao as createReducer, ap as resetCommonState, aq as determineBenchEditable, ar as setLockCaseUid, as as LOAD_STATES, at as normalizeSpans, au as getGroupedCases, av as parseCodeEdits, aw as doesPathEndWithV2, ax as compareDecoratedNotesForNav, ay as parseVWByStatus, az as determineProcessStatus, aA as shimSegmentsIfNeeded, aB as convertToFilterRecord, aC as isIPCNote, aD as segmentize, aE as decoratedNoteFactory, aF as parseAndFilterV2Errors, aG as parseProcessInstance, aH as normalizeClaims, aI as parseVWIssues, aJ as normalizeCCIS, aK as normalizeCustomRules, aL as parseInvoiceIssues, aM as createSyntheticStandardErrors, aN as filterInvoiceIssues, aO as filterMergeHistoryWarnings, aP as isChargeSessionCode, aQ as AmplifyUIActions, aR as getConfigurationsForSectionV2, aS as getNoteUnavailableReason, aT as getServicedeskActions, aU as getToggleCaseComment, aV as getRenderHoldCase, aW as getRenderOffHoldCase, aX as getOldCaseLoadedAlert, aY as getPreviousSentCaseAlert, aZ as chooseContext, a_ as getActionBarSelectMultipleWorkitemsCapability, a$ as saveServiceLineCapability, b0 as getTimelineInfiniteLoadCapability, b1 as getAttachDocsCapability, b2 as getProductivityTrackerCapability, b3 as getGetCaserunWithRefreshCapability, b4 as getUseProviderDirectoryLocations, b5 as getImprovements, b6 as getImprovementsAction, b7 as getRenderSubmitCase, b8 as getRenderviewOnlyCase, b9 as getRenderPagination, ba as getRenderToggleChargeableCase, bb as getCaseEditable, bc as getCreateCaseCapability, bd as getSplitActionMenuCapability, be as getLateCaseClearNotificationCapability, bf as getActionMenuCapability, bg as getDiagnosisCodeSuggestionCapability, bh as getCoderNotesCapability, bi as getTransactionV2Capability, bj as getAmplifyCaseRunV2Capability, bk as getActionMenuCancelCapability, bl as getGeneralCancelCapability, bm as getMergeActionMenuCapability, bn as getCoderFeedbackCapability, bo as getCodeSourcesFeaturesCapability, bp as getRelatedCasesFilterCapability, bq as getUseDataAccessAmplifyCapability, br as xcaliberTokenManager, bs as benchEditable, bt as fetchXCaliberToken, bu as paginationUtils, bv as resources, bw as xcaliberTokenMiddleware, bx as AuthHandler$1, by as _caseStatusStrings, bz as _utils, bA as _api, bB as _caseUtils, bC as _cmxErrors, bD as _highlighterUtils, bE as _loadStates } from './chunks/code-bench-sHBTBvNX.mjs';
export { bF as AmplifyProcessStates, bG as _cpt, bH as appServiceLines, bI as buildDescriptionRequest, bJ as cmxTypeguards, bK as codeBenchActions, bL as configurationUtils, bM as dictionaryUtilities, bN as identifierUtils, bO as shouldAutoAdvanceWorklistAfterSubmit, bP as vitalware, bQ as xcaliberActions } from './chunks/code-bench-sHBTBvNX.mjs';
import { g as groupBy, u as uniqBy, a as upperFirst, c as cloneDeep, b as get$1, p as pick, h as has, s as set$2, d as uniqWith, i as isEqual, m as matches, e as unionBy, f as isEmpty, j as convertRecordToOptionList } from './chunks/object-utils-CWxdM56M.mjs';
export { o as objectUtils } from './chunks/object-utils-CWxdM56M.mjs';
import { l as loadCase, a as loadCaseFromURL } from './chunks/cases.action-BkhKVoF6.mjs';
export { c as caseActions } from './chunks/cases.action-BkhKVoF6.mjs';
import { n as navigationIntent, l as loadCQAItemFromURL, h as getDocumentsAsHtmlFromCQAWorkItem, R as ReduxActions, i as deleteCQACode, r as resequenceCode, j as refreshSpanCompletion, k as resolveCQAWorkitem, m as fetchQaRule, o as fetchRiskCategories, p as fetchCodeDescriptions, f as createCQATransaction, q as deleteCQATransaction, s as retrieveAssociatedWorkitems, t as fetchWorkerInfoForUser, u as getGraderWorkItemActivity, a as addEmptySpan, c as attachCodeToSpan, b as detachCodeFromSpan, d as deleteSpan, v as clearRubricVersion, w as fetchRubricVersion, x as updateAttribute, y as fetchAttributes, z as deleteAttribute, A as clearDownstreamAttributes, B as setValidationResult, C as setCaseLevelComplete, D as setPendingSpanNav, E as setCodeCompletion, F as setManualActiveCode, G as fetchAllAttributes, H as pathUtils } from './chunks/grade-bench-panel-onp4FZq1.mjs';
export { I as buildQualityAssessmentWorklistPath, J as getOptionsFromTree, K as getValueAtPath, L as gradeBenchPanelActions, M as navigationIntentActions } from './chunks/grade-bench-panel-onp4FZq1.mjs';
import { f as fetchImprovementOptions, g as getImprovementsForProcessInstance, a as addImprovement, r as removeImprovement, u as updateImprovement, i as improvementSearch } from './chunks/improvements.actions-7dHjGjgF.mjs';
export { b as improvementActions } from './chunks/improvements.actions-7dHjGjgF.mjs';
import { h as getAllSpans, i as mergeOverlappingSpanAttributes, j as findCodesBySpanId, k as findSpanById } from './chunks/span-utils-BQ63jDMe.mjs';
export { c as calculateAvailableCodes, a as calculateTextSelectionOffsets, e as enrichingAnnotationHooks, b as extractCodesFromInvoices, m as mapExtractedCodetoSuggestedCode, u as useCodeAssessmentUpdate, d as useCodeSearch, f as useCreateTransaction, g as useCreateTransactionAndAddCode } from './chunks/span-utils-BQ63jDMe.mjs';
import { useCallback } from 'react';
import { c as codePredicates, t as transactionUpdateDTOFactory } from './chunks/transaction-updates-CXDwbezT.mjs';
import { c as capabilityValue, a as conditionalUtilities } from './chunks/conditional-0YSA_RAK.mjs';

var web_url = {};

var web_url_constructor = {};

var es_string_iterator = {};

var fails;
var hasRequiredFails;

function requireFails () {
	if (hasRequiredFails) return fails;
	hasRequiredFails = 1;
	fails = function (exec) {
	  try {
	    return !!exec();
	  } catch (error) {
	    return true;
	  }
	};
	return fails;
}

var functionBindNative;
var hasRequiredFunctionBindNative;

function requireFunctionBindNative () {
	if (hasRequiredFunctionBindNative) return functionBindNative;
	hasRequiredFunctionBindNative = 1;
	var fails = requireFails();

	functionBindNative = !fails(function () {
	  // eslint-disable-next-line es/no-function-prototype-bind -- safe
	  var test = (function () { /* empty */ }).bind();
	  // eslint-disable-next-line no-prototype-builtins -- safe
	  return typeof test != 'function' || test.hasOwnProperty('prototype');
	});
	return functionBindNative;
}

var functionUncurryThis;
var hasRequiredFunctionUncurryThis;

function requireFunctionUncurryThis () {
	if (hasRequiredFunctionUncurryThis) return functionUncurryThis;
	hasRequiredFunctionUncurryThis = 1;
	var NATIVE_BIND = requireFunctionBindNative();

	var FunctionPrototype = Function.prototype;
	var call = FunctionPrototype.call;
	var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);

	functionUncurryThis = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
	  return function () {
	    return call.apply(fn, arguments);
	  };
	};
	return functionUncurryThis;
}

var mathTrunc;
var hasRequiredMathTrunc;

function requireMathTrunc () {
	if (hasRequiredMathTrunc) return mathTrunc;
	hasRequiredMathTrunc = 1;
	var ceil = Math.ceil;
	var floor = Math.floor;

	// `Math.trunc` method
	// https://tc39.es/ecma262/#sec-math.trunc
	// eslint-disable-next-line es/no-math-trunc -- safe
	mathTrunc = Math.trunc || function trunc(x) {
	  var n = +x;
	  return (n > 0 ? floor : ceil)(n);
	};
	return mathTrunc;
}

var toIntegerOrInfinity;
var hasRequiredToIntegerOrInfinity;

function requireToIntegerOrInfinity () {
	if (hasRequiredToIntegerOrInfinity) return toIntegerOrInfinity;
	hasRequiredToIntegerOrInfinity = 1;
	var trunc = requireMathTrunc();

	// `ToIntegerOrInfinity` abstract operation
	// https://tc39.es/ecma262/#sec-tointegerorinfinity
	toIntegerOrInfinity = function (argument) {
	  var number = +argument;
	  // eslint-disable-next-line no-self-compare -- NaN check
	  return number !== number || number === 0 ? 0 : trunc(number);
	};
	return toIntegerOrInfinity;
}

var global$1;
var hasRequiredGlobal;

function requireGlobal () {
	if (hasRequiredGlobal) return global$1;
	hasRequiredGlobal = 1;
	var check = function (it) {
	  return it && it.Math == Math && it;
	};

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	global$1 =
	  // eslint-disable-next-line es/no-global-this -- safe
	  check(typeof globalThis == 'object' && globalThis) ||
	  check(typeof window == 'object' && window) ||
	  // eslint-disable-next-line no-restricted-globals -- safe
	  check(typeof self == 'object' && self) ||
	  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
	  // eslint-disable-next-line no-new-func -- fallback
	  (function () { return this; })() || Function('return this')();
	return global$1;
}

var shared = {exports: {}};

var isPure;
var hasRequiredIsPure;

function requireIsPure () {
	if (hasRequiredIsPure) return isPure;
	hasRequiredIsPure = 1;
	isPure = false;
	return isPure;
}

var defineGlobalProperty;
var hasRequiredDefineGlobalProperty;

function requireDefineGlobalProperty () {
	if (hasRequiredDefineGlobalProperty) return defineGlobalProperty;
	hasRequiredDefineGlobalProperty = 1;
	var global = requireGlobal();

	// eslint-disable-next-line es/no-object-defineproperty -- safe
	var defineProperty = Object.defineProperty;

	defineGlobalProperty = function (key, value) {
	  try {
	    defineProperty(global, key, { value: value, configurable: true, writable: true });
	  } catch (error) {
	    global[key] = value;
	  } return value;
	};
	return defineGlobalProperty;
}

var sharedStore;
var hasRequiredSharedStore;

function requireSharedStore () {
	if (hasRequiredSharedStore) return sharedStore;
	hasRequiredSharedStore = 1;
	var global = requireGlobal();
	var defineGlobalProperty = requireDefineGlobalProperty();

	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || defineGlobalProperty(SHARED, {});

	sharedStore = store;
	return sharedStore;
}

var hasRequiredShared;

function requireShared () {
	if (hasRequiredShared) return shared.exports;
	hasRequiredShared = 1;
	var IS_PURE = requireIsPure();
	var store = requireSharedStore();

	(shared.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: '3.30.0',
	  mode: IS_PURE ? 'pure' : 'global',
	  copyright: '© 2014-2023 Denis Pushkarev (zloirock.ru)',
	  license: 'https://github.com/zloirock/core-js/blob/v3.30.0/LICENSE',
	  source: 'https://github.com/zloirock/core-js'
	});
	return shared.exports;
}

var isNullOrUndefined;
var hasRequiredIsNullOrUndefined;

function requireIsNullOrUndefined () {
	if (hasRequiredIsNullOrUndefined) return isNullOrUndefined;
	hasRequiredIsNullOrUndefined = 1;
	// we can't use just `it == null` since of `document.all` special case
	// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
	isNullOrUndefined = function (it) {
	  return it === null || it === undefined;
	};
	return isNullOrUndefined;
}

var requireObjectCoercible;
var hasRequiredRequireObjectCoercible;

function requireRequireObjectCoercible () {
	if (hasRequiredRequireObjectCoercible) return requireObjectCoercible;
	hasRequiredRequireObjectCoercible = 1;
	var isNullOrUndefined = requireIsNullOrUndefined();

	var $TypeError = TypeError;

	// `RequireObjectCoercible` abstract operation
	// https://tc39.es/ecma262/#sec-requireobjectcoercible
	requireObjectCoercible = function (it) {
	  if (isNullOrUndefined(it)) throw $TypeError("Can't call method on " + it);
	  return it;
	};
	return requireObjectCoercible;
}

var toObject;
var hasRequiredToObject;

function requireToObject () {
	if (hasRequiredToObject) return toObject;
	hasRequiredToObject = 1;
	var requireObjectCoercible = requireRequireObjectCoercible();

	var $Object = Object;

	// `ToObject` abstract operation
	// https://tc39.es/ecma262/#sec-toobject
	toObject = function (argument) {
	  return $Object(requireObjectCoercible(argument));
	};
	return toObject;
}

var hasOwnProperty_1;
var hasRequiredHasOwnProperty;

function requireHasOwnProperty () {
	if (hasRequiredHasOwnProperty) return hasOwnProperty_1;
	hasRequiredHasOwnProperty = 1;
	var uncurryThis = requireFunctionUncurryThis();
	var toObject = requireToObject();

	var hasOwnProperty = uncurryThis({}.hasOwnProperty);

	// `HasOwnProperty` abstract operation
	// https://tc39.es/ecma262/#sec-hasownproperty
	// eslint-disable-next-line es/no-object-hasown -- safe
	hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
	  return hasOwnProperty(toObject(it), key);
	};
	return hasOwnProperty_1;
}

var uid;
var hasRequiredUid;

function requireUid () {
	if (hasRequiredUid) return uid;
	hasRequiredUid = 1;
	var uncurryThis = requireFunctionUncurryThis();

	var id = 0;
	var postfix = Math.random();
	var toString = uncurryThis(1.0.toString);

	uid = function (key) {
	  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
	};
	return uid;
}

var engineUserAgent;
var hasRequiredEngineUserAgent;

function requireEngineUserAgent () {
	if (hasRequiredEngineUserAgent) return engineUserAgent;
	hasRequiredEngineUserAgent = 1;
	engineUserAgent = typeof navigator != 'undefined' && String(navigator.userAgent) || '';
	return engineUserAgent;
}

var engineV8Version;
var hasRequiredEngineV8Version;

function requireEngineV8Version () {
	if (hasRequiredEngineV8Version) return engineV8Version;
	hasRequiredEngineV8Version = 1;
	var global = requireGlobal();
	var userAgent = requireEngineUserAgent();

	var process = global.process;
	var Deno = global.Deno;
	var versions = process && process.versions || Deno && Deno.version;
	var v8 = versions && versions.v8;
	var match, version;

	if (v8) {
	  match = v8.split('.');
	  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
	  // but their correct versions are not interesting for us
	  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
	}

	// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
	// so check `userAgent` even if `.v8` exists, but 0
	if (!version && userAgent) {
	  match = userAgent.match(/Edge\/(\d+)/);
	  if (!match || match[1] >= 74) {
	    match = userAgent.match(/Chrome\/(\d+)/);
	    if (match) version = +match[1];
	  }
	}

	engineV8Version = version;
	return engineV8Version;
}

/* eslint-disable es/no-symbol -- required for testing */

var symbolConstructorDetection;
var hasRequiredSymbolConstructorDetection;

function requireSymbolConstructorDetection () {
	if (hasRequiredSymbolConstructorDetection) return symbolConstructorDetection;
	hasRequiredSymbolConstructorDetection = 1;
	var V8_VERSION = requireEngineV8Version();
	var fails = requireFails();

	// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
	symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails(function () {
	  var symbol = Symbol();
	  // Chrome 38 Symbol has incorrect toString conversion
	  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
	  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
	    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
	    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
	});
	return symbolConstructorDetection;
}

/* eslint-disable es/no-symbol -- required for testing */

var useSymbolAsUid;
var hasRequiredUseSymbolAsUid;

function requireUseSymbolAsUid () {
	if (hasRequiredUseSymbolAsUid) return useSymbolAsUid;
	hasRequiredUseSymbolAsUid = 1;
	var NATIVE_SYMBOL = requireSymbolConstructorDetection();

	useSymbolAsUid = NATIVE_SYMBOL
	  && !Symbol.sham
	  && typeof Symbol.iterator == 'symbol';
	return useSymbolAsUid;
}

var wellKnownSymbol;
var hasRequiredWellKnownSymbol;

function requireWellKnownSymbol () {
	if (hasRequiredWellKnownSymbol) return wellKnownSymbol;
	hasRequiredWellKnownSymbol = 1;
	var global = requireGlobal();
	var shared = requireShared();
	var hasOwn = requireHasOwnProperty();
	var uid = requireUid();
	var NATIVE_SYMBOL = requireSymbolConstructorDetection();
	var USE_SYMBOL_AS_UID = requireUseSymbolAsUid();

	var Symbol = global.Symbol;
	var WellKnownSymbolsStore = shared('wks');
	var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol['for'] || Symbol : Symbol && Symbol.withoutSetter || uid;

	wellKnownSymbol = function (name) {
	  if (!hasOwn(WellKnownSymbolsStore, name)) {
	    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol, name)
	      ? Symbol[name]
	      : createWellKnownSymbol('Symbol.' + name);
	  } return WellKnownSymbolsStore[name];
	};
	return wellKnownSymbol;
}

var toStringTagSupport;
var hasRequiredToStringTagSupport;

function requireToStringTagSupport () {
	if (hasRequiredToStringTagSupport) return toStringTagSupport;
	hasRequiredToStringTagSupport = 1;
	var wellKnownSymbol = requireWellKnownSymbol();

	var TO_STRING_TAG = wellKnownSymbol('toStringTag');
	var test = {};

	test[TO_STRING_TAG] = 'z';

	toStringTagSupport = String(test) === '[object z]';
	return toStringTagSupport;
}

var documentAll_1;
var hasRequiredDocumentAll;

function requireDocumentAll () {
	if (hasRequiredDocumentAll) return documentAll_1;
	hasRequiredDocumentAll = 1;
	var documentAll = typeof document == 'object' && document.all;

	// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
	// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
	var IS_HTMLDDA = typeof documentAll == 'undefined' && documentAll !== undefined;

	documentAll_1 = {
	  all: documentAll,
	  IS_HTMLDDA: IS_HTMLDDA
	};
	return documentAll_1;
}

var isCallable;
var hasRequiredIsCallable;

function requireIsCallable () {
	if (hasRequiredIsCallable) return isCallable;
	hasRequiredIsCallable = 1;
	var $documentAll = requireDocumentAll();

	var documentAll = $documentAll.all;

	// `IsCallable` abstract operation
	// https://tc39.es/ecma262/#sec-iscallable
	isCallable = $documentAll.IS_HTMLDDA ? function (argument) {
	  return typeof argument == 'function' || argument === documentAll;
	} : function (argument) {
	  return typeof argument == 'function';
	};
	return isCallable;
}

var classofRaw;
var hasRequiredClassofRaw;

function requireClassofRaw () {
	if (hasRequiredClassofRaw) return classofRaw;
	hasRequiredClassofRaw = 1;
	var uncurryThis = requireFunctionUncurryThis();

	var toString = uncurryThis({}.toString);
	var stringSlice = uncurryThis(''.slice);

	classofRaw = function (it) {
	  return stringSlice(toString(it), 8, -1);
	};
	return classofRaw;
}

var classof;
var hasRequiredClassof;

function requireClassof () {
	if (hasRequiredClassof) return classof;
	hasRequiredClassof = 1;
	var TO_STRING_TAG_SUPPORT = requireToStringTagSupport();
	var isCallable = requireIsCallable();
	var classofRaw = requireClassofRaw();
	var wellKnownSymbol = requireWellKnownSymbol();

	var TO_STRING_TAG = wellKnownSymbol('toStringTag');
	var $Object = Object;

	// ES3 wrong here
	var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (error) { /* empty */ }
	};

	// getting tag from ES6+ `Object.prototype.toString`
	classof = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
	  var O, tag, result;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
	    // builtinTag case
	    : CORRECT_ARGUMENTS ? classofRaw(O)
	    // ES3 arguments fallback
	    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
	};
	return classof;
}

var toString;
var hasRequiredToString;

function requireToString () {
	if (hasRequiredToString) return toString;
	hasRequiredToString = 1;
	var classof = requireClassof();

	var $String = String;

	toString = function (argument) {
	  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
	  return $String(argument);
	};
	return toString;
}

var stringMultibyte;
var hasRequiredStringMultibyte;

function requireStringMultibyte () {
	if (hasRequiredStringMultibyte) return stringMultibyte;
	hasRequiredStringMultibyte = 1;
	var uncurryThis = requireFunctionUncurryThis();
	var toIntegerOrInfinity = requireToIntegerOrInfinity();
	var toString = requireToString();
	var requireObjectCoercible = requireRequireObjectCoercible();

	var charAt = uncurryThis(''.charAt);
	var charCodeAt = uncurryThis(''.charCodeAt);
	var stringSlice = uncurryThis(''.slice);

	var createMethod = function (CONVERT_TO_STRING) {
	  return function ($this, pos) {
	    var S = toString(requireObjectCoercible($this));
	    var position = toIntegerOrInfinity(pos);
	    var size = S.length;
	    var first, second;
	    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
	    first = charCodeAt(S, position);
	    return first < 0xD800 || first > 0xDBFF || position + 1 === size
	      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
	        ? CONVERT_TO_STRING
	          ? charAt(S, position)
	          : first
	        : CONVERT_TO_STRING
	          ? stringSlice(S, position, position + 2)
	          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
	  };
	};

	stringMultibyte = {
	  // `String.prototype.codePointAt` method
	  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
	  codeAt: createMethod(false),
	  // `String.prototype.at` method
	  // https://github.com/mathiasbynens/String.prototype.at
	  charAt: createMethod(true)
	};
	return stringMultibyte;
}

var weakMapBasicDetection;
var hasRequiredWeakMapBasicDetection;

function requireWeakMapBasicDetection () {
	if (hasRequiredWeakMapBasicDetection) return weakMapBasicDetection;
	hasRequiredWeakMapBasicDetection = 1;
	var global = requireGlobal();
	var isCallable = requireIsCallable();

	var WeakMap = global.WeakMap;

	weakMapBasicDetection = isCallable(WeakMap) && /native code/.test(String(WeakMap));
	return weakMapBasicDetection;
}

var isObject$1;
var hasRequiredIsObject;

function requireIsObject () {
	if (hasRequiredIsObject) return isObject$1;
	hasRequiredIsObject = 1;
	var isCallable = requireIsCallable();
	var $documentAll = requireDocumentAll();

	var documentAll = $documentAll.all;

	isObject$1 = $documentAll.IS_HTMLDDA ? function (it) {
	  return typeof it == 'object' ? it !== null : isCallable(it) || it === documentAll;
	} : function (it) {
	  return typeof it == 'object' ? it !== null : isCallable(it);
	};
	return isObject$1;
}

var descriptors;
var hasRequiredDescriptors;

function requireDescriptors () {
	if (hasRequiredDescriptors) return descriptors;
	hasRequiredDescriptors = 1;
	var fails = requireFails();

	// Detect IE8's incomplete defineProperty implementation
	descriptors = !fails(function () {
	  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
	  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
	});
	return descriptors;
}

var objectDefineProperty = {};

var documentCreateElement;
var hasRequiredDocumentCreateElement;

function requireDocumentCreateElement () {
	if (hasRequiredDocumentCreateElement) return documentCreateElement;
	hasRequiredDocumentCreateElement = 1;
	var global = requireGlobal();
	var isObject = requireIsObject();

	var document = global.document;
	// typeof document.createElement is 'object' in old IE
	var EXISTS = isObject(document) && isObject(document.createElement);

	documentCreateElement = function (it) {
	  return EXISTS ? document.createElement(it) : {};
	};
	return documentCreateElement;
}

var ie8DomDefine;
var hasRequiredIe8DomDefine;

function requireIe8DomDefine () {
	if (hasRequiredIe8DomDefine) return ie8DomDefine;
	hasRequiredIe8DomDefine = 1;
	var DESCRIPTORS = requireDescriptors();
	var fails = requireFails();
	var createElement = requireDocumentCreateElement();

	// Thanks to IE8 for its funny defineProperty
	ie8DomDefine = !DESCRIPTORS && !fails(function () {
	  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
	  return Object.defineProperty(createElement('div'), 'a', {
	    get: function () { return 7; }
	  }).a != 7;
	});
	return ie8DomDefine;
}

var v8PrototypeDefineBug;
var hasRequiredV8PrototypeDefineBug;

function requireV8PrototypeDefineBug () {
	if (hasRequiredV8PrototypeDefineBug) return v8PrototypeDefineBug;
	hasRequiredV8PrototypeDefineBug = 1;
	var DESCRIPTORS = requireDescriptors();
	var fails = requireFails();

	// V8 ~ Chrome 36-
	// https://bugs.chromium.org/p/v8/issues/detail?id=3334
	v8PrototypeDefineBug = DESCRIPTORS && fails(function () {
	  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
	  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
	    value: 42,
	    writable: false
	  }).prototype != 42;
	});
	return v8PrototypeDefineBug;
}

var anObject;
var hasRequiredAnObject;

function requireAnObject () {
	if (hasRequiredAnObject) return anObject;
	hasRequiredAnObject = 1;
	var isObject = requireIsObject();

	var $String = String;
	var $TypeError = TypeError;

	// `Assert: Type(argument) is Object`
	anObject = function (argument) {
	  if (isObject(argument)) return argument;
	  throw $TypeError($String(argument) + ' is not an object');
	};
	return anObject;
}

var functionCall;
var hasRequiredFunctionCall;

function requireFunctionCall () {
	if (hasRequiredFunctionCall) return functionCall;
	hasRequiredFunctionCall = 1;
	var NATIVE_BIND = requireFunctionBindNative();

	var call = Function.prototype.call;

	functionCall = NATIVE_BIND ? call.bind(call) : function () {
	  return call.apply(call, arguments);
	};
	return functionCall;
}

var getBuiltIn;
var hasRequiredGetBuiltIn;

function requireGetBuiltIn () {
	if (hasRequiredGetBuiltIn) return getBuiltIn;
	hasRequiredGetBuiltIn = 1;
	var global = requireGlobal();
	var isCallable = requireIsCallable();

	var aFunction = function (argument) {
	  return isCallable(argument) ? argument : undefined;
	};

	getBuiltIn = function (namespace, method) {
	  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
	};
	return getBuiltIn;
}

var objectIsPrototypeOf;
var hasRequiredObjectIsPrototypeOf;

function requireObjectIsPrototypeOf () {
	if (hasRequiredObjectIsPrototypeOf) return objectIsPrototypeOf;
	hasRequiredObjectIsPrototypeOf = 1;
	var uncurryThis = requireFunctionUncurryThis();

	objectIsPrototypeOf = uncurryThis({}.isPrototypeOf);
	return objectIsPrototypeOf;
}

var isSymbol;
var hasRequiredIsSymbol;

function requireIsSymbol () {
	if (hasRequiredIsSymbol) return isSymbol;
	hasRequiredIsSymbol = 1;
	var getBuiltIn = requireGetBuiltIn();
	var isCallable = requireIsCallable();
	var isPrototypeOf = requireObjectIsPrototypeOf();
	var USE_SYMBOL_AS_UID = requireUseSymbolAsUid();

	var $Object = Object;

	isSymbol = USE_SYMBOL_AS_UID ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  var $Symbol = getBuiltIn('Symbol');
	  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
	};
	return isSymbol;
}

var tryToString;
var hasRequiredTryToString;

function requireTryToString () {
	if (hasRequiredTryToString) return tryToString;
	hasRequiredTryToString = 1;
	var $String = String;

	tryToString = function (argument) {
	  try {
	    return $String(argument);
	  } catch (error) {
	    return 'Object';
	  }
	};
	return tryToString;
}

var aCallable;
var hasRequiredACallable;

function requireACallable () {
	if (hasRequiredACallable) return aCallable;
	hasRequiredACallable = 1;
	var isCallable = requireIsCallable();
	var tryToString = requireTryToString();

	var $TypeError = TypeError;

	// `Assert: IsCallable(argument) is true`
	aCallable = function (argument) {
	  if (isCallable(argument)) return argument;
	  throw $TypeError(tryToString(argument) + ' is not a function');
	};
	return aCallable;
}

var getMethod;
var hasRequiredGetMethod;

function requireGetMethod () {
	if (hasRequiredGetMethod) return getMethod;
	hasRequiredGetMethod = 1;
	var aCallable = requireACallable();
	var isNullOrUndefined = requireIsNullOrUndefined();

	// `GetMethod` abstract operation
	// https://tc39.es/ecma262/#sec-getmethod
	getMethod = function (V, P) {
	  var func = V[P];
	  return isNullOrUndefined(func) ? undefined : aCallable(func);
	};
	return getMethod;
}

var ordinaryToPrimitive;
var hasRequiredOrdinaryToPrimitive;

function requireOrdinaryToPrimitive () {
	if (hasRequiredOrdinaryToPrimitive) return ordinaryToPrimitive;
	hasRequiredOrdinaryToPrimitive = 1;
	var call = requireFunctionCall();
	var isCallable = requireIsCallable();
	var isObject = requireIsObject();

	var $TypeError = TypeError;

	// `OrdinaryToPrimitive` abstract operation
	// https://tc39.es/ecma262/#sec-ordinarytoprimitive
	ordinaryToPrimitive = function (input, pref) {
	  var fn, val;
	  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
	  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
	  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
	  throw $TypeError("Can't convert object to primitive value");
	};
	return ordinaryToPrimitive;
}

var toPrimitive;
var hasRequiredToPrimitive;

function requireToPrimitive () {
	if (hasRequiredToPrimitive) return toPrimitive;
	hasRequiredToPrimitive = 1;
	var call = requireFunctionCall();
	var isObject = requireIsObject();
	var isSymbol = requireIsSymbol();
	var getMethod = requireGetMethod();
	var ordinaryToPrimitive = requireOrdinaryToPrimitive();
	var wellKnownSymbol = requireWellKnownSymbol();

	var $TypeError = TypeError;
	var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

	// `ToPrimitive` abstract operation
	// https://tc39.es/ecma262/#sec-toprimitive
	toPrimitive = function (input, pref) {
	  if (!isObject(input) || isSymbol(input)) return input;
	  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
	  var result;
	  if (exoticToPrim) {
	    if (pref === undefined) pref = 'default';
	    result = call(exoticToPrim, input, pref);
	    if (!isObject(result) || isSymbol(result)) return result;
	    throw $TypeError("Can't convert object to primitive value");
	  }
	  if (pref === undefined) pref = 'number';
	  return ordinaryToPrimitive(input, pref);
	};
	return toPrimitive;
}

var toPropertyKey;
var hasRequiredToPropertyKey;

function requireToPropertyKey () {
	if (hasRequiredToPropertyKey) return toPropertyKey;
	hasRequiredToPropertyKey = 1;
	var toPrimitive = requireToPrimitive();
	var isSymbol = requireIsSymbol();

	// `ToPropertyKey` abstract operation
	// https://tc39.es/ecma262/#sec-topropertykey
	toPropertyKey = function (argument) {
	  var key = toPrimitive(argument, 'string');
	  return isSymbol(key) ? key : key + '';
	};
	return toPropertyKey;
}

var hasRequiredObjectDefineProperty;

function requireObjectDefineProperty () {
	if (hasRequiredObjectDefineProperty) return objectDefineProperty;
	hasRequiredObjectDefineProperty = 1;
	var DESCRIPTORS = requireDescriptors();
	var IE8_DOM_DEFINE = requireIe8DomDefine();
	var V8_PROTOTYPE_DEFINE_BUG = requireV8PrototypeDefineBug();
	var anObject = requireAnObject();
	var toPropertyKey = requireToPropertyKey();

	var $TypeError = TypeError;
	// eslint-disable-next-line es/no-object-defineproperty -- safe
	var $defineProperty = Object.defineProperty;
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var ENUMERABLE = 'enumerable';
	var CONFIGURABLE = 'configurable';
	var WRITABLE = 'writable';

	// `Object.defineProperty` method
	// https://tc39.es/ecma262/#sec-object.defineproperty
	objectDefineProperty.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPropertyKey(P);
	  anObject(Attributes);
	  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
	    var current = $getOwnPropertyDescriptor(O, P);
	    if (current && current[WRITABLE]) {
	      O[P] = Attributes.value;
	      Attributes = {
	        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
	        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
	        writable: false
	      };
	    }
	  } return $defineProperty(O, P, Attributes);
	} : $defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPropertyKey(P);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return $defineProperty(O, P, Attributes);
	  } catch (error) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw $TypeError('Accessors not supported');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};
	return objectDefineProperty;
}

var createPropertyDescriptor;
var hasRequiredCreatePropertyDescriptor;

function requireCreatePropertyDescriptor () {
	if (hasRequiredCreatePropertyDescriptor) return createPropertyDescriptor;
	hasRequiredCreatePropertyDescriptor = 1;
	createPropertyDescriptor = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};
	return createPropertyDescriptor;
}

var createNonEnumerableProperty;
var hasRequiredCreateNonEnumerableProperty;

function requireCreateNonEnumerableProperty () {
	if (hasRequiredCreateNonEnumerableProperty) return createNonEnumerableProperty;
	hasRequiredCreateNonEnumerableProperty = 1;
	var DESCRIPTORS = requireDescriptors();
	var definePropertyModule = requireObjectDefineProperty();
	var createPropertyDescriptor = requireCreatePropertyDescriptor();

	createNonEnumerableProperty = DESCRIPTORS ? function (object, key, value) {
	  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};
	return createNonEnumerableProperty;
}

var sharedKey;
var hasRequiredSharedKey;

function requireSharedKey () {
	if (hasRequiredSharedKey) return sharedKey;
	hasRequiredSharedKey = 1;
	var shared = requireShared();
	var uid = requireUid();

	var keys = shared('keys');

	sharedKey = function (key) {
	  return keys[key] || (keys[key] = uid(key));
	};
	return sharedKey;
}

var hiddenKeys;
var hasRequiredHiddenKeys;

function requireHiddenKeys () {
	if (hasRequiredHiddenKeys) return hiddenKeys;
	hasRequiredHiddenKeys = 1;
	hiddenKeys = {};
	return hiddenKeys;
}

var internalState;
var hasRequiredInternalState;

function requireInternalState () {
	if (hasRequiredInternalState) return internalState;
	hasRequiredInternalState = 1;
	var NATIVE_WEAK_MAP = requireWeakMapBasicDetection();
	var global = requireGlobal();
	var isObject = requireIsObject();
	var createNonEnumerableProperty = requireCreateNonEnumerableProperty();
	var hasOwn = requireHasOwnProperty();
	var shared = requireSharedStore();
	var sharedKey = requireSharedKey();
	var hiddenKeys = requireHiddenKeys();

	var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
	var TypeError = global.TypeError;
	var WeakMap = global.WeakMap;
	var set, get, has;

	var enforce = function (it) {
	  return has(it) ? get(it) : set(it, {});
	};

	var getterFor = function (TYPE) {
	  return function (it) {
	    var state;
	    if (!isObject(it) || (state = get(it)).type !== TYPE) {
	      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
	    } return state;
	  };
	};

	if (NATIVE_WEAK_MAP || shared.state) {
	  var store = shared.state || (shared.state = new WeakMap());
	  /* eslint-disable no-self-assign -- prototype methods protection */
	  store.get = store.get;
	  store.has = store.has;
	  store.set = store.set;
	  /* eslint-enable no-self-assign -- prototype methods protection */
	  set = function (it, metadata) {
	    if (store.has(it)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
	    metadata.facade = it;
	    store.set(it, metadata);
	    return metadata;
	  };
	  get = function (it) {
	    return store.get(it) || {};
	  };
	  has = function (it) {
	    return store.has(it);
	  };
	} else {
	  var STATE = sharedKey('state');
	  hiddenKeys[STATE] = true;
	  set = function (it, metadata) {
	    if (hasOwn(it, STATE)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
	    metadata.facade = it;
	    createNonEnumerableProperty(it, STATE, metadata);
	    return metadata;
	  };
	  get = function (it) {
	    return hasOwn(it, STATE) ? it[STATE] : {};
	  };
	  has = function (it) {
	    return hasOwn(it, STATE);
	  };
	}

	internalState = {
	  set: set,
	  get: get,
	  has: has,
	  enforce: enforce,
	  getterFor: getterFor
	};
	return internalState;
}

var objectGetOwnPropertyDescriptor = {};

var objectPropertyIsEnumerable = {};

var hasRequiredObjectPropertyIsEnumerable;

function requireObjectPropertyIsEnumerable () {
	if (hasRequiredObjectPropertyIsEnumerable) return objectPropertyIsEnumerable;
	hasRequiredObjectPropertyIsEnumerable = 1;
	var $propertyIsEnumerable = {}.propertyIsEnumerable;
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

	// Nashorn ~ JDK8 bug
	var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

	// `Object.prototype.propertyIsEnumerable` method implementation
	// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
	objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
	  var descriptor = getOwnPropertyDescriptor(this, V);
	  return !!descriptor && descriptor.enumerable;
	} : $propertyIsEnumerable;
	return objectPropertyIsEnumerable;
}

var indexedObject;
var hasRequiredIndexedObject;

function requireIndexedObject () {
	if (hasRequiredIndexedObject) return indexedObject;
	hasRequiredIndexedObject = 1;
	var uncurryThis = requireFunctionUncurryThis();
	var fails = requireFails();
	var classof = requireClassofRaw();

	var $Object = Object;
	var split = uncurryThis(''.split);

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	indexedObject = fails(function () {
	  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
	  // eslint-disable-next-line no-prototype-builtins -- safe
	  return !$Object('z').propertyIsEnumerable(0);
	}) ? function (it) {
	  return classof(it) == 'String' ? split(it, '') : $Object(it);
	} : $Object;
	return indexedObject;
}

var toIndexedObject;
var hasRequiredToIndexedObject;

function requireToIndexedObject () {
	if (hasRequiredToIndexedObject) return toIndexedObject;
	hasRequiredToIndexedObject = 1;
	// toObject with fallback for non-array-like ES3 strings
	var IndexedObject = requireIndexedObject();
	var requireObjectCoercible = requireRequireObjectCoercible();

	toIndexedObject = function (it) {
	  return IndexedObject(requireObjectCoercible(it));
	};
	return toIndexedObject;
}

var hasRequiredObjectGetOwnPropertyDescriptor;

function requireObjectGetOwnPropertyDescriptor () {
	if (hasRequiredObjectGetOwnPropertyDescriptor) return objectGetOwnPropertyDescriptor;
	hasRequiredObjectGetOwnPropertyDescriptor = 1;
	var DESCRIPTORS = requireDescriptors();
	var call = requireFunctionCall();
	var propertyIsEnumerableModule = requireObjectPropertyIsEnumerable();
	var createPropertyDescriptor = requireCreatePropertyDescriptor();
	var toIndexedObject = requireToIndexedObject();
	var toPropertyKey = requireToPropertyKey();
	var hasOwn = requireHasOwnProperty();
	var IE8_DOM_DEFINE = requireIe8DomDefine();

	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

	// `Object.getOwnPropertyDescriptor` method
	// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
	objectGetOwnPropertyDescriptor.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
	  O = toIndexedObject(O);
	  P = toPropertyKey(P);
	  if (IE8_DOM_DEFINE) try {
	    return $getOwnPropertyDescriptor(O, P);
	  } catch (error) { /* empty */ }
	  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
	};
	return objectGetOwnPropertyDescriptor;
}

var makeBuiltIn = {exports: {}};

var functionName;
var hasRequiredFunctionName;

function requireFunctionName () {
	if (hasRequiredFunctionName) return functionName;
	hasRequiredFunctionName = 1;
	var DESCRIPTORS = requireDescriptors();
	var hasOwn = requireHasOwnProperty();

	var FunctionPrototype = Function.prototype;
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

	var EXISTS = hasOwn(FunctionPrototype, 'name');
	// additional protection from minified / mangled / dropped function names
	var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
	var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

	functionName = {
	  EXISTS: EXISTS,
	  PROPER: PROPER,
	  CONFIGURABLE: CONFIGURABLE
	};
	return functionName;
}

var inspectSource;
var hasRequiredInspectSource;

function requireInspectSource () {
	if (hasRequiredInspectSource) return inspectSource;
	hasRequiredInspectSource = 1;
	var uncurryThis = requireFunctionUncurryThis();
	var isCallable = requireIsCallable();
	var store = requireSharedStore();

	var functionToString = uncurryThis(Function.toString);

	// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
	if (!isCallable(store.inspectSource)) {
	  store.inspectSource = function (it) {
	    return functionToString(it);
	  };
	}

	inspectSource = store.inspectSource;
	return inspectSource;
}

var hasRequiredMakeBuiltIn;

function requireMakeBuiltIn () {
	if (hasRequiredMakeBuiltIn) return makeBuiltIn.exports;
	hasRequiredMakeBuiltIn = 1;
	var uncurryThis = requireFunctionUncurryThis();
	var fails = requireFails();
	var isCallable = requireIsCallable();
	var hasOwn = requireHasOwnProperty();
	var DESCRIPTORS = requireDescriptors();
	var CONFIGURABLE_FUNCTION_NAME = requireFunctionName().CONFIGURABLE;
	var inspectSource = requireInspectSource();
	var InternalStateModule = requireInternalState();

	var enforceInternalState = InternalStateModule.enforce;
	var getInternalState = InternalStateModule.get;
	var $String = String;
	// eslint-disable-next-line es/no-object-defineproperty -- safe
	var defineProperty = Object.defineProperty;
	var stringSlice = uncurryThis(''.slice);
	var replace = uncurryThis(''.replace);
	var join = uncurryThis([].join);

	var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
	  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
	});

	var TEMPLATE = String(String).split('String');

	var makeBuiltIn$1 = makeBuiltIn.exports = function (value, name, options) {
	  if (stringSlice($String(name), 0, 7) === 'Symbol(') {
	    name = '[' + replace($String(name), /^Symbol\(([^)]*)\)/, '$1') + ']';
	  }
	  if (options && options.getter) name = 'get ' + name;
	  if (options && options.setter) name = 'set ' + name;
	  if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
	    if (DESCRIPTORS) defineProperty(value, 'name', { value: name, configurable: true });
	    else value.name = name;
	  }
	  if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
	    defineProperty(value, 'length', { value: options.arity });
	  }
	  try {
	    if (options && hasOwn(options, 'constructor') && options.constructor) {
	      if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
	    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
	    } else if (value.prototype) value.prototype = undefined;
	  } catch (error) { /* empty */ }
	  var state = enforceInternalState(value);
	  if (!hasOwn(state, 'source')) {
	    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
	  } return value;
	};

	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	// eslint-disable-next-line no-extend-native -- required
	Function.prototype.toString = makeBuiltIn$1(function toString() {
	  return isCallable(this) && getInternalState(this).source || inspectSource(this);
	}, 'toString');
	return makeBuiltIn.exports;
}

var defineBuiltIn;
var hasRequiredDefineBuiltIn;

function requireDefineBuiltIn () {
	if (hasRequiredDefineBuiltIn) return defineBuiltIn;
	hasRequiredDefineBuiltIn = 1;
	var isCallable = requireIsCallable();
	var definePropertyModule = requireObjectDefineProperty();
	var makeBuiltIn = requireMakeBuiltIn();
	var defineGlobalProperty = requireDefineGlobalProperty();

	defineBuiltIn = function (O, key, value, options) {
	  if (!options) options = {};
	  var simple = options.enumerable;
	  var name = options.name !== undefined ? options.name : key;
	  if (isCallable(value)) makeBuiltIn(value, name, options);
	  if (options.global) {
	    if (simple) O[key] = value;
	    else defineGlobalProperty(key, value);
	  } else {
	    try {
	      if (!options.unsafe) delete O[key];
	      else if (O[key]) simple = true;
	    } catch (error) { /* empty */ }
	    if (simple) O[key] = value;
	    else definePropertyModule.f(O, key, {
	      value: value,
	      enumerable: false,
	      configurable: !options.nonConfigurable,
	      writable: !options.nonWritable
	    });
	  } return O;
	};
	return defineBuiltIn;
}

var objectGetOwnPropertyNames = {};

var toAbsoluteIndex;
var hasRequiredToAbsoluteIndex;

function requireToAbsoluteIndex () {
	if (hasRequiredToAbsoluteIndex) return toAbsoluteIndex;
	hasRequiredToAbsoluteIndex = 1;
	var toIntegerOrInfinity = requireToIntegerOrInfinity();

	var max = Math.max;
	var min = Math.min;

	// Helper for a popular repeating case of the spec:
	// Let integer be ? ToInteger(index).
	// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
	toAbsoluteIndex = function (index, length) {
	  var integer = toIntegerOrInfinity(index);
	  return integer < 0 ? max(integer + length, 0) : min(integer, length);
	};
	return toAbsoluteIndex;
}

var toLength;
var hasRequiredToLength;

function requireToLength () {
	if (hasRequiredToLength) return toLength;
	hasRequiredToLength = 1;
	var toIntegerOrInfinity = requireToIntegerOrInfinity();

	var min = Math.min;

	// `ToLength` abstract operation
	// https://tc39.es/ecma262/#sec-tolength
	toLength = function (argument) {
	  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
	};
	return toLength;
}

var lengthOfArrayLike;
var hasRequiredLengthOfArrayLike;

function requireLengthOfArrayLike () {
	if (hasRequiredLengthOfArrayLike) return lengthOfArrayLike;
	hasRequiredLengthOfArrayLike = 1;
	var toLength = requireToLength();

	// `LengthOfArrayLike` abstract operation
	// https://tc39.es/ecma262/#sec-lengthofarraylike
	lengthOfArrayLike = function (obj) {
	  return toLength(obj.length);
	};
	return lengthOfArrayLike;
}

var arrayIncludes;
var hasRequiredArrayIncludes;

function requireArrayIncludes () {
	if (hasRequiredArrayIncludes) return arrayIncludes;
	hasRequiredArrayIncludes = 1;
	var toIndexedObject = requireToIndexedObject();
	var toAbsoluteIndex = requireToAbsoluteIndex();
	var lengthOfArrayLike = requireLengthOfArrayLike();

	// `Array.prototype.{ indexOf, includes }` methods implementation
	var createMethod = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIndexedObject($this);
	    var length = lengthOfArrayLike(O);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare -- NaN check
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare -- NaN check
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) {
	      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

	arrayIncludes = {
	  // `Array.prototype.includes` method
	  // https://tc39.es/ecma262/#sec-array.prototype.includes
	  includes: createMethod(true),
	  // `Array.prototype.indexOf` method
	  // https://tc39.es/ecma262/#sec-array.prototype.indexof
	  indexOf: createMethod(false)
	};
	return arrayIncludes;
}

var objectKeysInternal;
var hasRequiredObjectKeysInternal;

function requireObjectKeysInternal () {
	if (hasRequiredObjectKeysInternal) return objectKeysInternal;
	hasRequiredObjectKeysInternal = 1;
	var uncurryThis = requireFunctionUncurryThis();
	var hasOwn = requireHasOwnProperty();
	var toIndexedObject = requireToIndexedObject();
	var indexOf = requireArrayIncludes().indexOf;
	var hiddenKeys = requireHiddenKeys();

	var push = uncurryThis([].push);

	objectKeysInternal = function (object, names) {
	  var O = toIndexedObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (hasOwn(O, key = names[i++])) {
	    ~indexOf(result, key) || push(result, key);
	  }
	  return result;
	};
	return objectKeysInternal;
}

var enumBugKeys;
var hasRequiredEnumBugKeys;

function requireEnumBugKeys () {
	if (hasRequiredEnumBugKeys) return enumBugKeys;
	hasRequiredEnumBugKeys = 1;
	// IE8- don't enum bug keys
	enumBugKeys = [
	  'constructor',
	  'hasOwnProperty',
	  'isPrototypeOf',
	  'propertyIsEnumerable',
	  'toLocaleString',
	  'toString',
	  'valueOf'
	];
	return enumBugKeys;
}

var hasRequiredObjectGetOwnPropertyNames;

function requireObjectGetOwnPropertyNames () {
	if (hasRequiredObjectGetOwnPropertyNames) return objectGetOwnPropertyNames;
	hasRequiredObjectGetOwnPropertyNames = 1;
	var internalObjectKeys = requireObjectKeysInternal();
	var enumBugKeys = requireEnumBugKeys();

	var hiddenKeys = enumBugKeys.concat('length', 'prototype');

	// `Object.getOwnPropertyNames` method
	// https://tc39.es/ecma262/#sec-object.getownpropertynames
	// eslint-disable-next-line es/no-object-getownpropertynames -- safe
	objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return internalObjectKeys(O, hiddenKeys);
	};
	return objectGetOwnPropertyNames;
}

var objectGetOwnPropertySymbols = {};

var hasRequiredObjectGetOwnPropertySymbols;

function requireObjectGetOwnPropertySymbols () {
	if (hasRequiredObjectGetOwnPropertySymbols) return objectGetOwnPropertySymbols;
	hasRequiredObjectGetOwnPropertySymbols = 1;
	// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
	objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;
	return objectGetOwnPropertySymbols;
}

var ownKeys$q;
var hasRequiredOwnKeys;

function requireOwnKeys () {
	if (hasRequiredOwnKeys) return ownKeys$q;
	hasRequiredOwnKeys = 1;
	var getBuiltIn = requireGetBuiltIn();
	var uncurryThis = requireFunctionUncurryThis();
	var getOwnPropertyNamesModule = requireObjectGetOwnPropertyNames();
	var getOwnPropertySymbolsModule = requireObjectGetOwnPropertySymbols();
	var anObject = requireAnObject();

	var concat = uncurryThis([].concat);

	// all object keys, includes non-enumerable and symbols
	ownKeys$q = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
	  var keys = getOwnPropertyNamesModule.f(anObject(it));
	  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
	  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
	};
	return ownKeys$q;
}

var copyConstructorProperties;
var hasRequiredCopyConstructorProperties;

function requireCopyConstructorProperties () {
	if (hasRequiredCopyConstructorProperties) return copyConstructorProperties;
	hasRequiredCopyConstructorProperties = 1;
	var hasOwn = requireHasOwnProperty();
	var ownKeys = requireOwnKeys();
	var getOwnPropertyDescriptorModule = requireObjectGetOwnPropertyDescriptor();
	var definePropertyModule = requireObjectDefineProperty();

	copyConstructorProperties = function (target, source, exceptions) {
	  var keys = ownKeys(source);
	  var defineProperty = definePropertyModule.f;
	  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
	      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
	    }
	  }
	};
	return copyConstructorProperties;
}

var isForced_1;
var hasRequiredIsForced;

function requireIsForced () {
	if (hasRequiredIsForced) return isForced_1;
	hasRequiredIsForced = 1;
	var fails = requireFails();
	var isCallable = requireIsCallable();

	var replacement = /#|\.prototype\./;

	var isForced = function (feature, detection) {
	  var value = data[normalize(feature)];
	  return value == POLYFILL ? true
	    : value == NATIVE ? false
	    : isCallable(detection) ? fails(detection)
	    : !!detection;
	};

	var normalize = isForced.normalize = function (string) {
	  return String(string).replace(replacement, '.').toLowerCase();
	};

	var data = isForced.data = {};
	var NATIVE = isForced.NATIVE = 'N';
	var POLYFILL = isForced.POLYFILL = 'P';

	isForced_1 = isForced;
	return isForced_1;
}

var _export;
var hasRequired_export;

function require_export () {
	if (hasRequired_export) return _export;
	hasRequired_export = 1;
	var global = requireGlobal();
	var getOwnPropertyDescriptor = requireObjectGetOwnPropertyDescriptor().f;
	var createNonEnumerableProperty = requireCreateNonEnumerableProperty();
	var defineBuiltIn = requireDefineBuiltIn();
	var defineGlobalProperty = requireDefineGlobalProperty();
	var copyConstructorProperties = requireCopyConstructorProperties();
	var isForced = requireIsForced();

	/*
	  options.target         - name of the target object
	  options.global         - target is the global object
	  options.stat           - export as static methods of target
	  options.proto          - export as prototype methods of target
	  options.real           - real prototype method for the `pure` version
	  options.forced         - export even if the native feature is available
	  options.bind           - bind methods to the target, required for the `pure` version
	  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
	  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
	  options.sham           - add a flag to not completely full polyfills
	  options.enumerable     - export as enumerable property
	  options.dontCallGetSet - prevent calling a getter on target
	  options.name           - the .name of the function if it does not match the key
	*/
	_export = function (options, source) {
	  var TARGET = options.target;
	  var GLOBAL = options.global;
	  var STATIC = options.stat;
	  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
	  if (GLOBAL) {
	    target = global;
	  } else if (STATIC) {
	    target = global[TARGET] || defineGlobalProperty(TARGET, {});
	  } else {
	    target = (global[TARGET] || {}).prototype;
	  }
	  if (target) for (key in source) {
	    sourceProperty = source[key];
	    if (options.dontCallGetSet) {
	      descriptor = getOwnPropertyDescriptor(target, key);
	      targetProperty = descriptor && descriptor.value;
	    } else targetProperty = target[key];
	    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
	    // contained in target
	    if (!FORCED && targetProperty !== undefined) {
	      if (typeof sourceProperty == typeof targetProperty) continue;
	      copyConstructorProperties(sourceProperty, targetProperty);
	    }
	    // add a flag to not completely full polyfills
	    if (options.sham || (targetProperty && targetProperty.sham)) {
	      createNonEnumerableProperty(sourceProperty, 'sham', true);
	    }
	    defineBuiltIn(target, key, sourceProperty, options);
	  }
	};
	return _export;
}

var objectDefineProperties = {};

var objectKeys;
var hasRequiredObjectKeys;

function requireObjectKeys () {
	if (hasRequiredObjectKeys) return objectKeys;
	hasRequiredObjectKeys = 1;
	var internalObjectKeys = requireObjectKeysInternal();
	var enumBugKeys = requireEnumBugKeys();

	// `Object.keys` method
	// https://tc39.es/ecma262/#sec-object.keys
	// eslint-disable-next-line es/no-object-keys -- safe
	objectKeys = Object.keys || function keys(O) {
	  return internalObjectKeys(O, enumBugKeys);
	};
	return objectKeys;
}

var hasRequiredObjectDefineProperties;

function requireObjectDefineProperties () {
	if (hasRequiredObjectDefineProperties) return objectDefineProperties;
	hasRequiredObjectDefineProperties = 1;
	var DESCRIPTORS = requireDescriptors();
	var V8_PROTOTYPE_DEFINE_BUG = requireV8PrototypeDefineBug();
	var definePropertyModule = requireObjectDefineProperty();
	var anObject = requireAnObject();
	var toIndexedObject = requireToIndexedObject();
	var objectKeys = requireObjectKeys();

	// `Object.defineProperties` method
	// https://tc39.es/ecma262/#sec-object.defineproperties
	// eslint-disable-next-line es/no-object-defineproperties -- safe
	objectDefineProperties.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var props = toIndexedObject(Properties);
	  var keys = objectKeys(Properties);
	  var length = keys.length;
	  var index = 0;
	  var key;
	  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
	  return O;
	};
	return objectDefineProperties;
}

var html;
var hasRequiredHtml;

function requireHtml () {
	if (hasRequiredHtml) return html;
	hasRequiredHtml = 1;
	var getBuiltIn = requireGetBuiltIn();

	html = getBuiltIn('document', 'documentElement');
	return html;
}

/* global ActiveXObject -- old IE, WSH */

var objectCreate;
var hasRequiredObjectCreate;

function requireObjectCreate () {
	if (hasRequiredObjectCreate) return objectCreate;
	hasRequiredObjectCreate = 1;
	var anObject = requireAnObject();
	var definePropertiesModule = requireObjectDefineProperties();
	var enumBugKeys = requireEnumBugKeys();
	var hiddenKeys = requireHiddenKeys();
	var html = requireHtml();
	var documentCreateElement = requireDocumentCreateElement();
	var sharedKey = requireSharedKey();

	var GT = '>';
	var LT = '<';
	var PROTOTYPE = 'prototype';
	var SCRIPT = 'script';
	var IE_PROTO = sharedKey('IE_PROTO');

	var EmptyConstructor = function () { /* empty */ };

	var scriptTag = function (content) {
	  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
	};

	// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
	var NullProtoObjectViaActiveX = function (activeXDocument) {
	  activeXDocument.write(scriptTag(''));
	  activeXDocument.close();
	  var temp = activeXDocument.parentWindow.Object;
	  activeXDocument = null; // avoid memory leak
	  return temp;
	};

	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var NullProtoObjectViaIFrame = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = documentCreateElement('iframe');
	  var JS = 'java' + SCRIPT + ':';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  html.appendChild(iframe);
	  // https://github.com/zloirock/core-js/issues/475
	  iframe.src = String(JS);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(scriptTag('document.F=Object'));
	  iframeDocument.close();
	  return iframeDocument.F;
	};

	// Check for document.domain and active x support
	// No need to use active x approach when document.domain is not set
	// see https://github.com/es-shims/es5-shim/issues/150
	// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
	// avoid IE GC bug
	var activeXDocument;
	var NullProtoObject = function () {
	  try {
	    activeXDocument = new ActiveXObject('htmlfile');
	  } catch (error) { /* ignore */ }
	  NullProtoObject = typeof document != 'undefined'
	    ? document.domain && activeXDocument
	      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
	      : NullProtoObjectViaIFrame()
	    : NullProtoObjectViaActiveX(activeXDocument); // WSH
	  var length = enumBugKeys.length;
	  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
	  return NullProtoObject();
	};

	hiddenKeys[IE_PROTO] = true;

	// `Object.create` method
	// https://tc39.es/ecma262/#sec-object.create
	// eslint-disable-next-line es/no-object-create -- safe
	objectCreate = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    EmptyConstructor[PROTOTYPE] = anObject(O);
	    result = new EmptyConstructor();
	    EmptyConstructor[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = NullProtoObject();
	  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
	};
	return objectCreate;
}

var correctPrototypeGetter;
var hasRequiredCorrectPrototypeGetter;

function requireCorrectPrototypeGetter () {
	if (hasRequiredCorrectPrototypeGetter) return correctPrototypeGetter;
	hasRequiredCorrectPrototypeGetter = 1;
	var fails = requireFails();

	correctPrototypeGetter = !fails(function () {
	  function F() { /* empty */ }
	  F.prototype.constructor = null;
	  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
	  return Object.getPrototypeOf(new F()) !== F.prototype;
	});
	return correctPrototypeGetter;
}

var objectGetPrototypeOf;
var hasRequiredObjectGetPrototypeOf;

function requireObjectGetPrototypeOf () {
	if (hasRequiredObjectGetPrototypeOf) return objectGetPrototypeOf;
	hasRequiredObjectGetPrototypeOf = 1;
	var hasOwn = requireHasOwnProperty();
	var isCallable = requireIsCallable();
	var toObject = requireToObject();
	var sharedKey = requireSharedKey();
	var CORRECT_PROTOTYPE_GETTER = requireCorrectPrototypeGetter();

	var IE_PROTO = sharedKey('IE_PROTO');
	var $Object = Object;
	var ObjectPrototype = $Object.prototype;

	// `Object.getPrototypeOf` method
	// https://tc39.es/ecma262/#sec-object.getprototypeof
	// eslint-disable-next-line es/no-object-getprototypeof -- safe
	objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
	  var object = toObject(O);
	  if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
	  var constructor = object.constructor;
	  if (isCallable(constructor) && object instanceof constructor) {
	    return constructor.prototype;
	  } return object instanceof $Object ? ObjectPrototype : null;
	};
	return objectGetPrototypeOf;
}

var iteratorsCore;
var hasRequiredIteratorsCore;

function requireIteratorsCore () {
	if (hasRequiredIteratorsCore) return iteratorsCore;
	hasRequiredIteratorsCore = 1;
	var fails = requireFails();
	var isCallable = requireIsCallable();
	var isObject = requireIsObject();
	var create = requireObjectCreate();
	var getPrototypeOf = requireObjectGetPrototypeOf();
	var defineBuiltIn = requireDefineBuiltIn();
	var wellKnownSymbol = requireWellKnownSymbol();
	var IS_PURE = requireIsPure();

	var ITERATOR = wellKnownSymbol('iterator');
	var BUGGY_SAFARI_ITERATORS = false;

	// `%IteratorPrototype%` object
	// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
	var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

	/* eslint-disable es/no-array-prototype-keys -- safe */
	if ([].keys) {
	  arrayIterator = [].keys();
	  // Safari 8 has buggy iterators w/o `next`
	  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
	  else {
	    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
	    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
	  }
	}

	var NEW_ITERATOR_PROTOTYPE = !isObject(IteratorPrototype) || fails(function () {
	  var test = {};
	  // FF44- legacy iterators case
	  return IteratorPrototype[ITERATOR].call(test) !== test;
	});

	if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
	else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);

	// `%IteratorPrototype%[@@iterator]()` method
	// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
	if (!isCallable(IteratorPrototype[ITERATOR])) {
	  defineBuiltIn(IteratorPrototype, ITERATOR, function () {
	    return this;
	  });
	}

	iteratorsCore = {
	  IteratorPrototype: IteratorPrototype,
	  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
	};
	return iteratorsCore;
}

var setToStringTag;
var hasRequiredSetToStringTag;

function requireSetToStringTag () {
	if (hasRequiredSetToStringTag) return setToStringTag;
	hasRequiredSetToStringTag = 1;
	var defineProperty = requireObjectDefineProperty().f;
	var hasOwn = requireHasOwnProperty();
	var wellKnownSymbol = requireWellKnownSymbol();

	var TO_STRING_TAG = wellKnownSymbol('toStringTag');

	setToStringTag = function (target, TAG, STATIC) {
	  if (target && !STATIC) target = target.prototype;
	  if (target && !hasOwn(target, TO_STRING_TAG)) {
	    defineProperty(target, TO_STRING_TAG, { configurable: true, value: TAG });
	  }
	};
	return setToStringTag;
}

var iterators;
var hasRequiredIterators;

function requireIterators () {
	if (hasRequiredIterators) return iterators;
	hasRequiredIterators = 1;
	iterators = {};
	return iterators;
}

var iteratorCreateConstructor;
var hasRequiredIteratorCreateConstructor;

function requireIteratorCreateConstructor () {
	if (hasRequiredIteratorCreateConstructor) return iteratorCreateConstructor;
	hasRequiredIteratorCreateConstructor = 1;
	var IteratorPrototype = requireIteratorsCore().IteratorPrototype;
	var create = requireObjectCreate();
	var createPropertyDescriptor = requireCreatePropertyDescriptor();
	var setToStringTag = requireSetToStringTag();
	var Iterators = requireIterators();

	var returnThis = function () { return this; };

	iteratorCreateConstructor = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
	  var TO_STRING_TAG = NAME + ' Iterator';
	  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
	  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
	  Iterators[TO_STRING_TAG] = returnThis;
	  return IteratorConstructor;
	};
	return iteratorCreateConstructor;
}

var functionUncurryThisAccessor;
var hasRequiredFunctionUncurryThisAccessor;

function requireFunctionUncurryThisAccessor () {
	if (hasRequiredFunctionUncurryThisAccessor) return functionUncurryThisAccessor;
	hasRequiredFunctionUncurryThisAccessor = 1;
	var uncurryThis = requireFunctionUncurryThis();
	var aCallable = requireACallable();

	functionUncurryThisAccessor = function (object, key, method) {
	  try {
	    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	    return uncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
	  } catch (error) { /* empty */ }
	};
	return functionUncurryThisAccessor;
}

var aPossiblePrototype;
var hasRequiredAPossiblePrototype;

function requireAPossiblePrototype () {
	if (hasRequiredAPossiblePrototype) return aPossiblePrototype;
	hasRequiredAPossiblePrototype = 1;
	var isCallable = requireIsCallable();

	var $String = String;
	var $TypeError = TypeError;

	aPossiblePrototype = function (argument) {
	  if (typeof argument == 'object' || isCallable(argument)) return argument;
	  throw $TypeError("Can't set " + $String(argument) + ' as a prototype');
	};
	return aPossiblePrototype;
}

/* eslint-disable no-proto -- safe */

var objectSetPrototypeOf;
var hasRequiredObjectSetPrototypeOf;

function requireObjectSetPrototypeOf () {
	if (hasRequiredObjectSetPrototypeOf) return objectSetPrototypeOf;
	hasRequiredObjectSetPrototypeOf = 1;
	var uncurryThisAccessor = requireFunctionUncurryThisAccessor();
	var anObject = requireAnObject();
	var aPossiblePrototype = requireAPossiblePrototype();

	// `Object.setPrototypeOf` method
	// https://tc39.es/ecma262/#sec-object.setprototypeof
	// Works with __proto__ only. Old v8 can't work with null proto objects.
	// eslint-disable-next-line es/no-object-setprototypeof -- safe
	objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
	  var CORRECT_SETTER = false;
	  var test = {};
	  var setter;
	  try {
	    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
	    setter(test, []);
	    CORRECT_SETTER = test instanceof Array;
	  } catch (error) { /* empty */ }
	  return function setPrototypeOf(O, proto) {
	    anObject(O);
	    aPossiblePrototype(proto);
	    if (CORRECT_SETTER) setter(O, proto);
	    else O.__proto__ = proto;
	    return O;
	  };
	}() : undefined);
	return objectSetPrototypeOf;
}

var iteratorDefine;
var hasRequiredIteratorDefine;

function requireIteratorDefine () {
	if (hasRequiredIteratorDefine) return iteratorDefine;
	hasRequiredIteratorDefine = 1;
	var $ = require_export();
	var call = requireFunctionCall();
	var IS_PURE = requireIsPure();
	var FunctionName = requireFunctionName();
	var isCallable = requireIsCallable();
	var createIteratorConstructor = requireIteratorCreateConstructor();
	var getPrototypeOf = requireObjectGetPrototypeOf();
	var setPrototypeOf = requireObjectSetPrototypeOf();
	var setToStringTag = requireSetToStringTag();
	var createNonEnumerableProperty = requireCreateNonEnumerableProperty();
	var defineBuiltIn = requireDefineBuiltIn();
	var wellKnownSymbol = requireWellKnownSymbol();
	var Iterators = requireIterators();
	var IteratorsCore = requireIteratorsCore();

	var PROPER_FUNCTION_NAME = FunctionName.PROPER;
	var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
	var IteratorPrototype = IteratorsCore.IteratorPrototype;
	var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
	var ITERATOR = wellKnownSymbol('iterator');
	var KEYS = 'keys';
	var VALUES = 'values';
	var ENTRIES = 'entries';

	var returnThis = function () { return this; };

	iteratorDefine = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
	  createIteratorConstructor(IteratorConstructor, NAME, next);

	  var getIterationMethod = function (KIND) {
	    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
	    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
	    switch (KIND) {
	      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
	      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
	      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
	    } return function () { return new IteratorConstructor(this); };
	  };

	  var TO_STRING_TAG = NAME + ' Iterator';
	  var INCORRECT_VALUES_NAME = false;
	  var IterablePrototype = Iterable.prototype;
	  var nativeIterator = IterablePrototype[ITERATOR]
	    || IterablePrototype['@@iterator']
	    || DEFAULT && IterablePrototype[DEFAULT];
	  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
	  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
	  var CurrentIteratorPrototype, methods, KEY;

	  // fix native
	  if (anyNativeIterator) {
	    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
	    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
	      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
	        if (setPrototypeOf) {
	          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
	        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
	          defineBuiltIn(CurrentIteratorPrototype, ITERATOR, returnThis);
	        }
	      }
	      // Set @@toStringTag to native iterators
	      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
	      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
	    }
	  }

	  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
	  if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
	    if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) {
	      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
	    } else {
	      INCORRECT_VALUES_NAME = true;
	      defaultIterator = function values() { return call(nativeIterator, this); };
	    }
	  }

	  // export additional methods
	  if (DEFAULT) {
	    methods = {
	      values: getIterationMethod(VALUES),
	      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
	      entries: getIterationMethod(ENTRIES)
	    };
	    if (FORCED) for (KEY in methods) {
	      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
	        defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
	      }
	    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
	  }

	  // define iterator
	  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
	    defineBuiltIn(IterablePrototype, ITERATOR, defaultIterator, { name: DEFAULT });
	  }
	  Iterators[NAME] = defaultIterator;

	  return methods;
	};
	return iteratorDefine;
}

var createIterResultObject;
var hasRequiredCreateIterResultObject;

function requireCreateIterResultObject () {
	if (hasRequiredCreateIterResultObject) return createIterResultObject;
	hasRequiredCreateIterResultObject = 1;
	// `CreateIterResultObject` abstract operation
	// https://tc39.es/ecma262/#sec-createiterresultobject
	createIterResultObject = function (value, done) {
	  return { value: value, done: done };
	};
	return createIterResultObject;
}

var hasRequiredEs_string_iterator;

function requireEs_string_iterator () {
	if (hasRequiredEs_string_iterator) return es_string_iterator;
	hasRequiredEs_string_iterator = 1;
	var charAt = requireStringMultibyte().charAt;
	var toString = requireToString();
	var InternalStateModule = requireInternalState();
	var defineIterator = requireIteratorDefine();
	var createIterResultObject = requireCreateIterResultObject();

	var STRING_ITERATOR = 'String Iterator';
	var setInternalState = InternalStateModule.set;
	var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

	// `String.prototype[@@iterator]` method
	// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
	defineIterator(String, 'String', function (iterated) {
	  setInternalState(this, {
	    type: STRING_ITERATOR,
	    string: toString(iterated),
	    index: 0
	  });
	// `%StringIteratorPrototype%.next` method
	// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
	}, function next() {
	  var state = getInternalState(this);
	  var string = state.string;
	  var index = state.index;
	  var point;
	  if (index >= string.length) return createIterResultObject(undefined, true);
	  point = charAt(string, index);
	  state.index += point.length;
	  return createIterResultObject(point, false);
	});
	return es_string_iterator;
}

var urlConstructorDetection;
var hasRequiredUrlConstructorDetection;

function requireUrlConstructorDetection () {
	if (hasRequiredUrlConstructorDetection) return urlConstructorDetection;
	hasRequiredUrlConstructorDetection = 1;
	var fails = requireFails();
	var wellKnownSymbol = requireWellKnownSymbol();
	var DESCRIPTORS = requireDescriptors();
	var IS_PURE = requireIsPure();

	var ITERATOR = wellKnownSymbol('iterator');

	urlConstructorDetection = !fails(function () {
	  // eslint-disable-next-line unicorn/relative-url-style -- required for testing
	  var url = new URL('b?a=1&b=2&c=3', 'http://a');
	  var searchParams = url.searchParams;
	  var result = '';
	  url.pathname = 'c%20d';
	  searchParams.forEach(function (value, key) {
	    searchParams['delete']('b');
	    result += key + value;
	  });
	  return (IS_PURE && !url.toJSON)
	    || (!searchParams.size && (IS_PURE || !DESCRIPTORS))
	    || !searchParams.sort
	    || url.href !== 'http://a/c%20d?a=1&c=3'
	    || searchParams.get('c') !== '3'
	    || String(new URLSearchParams('?a=1')) !== 'a=1'
	    || !searchParams[ITERATOR]
	    // throws in Edge
	    || new URL('https://a@b').username !== 'a'
	    || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
	    // not punycoded in Edge
	    || new URL('http://тест').host !== 'xn--e1aybc'
	    // not escaped in Chrome 62-
	    || new URL('http://a#б').hash !== '#%D0%B1'
	    // fails in Chrome 66-
	    || result !== 'a1c3'
	    // throws in Safari
	    || new URL('http://x', undefined).host !== 'x';
	});
	return urlConstructorDetection;
}

var functionUncurryThisClause;
var hasRequiredFunctionUncurryThisClause;

function requireFunctionUncurryThisClause () {
	if (hasRequiredFunctionUncurryThisClause) return functionUncurryThisClause;
	hasRequiredFunctionUncurryThisClause = 1;
	var classofRaw = requireClassofRaw();
	var uncurryThis = requireFunctionUncurryThis();

	functionUncurryThisClause = function (fn) {
	  // Nashorn bug:
	  //   https://github.com/zloirock/core-js/issues/1128
	  //   https://github.com/zloirock/core-js/issues/1130
	  if (classofRaw(fn) === 'Function') return uncurryThis(fn);
	};
	return functionUncurryThisClause;
}

var functionBindContext;
var hasRequiredFunctionBindContext;

function requireFunctionBindContext () {
	if (hasRequiredFunctionBindContext) return functionBindContext;
	hasRequiredFunctionBindContext = 1;
	var uncurryThis = requireFunctionUncurryThisClause();
	var aCallable = requireACallable();
	var NATIVE_BIND = requireFunctionBindNative();

	var bind = uncurryThis(uncurryThis.bind);

	// optional / simple context binding
	functionBindContext = function (fn, that) {
	  aCallable(fn);
	  return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};
	return functionBindContext;
}

var defineBuiltInAccessor;
var hasRequiredDefineBuiltInAccessor;

function requireDefineBuiltInAccessor () {
	if (hasRequiredDefineBuiltInAccessor) return defineBuiltInAccessor;
	hasRequiredDefineBuiltInAccessor = 1;
	var makeBuiltIn = requireMakeBuiltIn();
	var defineProperty = requireObjectDefineProperty();

	defineBuiltInAccessor = function (target, name, descriptor) {
	  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
	  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
	  return defineProperty.f(target, name, descriptor);
	};
	return defineBuiltInAccessor;
}

var anInstance;
var hasRequiredAnInstance;

function requireAnInstance () {
	if (hasRequiredAnInstance) return anInstance;
	hasRequiredAnInstance = 1;
	var isPrototypeOf = requireObjectIsPrototypeOf();

	var $TypeError = TypeError;

	anInstance = function (it, Prototype) {
	  if (isPrototypeOf(Prototype, it)) return it;
	  throw $TypeError('Incorrect invocation');
	};
	return anInstance;
}

var objectAssign;
var hasRequiredObjectAssign;

function requireObjectAssign () {
	if (hasRequiredObjectAssign) return objectAssign;
	hasRequiredObjectAssign = 1;
	var DESCRIPTORS = requireDescriptors();
	var uncurryThis = requireFunctionUncurryThis();
	var call = requireFunctionCall();
	var fails = requireFails();
	var objectKeys = requireObjectKeys();
	var getOwnPropertySymbolsModule = requireObjectGetOwnPropertySymbols();
	var propertyIsEnumerableModule = requireObjectPropertyIsEnumerable();
	var toObject = requireToObject();
	var IndexedObject = requireIndexedObject();

	// eslint-disable-next-line es/no-object-assign -- safe
	var $assign = Object.assign;
	// eslint-disable-next-line es/no-object-defineproperty -- required for testing
	var defineProperty = Object.defineProperty;
	var concat = uncurryThis([].concat);

	// `Object.assign` method
	// https://tc39.es/ecma262/#sec-object.assign
	objectAssign = !$assign || fails(function () {
	  // should have correct order of operations (Edge bug)
	  if (DESCRIPTORS && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
	    enumerable: true,
	    get: function () {
	      defineProperty(this, 'b', {
	        value: 3,
	        enumerable: false
	      });
	    }
	  }), { b: 2 })).b !== 1) return true;
	  // should work with symbols and should have deterministic property order (V8 bug)
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line es/no-symbol -- safe
	  var symbol = Symbol();
	  var alphabet = 'abcdefghijklmnopqrst';
	  A[symbol] = 7;
	  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
	  return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
	  var T = toObject(target);
	  var argumentsLength = arguments.length;
	  var index = 1;
	  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
	  var propertyIsEnumerable = propertyIsEnumerableModule.f;
	  while (argumentsLength > index) {
	    var S = IndexedObject(arguments[index++]);
	    var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || call(propertyIsEnumerable, S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;
	return objectAssign;
}

var iteratorClose;
var hasRequiredIteratorClose;

function requireIteratorClose () {
	if (hasRequiredIteratorClose) return iteratorClose;
	hasRequiredIteratorClose = 1;
	var call = requireFunctionCall();
	var anObject = requireAnObject();
	var getMethod = requireGetMethod();

	iteratorClose = function (iterator, kind, value) {
	  var innerResult, innerError;
	  anObject(iterator);
	  try {
	    innerResult = getMethod(iterator, 'return');
	    if (!innerResult) {
	      if (kind === 'throw') throw value;
	      return value;
	    }
	    innerResult = call(innerResult, iterator);
	  } catch (error) {
	    innerError = true;
	    innerResult = error;
	  }
	  if (kind === 'throw') throw value;
	  if (innerError) throw innerResult;
	  anObject(innerResult);
	  return value;
	};
	return iteratorClose;
}

var callWithSafeIterationClosing;
var hasRequiredCallWithSafeIterationClosing;

function requireCallWithSafeIterationClosing () {
	if (hasRequiredCallWithSafeIterationClosing) return callWithSafeIterationClosing;
	hasRequiredCallWithSafeIterationClosing = 1;
	var anObject = requireAnObject();
	var iteratorClose = requireIteratorClose();

	// call something on iterator step with safe closing on error
	callWithSafeIterationClosing = function (iterator, fn, value, ENTRIES) {
	  try {
	    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
	  } catch (error) {
	    iteratorClose(iterator, 'throw', error);
	  }
	};
	return callWithSafeIterationClosing;
}

var isArrayIteratorMethod;
var hasRequiredIsArrayIteratorMethod;

function requireIsArrayIteratorMethod () {
	if (hasRequiredIsArrayIteratorMethod) return isArrayIteratorMethod;
	hasRequiredIsArrayIteratorMethod = 1;
	var wellKnownSymbol = requireWellKnownSymbol();
	var Iterators = requireIterators();

	var ITERATOR = wellKnownSymbol('iterator');
	var ArrayPrototype = Array.prototype;

	// check on default Array iterator
	isArrayIteratorMethod = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
	};
	return isArrayIteratorMethod;
}

var isConstructor;
var hasRequiredIsConstructor;

function requireIsConstructor () {
	if (hasRequiredIsConstructor) return isConstructor;
	hasRequiredIsConstructor = 1;
	var uncurryThis = requireFunctionUncurryThis();
	var fails = requireFails();
	var isCallable = requireIsCallable();
	var classof = requireClassof();
	var getBuiltIn = requireGetBuiltIn();
	var inspectSource = requireInspectSource();

	var noop = function () { /* empty */ };
	var empty = [];
	var construct = getBuiltIn('Reflect', 'construct');
	var constructorRegExp = /^\s*(?:class|function)\b/;
	var exec = uncurryThis(constructorRegExp.exec);
	var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

	var isConstructorModern = function isConstructor(argument) {
	  if (!isCallable(argument)) return false;
	  try {
	    construct(noop, empty, argument);
	    return true;
	  } catch (error) {
	    return false;
	  }
	};

	var isConstructorLegacy = function isConstructor(argument) {
	  if (!isCallable(argument)) return false;
	  switch (classof(argument)) {
	    case 'AsyncFunction':
	    case 'GeneratorFunction':
	    case 'AsyncGeneratorFunction': return false;
	  }
	  try {
	    // we can't check .prototype since constructors produced by .bind haven't it
	    // `Function#toString` throws on some built-it function in some legacy engines
	    // (for example, `DOMQuad` and similar in FF41-)
	    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
	  } catch (error) {
	    return true;
	  }
	};

	isConstructorLegacy.sham = true;

	// `IsConstructor` abstract operation
	// https://tc39.es/ecma262/#sec-isconstructor
	isConstructor = !construct || fails(function () {
	  var called;
	  return isConstructorModern(isConstructorModern.call)
	    || !isConstructorModern(Object)
	    || !isConstructorModern(function () { called = true; })
	    || called;
	}) ? isConstructorLegacy : isConstructorModern;
	return isConstructor;
}

var createProperty;
var hasRequiredCreateProperty;

function requireCreateProperty () {
	if (hasRequiredCreateProperty) return createProperty;
	hasRequiredCreateProperty = 1;
	var toPropertyKey = requireToPropertyKey();
	var definePropertyModule = requireObjectDefineProperty();
	var createPropertyDescriptor = requireCreatePropertyDescriptor();

	createProperty = function (object, key, value) {
	  var propertyKey = toPropertyKey(key);
	  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
	  else object[propertyKey] = value;
	};
	return createProperty;
}

var getIteratorMethod;
var hasRequiredGetIteratorMethod;

function requireGetIteratorMethod () {
	if (hasRequiredGetIteratorMethod) return getIteratorMethod;
	hasRequiredGetIteratorMethod = 1;
	var classof = requireClassof();
	var getMethod = requireGetMethod();
	var isNullOrUndefined = requireIsNullOrUndefined();
	var Iterators = requireIterators();
	var wellKnownSymbol = requireWellKnownSymbol();

	var ITERATOR = wellKnownSymbol('iterator');

	getIteratorMethod = function (it) {
	  if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR)
	    || getMethod(it, '@@iterator')
	    || Iterators[classof(it)];
	};
	return getIteratorMethod;
}

var getIterator;
var hasRequiredGetIterator;

function requireGetIterator () {
	if (hasRequiredGetIterator) return getIterator;
	hasRequiredGetIterator = 1;
	var call = requireFunctionCall();
	var aCallable = requireACallable();
	var anObject = requireAnObject();
	var tryToString = requireTryToString();
	var getIteratorMethod = requireGetIteratorMethod();

	var $TypeError = TypeError;

	getIterator = function (argument, usingIterator) {
	  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
	  if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
	  throw $TypeError(tryToString(argument) + ' is not iterable');
	};
	return getIterator;
}

var arrayFrom;
var hasRequiredArrayFrom;

function requireArrayFrom () {
	if (hasRequiredArrayFrom) return arrayFrom;
	hasRequiredArrayFrom = 1;
	var bind = requireFunctionBindContext();
	var call = requireFunctionCall();
	var toObject = requireToObject();
	var callWithSafeIterationClosing = requireCallWithSafeIterationClosing();
	var isArrayIteratorMethod = requireIsArrayIteratorMethod();
	var isConstructor = requireIsConstructor();
	var lengthOfArrayLike = requireLengthOfArrayLike();
	var createProperty = requireCreateProperty();
	var getIterator = requireGetIterator();
	var getIteratorMethod = requireGetIteratorMethod();

	var $Array = Array;

	// `Array.from` method implementation
	// https://tc39.es/ecma262/#sec-array.from
	arrayFrom = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	  var O = toObject(arrayLike);
	  var IS_CONSTRUCTOR = isConstructor(this);
	  var argumentsLength = arguments.length;
	  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
	  var mapping = mapfn !== undefined;
	  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
	  var iteratorMethod = getIteratorMethod(O);
	  var index = 0;
	  var length, result, step, iterator, next, value;
	  // if the target is not iterable or it's an array with the default iterator - use a simple case
	  if (iteratorMethod && !(this === $Array && isArrayIteratorMethod(iteratorMethod))) {
	    iterator = getIterator(O, iteratorMethod);
	    next = iterator.next;
	    result = IS_CONSTRUCTOR ? new this() : [];
	    for (;!(step = call(next, iterator)).done; index++) {
	      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
	      createProperty(result, index, value);
	    }
	  } else {
	    length = lengthOfArrayLike(O);
	    result = IS_CONSTRUCTOR ? new this(length) : $Array(length);
	    for (;length > index; index++) {
	      value = mapping ? mapfn(O[index], index) : O[index];
	      createProperty(result, index, value);
	    }
	  }
	  result.length = index;
	  return result;
	};
	return arrayFrom;
}

var arraySliceSimple;
var hasRequiredArraySliceSimple;

function requireArraySliceSimple () {
	if (hasRequiredArraySliceSimple) return arraySliceSimple;
	hasRequiredArraySliceSimple = 1;
	var toAbsoluteIndex = requireToAbsoluteIndex();
	var lengthOfArrayLike = requireLengthOfArrayLike();
	var createProperty = requireCreateProperty();

	var $Array = Array;
	var max = Math.max;

	arraySliceSimple = function (O, start, end) {
	  var length = lengthOfArrayLike(O);
	  var k = toAbsoluteIndex(start, length);
	  var fin = toAbsoluteIndex(end === undefined ? length : end, length);
	  var result = $Array(max(fin - k, 0));
	  for (var n = 0; k < fin; k++, n++) createProperty(result, n, O[k]);
	  result.length = n;
	  return result;
	};
	return arraySliceSimple;
}

var stringPunycodeToAscii;
var hasRequiredStringPunycodeToAscii;

function requireStringPunycodeToAscii () {
	if (hasRequiredStringPunycodeToAscii) return stringPunycodeToAscii;
	hasRequiredStringPunycodeToAscii = 1;
	// based on https://github.com/bestiejs/punycode.js/blob/master/punycode.js
	var uncurryThis = requireFunctionUncurryThis();

	var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
	var base = 36;
	var tMin = 1;
	var tMax = 26;
	var skew = 38;
	var damp = 700;
	var initialBias = 72;
	var initialN = 128; // 0x80
	var delimiter = '-'; // '\x2D'
	var regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
	var regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
	var OVERFLOW_ERROR = 'Overflow: input needs wider integers to process';
	var baseMinusTMin = base - tMin;

	var $RangeError = RangeError;
	var exec = uncurryThis(regexSeparators.exec);
	var floor = Math.floor;
	var fromCharCode = String.fromCharCode;
	var charCodeAt = uncurryThis(''.charCodeAt);
	var join = uncurryThis([].join);
	var push = uncurryThis([].push);
	var replace = uncurryThis(''.replace);
	var split = uncurryThis(''.split);
	var toLowerCase = uncurryThis(''.toLowerCase);

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 */
	var ucs2decode = function (string) {
	  var output = [];
	  var counter = 0;
	  var length = string.length;
	  while (counter < length) {
	    var value = charCodeAt(string, counter++);
	    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
	      // It's a high surrogate, and there is a next character.
	      var extra = charCodeAt(string, counter++);
	      if ((extra & 0xFC00) == 0xDC00) { // Low surrogate.
	        push(output, ((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
	      } else {
	        // It's an unmatched surrogate; only append this code unit, in case the
	        // next code unit is the high surrogate of a surrogate pair.
	        push(output, value);
	        counter--;
	      }
	    } else {
	      push(output, value);
	    }
	  }
	  return output;
	};

	/**
	 * Converts a digit/integer into a basic code point.
	 */
	var digitToBasic = function (digit) {
	  //  0..25 map to ASCII a..z or A..Z
	  // 26..35 map to ASCII 0..9
	  return digit + 22 + 75 * (digit < 26);
	};

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 */
	var adapt = function (delta, numPoints, firstTime) {
	  var k = 0;
	  delta = firstTime ? floor(delta / damp) : delta >> 1;
	  delta += floor(delta / numPoints);
	  while (delta > baseMinusTMin * tMax >> 1) {
	    delta = floor(delta / baseMinusTMin);
	    k += base;
	  }
	  return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	};

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 */
	var encode = function (input) {
	  var output = [];

	  // Convert the input in UCS-2 to an array of Unicode code points.
	  input = ucs2decode(input);

	  // Cache the length.
	  var inputLength = input.length;

	  // Initialize the state.
	  var n = initialN;
	  var delta = 0;
	  var bias = initialBias;
	  var i, currentValue;

	  // Handle the basic code points.
	  for (i = 0; i < input.length; i++) {
	    currentValue = input[i];
	    if (currentValue < 0x80) {
	      push(output, fromCharCode(currentValue));
	    }
	  }

	  var basicLength = output.length; // number of basic code points.
	  var handledCPCount = basicLength; // number of code points that have been handled;

	  // Finish the basic string with a delimiter unless it's empty.
	  if (basicLength) {
	    push(output, delimiter);
	  }

	  // Main encoding loop:
	  while (handledCPCount < inputLength) {
	    // All non-basic code points < n have been handled already. Find the next larger one:
	    var m = maxInt;
	    for (i = 0; i < input.length; i++) {
	      currentValue = input[i];
	      if (currentValue >= n && currentValue < m) {
	        m = currentValue;
	      }
	    }

	    // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
	    var handledCPCountPlusOne = handledCPCount + 1;
	    if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
	      throw $RangeError(OVERFLOW_ERROR);
	    }

	    delta += (m - n) * handledCPCountPlusOne;
	    n = m;

	    for (i = 0; i < input.length; i++) {
	      currentValue = input[i];
	      if (currentValue < n && ++delta > maxInt) {
	        throw $RangeError(OVERFLOW_ERROR);
	      }
	      if (currentValue == n) {
	        // Represent delta as a generalized variable-length integer.
	        var q = delta;
	        var k = base;
	        while (true) {
	          var t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
	          if (q < t) break;
	          var qMinusT = q - t;
	          var baseMinusT = base - t;
	          push(output, fromCharCode(digitToBasic(t + qMinusT % baseMinusT)));
	          q = floor(qMinusT / baseMinusT);
	          k += base;
	        }

	        push(output, fromCharCode(digitToBasic(q)));
	        bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
	        delta = 0;
	        handledCPCount++;
	      }
	    }

	    delta++;
	    n++;
	  }
	  return join(output, '');
	};

	stringPunycodeToAscii = function (input) {
	  var encoded = [];
	  var labels = split(replace(toLowerCase(input), regexSeparators, '\u002E'), '.');
	  var i, label;
	  for (i = 0; i < labels.length; i++) {
	    label = labels[i];
	    push(encoded, exec(regexNonASCII, label) ? 'xn--' + encode(label) : label);
	  }
	  return join(encoded, '.');
	};
	return stringPunycodeToAscii;
}

var validateArgumentsLength;
var hasRequiredValidateArgumentsLength;

function requireValidateArgumentsLength () {
	if (hasRequiredValidateArgumentsLength) return validateArgumentsLength;
	hasRequiredValidateArgumentsLength = 1;
	var $TypeError = TypeError;

	validateArgumentsLength = function (passed, required) {
	  if (passed < required) throw $TypeError('Not enough arguments');
	  return passed;
	};
	return validateArgumentsLength;
}

var addToUnscopables;
var hasRequiredAddToUnscopables;

function requireAddToUnscopables () {
	if (hasRequiredAddToUnscopables) return addToUnscopables;
	hasRequiredAddToUnscopables = 1;
	var wellKnownSymbol = requireWellKnownSymbol();
	var create = requireObjectCreate();
	var defineProperty = requireObjectDefineProperty().f;

	var UNSCOPABLES = wellKnownSymbol('unscopables');
	var ArrayPrototype = Array.prototype;

	// Array.prototype[@@unscopables]
	// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
	if (ArrayPrototype[UNSCOPABLES] == undefined) {
	  defineProperty(ArrayPrototype, UNSCOPABLES, {
	    configurable: true,
	    value: create(null)
	  });
	}

	// add a key to Array.prototype[@@unscopables]
	addToUnscopables = function (key) {
	  ArrayPrototype[UNSCOPABLES][key] = true;
	};
	return addToUnscopables;
}

var es_array_iterator;
var hasRequiredEs_array_iterator;

function requireEs_array_iterator () {
	if (hasRequiredEs_array_iterator) return es_array_iterator;
	hasRequiredEs_array_iterator = 1;
	var toIndexedObject = requireToIndexedObject();
	var addToUnscopables = requireAddToUnscopables();
	var Iterators = requireIterators();
	var InternalStateModule = requireInternalState();
	var defineProperty = requireObjectDefineProperty().f;
	var defineIterator = requireIteratorDefine();
	var createIterResultObject = requireCreateIterResultObject();
	var IS_PURE = requireIsPure();
	var DESCRIPTORS = requireDescriptors();

	var ARRAY_ITERATOR = 'Array Iterator';
	var setInternalState = InternalStateModule.set;
	var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

	// `Array.prototype.entries` method
	// https://tc39.es/ecma262/#sec-array.prototype.entries
	// `Array.prototype.keys` method
	// https://tc39.es/ecma262/#sec-array.prototype.keys
	// `Array.prototype.values` method
	// https://tc39.es/ecma262/#sec-array.prototype.values
	// `Array.prototype[@@iterator]` method
	// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
	// `CreateArrayIterator` internal method
	// https://tc39.es/ecma262/#sec-createarrayiterator
	es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
	  setInternalState(this, {
	    type: ARRAY_ITERATOR,
	    target: toIndexedObject(iterated), // target
	    index: 0,                          // next index
	    kind: kind                         // kind
	  });
	// `%ArrayIteratorPrototype%.next` method
	// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
	}, function () {
	  var state = getInternalState(this);
	  var target = state.target;
	  var kind = state.kind;
	  var index = state.index++;
	  if (!target || index >= target.length) {
	    state.target = undefined;
	    return createIterResultObject(undefined, true);
	  }
	  if (kind == 'keys') return createIterResultObject(index, false);
	  if (kind == 'values') return createIterResultObject(target[index], false);
	  return createIterResultObject([index, target[index]], false);
	}, 'values');

	// argumentsList[@@iterator] is %ArrayProto_values%
	// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
	// https://tc39.es/ecma262/#sec-createmappedargumentsobject
	var values = Iterators.Arguments = Iterators.Array;

	// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');

	// V8 ~ Chrome 45- bug
	if (!IS_PURE && DESCRIPTORS && values.name !== 'values') try {
	  defineProperty(values, 'name', { value: 'values' });
	} catch (error) { /* empty */ }
	return es_array_iterator;
}

var defineBuiltIns;
var hasRequiredDefineBuiltIns;

function requireDefineBuiltIns () {
	if (hasRequiredDefineBuiltIns) return defineBuiltIns;
	hasRequiredDefineBuiltIns = 1;
	var defineBuiltIn = requireDefineBuiltIn();

	defineBuiltIns = function (target, src, options) {
	  for (var key in src) defineBuiltIn(target, key, src[key], options);
	  return target;
	};
	return defineBuiltIns;
}

var arraySort;
var hasRequiredArraySort;

function requireArraySort () {
	if (hasRequiredArraySort) return arraySort;
	hasRequiredArraySort = 1;
	var arraySlice = requireArraySliceSimple();

	var floor = Math.floor;

	var mergeSort = function (array, comparefn) {
	  var length = array.length;
	  var middle = floor(length / 2);
	  return length < 8 ? insertionSort(array, comparefn) : merge(
	    array,
	    mergeSort(arraySlice(array, 0, middle), comparefn),
	    mergeSort(arraySlice(array, middle), comparefn),
	    comparefn
	  );
	};

	var insertionSort = function (array, comparefn) {
	  var length = array.length;
	  var i = 1;
	  var element, j;

	  while (i < length) {
	    j = i;
	    element = array[i];
	    while (j && comparefn(array[j - 1], element) > 0) {
	      array[j] = array[--j];
	    }
	    if (j !== i++) array[j] = element;
	  } return array;
	};

	var merge = function (array, left, right, comparefn) {
	  var llength = left.length;
	  var rlength = right.length;
	  var lindex = 0;
	  var rindex = 0;

	  while (lindex < llength || rindex < rlength) {
	    array[lindex + rindex] = (lindex < llength && rindex < rlength)
	      ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]
	      : lindex < llength ? left[lindex++] : right[rindex++];
	  } return array;
	};

	arraySort = mergeSort;
	return arraySort;
}

var web_urlSearchParams_constructor;
var hasRequiredWeb_urlSearchParams_constructor;

function requireWeb_urlSearchParams_constructor () {
	if (hasRequiredWeb_urlSearchParams_constructor) return web_urlSearchParams_constructor;
	hasRequiredWeb_urlSearchParams_constructor = 1;
	// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
	requireEs_array_iterator();
	var $ = require_export();
	var global = requireGlobal();
	var call = requireFunctionCall();
	var uncurryThis = requireFunctionUncurryThis();
	var DESCRIPTORS = requireDescriptors();
	var USE_NATIVE_URL = requireUrlConstructorDetection();
	var defineBuiltIn = requireDefineBuiltIn();
	var defineBuiltInAccessor = requireDefineBuiltInAccessor();
	var defineBuiltIns = requireDefineBuiltIns();
	var setToStringTag = requireSetToStringTag();
	var createIteratorConstructor = requireIteratorCreateConstructor();
	var InternalStateModule = requireInternalState();
	var anInstance = requireAnInstance();
	var isCallable = requireIsCallable();
	var hasOwn = requireHasOwnProperty();
	var bind = requireFunctionBindContext();
	var classof = requireClassof();
	var anObject = requireAnObject();
	var isObject = requireIsObject();
	var $toString = requireToString();
	var create = requireObjectCreate();
	var createPropertyDescriptor = requireCreatePropertyDescriptor();
	var getIterator = requireGetIterator();
	var getIteratorMethod = requireGetIteratorMethod();
	var validateArgumentsLength = requireValidateArgumentsLength();
	var wellKnownSymbol = requireWellKnownSymbol();
	var arraySort = requireArraySort();

	var ITERATOR = wellKnownSymbol('iterator');
	var URL_SEARCH_PARAMS = 'URLSearchParams';
	var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
	var setInternalState = InternalStateModule.set;
	var getInternalParamsState = InternalStateModule.getterFor(URL_SEARCH_PARAMS);
	var getInternalIteratorState = InternalStateModule.getterFor(URL_SEARCH_PARAMS_ITERATOR);
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

	// Avoid NodeJS experimental warning
	var safeGetBuiltIn = function (name) {
	  if (!DESCRIPTORS) return global[name];
	  var descriptor = getOwnPropertyDescriptor(global, name);
	  return descriptor && descriptor.value;
	};

	var nativeFetch = safeGetBuiltIn('fetch');
	var NativeRequest = safeGetBuiltIn('Request');
	var Headers = safeGetBuiltIn('Headers');
	var RequestPrototype = NativeRequest && NativeRequest.prototype;
	var HeadersPrototype = Headers && Headers.prototype;
	var RegExp = global.RegExp;
	var TypeError = global.TypeError;
	var decodeURIComponent = global.decodeURIComponent;
	var encodeURIComponent = global.encodeURIComponent;
	var charAt = uncurryThis(''.charAt);
	var join = uncurryThis([].join);
	var push = uncurryThis([].push);
	var replace = uncurryThis(''.replace);
	var shift = uncurryThis([].shift);
	var splice = uncurryThis([].splice);
	var split = uncurryThis(''.split);
	var stringSlice = uncurryThis(''.slice);

	var plus = /\+/g;
	var sequences = Array(4);

	var percentSequence = function (bytes) {
	  return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
	};

	var percentDecode = function (sequence) {
	  try {
	    return decodeURIComponent(sequence);
	  } catch (error) {
	    return sequence;
	  }
	};

	var deserialize = function (it) {
	  var result = replace(it, plus, ' ');
	  var bytes = 4;
	  try {
	    return decodeURIComponent(result);
	  } catch (error) {
	    while (bytes) {
	      result = replace(result, percentSequence(bytes--), percentDecode);
	    }
	    return result;
	  }
	};

	var find = /[!'()~]|%20/g;

	var replacements = {
	  '!': '%21',
	  "'": '%27',
	  '(': '%28',
	  ')': '%29',
	  '~': '%7E',
	  '%20': '+'
	};

	var replacer = function (match) {
	  return replacements[match];
	};

	var serialize = function (it) {
	  return replace(encodeURIComponent(it), find, replacer);
	};

	var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
	  setInternalState(this, {
	    type: URL_SEARCH_PARAMS_ITERATOR,
	    iterator: getIterator(getInternalParamsState(params).entries),
	    kind: kind
	  });
	}, 'Iterator', function next() {
	  var state = getInternalIteratorState(this);
	  var kind = state.kind;
	  var step = state.iterator.next();
	  var entry = step.value;
	  if (!step.done) {
	    step.value = kind === 'keys' ? entry.key : kind === 'values' ? entry.value : [entry.key, entry.value];
	  } return step;
	}, true);

	var URLSearchParamsState = function (init) {
	  this.entries = [];
	  this.url = null;

	  if (init !== undefined) {
	    if (isObject(init)) this.parseObject(init);
	    else this.parseQuery(typeof init == 'string' ? charAt(init, 0) === '?' ? stringSlice(init, 1) : init : $toString(init));
	  }
	};

	URLSearchParamsState.prototype = {
	  type: URL_SEARCH_PARAMS,
	  bindURL: function (url) {
	    this.url = url;
	    this.update();
	  },
	  parseObject: function (object) {
	    var iteratorMethod = getIteratorMethod(object);
	    var iterator, next, step, entryIterator, entryNext, first, second;

	    if (iteratorMethod) {
	      iterator = getIterator(object, iteratorMethod);
	      next = iterator.next;
	      while (!(step = call(next, iterator)).done) {
	        entryIterator = getIterator(anObject(step.value));
	        entryNext = entryIterator.next;
	        if (
	          (first = call(entryNext, entryIterator)).done ||
	          (second = call(entryNext, entryIterator)).done ||
	          !call(entryNext, entryIterator).done
	        ) throw TypeError('Expected sequence with length 2');
	        push(this.entries, { key: $toString(first.value), value: $toString(second.value) });
	      }
	    } else for (var key in object) if (hasOwn(object, key)) {
	      push(this.entries, { key: key, value: $toString(object[key]) });
	    }
	  },
	  parseQuery: function (query) {
	    if (query) {
	      var attributes = split(query, '&');
	      var index = 0;
	      var attribute, entry;
	      while (index < attributes.length) {
	        attribute = attributes[index++];
	        if (attribute.length) {
	          entry = split(attribute, '=');
	          push(this.entries, {
	            key: deserialize(shift(entry)),
	            value: deserialize(join(entry, '='))
	          });
	        }
	      }
	    }
	  },
	  serialize: function () {
	    var entries = this.entries;
	    var result = [];
	    var index = 0;
	    var entry;
	    while (index < entries.length) {
	      entry = entries[index++];
	      push(result, serialize(entry.key) + '=' + serialize(entry.value));
	    } return join(result, '&');
	  },
	  update: function () {
	    this.entries.length = 0;
	    this.parseQuery(this.url.query);
	  },
	  updateURL: function () {
	    if (this.url) this.url.update();
	  }
	};

	// `URLSearchParams` constructor
	// https://url.spec.whatwg.org/#interface-urlsearchparams
	var URLSearchParamsConstructor = function URLSearchParams(/* init */) {
	  anInstance(this, URLSearchParamsPrototype);
	  var init = arguments.length > 0 ? arguments[0] : undefined;
	  var state = setInternalState(this, new URLSearchParamsState(init));
	  if (!DESCRIPTORS) this.length = state.entries.length;
	};

	var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;

	defineBuiltIns(URLSearchParamsPrototype, {
	  // `URLSearchParams.prototype.append` method
	  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
	  append: function append(name, value) {
	    validateArgumentsLength(arguments.length, 2);
	    var state = getInternalParamsState(this);
	    push(state.entries, { key: $toString(name), value: $toString(value) });
	    if (!DESCRIPTORS) this.length++;
	    state.updateURL();
	  },
	  // `URLSearchParams.prototype.delete` method
	  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
	  'delete': function (name) {
	    validateArgumentsLength(arguments.length, 1);
	    var state = getInternalParamsState(this);
	    var entries = state.entries;
	    var key = $toString(name);
	    var index = 0;
	    while (index < entries.length) {
	      if (entries[index].key === key) splice(entries, index, 1);
	      else index++;
	    }
	    if (!DESCRIPTORS) this.length = entries.length;
	    state.updateURL();
	  },
	  // `URLSearchParams.prototype.get` method
	  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
	  get: function get(name) {
	    validateArgumentsLength(arguments.length, 1);
	    var entries = getInternalParamsState(this).entries;
	    var key = $toString(name);
	    var index = 0;
	    for (; index < entries.length; index++) {
	      if (entries[index].key === key) return entries[index].value;
	    }
	    return null;
	  },
	  // `URLSearchParams.prototype.getAll` method
	  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
	  getAll: function getAll(name) {
	    validateArgumentsLength(arguments.length, 1);
	    var entries = getInternalParamsState(this).entries;
	    var key = $toString(name);
	    var result = [];
	    var index = 0;
	    for (; index < entries.length; index++) {
	      if (entries[index].key === key) push(result, entries[index].value);
	    }
	    return result;
	  },
	  // `URLSearchParams.prototype.has` method
	  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
	  has: function has(name) {
	    validateArgumentsLength(arguments.length, 1);
	    var entries = getInternalParamsState(this).entries;
	    var key = $toString(name);
	    var index = 0;
	    while (index < entries.length) {
	      if (entries[index++].key === key) return true;
	    }
	    return false;
	  },
	  // `URLSearchParams.prototype.set` method
	  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
	  set: function set(name, value) {
	    validateArgumentsLength(arguments.length, 1);
	    var state = getInternalParamsState(this);
	    var entries = state.entries;
	    var found = false;
	    var key = $toString(name);
	    var val = $toString(value);
	    var index = 0;
	    var entry;
	    for (; index < entries.length; index++) {
	      entry = entries[index];
	      if (entry.key === key) {
	        if (found) splice(entries, index--, 1);
	        else {
	          found = true;
	          entry.value = val;
	        }
	      }
	    }
	    if (!found) push(entries, { key: key, value: val });
	    if (!DESCRIPTORS) this.length = entries.length;
	    state.updateURL();
	  },
	  // `URLSearchParams.prototype.sort` method
	  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
	  sort: function sort() {
	    var state = getInternalParamsState(this);
	    arraySort(state.entries, function (a, b) {
	      return a.key > b.key ? 1 : -1;
	    });
	    state.updateURL();
	  },
	  // `URLSearchParams.prototype.forEach` method
	  forEach: function forEach(callback /* , thisArg */) {
	    var entries = getInternalParamsState(this).entries;
	    var boundFunction = bind(callback, arguments.length > 1 ? arguments[1] : undefined);
	    var index = 0;
	    var entry;
	    while (index < entries.length) {
	      entry = entries[index++];
	      boundFunction(entry.value, entry.key, this);
	    }
	  },
	  // `URLSearchParams.prototype.keys` method
	  keys: function keys() {
	    return new URLSearchParamsIterator(this, 'keys');
	  },
	  // `URLSearchParams.prototype.values` method
	  values: function values() {
	    return new URLSearchParamsIterator(this, 'values');
	  },
	  // `URLSearchParams.prototype.entries` method
	  entries: function entries() {
	    return new URLSearchParamsIterator(this, 'entries');
	  }
	}, { enumerable: true });

	// `URLSearchParams.prototype[@@iterator]` method
	defineBuiltIn(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries, { name: 'entries' });

	// `URLSearchParams.prototype.toString` method
	// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
	defineBuiltIn(URLSearchParamsPrototype, 'toString', function toString() {
	  return getInternalParamsState(this).serialize();
	}, { enumerable: true });

	// `URLSearchParams.prototype.size` getter
	// https://github.com/whatwg/url/pull/734
	if (DESCRIPTORS) defineBuiltInAccessor(URLSearchParamsPrototype, 'size', {
	  get: function size() {
	    return getInternalParamsState(this).entries.length;
	  },
	  configurable: true,
	  enumerable: true
	});

	setToStringTag(URLSearchParamsConstructor, URL_SEARCH_PARAMS);

	$({ global: true, constructor: true, forced: !USE_NATIVE_URL }, {
	  URLSearchParams: URLSearchParamsConstructor
	});

	// Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
	if (!USE_NATIVE_URL && isCallable(Headers)) {
	  var headersHas = uncurryThis(HeadersPrototype.has);
	  var headersSet = uncurryThis(HeadersPrototype.set);

	  var wrapRequestOptions = function (init) {
	    if (isObject(init)) {
	      var body = init.body;
	      var headers;
	      if (classof(body) === URL_SEARCH_PARAMS) {
	        headers = init.headers ? new Headers(init.headers) : new Headers();
	        if (!headersHas(headers, 'content-type')) {
	          headersSet(headers, 'content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
	        }
	        return create(init, {
	          body: createPropertyDescriptor(0, $toString(body)),
	          headers: createPropertyDescriptor(0, headers)
	        });
	      }
	    } return init;
	  };

	  if (isCallable(nativeFetch)) {
	    $({ global: true, enumerable: true, dontCallGetSet: true, forced: true }, {
	      fetch: function fetch(input /* , init */) {
	        return nativeFetch(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
	      }
	    });
	  }

	  if (isCallable(NativeRequest)) {
	    var RequestConstructor = function Request(input /* , init */) {
	      anInstance(this, RequestPrototype);
	      return new NativeRequest(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
	    };

	    RequestPrototype.constructor = RequestConstructor;
	    RequestConstructor.prototype = RequestPrototype;

	    $({ global: true, constructor: true, dontCallGetSet: true, forced: true }, {
	      Request: RequestConstructor
	    });
	  }
	}

	web_urlSearchParams_constructor = {
	  URLSearchParams: URLSearchParamsConstructor,
	  getState: getInternalParamsState
	};
	return web_urlSearchParams_constructor;
}

var hasRequiredWeb_url_constructor;

function requireWeb_url_constructor () {
	if (hasRequiredWeb_url_constructor) return web_url_constructor;
	hasRequiredWeb_url_constructor = 1;
	// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
	requireEs_string_iterator();
	var $ = require_export();
	var DESCRIPTORS = requireDescriptors();
	var USE_NATIVE_URL = requireUrlConstructorDetection();
	var global = requireGlobal();
	var bind = requireFunctionBindContext();
	var uncurryThis = requireFunctionUncurryThis();
	var defineBuiltIn = requireDefineBuiltIn();
	var defineBuiltInAccessor = requireDefineBuiltInAccessor();
	var anInstance = requireAnInstance();
	var hasOwn = requireHasOwnProperty();
	var assign = requireObjectAssign();
	var arrayFrom = requireArrayFrom();
	var arraySlice = requireArraySliceSimple();
	var codeAt = requireStringMultibyte().codeAt;
	var toASCII = requireStringPunycodeToAscii();
	var $toString = requireToString();
	var setToStringTag = requireSetToStringTag();
	var validateArgumentsLength = requireValidateArgumentsLength();
	var URLSearchParamsModule = requireWeb_urlSearchParams_constructor();
	var InternalStateModule = requireInternalState();

	var setInternalState = InternalStateModule.set;
	var getInternalURLState = InternalStateModule.getterFor('URL');
	var URLSearchParams = URLSearchParamsModule.URLSearchParams;
	var getInternalSearchParamsState = URLSearchParamsModule.getState;

	var NativeURL = global.URL;
	var TypeError = global.TypeError;
	var parseInt = global.parseInt;
	var floor = Math.floor;
	var pow = Math.pow;
	var charAt = uncurryThis(''.charAt);
	var exec = uncurryThis(/./.exec);
	var join = uncurryThis([].join);
	var numberToString = uncurryThis(1.0.toString);
	var pop = uncurryThis([].pop);
	var push = uncurryThis([].push);
	var replace = uncurryThis(''.replace);
	var shift = uncurryThis([].shift);
	var split = uncurryThis(''.split);
	var stringSlice = uncurryThis(''.slice);
	var toLowerCase = uncurryThis(''.toLowerCase);
	var unshift = uncurryThis([].unshift);

	var INVALID_AUTHORITY = 'Invalid authority';
	var INVALID_SCHEME = 'Invalid scheme';
	var INVALID_HOST = 'Invalid host';
	var INVALID_PORT = 'Invalid port';

	var ALPHA = /[a-z]/i;
	// eslint-disable-next-line regexp/no-obscure-range -- safe
	var ALPHANUMERIC = /[\d+-.a-z]/i;
	var DIGIT = /\d/;
	var HEX_START = /^0x/i;
	var OCT = /^[0-7]+$/;
	var DEC = /^\d+$/;
	var HEX = /^[\da-f]+$/i;
	/* eslint-disable regexp/no-control-character -- safe */
	var FORBIDDEN_HOST_CODE_POINT = /[\0\t\n\r #%/:<>?@[\\\]^|]/;
	var FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\0\t\n\r #/:<>?@[\\\]^|]/;
	var LEADING_C0_CONTROL_OR_SPACE = /^[\u0000-\u0020]+/;
	var TRAILING_C0_CONTROL_OR_SPACE = /(^|[^\u0000-\u0020])[\u0000-\u0020]+$/;
	var TAB_AND_NEW_LINE = /[\t\n\r]/g;
	/* eslint-enable regexp/no-control-character -- safe */
	var EOF;

	// https://url.spec.whatwg.org/#ipv4-number-parser
	var parseIPv4 = function (input) {
	  var parts = split(input, '.');
	  var partsLength, numbers, index, part, radix, number, ipv4;
	  if (parts.length && parts[parts.length - 1] == '') {
	    parts.length--;
	  }
	  partsLength = parts.length;
	  if (partsLength > 4) return input;
	  numbers = [];
	  for (index = 0; index < partsLength; index++) {
	    part = parts[index];
	    if (part == '') return input;
	    radix = 10;
	    if (part.length > 1 && charAt(part, 0) == '0') {
	      radix = exec(HEX_START, part) ? 16 : 8;
	      part = stringSlice(part, radix == 8 ? 1 : 2);
	    }
	    if (part === '') {
	      number = 0;
	    } else {
	      if (!exec(radix == 10 ? DEC : radix == 8 ? OCT : HEX, part)) return input;
	      number = parseInt(part, radix);
	    }
	    push(numbers, number);
	  }
	  for (index = 0; index < partsLength; index++) {
	    number = numbers[index];
	    if (index == partsLength - 1) {
	      if (number >= pow(256, 5 - partsLength)) return null;
	    } else if (number > 255) return null;
	  }
	  ipv4 = pop(numbers);
	  for (index = 0; index < numbers.length; index++) {
	    ipv4 += numbers[index] * pow(256, 3 - index);
	  }
	  return ipv4;
	};

	// https://url.spec.whatwg.org/#concept-ipv6-parser
	// eslint-disable-next-line max-statements -- TODO
	var parseIPv6 = function (input) {
	  var address = [0, 0, 0, 0, 0, 0, 0, 0];
	  var pieceIndex = 0;
	  var compress = null;
	  var pointer = 0;
	  var value, length, numbersSeen, ipv4Piece, number, swaps, swap;

	  var chr = function () {
	    return charAt(input, pointer);
	  };

	  if (chr() == ':') {
	    if (charAt(input, 1) != ':') return;
	    pointer += 2;
	    pieceIndex++;
	    compress = pieceIndex;
	  }
	  while (chr()) {
	    if (pieceIndex == 8) return;
	    if (chr() == ':') {
	      if (compress !== null) return;
	      pointer++;
	      pieceIndex++;
	      compress = pieceIndex;
	      continue;
	    }
	    value = length = 0;
	    while (length < 4 && exec(HEX, chr())) {
	      value = value * 16 + parseInt(chr(), 16);
	      pointer++;
	      length++;
	    }
	    if (chr() == '.') {
	      if (length == 0) return;
	      pointer -= length;
	      if (pieceIndex > 6) return;
	      numbersSeen = 0;
	      while (chr()) {
	        ipv4Piece = null;
	        if (numbersSeen > 0) {
	          if (chr() == '.' && numbersSeen < 4) pointer++;
	          else return;
	        }
	        if (!exec(DIGIT, chr())) return;
	        while (exec(DIGIT, chr())) {
	          number = parseInt(chr(), 10);
	          if (ipv4Piece === null) ipv4Piece = number;
	          else if (ipv4Piece == 0) return;
	          else ipv4Piece = ipv4Piece * 10 + number;
	          if (ipv4Piece > 255) return;
	          pointer++;
	        }
	        address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
	        numbersSeen++;
	        if (numbersSeen == 2 || numbersSeen == 4) pieceIndex++;
	      }
	      if (numbersSeen != 4) return;
	      break;
	    } else if (chr() == ':') {
	      pointer++;
	      if (!chr()) return;
	    } else if (chr()) return;
	    address[pieceIndex++] = value;
	  }
	  if (compress !== null) {
	    swaps = pieceIndex - compress;
	    pieceIndex = 7;
	    while (pieceIndex != 0 && swaps > 0) {
	      swap = address[pieceIndex];
	      address[pieceIndex--] = address[compress + swaps - 1];
	      address[compress + --swaps] = swap;
	    }
	  } else if (pieceIndex != 8) return;
	  return address;
	};

	var findLongestZeroSequence = function (ipv6) {
	  var maxIndex = null;
	  var maxLength = 1;
	  var currStart = null;
	  var currLength = 0;
	  var index = 0;
	  for (; index < 8; index++) {
	    if (ipv6[index] !== 0) {
	      if (currLength > maxLength) {
	        maxIndex = currStart;
	        maxLength = currLength;
	      }
	      currStart = null;
	      currLength = 0;
	    } else {
	      if (currStart === null) currStart = index;
	      ++currLength;
	    }
	  }
	  if (currLength > maxLength) {
	    maxIndex = currStart;
	    maxLength = currLength;
	  }
	  return maxIndex;
	};

	// https://url.spec.whatwg.org/#host-serializing
	var serializeHost = function (host) {
	  var result, index, compress, ignore0;
	  // ipv4
	  if (typeof host == 'number') {
	    result = [];
	    for (index = 0; index < 4; index++) {
	      unshift(result, host % 256);
	      host = floor(host / 256);
	    } return join(result, '.');
	  // ipv6
	  } else if (typeof host == 'object') {
	    result = '';
	    compress = findLongestZeroSequence(host);
	    for (index = 0; index < 8; index++) {
	      if (ignore0 && host[index] === 0) continue;
	      if (ignore0) ignore0 = false;
	      if (compress === index) {
	        result += index ? ':' : '::';
	        ignore0 = true;
	      } else {
	        result += numberToString(host[index], 16);
	        if (index < 7) result += ':';
	      }
	    }
	    return '[' + result + ']';
	  } return host;
	};

	var C0ControlPercentEncodeSet = {};
	var fragmentPercentEncodeSet = assign({}, C0ControlPercentEncodeSet, {
	  ' ': 1, '"': 1, '<': 1, '>': 1, '`': 1
	});
	var pathPercentEncodeSet = assign({}, fragmentPercentEncodeSet, {
	  '#': 1, '?': 1, '{': 1, '}': 1
	});
	var userinfoPercentEncodeSet = assign({}, pathPercentEncodeSet, {
	  '/': 1, ':': 1, ';': 1, '=': 1, '@': 1, '[': 1, '\\': 1, ']': 1, '^': 1, '|': 1
	});

	var percentEncode = function (chr, set) {
	  var code = codeAt(chr, 0);
	  return code > 0x20 && code < 0x7F && !hasOwn(set, chr) ? chr : encodeURIComponent(chr);
	};

	// https://url.spec.whatwg.org/#special-scheme
	var specialSchemes = {
	  ftp: 21,
	  file: null,
	  http: 80,
	  https: 443,
	  ws: 80,
	  wss: 443
	};

	// https://url.spec.whatwg.org/#windows-drive-letter
	var isWindowsDriveLetter = function (string, normalized) {
	  var second;
	  return string.length == 2 && exec(ALPHA, charAt(string, 0))
	    && ((second = charAt(string, 1)) == ':' || (!normalized && second == '|'));
	};

	// https://url.spec.whatwg.org/#start-with-a-windows-drive-letter
	var startsWithWindowsDriveLetter = function (string) {
	  var third;
	  return string.length > 1 && isWindowsDriveLetter(stringSlice(string, 0, 2)) && (
	    string.length == 2 ||
	    ((third = charAt(string, 2)) === '/' || third === '\\' || third === '?' || third === '#')
	  );
	};

	// https://url.spec.whatwg.org/#single-dot-path-segment
	var isSingleDot = function (segment) {
	  return segment === '.' || toLowerCase(segment) === '%2e';
	};

	// https://url.spec.whatwg.org/#double-dot-path-segment
	var isDoubleDot = function (segment) {
	  segment = toLowerCase(segment);
	  return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
	};

	// States:
	var SCHEME_START = {};
	var SCHEME = {};
	var NO_SCHEME = {};
	var SPECIAL_RELATIVE_OR_AUTHORITY = {};
	var PATH_OR_AUTHORITY = {};
	var RELATIVE = {};
	var RELATIVE_SLASH = {};
	var SPECIAL_AUTHORITY_SLASHES = {};
	var SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
	var AUTHORITY = {};
	var HOST = {};
	var HOSTNAME = {};
	var PORT = {};
	var FILE = {};
	var FILE_SLASH = {};
	var FILE_HOST = {};
	var PATH_START = {};
	var PATH = {};
	var CANNOT_BE_A_BASE_URL_PATH = {};
	var QUERY = {};
	var FRAGMENT = {};

	var URLState = function (url, isBase, base) {
	  var urlString = $toString(url);
	  var baseState, failure, searchParams;
	  if (isBase) {
	    failure = this.parse(urlString);
	    if (failure) throw TypeError(failure);
	    this.searchParams = null;
	  } else {
	    if (base !== undefined) baseState = new URLState(base, true);
	    failure = this.parse(urlString, null, baseState);
	    if (failure) throw TypeError(failure);
	    searchParams = getInternalSearchParamsState(new URLSearchParams());
	    searchParams.bindURL(this);
	    this.searchParams = searchParams;
	  }
	};

	URLState.prototype = {
	  type: 'URL',
	  // https://url.spec.whatwg.org/#url-parsing
	  // eslint-disable-next-line max-statements -- TODO
	  parse: function (input, stateOverride, base) {
	    var url = this;
	    var state = stateOverride || SCHEME_START;
	    var pointer = 0;
	    var buffer = '';
	    var seenAt = false;
	    var seenBracket = false;
	    var seenPasswordToken = false;
	    var codePoints, chr, bufferCodePoints, failure;

	    input = $toString(input);

	    if (!stateOverride) {
	      url.scheme = '';
	      url.username = '';
	      url.password = '';
	      url.host = null;
	      url.port = null;
	      url.path = [];
	      url.query = null;
	      url.fragment = null;
	      url.cannotBeABaseURL = false;
	      input = replace(input, LEADING_C0_CONTROL_OR_SPACE, '');
	      input = replace(input, TRAILING_C0_CONTROL_OR_SPACE, '$1');
	    }

	    input = replace(input, TAB_AND_NEW_LINE, '');

	    codePoints = arrayFrom(input);

	    while (pointer <= codePoints.length) {
	      chr = codePoints[pointer];
	      switch (state) {
	        case SCHEME_START:
	          if (chr && exec(ALPHA, chr)) {
	            buffer += toLowerCase(chr);
	            state = SCHEME;
	          } else if (!stateOverride) {
	            state = NO_SCHEME;
	            continue;
	          } else return INVALID_SCHEME;
	          break;

	        case SCHEME:
	          if (chr && (exec(ALPHANUMERIC, chr) || chr == '+' || chr == '-' || chr == '.')) {
	            buffer += toLowerCase(chr);
	          } else if (chr == ':') {
	            if (stateOverride && (
	              (url.isSpecial() != hasOwn(specialSchemes, buffer)) ||
	              (buffer == 'file' && (url.includesCredentials() || url.port !== null)) ||
	              (url.scheme == 'file' && !url.host)
	            )) return;
	            url.scheme = buffer;
	            if (stateOverride) {
	              if (url.isSpecial() && specialSchemes[url.scheme] == url.port) url.port = null;
	              return;
	            }
	            buffer = '';
	            if (url.scheme == 'file') {
	              state = FILE;
	            } else if (url.isSpecial() && base && base.scheme == url.scheme) {
	              state = SPECIAL_RELATIVE_OR_AUTHORITY;
	            } else if (url.isSpecial()) {
	              state = SPECIAL_AUTHORITY_SLASHES;
	            } else if (codePoints[pointer + 1] == '/') {
	              state = PATH_OR_AUTHORITY;
	              pointer++;
	            } else {
	              url.cannotBeABaseURL = true;
	              push(url.path, '');
	              state = CANNOT_BE_A_BASE_URL_PATH;
	            }
	          } else if (!stateOverride) {
	            buffer = '';
	            state = NO_SCHEME;
	            pointer = 0;
	            continue;
	          } else return INVALID_SCHEME;
	          break;

	        case NO_SCHEME:
	          if (!base || (base.cannotBeABaseURL && chr != '#')) return INVALID_SCHEME;
	          if (base.cannotBeABaseURL && chr == '#') {
	            url.scheme = base.scheme;
	            url.path = arraySlice(base.path);
	            url.query = base.query;
	            url.fragment = '';
	            url.cannotBeABaseURL = true;
	            state = FRAGMENT;
	            break;
	          }
	          state = base.scheme == 'file' ? FILE : RELATIVE;
	          continue;

	        case SPECIAL_RELATIVE_OR_AUTHORITY:
	          if (chr == '/' && codePoints[pointer + 1] == '/') {
	            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
	            pointer++;
	          } else {
	            state = RELATIVE;
	            continue;
	          } break;

	        case PATH_OR_AUTHORITY:
	          if (chr == '/') {
	            state = AUTHORITY;
	            break;
	          } else {
	            state = PATH;
	            continue;
	          }

	        case RELATIVE:
	          url.scheme = base.scheme;
	          if (chr == EOF) {
	            url.username = base.username;
	            url.password = base.password;
	            url.host = base.host;
	            url.port = base.port;
	            url.path = arraySlice(base.path);
	            url.query = base.query;
	          } else if (chr == '/' || (chr == '\\' && url.isSpecial())) {
	            state = RELATIVE_SLASH;
	          } else if (chr == '?') {
	            url.username = base.username;
	            url.password = base.password;
	            url.host = base.host;
	            url.port = base.port;
	            url.path = arraySlice(base.path);
	            url.query = '';
	            state = QUERY;
	          } else if (chr == '#') {
	            url.username = base.username;
	            url.password = base.password;
	            url.host = base.host;
	            url.port = base.port;
	            url.path = arraySlice(base.path);
	            url.query = base.query;
	            url.fragment = '';
	            state = FRAGMENT;
	          } else {
	            url.username = base.username;
	            url.password = base.password;
	            url.host = base.host;
	            url.port = base.port;
	            url.path = arraySlice(base.path);
	            url.path.length--;
	            state = PATH;
	            continue;
	          } break;

	        case RELATIVE_SLASH:
	          if (url.isSpecial() && (chr == '/' || chr == '\\')) {
	            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
	          } else if (chr == '/') {
	            state = AUTHORITY;
	          } else {
	            url.username = base.username;
	            url.password = base.password;
	            url.host = base.host;
	            url.port = base.port;
	            state = PATH;
	            continue;
	          } break;

	        case SPECIAL_AUTHORITY_SLASHES:
	          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
	          if (chr != '/' || charAt(buffer, pointer + 1) != '/') continue;
	          pointer++;
	          break;

	        case SPECIAL_AUTHORITY_IGNORE_SLASHES:
	          if (chr != '/' && chr != '\\') {
	            state = AUTHORITY;
	            continue;
	          } break;

	        case AUTHORITY:
	          if (chr == '@') {
	            if (seenAt) buffer = '%40' + buffer;
	            seenAt = true;
	            bufferCodePoints = arrayFrom(buffer);
	            for (var i = 0; i < bufferCodePoints.length; i++) {
	              var codePoint = bufferCodePoints[i];
	              if (codePoint == ':' && !seenPasswordToken) {
	                seenPasswordToken = true;
	                continue;
	              }
	              var encodedCodePoints = percentEncode(codePoint, userinfoPercentEncodeSet);
	              if (seenPasswordToken) url.password += encodedCodePoints;
	              else url.username += encodedCodePoints;
	            }
	            buffer = '';
	          } else if (
	            chr == EOF || chr == '/' || chr == '?' || chr == '#' ||
	            (chr == '\\' && url.isSpecial())
	          ) {
	            if (seenAt && buffer == '') return INVALID_AUTHORITY;
	            pointer -= arrayFrom(buffer).length + 1;
	            buffer = '';
	            state = HOST;
	          } else buffer += chr;
	          break;

	        case HOST:
	        case HOSTNAME:
	          if (stateOverride && url.scheme == 'file') {
	            state = FILE_HOST;
	            continue;
	          } else if (chr == ':' && !seenBracket) {
	            if (buffer == '') return INVALID_HOST;
	            failure = url.parseHost(buffer);
	            if (failure) return failure;
	            buffer = '';
	            state = PORT;
	            if (stateOverride == HOSTNAME) return;
	          } else if (
	            chr == EOF || chr == '/' || chr == '?' || chr == '#' ||
	            (chr == '\\' && url.isSpecial())
	          ) {
	            if (url.isSpecial() && buffer == '') return INVALID_HOST;
	            if (stateOverride && buffer == '' && (url.includesCredentials() || url.port !== null)) return;
	            failure = url.parseHost(buffer);
	            if (failure) return failure;
	            buffer = '';
	            state = PATH_START;
	            if (stateOverride) return;
	            continue;
	          } else {
	            if (chr == '[') seenBracket = true;
	            else if (chr == ']') seenBracket = false;
	            buffer += chr;
	          } break;

	        case PORT:
	          if (exec(DIGIT, chr)) {
	            buffer += chr;
	          } else if (
	            chr == EOF || chr == '/' || chr == '?' || chr == '#' ||
	            (chr == '\\' && url.isSpecial()) ||
	            stateOverride
	          ) {
	            if (buffer != '') {
	              var port = parseInt(buffer, 10);
	              if (port > 0xFFFF) return INVALID_PORT;
	              url.port = (url.isSpecial() && port === specialSchemes[url.scheme]) ? null : port;
	              buffer = '';
	            }
	            if (stateOverride) return;
	            state = PATH_START;
	            continue;
	          } else return INVALID_PORT;
	          break;

	        case FILE:
	          url.scheme = 'file';
	          if (chr == '/' || chr == '\\') state = FILE_SLASH;
	          else if (base && base.scheme == 'file') {
	            if (chr == EOF) {
	              url.host = base.host;
	              url.path = arraySlice(base.path);
	              url.query = base.query;
	            } else if (chr == '?') {
	              url.host = base.host;
	              url.path = arraySlice(base.path);
	              url.query = '';
	              state = QUERY;
	            } else if (chr == '#') {
	              url.host = base.host;
	              url.path = arraySlice(base.path);
	              url.query = base.query;
	              url.fragment = '';
	              state = FRAGMENT;
	            } else {
	              if (!startsWithWindowsDriveLetter(join(arraySlice(codePoints, pointer), ''))) {
	                url.host = base.host;
	                url.path = arraySlice(base.path);
	                url.shortenPath();
	              }
	              state = PATH;
	              continue;
	            }
	          } else {
	            state = PATH;
	            continue;
	          } break;

	        case FILE_SLASH:
	          if (chr == '/' || chr == '\\') {
	            state = FILE_HOST;
	            break;
	          }
	          if (base && base.scheme == 'file' && !startsWithWindowsDriveLetter(join(arraySlice(codePoints, pointer), ''))) {
	            if (isWindowsDriveLetter(base.path[0], true)) push(url.path, base.path[0]);
	            else url.host = base.host;
	          }
	          state = PATH;
	          continue;

	        case FILE_HOST:
	          if (chr == EOF || chr == '/' || chr == '\\' || chr == '?' || chr == '#') {
	            if (!stateOverride && isWindowsDriveLetter(buffer)) {
	              state = PATH;
	            } else if (buffer == '') {
	              url.host = '';
	              if (stateOverride) return;
	              state = PATH_START;
	            } else {
	              failure = url.parseHost(buffer);
	              if (failure) return failure;
	              if (url.host == 'localhost') url.host = '';
	              if (stateOverride) return;
	              buffer = '';
	              state = PATH_START;
	            } continue;
	          } else buffer += chr;
	          break;

	        case PATH_START:
	          if (url.isSpecial()) {
	            state = PATH;
	            if (chr != '/' && chr != '\\') continue;
	          } else if (!stateOverride && chr == '?') {
	            url.query = '';
	            state = QUERY;
	          } else if (!stateOverride && chr == '#') {
	            url.fragment = '';
	            state = FRAGMENT;
	          } else if (chr != EOF) {
	            state = PATH;
	            if (chr != '/') continue;
	          } break;

	        case PATH:
	          if (
	            chr == EOF || chr == '/' ||
	            (chr == '\\' && url.isSpecial()) ||
	            (!stateOverride && (chr == '?' || chr == '#'))
	          ) {
	            if (isDoubleDot(buffer)) {
	              url.shortenPath();
	              if (chr != '/' && !(chr == '\\' && url.isSpecial())) {
	                push(url.path, '');
	              }
	            } else if (isSingleDot(buffer)) {
	              if (chr != '/' && !(chr == '\\' && url.isSpecial())) {
	                push(url.path, '');
	              }
	            } else {
	              if (url.scheme == 'file' && !url.path.length && isWindowsDriveLetter(buffer)) {
	                if (url.host) url.host = '';
	                buffer = charAt(buffer, 0) + ':'; // normalize windows drive letter
	              }
	              push(url.path, buffer);
	            }
	            buffer = '';
	            if (url.scheme == 'file' && (chr == EOF || chr == '?' || chr == '#')) {
	              while (url.path.length > 1 && url.path[0] === '') {
	                shift(url.path);
	              }
	            }
	            if (chr == '?') {
	              url.query = '';
	              state = QUERY;
	            } else if (chr == '#') {
	              url.fragment = '';
	              state = FRAGMENT;
	            }
	          } else {
	            buffer += percentEncode(chr, pathPercentEncodeSet);
	          } break;

	        case CANNOT_BE_A_BASE_URL_PATH:
	          if (chr == '?') {
	            url.query = '';
	            state = QUERY;
	          } else if (chr == '#') {
	            url.fragment = '';
	            state = FRAGMENT;
	          } else if (chr != EOF) {
	            url.path[0] += percentEncode(chr, C0ControlPercentEncodeSet);
	          } break;

	        case QUERY:
	          if (!stateOverride && chr == '#') {
	            url.fragment = '';
	            state = FRAGMENT;
	          } else if (chr != EOF) {
	            if (chr == "'" && url.isSpecial()) url.query += '%27';
	            else if (chr == '#') url.query += '%23';
	            else url.query += percentEncode(chr, C0ControlPercentEncodeSet);
	          } break;

	        case FRAGMENT:
	          if (chr != EOF) url.fragment += percentEncode(chr, fragmentPercentEncodeSet);
	          break;
	      }

	      pointer++;
	    }
	  },
	  // https://url.spec.whatwg.org/#host-parsing
	  parseHost: function (input) {
	    var result, codePoints, index;
	    if (charAt(input, 0) == '[') {
	      if (charAt(input, input.length - 1) != ']') return INVALID_HOST;
	      result = parseIPv6(stringSlice(input, 1, -1));
	      if (!result) return INVALID_HOST;
	      this.host = result;
	    // opaque host
	    } else if (!this.isSpecial()) {
	      if (exec(FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT, input)) return INVALID_HOST;
	      result = '';
	      codePoints = arrayFrom(input);
	      for (index = 0; index < codePoints.length; index++) {
	        result += percentEncode(codePoints[index], C0ControlPercentEncodeSet);
	      }
	      this.host = result;
	    } else {
	      input = toASCII(input);
	      if (exec(FORBIDDEN_HOST_CODE_POINT, input)) return INVALID_HOST;
	      result = parseIPv4(input);
	      if (result === null) return INVALID_HOST;
	      this.host = result;
	    }
	  },
	  // https://url.spec.whatwg.org/#cannot-have-a-username-password-port
	  cannotHaveUsernamePasswordPort: function () {
	    return !this.host || this.cannotBeABaseURL || this.scheme == 'file';
	  },
	  // https://url.spec.whatwg.org/#include-credentials
	  includesCredentials: function () {
	    return this.username != '' || this.password != '';
	  },
	  // https://url.spec.whatwg.org/#is-special
	  isSpecial: function () {
	    return hasOwn(specialSchemes, this.scheme);
	  },
	  // https://url.spec.whatwg.org/#shorten-a-urls-path
	  shortenPath: function () {
	    var path = this.path;
	    var pathSize = path.length;
	    if (pathSize && (this.scheme != 'file' || pathSize != 1 || !isWindowsDriveLetter(path[0], true))) {
	      path.length--;
	    }
	  },
	  // https://url.spec.whatwg.org/#concept-url-serializer
	  serialize: function () {
	    var url = this;
	    var scheme = url.scheme;
	    var username = url.username;
	    var password = url.password;
	    var host = url.host;
	    var port = url.port;
	    var path = url.path;
	    var query = url.query;
	    var fragment = url.fragment;
	    var output = scheme + ':';
	    if (host !== null) {
	      output += '//';
	      if (url.includesCredentials()) {
	        output += username + (password ? ':' + password : '') + '@';
	      }
	      output += serializeHost(host);
	      if (port !== null) output += ':' + port;
	    } else if (scheme == 'file') output += '//';
	    output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + join(path, '/') : '';
	    if (query !== null) output += '?' + query;
	    if (fragment !== null) output += '#' + fragment;
	    return output;
	  },
	  // https://url.spec.whatwg.org/#dom-url-href
	  setHref: function (href) {
	    var failure = this.parse(href);
	    if (failure) throw TypeError(failure);
	    this.searchParams.update();
	  },
	  // https://url.spec.whatwg.org/#dom-url-origin
	  getOrigin: function () {
	    var scheme = this.scheme;
	    var port = this.port;
	    if (scheme == 'blob') try {
	      return new URLConstructor(scheme.path[0]).origin;
	    } catch (error) {
	      return 'null';
	    }
	    if (scheme == 'file' || !this.isSpecial()) return 'null';
	    return scheme + '://' + serializeHost(this.host) + (port !== null ? ':' + port : '');
	  },
	  // https://url.spec.whatwg.org/#dom-url-protocol
	  getProtocol: function () {
	    return this.scheme + ':';
	  },
	  setProtocol: function (protocol) {
	    this.parse($toString(protocol) + ':', SCHEME_START);
	  },
	  // https://url.spec.whatwg.org/#dom-url-username
	  getUsername: function () {
	    return this.username;
	  },
	  setUsername: function (username) {
	    var codePoints = arrayFrom($toString(username));
	    if (this.cannotHaveUsernamePasswordPort()) return;
	    this.username = '';
	    for (var i = 0; i < codePoints.length; i++) {
	      this.username += percentEncode(codePoints[i], userinfoPercentEncodeSet);
	    }
	  },
	  // https://url.spec.whatwg.org/#dom-url-password
	  getPassword: function () {
	    return this.password;
	  },
	  setPassword: function (password) {
	    var codePoints = arrayFrom($toString(password));
	    if (this.cannotHaveUsernamePasswordPort()) return;
	    this.password = '';
	    for (var i = 0; i < codePoints.length; i++) {
	      this.password += percentEncode(codePoints[i], userinfoPercentEncodeSet);
	    }
	  },
	  // https://url.spec.whatwg.org/#dom-url-host
	  getHost: function () {
	    var host = this.host;
	    var port = this.port;
	    return host === null ? ''
	      : port === null ? serializeHost(host)
	      : serializeHost(host) + ':' + port;
	  },
	  setHost: function (host) {
	    if (this.cannotBeABaseURL) return;
	    this.parse(host, HOST);
	  },
	  // https://url.spec.whatwg.org/#dom-url-hostname
	  getHostname: function () {
	    var host = this.host;
	    return host === null ? '' : serializeHost(host);
	  },
	  setHostname: function (hostname) {
	    if (this.cannotBeABaseURL) return;
	    this.parse(hostname, HOSTNAME);
	  },
	  // https://url.spec.whatwg.org/#dom-url-port
	  getPort: function () {
	    var port = this.port;
	    return port === null ? '' : $toString(port);
	  },
	  setPort: function (port) {
	    if (this.cannotHaveUsernamePasswordPort()) return;
	    port = $toString(port);
	    if (port == '') this.port = null;
	    else this.parse(port, PORT);
	  },
	  // https://url.spec.whatwg.org/#dom-url-pathname
	  getPathname: function () {
	    var path = this.path;
	    return this.cannotBeABaseURL ? path[0] : path.length ? '/' + join(path, '/') : '';
	  },
	  setPathname: function (pathname) {
	    if (this.cannotBeABaseURL) return;
	    this.path = [];
	    this.parse(pathname, PATH_START);
	  },
	  // https://url.spec.whatwg.org/#dom-url-search
	  getSearch: function () {
	    var query = this.query;
	    return query ? '?' + query : '';
	  },
	  setSearch: function (search) {
	    search = $toString(search);
	    if (search == '') {
	      this.query = null;
	    } else {
	      if ('?' == charAt(search, 0)) search = stringSlice(search, 1);
	      this.query = '';
	      this.parse(search, QUERY);
	    }
	    this.searchParams.update();
	  },
	  // https://url.spec.whatwg.org/#dom-url-searchparams
	  getSearchParams: function () {
	    return this.searchParams.facade;
	  },
	  // https://url.spec.whatwg.org/#dom-url-hash
	  getHash: function () {
	    var fragment = this.fragment;
	    return fragment ? '#' + fragment : '';
	  },
	  setHash: function (hash) {
	    hash = $toString(hash);
	    if (hash == '') {
	      this.fragment = null;
	      return;
	    }
	    if ('#' == charAt(hash, 0)) hash = stringSlice(hash, 1);
	    this.fragment = '';
	    this.parse(hash, FRAGMENT);
	  },
	  update: function () {
	    this.query = this.searchParams.serialize() || null;
	  }
	};

	// `URL` constructor
	// https://url.spec.whatwg.org/#url-class
	var URLConstructor = function URL(url /* , base */) {
	  var that = anInstance(this, URLPrototype);
	  var base = validateArgumentsLength(arguments.length, 1) > 1 ? arguments[1] : undefined;
	  var state = setInternalState(that, new URLState(url, false, base));
	  if (!DESCRIPTORS) {
	    that.href = state.serialize();
	    that.origin = state.getOrigin();
	    that.protocol = state.getProtocol();
	    that.username = state.getUsername();
	    that.password = state.getPassword();
	    that.host = state.getHost();
	    that.hostname = state.getHostname();
	    that.port = state.getPort();
	    that.pathname = state.getPathname();
	    that.search = state.getSearch();
	    that.searchParams = state.getSearchParams();
	    that.hash = state.getHash();
	  }
	};

	var URLPrototype = URLConstructor.prototype;

	var accessorDescriptor = function (getter, setter) {
	  return {
	    get: function () {
	      return getInternalURLState(this)[getter]();
	    },
	    set: setter && function (value) {
	      return getInternalURLState(this)[setter](value);
	    },
	    configurable: true,
	    enumerable: true
	  };
	};

	if (DESCRIPTORS) {
	  // `URL.prototype.href` accessors pair
	  // https://url.spec.whatwg.org/#dom-url-href
	  defineBuiltInAccessor(URLPrototype, 'href', accessorDescriptor('serialize', 'setHref'));
	  // `URL.prototype.origin` getter
	  // https://url.spec.whatwg.org/#dom-url-origin
	  defineBuiltInAccessor(URLPrototype, 'origin', accessorDescriptor('getOrigin'));
	  // `URL.prototype.protocol` accessors pair
	  // https://url.spec.whatwg.org/#dom-url-protocol
	  defineBuiltInAccessor(URLPrototype, 'protocol', accessorDescriptor('getProtocol', 'setProtocol'));
	  // `URL.prototype.username` accessors pair
	  // https://url.spec.whatwg.org/#dom-url-username
	  defineBuiltInAccessor(URLPrototype, 'username', accessorDescriptor('getUsername', 'setUsername'));
	  // `URL.prototype.password` accessors pair
	  // https://url.spec.whatwg.org/#dom-url-password
	  defineBuiltInAccessor(URLPrototype, 'password', accessorDescriptor('getPassword', 'setPassword'));
	  // `URL.prototype.host` accessors pair
	  // https://url.spec.whatwg.org/#dom-url-host
	  defineBuiltInAccessor(URLPrototype, 'host', accessorDescriptor('getHost', 'setHost'));
	  // `URL.prototype.hostname` accessors pair
	  // https://url.spec.whatwg.org/#dom-url-hostname
	  defineBuiltInAccessor(URLPrototype, 'hostname', accessorDescriptor('getHostname', 'setHostname'));
	  // `URL.prototype.port` accessors pair
	  // https://url.spec.whatwg.org/#dom-url-port
	  defineBuiltInAccessor(URLPrototype, 'port', accessorDescriptor('getPort', 'setPort'));
	  // `URL.prototype.pathname` accessors pair
	  // https://url.spec.whatwg.org/#dom-url-pathname
	  defineBuiltInAccessor(URLPrototype, 'pathname', accessorDescriptor('getPathname', 'setPathname'));
	  // `URL.prototype.search` accessors pair
	  // https://url.spec.whatwg.org/#dom-url-search
	  defineBuiltInAccessor(URLPrototype, 'search', accessorDescriptor('getSearch', 'setSearch'));
	  // `URL.prototype.searchParams` getter
	  // https://url.spec.whatwg.org/#dom-url-searchparams
	  defineBuiltInAccessor(URLPrototype, 'searchParams', accessorDescriptor('getSearchParams'));
	  // `URL.prototype.hash` accessors pair
	  // https://url.spec.whatwg.org/#dom-url-hash
	  defineBuiltInAccessor(URLPrototype, 'hash', accessorDescriptor('getHash', 'setHash'));
	}

	// `URL.prototype.toJSON` method
	// https://url.spec.whatwg.org/#dom-url-tojson
	defineBuiltIn(URLPrototype, 'toJSON', function toJSON() {
	  return getInternalURLState(this).serialize();
	}, { enumerable: true });

	// `URL.prototype.toString` method
	// https://url.spec.whatwg.org/#URL-stringification-behavior
	defineBuiltIn(URLPrototype, 'toString', function toString() {
	  return getInternalURLState(this).serialize();
	}, { enumerable: true });

	if (NativeURL) {
	  var nativeCreateObjectURL = NativeURL.createObjectURL;
	  var nativeRevokeObjectURL = NativeURL.revokeObjectURL;
	  // `URL.createObjectURL` method
	  // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
	  if (nativeCreateObjectURL) defineBuiltIn(URLConstructor, 'createObjectURL', bind(nativeCreateObjectURL, NativeURL));
	  // `URL.revokeObjectURL` method
	  // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
	  if (nativeRevokeObjectURL) defineBuiltIn(URLConstructor, 'revokeObjectURL', bind(nativeRevokeObjectURL, NativeURL));
	}

	setToStringTag(URLConstructor, 'URL');

	$({ global: true, constructor: true, forced: !USE_NATIVE_URL, sham: !DESCRIPTORS }, {
	  URL: URLConstructor
	});
	return web_url_constructor;
}

var hasRequiredWeb_url;

function requireWeb_url () {
	if (hasRequiredWeb_url) return web_url;
	hasRequiredWeb_url = 1;
	// TODO: Remove this module from `core-js@4` since it's replaced to module below
	requireWeb_url_constructor();
	return web_url;
}

var web_url_canParse = {};

var hasRequiredWeb_url_canParse;

function requireWeb_url_canParse () {
	if (hasRequiredWeb_url_canParse) return web_url_canParse;
	hasRequiredWeb_url_canParse = 1;
	var $ = require_export();
	var getBuiltIn = requireGetBuiltIn();
	var validateArgumentsLength = requireValidateArgumentsLength();
	var toString = requireToString();

	var URL = getBuiltIn('URL');

	// `URL.canParse` method
	// https://url.spec.whatwg.org/#dom-url-canparse
	$({ target: 'URL', stat: true }, {
	  canParse: function canParse(url) {
	    var length = validateArgumentsLength(arguments.length, 1);
	    var urlString = toString(url);
	    var base = length < 2 || arguments[1] === undefined ? undefined : toString(arguments[1]);
	    try {
	      return !!new URL(urlString, base);
	    } catch (error) {
	      return false;
	    }
	  }
	});
	return web_url_canParse;
}

var web_url_toJson = {};

var hasRequiredWeb_url_toJson;

function requireWeb_url_toJson () {
	if (hasRequiredWeb_url_toJson) return web_url_toJson;
	hasRequiredWeb_url_toJson = 1;
	var $ = require_export();
	var call = requireFunctionCall();

	// `URL.prototype.toJSON` method
	// https://url.spec.whatwg.org/#dom-url-tojson
	$({ target: 'URL', proto: true, enumerable: true }, {
	  toJSON: function toJSON() {
	    return call(URL.prototype.toString, this);
	  }
	});
	return web_url_toJson;
}

var web_urlSearchParams = {};

var hasRequiredWeb_urlSearchParams;

function requireWeb_urlSearchParams () {
	if (hasRequiredWeb_urlSearchParams) return web_urlSearchParams;
	hasRequiredWeb_urlSearchParams = 1;
	// TODO: Remove this module from `core-js@4` since it's replaced to module below
	requireWeb_urlSearchParams_constructor();
	return web_urlSearchParams;
}

var web_urlSearchParams_size = {};

var hasRequiredWeb_urlSearchParams_size;

function requireWeb_urlSearchParams_size () {
	if (hasRequiredWeb_urlSearchParams_size) return web_urlSearchParams_size;
	hasRequiredWeb_urlSearchParams_size = 1;
	var DESCRIPTORS = requireDescriptors();
	var uncurryThis = requireFunctionUncurryThis();
	var defineBuiltInAccessor = requireDefineBuiltInAccessor();

	var URLSearchParamsPrototype = URLSearchParams.prototype;
	var forEach = uncurryThis(URLSearchParamsPrototype.forEach);

	// `URLSearchParams.prototype.size` getter
	// https://github.com/whatwg/url/pull/734
	if (DESCRIPTORS && !('size' in URLSearchParamsPrototype)) {
	  defineBuiltInAccessor(URLSearchParamsPrototype, 'size', {
	    get: function size() {
	      var count = 0;
	      forEach(this, function () { count++; });
	      return count;
	    },
	    configurable: true,
	    enumerable: true
	  });
	}
	return web_urlSearchParams_size;
}

var path;
var hasRequiredPath;

function requirePath () {
	if (hasRequiredPath) return path;
	hasRequiredPath = 1;
	var global = requireGlobal();

	path = global;
	return path;
}

var url$4;
var hasRequiredUrl$4;

function requireUrl$4 () {
	if (hasRequiredUrl$4) return url$4;
	hasRequiredUrl$4 = 1;
	requireWeb_url();
	requireWeb_url_canParse();
	requireWeb_url_toJson();
	requireWeb_urlSearchParams();
	requireWeb_urlSearchParams_size();
	var path = requirePath();

	url$4 = path.URL;
	return url$4;
}

var url$3;
var hasRequiredUrl$3;

function requireUrl$3 () {
	if (hasRequiredUrl$3) return url$3;
	hasRequiredUrl$3 = 1;
	var parent = requireUrl$4();

	url$3 = parent;
	return url$3;
}

var url$2;
var hasRequiredUrl$2;

function requireUrl$2 () {
	if (hasRequiredUrl$2) return url$2;
	hasRequiredUrl$2 = 1;
	var parent = requireUrl$3();

	url$2 = parent;
	return url$2;
}

var url$1;
var hasRequiredUrl$1;

function requireUrl$1 () {
	if (hasRequiredUrl$1) return url$1;
	hasRequiredUrl$1 = 1;
	var parent = requireUrl$2();

	url$1 = parent;
	return url$1;
}

var url;
var hasRequiredUrl;

function requireUrl () {
	if (hasRequiredUrl) return url;
	hasRequiredUrl = 1;
	url = requireUrl$1();
	return url;
}

requireUrl();

var es_array_find = {};

var isArray;
var hasRequiredIsArray;

function requireIsArray () {
	if (hasRequiredIsArray) return isArray;
	hasRequiredIsArray = 1;
	var classof = requireClassofRaw();

	// `IsArray` abstract operation
	// https://tc39.es/ecma262/#sec-isarray
	// eslint-disable-next-line es/no-array-isarray -- safe
	isArray = Array.isArray || function isArray(argument) {
	  return classof(argument) == 'Array';
	};
	return isArray;
}

var arraySpeciesConstructor;
var hasRequiredArraySpeciesConstructor;

function requireArraySpeciesConstructor () {
	if (hasRequiredArraySpeciesConstructor) return arraySpeciesConstructor;
	hasRequiredArraySpeciesConstructor = 1;
	var isArray = requireIsArray();
	var isConstructor = requireIsConstructor();
	var isObject = requireIsObject();
	var wellKnownSymbol = requireWellKnownSymbol();

	var SPECIES = wellKnownSymbol('species');
	var $Array = Array;

	// a part of `ArraySpeciesCreate` abstract operation
	// https://tc39.es/ecma262/#sec-arrayspeciescreate
	arraySpeciesConstructor = function (originalArray) {
	  var C;
	  if (isArray(originalArray)) {
	    C = originalArray.constructor;
	    // cross-realm fallback
	    if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;
	    else if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? $Array : C;
	};
	return arraySpeciesConstructor;
}

var arraySpeciesCreate;
var hasRequiredArraySpeciesCreate;

function requireArraySpeciesCreate () {
	if (hasRequiredArraySpeciesCreate) return arraySpeciesCreate;
	hasRequiredArraySpeciesCreate = 1;
	var arraySpeciesConstructor = requireArraySpeciesConstructor();

	// `ArraySpeciesCreate` abstract operation
	// https://tc39.es/ecma262/#sec-arrayspeciescreate
	arraySpeciesCreate = function (originalArray, length) {
	  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
	};
	return arraySpeciesCreate;
}

var arrayIteration;
var hasRequiredArrayIteration;

function requireArrayIteration () {
	if (hasRequiredArrayIteration) return arrayIteration;
	hasRequiredArrayIteration = 1;
	var bind = requireFunctionBindContext();
	var uncurryThis = requireFunctionUncurryThis();
	var IndexedObject = requireIndexedObject();
	var toObject = requireToObject();
	var lengthOfArrayLike = requireLengthOfArrayLike();
	var arraySpeciesCreate = requireArraySpeciesCreate();

	var push = uncurryThis([].push);

	// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
	var createMethod = function (TYPE) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var IS_FILTER_REJECT = TYPE == 7;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  return function ($this, callbackfn, that, specificCreate) {
	    var O = toObject($this);
	    var self = IndexedObject(O);
	    var boundFunction = bind(callbackfn, that);
	    var length = lengthOfArrayLike(self);
	    var index = 0;
	    var create = specificCreate || arraySpeciesCreate;
	    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
	    var value, result;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      value = self[index];
	      result = boundFunction(value, index, O);
	      if (TYPE) {
	        if (IS_MAP) target[index] = result; // map
	        else if (result) switch (TYPE) {
	          case 3: return true;              // some
	          case 5: return value;             // find
	          case 6: return index;             // findIndex
	          case 2: push(target, value);      // filter
	        } else switch (TYPE) {
	          case 4: return false;             // every
	          case 7: push(target, value);      // filterReject
	        }
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
	  };
	};

	arrayIteration = {
	  // `Array.prototype.forEach` method
	  // https://tc39.es/ecma262/#sec-array.prototype.foreach
	  forEach: createMethod(0),
	  // `Array.prototype.map` method
	  // https://tc39.es/ecma262/#sec-array.prototype.map
	  map: createMethod(1),
	  // `Array.prototype.filter` method
	  // https://tc39.es/ecma262/#sec-array.prototype.filter
	  filter: createMethod(2),
	  // `Array.prototype.some` method
	  // https://tc39.es/ecma262/#sec-array.prototype.some
	  some: createMethod(3),
	  // `Array.prototype.every` method
	  // https://tc39.es/ecma262/#sec-array.prototype.every
	  every: createMethod(4),
	  // `Array.prototype.find` method
	  // https://tc39.es/ecma262/#sec-array.prototype.find
	  find: createMethod(5),
	  // `Array.prototype.findIndex` method
	  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
	  findIndex: createMethod(6),
	  // `Array.prototype.filterReject` method
	  // https://github.com/tc39/proposal-array-filtering
	  filterReject: createMethod(7)
	};
	return arrayIteration;
}

var hasRequiredEs_array_find;

function requireEs_array_find () {
	if (hasRequiredEs_array_find) return es_array_find;
	hasRequiredEs_array_find = 1;
	var $ = require_export();
	var $find = requireArrayIteration().find;
	var addToUnscopables = requireAddToUnscopables();

	var FIND = 'find';
	var SKIPS_HOLES = true;

	// Shouldn't skip holes
	// eslint-disable-next-line es/no-array-prototype-find -- testing
	if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

	// `Array.prototype.find` method
	// https://tc39.es/ecma262/#sec-array.prototype.find
	$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});

	// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
	addToUnscopables(FIND);
	return es_array_find;
}

var entryUnbind;
var hasRequiredEntryUnbind;

function requireEntryUnbind () {
	if (hasRequiredEntryUnbind) return entryUnbind;
	hasRequiredEntryUnbind = 1;
	var global = requireGlobal();
	var uncurryThis = requireFunctionUncurryThis();

	entryUnbind = function (CONSTRUCTOR, METHOD) {
	  return uncurryThis(global[CONSTRUCTOR].prototype[METHOD]);
	};
	return entryUnbind;
}

var find$4;
var hasRequiredFind$4;

function requireFind$4 () {
	if (hasRequiredFind$4) return find$4;
	hasRequiredFind$4 = 1;
	requireEs_array_find();
	var entryUnbind = requireEntryUnbind();

	find$4 = entryUnbind('Array', 'find');
	return find$4;
}

var find$3;
var hasRequiredFind$3;

function requireFind$3 () {
	if (hasRequiredFind$3) return find$3;
	hasRequiredFind$3 = 1;
	var parent = requireFind$4();

	find$3 = parent;
	return find$3;
}

var find$2;
var hasRequiredFind$2;

function requireFind$2 () {
	if (hasRequiredFind$2) return find$2;
	hasRequiredFind$2 = 1;
	var parent = requireFind$3();

	find$2 = parent;
	return find$2;
}

var find$1;
var hasRequiredFind$1;

function requireFind$1 () {
	if (hasRequiredFind$1) return find$1;
	hasRequiredFind$1 = 1;
	var parent = requireFind$2();

	find$1 = parent;
	return find$1;
}

var find;
var hasRequiredFind;

function requireFind () {
	if (hasRequiredFind) return find;
	hasRequiredFind = 1;
	find = requireFind$1();
	return find;
}

requireFind();

var es_object_values = {};

var objectToArray;
var hasRequiredObjectToArray;

function requireObjectToArray () {
	if (hasRequiredObjectToArray) return objectToArray;
	hasRequiredObjectToArray = 1;
	var DESCRIPTORS = requireDescriptors();
	var uncurryThis = requireFunctionUncurryThis();
	var objectKeys = requireObjectKeys();
	var toIndexedObject = requireToIndexedObject();
	var $propertyIsEnumerable = requireObjectPropertyIsEnumerable().f;

	var propertyIsEnumerable = uncurryThis($propertyIsEnumerable);
	var push = uncurryThis([].push);

	// `Object.{ entries, values }` methods implementation
	var createMethod = function (TO_ENTRIES) {
	  return function (it) {
	    var O = toIndexedObject(it);
	    var keys = objectKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!DESCRIPTORS || propertyIsEnumerable(O, key)) {
	        push(result, TO_ENTRIES ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};

	objectToArray = {
	  // `Object.entries` method
	  // https://tc39.es/ecma262/#sec-object.entries
	  entries: createMethod(true),
	  // `Object.values` method
	  // https://tc39.es/ecma262/#sec-object.values
	  values: createMethod(false)
	};
	return objectToArray;
}

var hasRequiredEs_object_values;

function requireEs_object_values () {
	if (hasRequiredEs_object_values) return es_object_values;
	hasRequiredEs_object_values = 1;
	var $ = require_export();
	var $values = requireObjectToArray().values;

	// `Object.values` method
	// https://tc39.es/ecma262/#sec-object.values
	$({ target: 'Object', stat: true }, {
	  values: function values(O) {
	    return $values(O);
	  }
	});
	return es_object_values;
}

var values;
var hasRequiredValues;

function requireValues () {
	if (hasRequiredValues) return values;
	hasRequiredValues = 1;
	requireEs_object_values();
	var path = requirePath();

	values = path.Object.values;
	return values;
}

requireValues();

var es_object_assign = {};

var hasRequiredEs_object_assign;

function requireEs_object_assign () {
	if (hasRequiredEs_object_assign) return es_object_assign;
	hasRequiredEs_object_assign = 1;
	var $ = require_export();
	var assign = requireObjectAssign();

	// `Object.assign` method
	// https://tc39.es/ecma262/#sec-object.assign
	// eslint-disable-next-line es/no-object-assign -- required for testing
	$({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
	  assign: assign
	});
	return es_object_assign;
}

var assign;
var hasRequiredAssign;

function requireAssign () {
	if (hasRequiredAssign) return assign;
	hasRequiredAssign = 1;
	requireEs_object_assign();
	var path = requirePath();

	assign = path.Object.assign;
	return assign;
}

requireAssign();

var es_object_entries = {};

var hasRequiredEs_object_entries;

function requireEs_object_entries () {
	if (hasRequiredEs_object_entries) return es_object_entries;
	hasRequiredEs_object_entries = 1;
	var $ = require_export();
	var $entries = requireObjectToArray().entries;

	// `Object.entries` method
	// https://tc39.es/ecma262/#sec-object.entries
	$({ target: 'Object', stat: true }, {
	  entries: function entries(O) {
	    return $entries(O);
	  }
	});
	return es_object_entries;
}

var entries;
var hasRequiredEntries;

function requireEntries () {
	if (hasRequiredEntries) return entries;
	hasRequiredEntries = 1;
	requireEs_object_entries();
	var path = requirePath();

	entries = path.Object.entries;
	return entries;
}

requireEntries();

var es_array_concat = {};

var doesNotExceedSafeInteger;
var hasRequiredDoesNotExceedSafeInteger;

function requireDoesNotExceedSafeInteger () {
	if (hasRequiredDoesNotExceedSafeInteger) return doesNotExceedSafeInteger;
	hasRequiredDoesNotExceedSafeInteger = 1;
	var $TypeError = TypeError;
	var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

	doesNotExceedSafeInteger = function (it) {
	  if (it > MAX_SAFE_INTEGER) throw $TypeError('Maximum allowed index exceeded');
	  return it;
	};
	return doesNotExceedSafeInteger;
}

var arrayMethodHasSpeciesSupport;
var hasRequiredArrayMethodHasSpeciesSupport;

function requireArrayMethodHasSpeciesSupport () {
	if (hasRequiredArrayMethodHasSpeciesSupport) return arrayMethodHasSpeciesSupport;
	hasRequiredArrayMethodHasSpeciesSupport = 1;
	var fails = requireFails();
	var wellKnownSymbol = requireWellKnownSymbol();
	var V8_VERSION = requireEngineV8Version();

	var SPECIES = wellKnownSymbol('species');

	arrayMethodHasSpeciesSupport = function (METHOD_NAME) {
	  // We can't use this feature detection in V8 since it causes
	  // deoptimization and serious performance degradation
	  // https://github.com/zloirock/core-js/issues/677
	  return V8_VERSION >= 51 || !fails(function () {
	    var array = [];
	    var constructor = array.constructor = {};
	    constructor[SPECIES] = function () {
	      return { foo: 1 };
	    };
	    return array[METHOD_NAME](Boolean).foo !== 1;
	  });
	};
	return arrayMethodHasSpeciesSupport;
}

var hasRequiredEs_array_concat;

function requireEs_array_concat () {
	if (hasRequiredEs_array_concat) return es_array_concat;
	hasRequiredEs_array_concat = 1;
	var $ = require_export();
	var fails = requireFails();
	var isArray = requireIsArray();
	var isObject = requireIsObject();
	var toObject = requireToObject();
	var lengthOfArrayLike = requireLengthOfArrayLike();
	var doesNotExceedSafeInteger = requireDoesNotExceedSafeInteger();
	var createProperty = requireCreateProperty();
	var arraySpeciesCreate = requireArraySpeciesCreate();
	var arrayMethodHasSpeciesSupport = requireArrayMethodHasSpeciesSupport();
	var wellKnownSymbol = requireWellKnownSymbol();
	var V8_VERSION = requireEngineV8Version();

	var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');

	// We can't use this feature detection in V8 since it causes
	// deoptimization and serious performance degradation
	// https://github.com/zloirock/core-js/issues/679
	var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
	  var array = [];
	  array[IS_CONCAT_SPREADABLE] = false;
	  return array.concat()[0] !== array;
	});

	var isConcatSpreadable = function (O) {
	  if (!isObject(O)) return false;
	  var spreadable = O[IS_CONCAT_SPREADABLE];
	  return spreadable !== undefined ? !!spreadable : isArray(O);
	};

	var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !arrayMethodHasSpeciesSupport('concat');

	// `Array.prototype.concat` method
	// https://tc39.es/ecma262/#sec-array.prototype.concat
	// with adding support of @@isConcatSpreadable and @@species
	$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
	  // eslint-disable-next-line no-unused-vars -- required for `.length`
	  concat: function concat(arg) {
	    var O = toObject(this);
	    var A = arraySpeciesCreate(O, 0);
	    var n = 0;
	    var i, k, length, len, E;
	    for (i = -1, length = arguments.length; i < length; i++) {
	      E = i === -1 ? O : arguments[i];
	      if (isConcatSpreadable(E)) {
	        len = lengthOfArrayLike(E);
	        doesNotExceedSafeInteger(n + len);
	        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
	      } else {
	        doesNotExceedSafeInteger(n + 1);
	        createProperty(A, n++, E);
	      }
	    }
	    A.length = n;
	    return A;
	  }
	});
	return es_array_concat;
}

var es_object_toString = {};

var objectToString;
var hasRequiredObjectToString;

function requireObjectToString () {
	if (hasRequiredObjectToString) return objectToString;
	hasRequiredObjectToString = 1;
	var TO_STRING_TAG_SUPPORT = requireToStringTagSupport();
	var classof = requireClassof();

	// `Object.prototype.toString` method implementation
	// https://tc39.es/ecma262/#sec-object.prototype.tostring
	objectToString = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
	  return '[object ' + classof(this) + ']';
	};
	return objectToString;
}

var hasRequiredEs_object_toString;

function requireEs_object_toString () {
	if (hasRequiredEs_object_toString) return es_object_toString;
	hasRequiredEs_object_toString = 1;
	var TO_STRING_TAG_SUPPORT = requireToStringTagSupport();
	var defineBuiltIn = requireDefineBuiltIn();
	var toString = requireObjectToString();

	// `Object.prototype.toString` method
	// https://tc39.es/ecma262/#sec-object.prototype.tostring
	if (!TO_STRING_TAG_SUPPORT) {
	  defineBuiltIn(Object.prototype, 'toString', toString, { unsafe: true });
	}
	return es_object_toString;
}

var es_symbol = {};

var es_symbol_constructor = {};

var objectGetOwnPropertyNamesExternal = {};

/* eslint-disable es/no-object-getownpropertynames -- safe */

var hasRequiredObjectGetOwnPropertyNamesExternal;

function requireObjectGetOwnPropertyNamesExternal () {
	if (hasRequiredObjectGetOwnPropertyNamesExternal) return objectGetOwnPropertyNamesExternal;
	hasRequiredObjectGetOwnPropertyNamesExternal = 1;
	var classof = requireClassofRaw();
	var toIndexedObject = requireToIndexedObject();
	var $getOwnPropertyNames = requireObjectGetOwnPropertyNames().f;
	var arraySlice = requireArraySliceSimple();

	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];

	var getWindowNames = function (it) {
	  try {
	    return $getOwnPropertyNames(it);
	  } catch (error) {
	    return arraySlice(windowNames);
	  }
	};

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	objectGetOwnPropertyNamesExternal.f = function getOwnPropertyNames(it) {
	  return windowNames && classof(it) == 'Window'
	    ? getWindowNames(it)
	    : $getOwnPropertyNames(toIndexedObject(it));
	};
	return objectGetOwnPropertyNamesExternal;
}

var wellKnownSymbolWrapped = {};

var hasRequiredWellKnownSymbolWrapped;

function requireWellKnownSymbolWrapped () {
	if (hasRequiredWellKnownSymbolWrapped) return wellKnownSymbolWrapped;
	hasRequiredWellKnownSymbolWrapped = 1;
	var wellKnownSymbol = requireWellKnownSymbol();

	wellKnownSymbolWrapped.f = wellKnownSymbol;
	return wellKnownSymbolWrapped;
}

var wellKnownSymbolDefine;
var hasRequiredWellKnownSymbolDefine;

function requireWellKnownSymbolDefine () {
	if (hasRequiredWellKnownSymbolDefine) return wellKnownSymbolDefine;
	hasRequiredWellKnownSymbolDefine = 1;
	var path = requirePath();
	var hasOwn = requireHasOwnProperty();
	var wrappedWellKnownSymbolModule = requireWellKnownSymbolWrapped();
	var defineProperty = requireObjectDefineProperty().f;

	wellKnownSymbolDefine = function (NAME) {
	  var Symbol = path.Symbol || (path.Symbol = {});
	  if (!hasOwn(Symbol, NAME)) defineProperty(Symbol, NAME, {
	    value: wrappedWellKnownSymbolModule.f(NAME)
	  });
	};
	return wellKnownSymbolDefine;
}

var symbolDefineToPrimitive;
var hasRequiredSymbolDefineToPrimitive;

function requireSymbolDefineToPrimitive () {
	if (hasRequiredSymbolDefineToPrimitive) return symbolDefineToPrimitive;
	hasRequiredSymbolDefineToPrimitive = 1;
	var call = requireFunctionCall();
	var getBuiltIn = requireGetBuiltIn();
	var wellKnownSymbol = requireWellKnownSymbol();
	var defineBuiltIn = requireDefineBuiltIn();

	symbolDefineToPrimitive = function () {
	  var Symbol = getBuiltIn('Symbol');
	  var SymbolPrototype = Symbol && Symbol.prototype;
	  var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
	  var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

	  if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) {
	    // `Symbol.prototype[@@toPrimitive]` method
	    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
	    // eslint-disable-next-line no-unused-vars -- required for .length
	    defineBuiltIn(SymbolPrototype, TO_PRIMITIVE, function (hint) {
	      return call(valueOf, this);
	    }, { arity: 1 });
	  }
	};
	return symbolDefineToPrimitive;
}

var hasRequiredEs_symbol_constructor;

function requireEs_symbol_constructor () {
	if (hasRequiredEs_symbol_constructor) return es_symbol_constructor;
	hasRequiredEs_symbol_constructor = 1;
	var $ = require_export();
	var global = requireGlobal();
	var call = requireFunctionCall();
	var uncurryThis = requireFunctionUncurryThis();
	var IS_PURE = requireIsPure();
	var DESCRIPTORS = requireDescriptors();
	var NATIVE_SYMBOL = requireSymbolConstructorDetection();
	var fails = requireFails();
	var hasOwn = requireHasOwnProperty();
	var isPrototypeOf = requireObjectIsPrototypeOf();
	var anObject = requireAnObject();
	var toIndexedObject = requireToIndexedObject();
	var toPropertyKey = requireToPropertyKey();
	var $toString = requireToString();
	var createPropertyDescriptor = requireCreatePropertyDescriptor();
	var nativeObjectCreate = requireObjectCreate();
	var objectKeys = requireObjectKeys();
	var getOwnPropertyNamesModule = requireObjectGetOwnPropertyNames();
	var getOwnPropertyNamesExternal = requireObjectGetOwnPropertyNamesExternal();
	var getOwnPropertySymbolsModule = requireObjectGetOwnPropertySymbols();
	var getOwnPropertyDescriptorModule = requireObjectGetOwnPropertyDescriptor();
	var definePropertyModule = requireObjectDefineProperty();
	var definePropertiesModule = requireObjectDefineProperties();
	var propertyIsEnumerableModule = requireObjectPropertyIsEnumerable();
	var defineBuiltIn = requireDefineBuiltIn();
	var defineBuiltInAccessor = requireDefineBuiltInAccessor();
	var shared = requireShared();
	var sharedKey = requireSharedKey();
	var hiddenKeys = requireHiddenKeys();
	var uid = requireUid();
	var wellKnownSymbol = requireWellKnownSymbol();
	var wrappedWellKnownSymbolModule = requireWellKnownSymbolWrapped();
	var defineWellKnownSymbol = requireWellKnownSymbolDefine();
	var defineSymbolToPrimitive = requireSymbolDefineToPrimitive();
	var setToStringTag = requireSetToStringTag();
	var InternalStateModule = requireInternalState();
	var $forEach = requireArrayIteration().forEach;

	var HIDDEN = sharedKey('hidden');
	var SYMBOL = 'Symbol';
	var PROTOTYPE = 'prototype';

	var setInternalState = InternalStateModule.set;
	var getInternalState = InternalStateModule.getterFor(SYMBOL);

	var ObjectPrototype = Object[PROTOTYPE];
	var $Symbol = global.Symbol;
	var SymbolPrototype = $Symbol && $Symbol[PROTOTYPE];
	var TypeError = global.TypeError;
	var QObject = global.QObject;
	var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
	var nativeDefineProperty = definePropertyModule.f;
	var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
	var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
	var push = uncurryThis([].push);

	var AllSymbols = shared('symbols');
	var ObjectPrototypeSymbols = shared('op-symbols');
	var WellKnownSymbolsStore = shared('wks');

	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDescriptor = DESCRIPTORS && fails(function () {
	  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
	    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (O, P, Attributes) {
	  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
	  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
	  nativeDefineProperty(O, P, Attributes);
	  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
	    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
	  }
	} : nativeDefineProperty;

	var wrap = function (tag, description) {
	  var symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype);
	  setInternalState(symbol, {
	    type: SYMBOL,
	    tag: tag,
	    description: description
	  });
	  if (!DESCRIPTORS) symbol.description = description;
	  return symbol;
	};

	var $defineProperty = function defineProperty(O, P, Attributes) {
	  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
	  anObject(O);
	  var key = toPropertyKey(P);
	  anObject(Attributes);
	  if (hasOwn(AllSymbols, key)) {
	    if (!Attributes.enumerable) {
	      if (!hasOwn(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
	      O[HIDDEN][key] = true;
	    } else {
	      if (hasOwn(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
	      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
	    } return setSymbolDescriptor(O, key, Attributes);
	  } return nativeDefineProperty(O, key, Attributes);
	};

	var $defineProperties = function defineProperties(O, Properties) {
	  anObject(O);
	  var properties = toIndexedObject(Properties);
	  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
	  $forEach(keys, function (key) {
	    if (!DESCRIPTORS || call($propertyIsEnumerable, properties, key)) $defineProperty(O, key, properties[key]);
	  });
	  return O;
	};

	var $create = function create(O, Properties) {
	  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
	};

	var $propertyIsEnumerable = function propertyIsEnumerable(V) {
	  var P = toPropertyKey(V);
	  var enumerable = call(nativePropertyIsEnumerable, this, P);
	  if (this === ObjectPrototype && hasOwn(AllSymbols, P) && !hasOwn(ObjectPrototypeSymbols, P)) return false;
	  return enumerable || !hasOwn(this, P) || !hasOwn(AllSymbols, P) || hasOwn(this, HIDDEN) && this[HIDDEN][P]
	    ? enumerable : true;
	};

	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
	  var it = toIndexedObject(O);
	  var key = toPropertyKey(P);
	  if (it === ObjectPrototype && hasOwn(AllSymbols, key) && !hasOwn(ObjectPrototypeSymbols, key)) return;
	  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
	  if (descriptor && hasOwn(AllSymbols, key) && !(hasOwn(it, HIDDEN) && it[HIDDEN][key])) {
	    descriptor.enumerable = true;
	  }
	  return descriptor;
	};

	var $getOwnPropertyNames = function getOwnPropertyNames(O) {
	  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
	  var result = [];
	  $forEach(names, function (key) {
	    if (!hasOwn(AllSymbols, key) && !hasOwn(hiddenKeys, key)) push(result, key);
	  });
	  return result;
	};

	var $getOwnPropertySymbols = function (O) {
	  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
	  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
	  var result = [];
	  $forEach(names, function (key) {
	    if (hasOwn(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn(ObjectPrototype, key))) {
	      push(result, AllSymbols[key]);
	    }
	  });
	  return result;
	};

	// `Symbol` constructor
	// https://tc39.es/ecma262/#sec-symbol-constructor
	if (!NATIVE_SYMBOL) {
	  $Symbol = function Symbol() {
	    if (isPrototypeOf(SymbolPrototype, this)) throw TypeError('Symbol is not a constructor');
	    var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
	    var tag = uid(description);
	    var setter = function (value) {
	      if (this === ObjectPrototype) call(setter, ObjectPrototypeSymbols, value);
	      if (hasOwn(this, HIDDEN) && hasOwn(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
	    };
	    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
	    return wrap(tag, description);
	  };

	  SymbolPrototype = $Symbol[PROTOTYPE];

	  defineBuiltIn(SymbolPrototype, 'toString', function toString() {
	    return getInternalState(this).tag;
	  });

	  defineBuiltIn($Symbol, 'withoutSetter', function (description) {
	    return wrap(uid(description), description);
	  });

	  propertyIsEnumerableModule.f = $propertyIsEnumerable;
	  definePropertyModule.f = $defineProperty;
	  definePropertiesModule.f = $defineProperties;
	  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
	  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
	  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

	  wrappedWellKnownSymbolModule.f = function (name) {
	    return wrap(wellKnownSymbol(name), name);
	  };

	  if (DESCRIPTORS) {
	    // https://github.com/tc39/proposal-Symbol-description
	    defineBuiltInAccessor(SymbolPrototype, 'description', {
	      configurable: true,
	      get: function description() {
	        return getInternalState(this).description;
	      }
	    });
	    if (!IS_PURE) {
	      defineBuiltIn(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
	    }
	  }
	}

	$({ global: true, constructor: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
	  Symbol: $Symbol
	});

	$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
	  defineWellKnownSymbol(name);
	});

	$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
	  useSetter: function () { USE_SETTER = true; },
	  useSimple: function () { USE_SETTER = false; }
	});

	$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
	  // `Object.create` method
	  // https://tc39.es/ecma262/#sec-object.create
	  create: $create,
	  // `Object.defineProperty` method
	  // https://tc39.es/ecma262/#sec-object.defineproperty
	  defineProperty: $defineProperty,
	  // `Object.defineProperties` method
	  // https://tc39.es/ecma262/#sec-object.defineproperties
	  defineProperties: $defineProperties,
	  // `Object.getOwnPropertyDescriptor` method
	  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
	});

	$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
	  // `Object.getOwnPropertyNames` method
	  // https://tc39.es/ecma262/#sec-object.getownpropertynames
	  getOwnPropertyNames: $getOwnPropertyNames
	});

	// `Symbol.prototype[@@toPrimitive]` method
	// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
	defineSymbolToPrimitive();

	// `Symbol.prototype[@@toStringTag]` property
	// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
	setToStringTag($Symbol, SYMBOL);

	hiddenKeys[HIDDEN] = true;
	return es_symbol_constructor;
}

var es_symbol_for = {};

var symbolRegistryDetection;
var hasRequiredSymbolRegistryDetection;

function requireSymbolRegistryDetection () {
	if (hasRequiredSymbolRegistryDetection) return symbolRegistryDetection;
	hasRequiredSymbolRegistryDetection = 1;
	var NATIVE_SYMBOL = requireSymbolConstructorDetection();

	/* eslint-disable es/no-symbol -- safe */
	symbolRegistryDetection = NATIVE_SYMBOL && !!Symbol['for'] && !!Symbol.keyFor;
	return symbolRegistryDetection;
}

var hasRequiredEs_symbol_for;

function requireEs_symbol_for () {
	if (hasRequiredEs_symbol_for) return es_symbol_for;
	hasRequiredEs_symbol_for = 1;
	var $ = require_export();
	var getBuiltIn = requireGetBuiltIn();
	var hasOwn = requireHasOwnProperty();
	var toString = requireToString();
	var shared = requireShared();
	var NATIVE_SYMBOL_REGISTRY = requireSymbolRegistryDetection();

	var StringToSymbolRegistry = shared('string-to-symbol-registry');
	var SymbolToStringRegistry = shared('symbol-to-string-registry');

	// `Symbol.for` method
	// https://tc39.es/ecma262/#sec-symbol.for
	$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
	  'for': function (key) {
	    var string = toString(key);
	    if (hasOwn(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
	    var symbol = getBuiltIn('Symbol')(string);
	    StringToSymbolRegistry[string] = symbol;
	    SymbolToStringRegistry[symbol] = string;
	    return symbol;
	  }
	});
	return es_symbol_for;
}

var es_symbol_keyFor = {};

var hasRequiredEs_symbol_keyFor;

function requireEs_symbol_keyFor () {
	if (hasRequiredEs_symbol_keyFor) return es_symbol_keyFor;
	hasRequiredEs_symbol_keyFor = 1;
	var $ = require_export();
	var hasOwn = requireHasOwnProperty();
	var isSymbol = requireIsSymbol();
	var tryToString = requireTryToString();
	var shared = requireShared();
	var NATIVE_SYMBOL_REGISTRY = requireSymbolRegistryDetection();

	var SymbolToStringRegistry = shared('symbol-to-string-registry');

	// `Symbol.keyFor` method
	// https://tc39.es/ecma262/#sec-symbol.keyfor
	$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(tryToString(sym) + ' is not a symbol');
	    if (hasOwn(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
	  }
	});
	return es_symbol_keyFor;
}

var es_json_stringify = {};

var functionApply;
var hasRequiredFunctionApply;

function requireFunctionApply () {
	if (hasRequiredFunctionApply) return functionApply;
	hasRequiredFunctionApply = 1;
	var NATIVE_BIND = requireFunctionBindNative();

	var FunctionPrototype = Function.prototype;
	var apply = FunctionPrototype.apply;
	var call = FunctionPrototype.call;

	// eslint-disable-next-line es/no-reflect -- safe
	functionApply = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function () {
	  return call.apply(apply, arguments);
	});
	return functionApply;
}

var arraySlice;
var hasRequiredArraySlice;

function requireArraySlice () {
	if (hasRequiredArraySlice) return arraySlice;
	hasRequiredArraySlice = 1;
	var uncurryThis = requireFunctionUncurryThis();

	arraySlice = uncurryThis([].slice);
	return arraySlice;
}

var getJsonReplacerFunction;
var hasRequiredGetJsonReplacerFunction;

function requireGetJsonReplacerFunction () {
	if (hasRequiredGetJsonReplacerFunction) return getJsonReplacerFunction;
	hasRequiredGetJsonReplacerFunction = 1;
	var uncurryThis = requireFunctionUncurryThis();
	var isArray = requireIsArray();
	var isCallable = requireIsCallable();
	var classof = requireClassofRaw();
	var toString = requireToString();

	var push = uncurryThis([].push);

	getJsonReplacerFunction = function (replacer) {
	  if (isCallable(replacer)) return replacer;
	  if (!isArray(replacer)) return;
	  var rawLength = replacer.length;
	  var keys = [];
	  for (var i = 0; i < rawLength; i++) {
	    var element = replacer[i];
	    if (typeof element == 'string') push(keys, element);
	    else if (typeof element == 'number' || classof(element) == 'Number' || classof(element) == 'String') push(keys, toString(element));
	  }
	  var keysLength = keys.length;
	  var root = true;
	  return function (key, value) {
	    if (root) {
	      root = false;
	      return value;
	    }
	    if (isArray(this)) return value;
	    for (var j = 0; j < keysLength; j++) if (keys[j] === key) return value;
	  };
	};
	return getJsonReplacerFunction;
}

var hasRequiredEs_json_stringify;

function requireEs_json_stringify () {
	if (hasRequiredEs_json_stringify) return es_json_stringify;
	hasRequiredEs_json_stringify = 1;
	var $ = require_export();
	var getBuiltIn = requireGetBuiltIn();
	var apply = requireFunctionApply();
	var call = requireFunctionCall();
	var uncurryThis = requireFunctionUncurryThis();
	var fails = requireFails();
	var isCallable = requireIsCallable();
	var isSymbol = requireIsSymbol();
	var arraySlice = requireArraySlice();
	var getReplacerFunction = requireGetJsonReplacerFunction();
	var NATIVE_SYMBOL = requireSymbolConstructorDetection();

	var $String = String;
	var $stringify = getBuiltIn('JSON', 'stringify');
	var exec = uncurryThis(/./.exec);
	var charAt = uncurryThis(''.charAt);
	var charCodeAt = uncurryThis(''.charCodeAt);
	var replace = uncurryThis(''.replace);
	var numberToString = uncurryThis(1.0.toString);

	var tester = /[\uD800-\uDFFF]/g;
	var low = /^[\uD800-\uDBFF]$/;
	var hi = /^[\uDC00-\uDFFF]$/;

	var WRONG_SYMBOLS_CONVERSION = !NATIVE_SYMBOL || fails(function () {
	  var symbol = getBuiltIn('Symbol')();
	  // MS Edge converts symbol values to JSON as {}
	  return $stringify([symbol]) != '[null]'
	    // WebKit converts symbol values to JSON as null
	    || $stringify({ a: symbol }) != '{}'
	    // V8 throws on boxed symbols
	    || $stringify(Object(symbol)) != '{}';
	});

	// https://github.com/tc39/proposal-well-formed-stringify
	var ILL_FORMED_UNICODE = fails(function () {
	  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"'
	    || $stringify('\uDEAD') !== '"\\udead"';
	});

	var stringifyWithSymbolsFix = function (it, replacer) {
	  var args = arraySlice(arguments);
	  var $replacer = getReplacerFunction(replacer);
	  if (!isCallable($replacer) && (it === undefined || isSymbol(it))) return; // IE8 returns string on undefined
	  args[1] = function (key, value) {
	    // some old implementations (like WebKit) could pass numbers as keys
	    if (isCallable($replacer)) value = call($replacer, this, $String(key), value);
	    if (!isSymbol(value)) return value;
	  };
	  return apply($stringify, null, args);
	};

	var fixIllFormed = function (match, offset, string) {
	  var prev = charAt(string, offset - 1);
	  var next = charAt(string, offset + 1);
	  if ((exec(low, match) && !exec(hi, next)) || (exec(hi, match) && !exec(low, prev))) {
	    return '\\u' + numberToString(charCodeAt(match, 0), 16);
	  } return match;
	};

	if ($stringify) {
	  // `JSON.stringify` method
	  // https://tc39.es/ecma262/#sec-json.stringify
	  $({ target: 'JSON', stat: true, arity: 3, forced: WRONG_SYMBOLS_CONVERSION || ILL_FORMED_UNICODE }, {
	    // eslint-disable-next-line no-unused-vars -- required for `.length`
	    stringify: function stringify(it, replacer, space) {
	      var args = arraySlice(arguments);
	      var result = apply(WRONG_SYMBOLS_CONVERSION ? stringifyWithSymbolsFix : $stringify, null, args);
	      return ILL_FORMED_UNICODE && typeof result == 'string' ? replace(result, tester, fixIllFormed) : result;
	    }
	  });
	}
	return es_json_stringify;
}

var es_object_getOwnPropertySymbols = {};

var hasRequiredEs_object_getOwnPropertySymbols;

function requireEs_object_getOwnPropertySymbols () {
	if (hasRequiredEs_object_getOwnPropertySymbols) return es_object_getOwnPropertySymbols;
	hasRequiredEs_object_getOwnPropertySymbols = 1;
	var $ = require_export();
	var NATIVE_SYMBOL = requireSymbolConstructorDetection();
	var fails = requireFails();
	var getOwnPropertySymbolsModule = requireObjectGetOwnPropertySymbols();
	var toObject = requireToObject();

	// V8 ~ Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FORCED = !NATIVE_SYMBOL || fails(function () { getOwnPropertySymbolsModule.f(1); });

	// `Object.getOwnPropertySymbols` method
	// https://tc39.es/ecma262/#sec-object.getownpropertysymbols
	$({ target: 'Object', stat: true, forced: FORCED }, {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    var $getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
	    return $getOwnPropertySymbols ? $getOwnPropertySymbols(toObject(it)) : [];
	  }
	});
	return es_object_getOwnPropertySymbols;
}

var hasRequiredEs_symbol;

function requireEs_symbol () {
	if (hasRequiredEs_symbol) return es_symbol;
	hasRequiredEs_symbol = 1;
	// TODO: Remove this module from `core-js@4` since it's split to modules listed below
	requireEs_symbol_constructor();
	requireEs_symbol_for();
	requireEs_symbol_keyFor();
	requireEs_json_stringify();
	requireEs_object_getOwnPropertySymbols();
	return es_symbol;
}

var es_symbol_asyncIterator = {};

var hasRequiredEs_symbol_asyncIterator;

function requireEs_symbol_asyncIterator () {
	if (hasRequiredEs_symbol_asyncIterator) return es_symbol_asyncIterator;
	hasRequiredEs_symbol_asyncIterator = 1;
	var defineWellKnownSymbol = requireWellKnownSymbolDefine();

	// `Symbol.asyncIterator` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.asynciterator
	defineWellKnownSymbol('asyncIterator');
	return es_symbol_asyncIterator;
}

var es_symbol_description = {};

var hasRequiredEs_symbol_description;

function requireEs_symbol_description () {
	if (hasRequiredEs_symbol_description) return es_symbol_description;
	hasRequiredEs_symbol_description = 1;
	var $ = require_export();
	var DESCRIPTORS = requireDescriptors();
	var global = requireGlobal();
	var uncurryThis = requireFunctionUncurryThis();
	var hasOwn = requireHasOwnProperty();
	var isCallable = requireIsCallable();
	var isPrototypeOf = requireObjectIsPrototypeOf();
	var toString = requireToString();
	var defineBuiltInAccessor = requireDefineBuiltInAccessor();
	var copyConstructorProperties = requireCopyConstructorProperties();

	var NativeSymbol = global.Symbol;
	var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

	if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in SymbolPrototype) ||
	  // Safari 12 bug
	  NativeSymbol().description !== undefined
	)) {
	  var EmptyStringDescriptionStore = {};
	  // wrap Symbol constructor for correct work with undefined description
	  var SymbolWrapper = function Symbol() {
	    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString(arguments[0]);
	    var result = isPrototypeOf(SymbolPrototype, this)
	      ? new NativeSymbol(description)
	      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
	      : description === undefined ? NativeSymbol() : NativeSymbol(description);
	    if (description === '') EmptyStringDescriptionStore[result] = true;
	    return result;
	  };

	  copyConstructorProperties(SymbolWrapper, NativeSymbol);
	  SymbolWrapper.prototype = SymbolPrototype;
	  SymbolPrototype.constructor = SymbolWrapper;

	  var NATIVE_SYMBOL = String(NativeSymbol('test')) == 'Symbol(test)';
	  var thisSymbolValue = uncurryThis(SymbolPrototype.valueOf);
	  var symbolDescriptiveString = uncurryThis(SymbolPrototype.toString);
	  var regexp = /^Symbol\((.*)\)[^)]+$/;
	  var replace = uncurryThis(''.replace);
	  var stringSlice = uncurryThis(''.slice);

	  defineBuiltInAccessor(SymbolPrototype, 'description', {
	    configurable: true,
	    get: function description() {
	      var symbol = thisSymbolValue(this);
	      if (hasOwn(EmptyStringDescriptionStore, symbol)) return '';
	      var string = symbolDescriptiveString(symbol);
	      var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, '$1');
	      return desc === '' ? undefined : desc;
	    }
	  });

	  $({ global: true, constructor: true, forced: true }, {
	    Symbol: SymbolWrapper
	  });
	}
	return es_symbol_description;
}

var es_symbol_hasInstance = {};

var hasRequiredEs_symbol_hasInstance;

function requireEs_symbol_hasInstance () {
	if (hasRequiredEs_symbol_hasInstance) return es_symbol_hasInstance;
	hasRequiredEs_symbol_hasInstance = 1;
	var defineWellKnownSymbol = requireWellKnownSymbolDefine();

	// `Symbol.hasInstance` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.hasinstance
	defineWellKnownSymbol('hasInstance');
	return es_symbol_hasInstance;
}

var es_symbol_isConcatSpreadable = {};

var hasRequiredEs_symbol_isConcatSpreadable;

function requireEs_symbol_isConcatSpreadable () {
	if (hasRequiredEs_symbol_isConcatSpreadable) return es_symbol_isConcatSpreadable;
	hasRequiredEs_symbol_isConcatSpreadable = 1;
	var defineWellKnownSymbol = requireWellKnownSymbolDefine();

	// `Symbol.isConcatSpreadable` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.isconcatspreadable
	defineWellKnownSymbol('isConcatSpreadable');
	return es_symbol_isConcatSpreadable;
}

var es_symbol_iterator = {};

var hasRequiredEs_symbol_iterator;

function requireEs_symbol_iterator () {
	if (hasRequiredEs_symbol_iterator) return es_symbol_iterator;
	hasRequiredEs_symbol_iterator = 1;
	var defineWellKnownSymbol = requireWellKnownSymbolDefine();

	// `Symbol.iterator` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.iterator
	defineWellKnownSymbol('iterator');
	return es_symbol_iterator;
}

var es_symbol_match = {};

var hasRequiredEs_symbol_match;

function requireEs_symbol_match () {
	if (hasRequiredEs_symbol_match) return es_symbol_match;
	hasRequiredEs_symbol_match = 1;
	var defineWellKnownSymbol = requireWellKnownSymbolDefine();

	// `Symbol.match` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.match
	defineWellKnownSymbol('match');
	return es_symbol_match;
}

var es_symbol_matchAll = {};

var hasRequiredEs_symbol_matchAll;

function requireEs_symbol_matchAll () {
	if (hasRequiredEs_symbol_matchAll) return es_symbol_matchAll;
	hasRequiredEs_symbol_matchAll = 1;
	var defineWellKnownSymbol = requireWellKnownSymbolDefine();

	// `Symbol.matchAll` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.matchall
	defineWellKnownSymbol('matchAll');
	return es_symbol_matchAll;
}

var es_symbol_replace = {};

var hasRequiredEs_symbol_replace;

function requireEs_symbol_replace () {
	if (hasRequiredEs_symbol_replace) return es_symbol_replace;
	hasRequiredEs_symbol_replace = 1;
	var defineWellKnownSymbol = requireWellKnownSymbolDefine();

	// `Symbol.replace` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.replace
	defineWellKnownSymbol('replace');
	return es_symbol_replace;
}

var es_symbol_search = {};

var hasRequiredEs_symbol_search;

function requireEs_symbol_search () {
	if (hasRequiredEs_symbol_search) return es_symbol_search;
	hasRequiredEs_symbol_search = 1;
	var defineWellKnownSymbol = requireWellKnownSymbolDefine();

	// `Symbol.search` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.search
	defineWellKnownSymbol('search');
	return es_symbol_search;
}

var es_symbol_species = {};

var hasRequiredEs_symbol_species;

function requireEs_symbol_species () {
	if (hasRequiredEs_symbol_species) return es_symbol_species;
	hasRequiredEs_symbol_species = 1;
	var defineWellKnownSymbol = requireWellKnownSymbolDefine();

	// `Symbol.species` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.species
	defineWellKnownSymbol('species');
	return es_symbol_species;
}

var es_symbol_split = {};

var hasRequiredEs_symbol_split;

function requireEs_symbol_split () {
	if (hasRequiredEs_symbol_split) return es_symbol_split;
	hasRequiredEs_symbol_split = 1;
	var defineWellKnownSymbol = requireWellKnownSymbolDefine();

	// `Symbol.split` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.split
	defineWellKnownSymbol('split');
	return es_symbol_split;
}

var es_symbol_toPrimitive = {};

var hasRequiredEs_symbol_toPrimitive;

function requireEs_symbol_toPrimitive () {
	if (hasRequiredEs_symbol_toPrimitive) return es_symbol_toPrimitive;
	hasRequiredEs_symbol_toPrimitive = 1;
	var defineWellKnownSymbol = requireWellKnownSymbolDefine();
	var defineSymbolToPrimitive = requireSymbolDefineToPrimitive();

	// `Symbol.toPrimitive` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.toprimitive
	defineWellKnownSymbol('toPrimitive');

	// `Symbol.prototype[@@toPrimitive]` method
	// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
	defineSymbolToPrimitive();
	return es_symbol_toPrimitive;
}

var es_symbol_toStringTag = {};

var hasRequiredEs_symbol_toStringTag;

function requireEs_symbol_toStringTag () {
	if (hasRequiredEs_symbol_toStringTag) return es_symbol_toStringTag;
	hasRequiredEs_symbol_toStringTag = 1;
	var getBuiltIn = requireGetBuiltIn();
	var defineWellKnownSymbol = requireWellKnownSymbolDefine();
	var setToStringTag = requireSetToStringTag();

	// `Symbol.toStringTag` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.tostringtag
	defineWellKnownSymbol('toStringTag');

	// `Symbol.prototype[@@toStringTag]` property
	// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
	setToStringTag(getBuiltIn('Symbol'), 'Symbol');
	return es_symbol_toStringTag;
}

var es_symbol_unscopables = {};

var hasRequiredEs_symbol_unscopables;

function requireEs_symbol_unscopables () {
	if (hasRequiredEs_symbol_unscopables) return es_symbol_unscopables;
	hasRequiredEs_symbol_unscopables = 1;
	var defineWellKnownSymbol = requireWellKnownSymbolDefine();

	// `Symbol.unscopables` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.unscopables
	defineWellKnownSymbol('unscopables');
	return es_symbol_unscopables;
}

var es_json_toStringTag = {};

var hasRequiredEs_json_toStringTag;

function requireEs_json_toStringTag () {
	if (hasRequiredEs_json_toStringTag) return es_json_toStringTag;
	hasRequiredEs_json_toStringTag = 1;
	var global = requireGlobal();
	var setToStringTag = requireSetToStringTag();

	// JSON[@@toStringTag] property
	// https://tc39.es/ecma262/#sec-json-@@tostringtag
	setToStringTag(global.JSON, 'JSON', true);
	return es_json_toStringTag;
}

var es_math_toStringTag = {};

var hasRequiredEs_math_toStringTag;

function requireEs_math_toStringTag () {
	if (hasRequiredEs_math_toStringTag) return es_math_toStringTag;
	hasRequiredEs_math_toStringTag = 1;
	var setToStringTag = requireSetToStringTag();

	// Math[@@toStringTag] property
	// https://tc39.es/ecma262/#sec-math-@@tostringtag
	setToStringTag(Math, 'Math', true);
	return es_math_toStringTag;
}

var es_reflect_toStringTag = {};

var hasRequiredEs_reflect_toStringTag;

function requireEs_reflect_toStringTag () {
	if (hasRequiredEs_reflect_toStringTag) return es_reflect_toStringTag;
	hasRequiredEs_reflect_toStringTag = 1;
	var $ = require_export();
	var global = requireGlobal();
	var setToStringTag = requireSetToStringTag();

	$({ global: true }, { Reflect: {} });

	// Reflect[@@toStringTag] property
	// https://tc39.es/ecma262/#sec-reflect-@@tostringtag
	setToStringTag(global.Reflect, 'Reflect', true);
	return es_reflect_toStringTag;
}

var symbol;
var hasRequiredSymbol;

function requireSymbol () {
	if (hasRequiredSymbol) return symbol;
	hasRequiredSymbol = 1;
	requireEs_array_concat();
	requireEs_object_toString();
	requireEs_symbol();
	requireEs_symbol_asyncIterator();
	requireEs_symbol_description();
	requireEs_symbol_hasInstance();
	requireEs_symbol_isConcatSpreadable();
	requireEs_symbol_iterator();
	requireEs_symbol_match();
	requireEs_symbol_matchAll();
	requireEs_symbol_replace();
	requireEs_symbol_search();
	requireEs_symbol_species();
	requireEs_symbol_split();
	requireEs_symbol_toPrimitive();
	requireEs_symbol_toStringTag();
	requireEs_symbol_unscopables();
	requireEs_json_toStringTag();
	requireEs_math_toStringTag();
	requireEs_reflect_toStringTag();
	var path = requirePath();

	symbol = path.Symbol;
	return symbol;
}

requireSymbol();

var es_map = {};

var es_map_constructor = {};

var internalMetadata = {exports: {}};

var arrayBufferNonExtensible;
var hasRequiredArrayBufferNonExtensible;

function requireArrayBufferNonExtensible () {
	if (hasRequiredArrayBufferNonExtensible) return arrayBufferNonExtensible;
	hasRequiredArrayBufferNonExtensible = 1;
	// FF26- bug: ArrayBuffers are non-extensible, but Object.isExtensible does not report it
	var fails = requireFails();

	arrayBufferNonExtensible = fails(function () {
	  if (typeof ArrayBuffer == 'function') {
	    var buffer = new ArrayBuffer(8);
	    // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
	    if (Object.isExtensible(buffer)) Object.defineProperty(buffer, 'a', { value: 8 });
	  }
	});
	return arrayBufferNonExtensible;
}

var objectIsExtensible;
var hasRequiredObjectIsExtensible;

function requireObjectIsExtensible () {
	if (hasRequiredObjectIsExtensible) return objectIsExtensible;
	hasRequiredObjectIsExtensible = 1;
	var fails = requireFails();
	var isObject = requireIsObject();
	var classof = requireClassofRaw();
	var ARRAY_BUFFER_NON_EXTENSIBLE = requireArrayBufferNonExtensible();

	// eslint-disable-next-line es/no-object-isextensible -- safe
	var $isExtensible = Object.isExtensible;
	var FAILS_ON_PRIMITIVES = fails(function () { });

	// `Object.isExtensible` method
	// https://tc39.es/ecma262/#sec-object.isextensible
	objectIsExtensible = (FAILS_ON_PRIMITIVES || ARRAY_BUFFER_NON_EXTENSIBLE) ? function isExtensible(it) {
	  if (!isObject(it)) return false;
	  if (ARRAY_BUFFER_NON_EXTENSIBLE && classof(it) == 'ArrayBuffer') return false;
	  return $isExtensible ? $isExtensible(it) : true;
	} : $isExtensible;
	return objectIsExtensible;
}

var freezing;
var hasRequiredFreezing;

function requireFreezing () {
	if (hasRequiredFreezing) return freezing;
	hasRequiredFreezing = 1;
	var fails = requireFails();

	freezing = !fails(function () {
	  // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
	  return Object.isExtensible(Object.preventExtensions({}));
	});
	return freezing;
}

var hasRequiredInternalMetadata;

function requireInternalMetadata () {
	if (hasRequiredInternalMetadata) return internalMetadata.exports;
	hasRequiredInternalMetadata = 1;
	var $ = require_export();
	var uncurryThis = requireFunctionUncurryThis();
	var hiddenKeys = requireHiddenKeys();
	var isObject = requireIsObject();
	var hasOwn = requireHasOwnProperty();
	var defineProperty = requireObjectDefineProperty().f;
	var getOwnPropertyNamesModule = requireObjectGetOwnPropertyNames();
	var getOwnPropertyNamesExternalModule = requireObjectGetOwnPropertyNamesExternal();
	var isExtensible = requireObjectIsExtensible();
	var uid = requireUid();
	var FREEZING = requireFreezing();

	var REQUIRED = false;
	var METADATA = uid('meta');
	var id = 0;

	var setMetadata = function (it) {
	  defineProperty(it, METADATA, { value: {
	    objectID: 'O' + id++, // object ID
	    weakData: {}          // weak collections IDs
	  } });
	};

	var fastKey = function (it, create) {
	  // return a primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!hasOwn(it, METADATA)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMetadata(it);
	  // return object ID
	  } return it[METADATA].objectID;
	};

	var getWeakData = function (it, create) {
	  if (!hasOwn(it, METADATA)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMetadata(it);
	  // return the store of weak collections IDs
	  } return it[METADATA].weakData;
	};

	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZING && REQUIRED && isExtensible(it) && !hasOwn(it, METADATA)) setMetadata(it);
	  return it;
	};

	var enable = function () {
	  meta.enable = function () { /* empty */ };
	  REQUIRED = true;
	  var getOwnPropertyNames = getOwnPropertyNamesModule.f;
	  var splice = uncurryThis([].splice);
	  var test = {};
	  test[METADATA] = 1;

	  // prevent exposing of metadata key
	  if (getOwnPropertyNames(test).length) {
	    getOwnPropertyNamesModule.f = function (it) {
	      var result = getOwnPropertyNames(it);
	      for (var i = 0, length = result.length; i < length; i++) {
	        if (result[i] === METADATA) {
	          splice(result, i, 1);
	          break;
	        }
	      } return result;
	    };

	    $({ target: 'Object', stat: true, forced: true }, {
	      getOwnPropertyNames: getOwnPropertyNamesExternalModule.f
	    });
	  }
	};

	var meta = internalMetadata.exports = {
	  enable: enable,
	  fastKey: fastKey,
	  getWeakData: getWeakData,
	  onFreeze: onFreeze
	};

	hiddenKeys[METADATA] = true;
	return internalMetadata.exports;
}

var iterate;
var hasRequiredIterate;

function requireIterate () {
	if (hasRequiredIterate) return iterate;
	hasRequiredIterate = 1;
	var bind = requireFunctionBindContext();
	var call = requireFunctionCall();
	var anObject = requireAnObject();
	var tryToString = requireTryToString();
	var isArrayIteratorMethod = requireIsArrayIteratorMethod();
	var lengthOfArrayLike = requireLengthOfArrayLike();
	var isPrototypeOf = requireObjectIsPrototypeOf();
	var getIterator = requireGetIterator();
	var getIteratorMethod = requireGetIteratorMethod();
	var iteratorClose = requireIteratorClose();

	var $TypeError = TypeError;

	var Result = function (stopped, result) {
	  this.stopped = stopped;
	  this.result = result;
	};

	var ResultPrototype = Result.prototype;

	iterate = function (iterable, unboundFunction, options) {
	  var that = options && options.that;
	  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
	  var IS_RECORD = !!(options && options.IS_RECORD);
	  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
	  var INTERRUPTED = !!(options && options.INTERRUPTED);
	  var fn = bind(unboundFunction, that);
	  var iterator, iterFn, index, length, result, next, step;

	  var stop = function (condition) {
	    if (iterator) iteratorClose(iterator, 'normal', condition);
	    return new Result(true, condition);
	  };

	  var callFn = function (value) {
	    if (AS_ENTRIES) {
	      anObject(value);
	      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
	    } return INTERRUPTED ? fn(value, stop) : fn(value);
	  };

	  if (IS_RECORD) {
	    iterator = iterable.iterator;
	  } else if (IS_ITERATOR) {
	    iterator = iterable;
	  } else {
	    iterFn = getIteratorMethod(iterable);
	    if (!iterFn) throw $TypeError(tryToString(iterable) + ' is not iterable');
	    // optimisation for array iterators
	    if (isArrayIteratorMethod(iterFn)) {
	      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
	        result = callFn(iterable[index]);
	        if (result && isPrototypeOf(ResultPrototype, result)) return result;
	      } return new Result(false);
	    }
	    iterator = getIterator(iterable, iterFn);
	  }

	  next = IS_RECORD ? iterable.next : iterator.next;
	  while (!(step = call(next, iterator)).done) {
	    try {
	      result = callFn(step.value);
	    } catch (error) {
	      iteratorClose(iterator, 'throw', error);
	    }
	    if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
	  } return new Result(false);
	};
	return iterate;
}

var checkCorrectnessOfIteration;
var hasRequiredCheckCorrectnessOfIteration;

function requireCheckCorrectnessOfIteration () {
	if (hasRequiredCheckCorrectnessOfIteration) return checkCorrectnessOfIteration;
	hasRequiredCheckCorrectnessOfIteration = 1;
	var wellKnownSymbol = requireWellKnownSymbol();

	var ITERATOR = wellKnownSymbol('iterator');
	var SAFE_CLOSING = false;

	try {
	  var called = 0;
	  var iteratorWithReturn = {
	    next: function () {
	      return { done: !!called++ };
	    },
	    'return': function () {
	      SAFE_CLOSING = true;
	    }
	  };
	  iteratorWithReturn[ITERATOR] = function () {
	    return this;
	  };
	  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
	  Array.from(iteratorWithReturn, function () { throw 2; });
	} catch (error) { /* empty */ }

	checkCorrectnessOfIteration = function (exec, SKIP_CLOSING) {
	  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
	  var ITERATION_SUPPORT = false;
	  try {
	    var object = {};
	    object[ITERATOR] = function () {
	      return {
	        next: function () {
	          return { done: ITERATION_SUPPORT = true };
	        }
	      };
	    };
	    exec(object);
	  } catch (error) { /* empty */ }
	  return ITERATION_SUPPORT;
	};
	return checkCorrectnessOfIteration;
}

var inheritIfRequired;
var hasRequiredInheritIfRequired;

function requireInheritIfRequired () {
	if (hasRequiredInheritIfRequired) return inheritIfRequired;
	hasRequiredInheritIfRequired = 1;
	var isCallable = requireIsCallable();
	var isObject = requireIsObject();
	var setPrototypeOf = requireObjectSetPrototypeOf();

	// makes subclassing work correct for wrapped built-ins
	inheritIfRequired = function ($this, dummy, Wrapper) {
	  var NewTarget, NewTargetPrototype;
	  if (
	    // it can work only with native `setPrototypeOf`
	    setPrototypeOf &&
	    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
	    isCallable(NewTarget = dummy.constructor) &&
	    NewTarget !== Wrapper &&
	    isObject(NewTargetPrototype = NewTarget.prototype) &&
	    NewTargetPrototype !== Wrapper.prototype
	  ) setPrototypeOf($this, NewTargetPrototype);
	  return $this;
	};
	return inheritIfRequired;
}

var collection;
var hasRequiredCollection;

function requireCollection () {
	if (hasRequiredCollection) return collection;
	hasRequiredCollection = 1;
	var $ = require_export();
	var global = requireGlobal();
	var uncurryThis = requireFunctionUncurryThis();
	var isForced = requireIsForced();
	var defineBuiltIn = requireDefineBuiltIn();
	var InternalMetadataModule = requireInternalMetadata();
	var iterate = requireIterate();
	var anInstance = requireAnInstance();
	var isCallable = requireIsCallable();
	var isNullOrUndefined = requireIsNullOrUndefined();
	var isObject = requireIsObject();
	var fails = requireFails();
	var checkCorrectnessOfIteration = requireCheckCorrectnessOfIteration();
	var setToStringTag = requireSetToStringTag();
	var inheritIfRequired = requireInheritIfRequired();

	collection = function (CONSTRUCTOR_NAME, wrapper, common) {
	  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
	  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var NativeConstructor = global[CONSTRUCTOR_NAME];
	  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
	  var Constructor = NativeConstructor;
	  var exported = {};

	  var fixMethod = function (KEY) {
	    var uncurriedNativeMethod = uncurryThis(NativePrototype[KEY]);
	    defineBuiltIn(NativePrototype, KEY,
	      KEY == 'add' ? function add(value) {
	        uncurriedNativeMethod(this, value === 0 ? 0 : value);
	        return this;
	      } : KEY == 'delete' ? function (key) {
	        return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
	      } : KEY == 'get' ? function get(key) {
	        return IS_WEAK && !isObject(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
	      } : KEY == 'has' ? function has(key) {
	        return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
	      } : function set(key, value) {
	        uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
	        return this;
	      }
	    );
	  };

	  var REPLACE = isForced(
	    CONSTRUCTOR_NAME,
	    !isCallable(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
	      new NativeConstructor().entries().next();
	    }))
	  );

	  if (REPLACE) {
	    // create collection constructor
	    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
	    InternalMetadataModule.enable();
	  } else if (isForced(CONSTRUCTOR_NAME, true)) {
	    var instance = new Constructor();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    // eslint-disable-next-line no-new -- required for testing
	    var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) { new NativeConstructor(iterable); });
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new NativeConstructor();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });

	    if (!ACCEPT_ITERABLES) {
	      Constructor = wrapper(function (dummy, iterable) {
	        anInstance(dummy, NativePrototype);
	        var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
	        if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
	        return that;
	      });
	      Constructor.prototype = NativePrototype;
	      NativePrototype.constructor = Constructor;
	    }

	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }

	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);

	    // weak collections should not contains .clear method
	    if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
	  }

	  exported[CONSTRUCTOR_NAME] = Constructor;
	  $({ global: true, constructor: true, forced: Constructor != NativeConstructor }, exported);

	  setToStringTag(Constructor, CONSTRUCTOR_NAME);

	  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

	  return Constructor;
	};
	return collection;
}

var setSpecies;
var hasRequiredSetSpecies;

function requireSetSpecies () {
	if (hasRequiredSetSpecies) return setSpecies;
	hasRequiredSetSpecies = 1;
	var getBuiltIn = requireGetBuiltIn();
	var defineBuiltInAccessor = requireDefineBuiltInAccessor();
	var wellKnownSymbol = requireWellKnownSymbol();
	var DESCRIPTORS = requireDescriptors();

	var SPECIES = wellKnownSymbol('species');

	setSpecies = function (CONSTRUCTOR_NAME) {
	  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);

	  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
	    defineBuiltInAccessor(Constructor, SPECIES, {
	      configurable: true,
	      get: function () { return this; }
	    });
	  }
	};
	return setSpecies;
}

var collectionStrong;
var hasRequiredCollectionStrong;

function requireCollectionStrong () {
	if (hasRequiredCollectionStrong) return collectionStrong;
	hasRequiredCollectionStrong = 1;
	var create = requireObjectCreate();
	var defineBuiltInAccessor = requireDefineBuiltInAccessor();
	var defineBuiltIns = requireDefineBuiltIns();
	var bind = requireFunctionBindContext();
	var anInstance = requireAnInstance();
	var isNullOrUndefined = requireIsNullOrUndefined();
	var iterate = requireIterate();
	var defineIterator = requireIteratorDefine();
	var createIterResultObject = requireCreateIterResultObject();
	var setSpecies = requireSetSpecies();
	var DESCRIPTORS = requireDescriptors();
	var fastKey = requireInternalMetadata().fastKey;
	var InternalStateModule = requireInternalState();

	var setInternalState = InternalStateModule.set;
	var internalStateGetterFor = InternalStateModule.getterFor;

	collectionStrong = {
	  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
	    var Constructor = wrapper(function (that, iterable) {
	      anInstance(that, Prototype);
	      setInternalState(that, {
	        type: CONSTRUCTOR_NAME,
	        index: create(null),
	        first: undefined,
	        last: undefined,
	        size: 0
	      });
	      if (!DESCRIPTORS) that.size = 0;
	      if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
	    });

	    var Prototype = Constructor.prototype;

	    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

	    var define = function (that, key, value) {
	      var state = getInternalState(that);
	      var entry = getEntry(that, key);
	      var previous, index;
	      // change existing entry
	      if (entry) {
	        entry.value = value;
	      // create new entry
	      } else {
	        state.last = entry = {
	          index: index = fastKey(key, true),
	          key: key,
	          value: value,
	          previous: previous = state.last,
	          next: undefined,
	          removed: false
	        };
	        if (!state.first) state.first = entry;
	        if (previous) previous.next = entry;
	        if (DESCRIPTORS) state.size++;
	        else that.size++;
	        // add to index
	        if (index !== 'F') state.index[index] = entry;
	      } return that;
	    };

	    var getEntry = function (that, key) {
	      var state = getInternalState(that);
	      // fast case
	      var index = fastKey(key);
	      var entry;
	      if (index !== 'F') return state.index[index];
	      // frozen object case
	      for (entry = state.first; entry; entry = entry.next) {
	        if (entry.key == key) return entry;
	      }
	    };

	    defineBuiltIns(Prototype, {
	      // `{ Map, Set }.prototype.clear()` methods
	      // https://tc39.es/ecma262/#sec-map.prototype.clear
	      // https://tc39.es/ecma262/#sec-set.prototype.clear
	      clear: function clear() {
	        var that = this;
	        var state = getInternalState(that);
	        var data = state.index;
	        var entry = state.first;
	        while (entry) {
	          entry.removed = true;
	          if (entry.previous) entry.previous = entry.previous.next = undefined;
	          delete data[entry.index];
	          entry = entry.next;
	        }
	        state.first = state.last = undefined;
	        if (DESCRIPTORS) state.size = 0;
	        else that.size = 0;
	      },
	      // `{ Map, Set }.prototype.delete(key)` methods
	      // https://tc39.es/ecma262/#sec-map.prototype.delete
	      // https://tc39.es/ecma262/#sec-set.prototype.delete
	      'delete': function (key) {
	        var that = this;
	        var state = getInternalState(that);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.next;
	          var prev = entry.previous;
	          delete state.index[entry.index];
	          entry.removed = true;
	          if (prev) prev.next = next;
	          if (next) next.previous = prev;
	          if (state.first == entry) state.first = next;
	          if (state.last == entry) state.last = prev;
	          if (DESCRIPTORS) state.size--;
	          else that.size--;
	        } return !!entry;
	      },
	      // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
	      // https://tc39.es/ecma262/#sec-map.prototype.foreach
	      // https://tc39.es/ecma262/#sec-set.prototype.foreach
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        var state = getInternalState(this);
	        var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	        var entry;
	        while (entry = entry ? entry.next : state.first) {
	          boundFunction(entry.value, entry.key, this);
	          // revert to the last existing entry
	          while (entry && entry.removed) entry = entry.previous;
	        }
	      },
	      // `{ Map, Set}.prototype.has(key)` methods
	      // https://tc39.es/ecma262/#sec-map.prototype.has
	      // https://tc39.es/ecma262/#sec-set.prototype.has
	      has: function has(key) {
	        return !!getEntry(this, key);
	      }
	    });

	    defineBuiltIns(Prototype, IS_MAP ? {
	      // `Map.prototype.get(key)` method
	      // https://tc39.es/ecma262/#sec-map.prototype.get
	      get: function get(key) {
	        var entry = getEntry(this, key);
	        return entry && entry.value;
	      },
	      // `Map.prototype.set(key, value)` method
	      // https://tc39.es/ecma262/#sec-map.prototype.set
	      set: function set(key, value) {
	        return define(this, key === 0 ? 0 : key, value);
	      }
	    } : {
	      // `Set.prototype.add(value)` method
	      // https://tc39.es/ecma262/#sec-set.prototype.add
	      add: function add(value) {
	        return define(this, value = value === 0 ? 0 : value, value);
	      }
	    });
	    if (DESCRIPTORS) defineBuiltInAccessor(Prototype, 'size', {
	      configurable: true,
	      get: function () {
	        return getInternalState(this).size;
	      }
	    });
	    return Constructor;
	  },
	  setStrong: function (Constructor, CONSTRUCTOR_NAME, IS_MAP) {
	    var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
	    var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
	    var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
	    // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
	    // https://tc39.es/ecma262/#sec-map.prototype.entries
	    // https://tc39.es/ecma262/#sec-map.prototype.keys
	    // https://tc39.es/ecma262/#sec-map.prototype.values
	    // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
	    // https://tc39.es/ecma262/#sec-set.prototype.entries
	    // https://tc39.es/ecma262/#sec-set.prototype.keys
	    // https://tc39.es/ecma262/#sec-set.prototype.values
	    // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
	    defineIterator(Constructor, CONSTRUCTOR_NAME, function (iterated, kind) {
	      setInternalState(this, {
	        type: ITERATOR_NAME,
	        target: iterated,
	        state: getInternalCollectionState(iterated),
	        kind: kind,
	        last: undefined
	      });
	    }, function () {
	      var state = getInternalIteratorState(this);
	      var kind = state.kind;
	      var entry = state.last;
	      // revert to the last existing entry
	      while (entry && entry.removed) entry = entry.previous;
	      // get next entry
	      if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
	        // or finish the iteration
	        state.target = undefined;
	        return createIterResultObject(undefined, true);
	      }
	      // return step by kind
	      if (kind == 'keys') return createIterResultObject(entry.key, false);
	      if (kind == 'values') return createIterResultObject(entry.value, false);
	      return createIterResultObject([entry.key, entry.value], false);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

	    // `{ Map, Set }.prototype[@@species]` accessors
	    // https://tc39.es/ecma262/#sec-get-map-@@species
	    // https://tc39.es/ecma262/#sec-get-set-@@species
	    setSpecies(CONSTRUCTOR_NAME);
	  }
	};
	return collectionStrong;
}

var hasRequiredEs_map_constructor;

function requireEs_map_constructor () {
	if (hasRequiredEs_map_constructor) return es_map_constructor;
	hasRequiredEs_map_constructor = 1;
	var collection = requireCollection();
	var collectionStrong = requireCollectionStrong();

	// `Map` constructor
	// https://tc39.es/ecma262/#sec-map-objects
	collection('Map', function (init) {
	  return function Map() { return init(this, arguments.length ? arguments[0] : undefined); };
	}, collectionStrong);
	return es_map_constructor;
}

var hasRequiredEs_map;

function requireEs_map () {
	if (hasRequiredEs_map) return es_map;
	hasRequiredEs_map = 1;
	// TODO: Remove this module from `core-js@4` since it's replaced to module below
	requireEs_map_constructor();
	return es_map;
}

var map;
var hasRequiredMap;

function requireMap () {
	if (hasRequiredMap) return map;
	hasRequiredMap = 1;
	requireEs_array_iterator();
	requireEs_map();
	requireEs_object_toString();
	requireEs_string_iterator();
	var path = requirePath();

	map = path.Map;
	return map;
}

requireMap();

var es_set = {};

var es_set_constructor = {};

var hasRequiredEs_set_constructor;

function requireEs_set_constructor () {
	if (hasRequiredEs_set_constructor) return es_set_constructor;
	hasRequiredEs_set_constructor = 1;
	var collection = requireCollection();
	var collectionStrong = requireCollectionStrong();

	// `Set` constructor
	// https://tc39.es/ecma262/#sec-set-objects
	collection('Set', function (init) {
	  return function Set() { return init(this, arguments.length ? arguments[0] : undefined); };
	}, collectionStrong);
	return es_set_constructor;
}

var hasRequiredEs_set;

function requireEs_set () {
	if (hasRequiredEs_set) return es_set;
	hasRequiredEs_set = 1;
	// TODO: Remove this module from `core-js@4` since it's replaced to module below
	requireEs_set_constructor();
	return es_set;
}

var set;
var hasRequiredSet;

function requireSet () {
	if (hasRequiredSet) return set;
	hasRequiredSet = 1;
	requireEs_array_iterator();
	requireEs_object_toString();
	requireEs_set();
	requireEs_string_iterator();
	var path = requirePath();

	set = path.Set;
	return set;
}

requireSet();

var urlSearchParamsPolyfill = {};

/**
 *
 *
 * @author Jerry Bendy <jerry@icewingcc.com>
 * @licence MIT
 *
 */

var hasRequiredUrlSearchParamsPolyfill;

function requireUrlSearchParamsPolyfill () {
	if (hasRequiredUrlSearchParamsPolyfill) return urlSearchParamsPolyfill;
	hasRequiredUrlSearchParamsPolyfill = 1;
	(function(self) {

	    var nativeURLSearchParams = (function() {
	            // #41 Fix issue in RN
	            try {
	                if (self.URLSearchParams && (new self.URLSearchParams('foo=bar')).get('foo') === 'bar') {
	                    return self.URLSearchParams;
	                }
	            } catch (e) {}
	            return null;
	        })(),
	        isSupportObjectConstructor = nativeURLSearchParams && (new nativeURLSearchParams({a: 1})).toString() === 'a=1',
	        // There is a bug in safari 10.1 (and earlier) that incorrectly decodes `%2B` as an empty space and not a plus.
	        decodesPlusesCorrectly = nativeURLSearchParams && (new nativeURLSearchParams('s=%2B').get('s') === '+'),
	        __URLSearchParams__ = "__URLSearchParams__",
	        // Fix bug in Edge which cannot encode ' &' correctly
	        encodesAmpersandsCorrectly = nativeURLSearchParams ? (function() {
	            var ampersandTest = new nativeURLSearchParams();
	            ampersandTest.append('s', ' &');
	            return ampersandTest.toString() === 's=+%26';
	        })() : true,
	        prototype = URLSearchParamsPolyfill.prototype,
	        iterable = !!(self.Symbol && self.Symbol.iterator);

	    if (nativeURLSearchParams && isSupportObjectConstructor && decodesPlusesCorrectly && encodesAmpersandsCorrectly) {
	        return;
	    }


	    /**
	     * Make a URLSearchParams instance
	     *
	     * @param {object|string|URLSearchParams} search
	     * @constructor
	     */
	    function URLSearchParamsPolyfill(search) {
	        search = search || "";

	        // support construct object with another URLSearchParams instance
	        if (search instanceof URLSearchParams || search instanceof URLSearchParamsPolyfill) {
	            search = search.toString();
	        }
	        this [__URLSearchParams__] = parseToDict(search);
	    }


	    /**
	     * Appends a specified key/value pair as a new search parameter.
	     *
	     * @param {string} name
	     * @param {string} value
	     */
	    prototype.append = function(name, value) {
	        appendTo(this [__URLSearchParams__], name, value);
	    };

	    /**
	     * Deletes the given search parameter, and its associated value,
	     * from the list of all search parameters.
	     *
	     * @param {string} name
	     */
	    prototype['delete'] = function(name) {
	        delete this [__URLSearchParams__] [name];
	    };

	    /**
	     * Returns the first value associated to the given search parameter.
	     *
	     * @param {string} name
	     * @returns {string|null}
	     */
	    prototype.get = function(name) {
	        var dict = this [__URLSearchParams__];
	        return this.has(name) ? dict[name][0] : null;
	    };

	    /**
	     * Returns all the values association with a given search parameter.
	     *
	     * @param {string} name
	     * @returns {Array}
	     */
	    prototype.getAll = function(name) {
	        var dict = this [__URLSearchParams__];
	        return this.has(name) ? dict [name].slice(0) : [];
	    };

	    /**
	     * Returns a Boolean indicating if such a search parameter exists.
	     *
	     * @param {string} name
	     * @returns {boolean}
	     */
	    prototype.has = function(name) {
	        return hasOwnProperty(this [__URLSearchParams__], name);
	    };

	    /**
	     * Sets the value associated to a given search parameter to
	     * the given value. If there were several values, delete the
	     * others.
	     *
	     * @param {string} name
	     * @param {string} value
	     */
	    prototype.set = function set(name, value) {
	        this [__URLSearchParams__][name] = ['' + value];
	    };

	    /**
	     * Returns a string containg a query string suitable for use in a URL.
	     *
	     * @returns {string}
	     */
	    prototype.toString = function() {
	        var dict = this[__URLSearchParams__], query = [], i, key, name, value;
	        for (key in dict) {
	            name = encode(key);
	            for (i = 0, value = dict[key]; i < value.length; i++) {
	                query.push(name + '=' + encode(value[i]));
	            }
	        }
	        return query.join('&');
	    };

	    // There is a bug in Safari 10.1 and `Proxy`ing it is not enough.
	    var forSureUsePolyfill = !decodesPlusesCorrectly;
	    var useProxy = (!forSureUsePolyfill && nativeURLSearchParams && !isSupportObjectConstructor && self.Proxy);
	    var propValue; 
	    if (useProxy) {
	        // Safari 10.0 doesn't support Proxy, so it won't extend URLSearchParams on safari 10.0
	        propValue = new Proxy(nativeURLSearchParams, {
	            construct: function (target, args) {
	                return new target((new URLSearchParamsPolyfill(args[0]).toString()));
	            }
	        });
	        // Chrome <=60 .toString() on a function proxy got error "Function.prototype.toString is not generic"
	        propValue.toString = Function.prototype.toString.bind(URLSearchParamsPolyfill);
	    } else {
	        propValue = URLSearchParamsPolyfill;
	    }
	    /*
	     * Apply polifill to global object and append other prototype into it
	     */
	    Object.defineProperty(self, 'URLSearchParams', {
	        value: propValue
	    });

	    var USPProto = self.URLSearchParams.prototype;

	    USPProto.polyfill = true;

	    /**
	     *
	     * @param {function} callback
	     * @param {object} thisArg
	     */
	    USPProto.forEach = USPProto.forEach || function(callback, thisArg) {
	        var dict = parseToDict(this.toString());
	        Object.getOwnPropertyNames(dict).forEach(function(name) {
	            dict[name].forEach(function(value) {
	                callback.call(thisArg, value, name, this);
	            }, this);
	        }, this);
	    };

	    /**
	     * Sort all name-value pairs
	     */
	    USPProto.sort = USPProto.sort || function() {
	        var dict = parseToDict(this.toString()), keys = [], k, i, j;
	        for (k in dict) {
	            keys.push(k);
	        }
	        keys.sort();

	        for (i = 0; i < keys.length; i++) {
	            this['delete'](keys[i]);
	        }
	        for (i = 0; i < keys.length; i++) {
	            var key = keys[i], values = dict[key];
	            for (j = 0; j < values.length; j++) {
	                this.append(key, values[j]);
	            }
	        }
	    };

	    /**
	     * Returns an iterator allowing to go through all keys of
	     * the key/value pairs contained in this object.
	     *
	     * @returns {function}
	     */
	    USPProto.keys = USPProto.keys || function() {
	        var items = [];
	        this.forEach(function(item, name) {
	            items.push(name);
	        });
	        return makeIterator(items);
	    };

	    /**
	     * Returns an iterator allowing to go through all values of
	     * the key/value pairs contained in this object.
	     *
	     * @returns {function}
	     */
	    USPProto.values = USPProto.values || function() {
	        var items = [];
	        this.forEach(function(item) {
	            items.push(item);
	        });
	        return makeIterator(items);
	    };

	    /**
	     * Returns an iterator allowing to go through all key/value
	     * pairs contained in this object.
	     *
	     * @returns {function}
	     */
	    USPProto.entries = USPProto.entries || function() {
	        var items = [];
	        this.forEach(function(item, name) {
	            items.push([name, item]);
	        });
	        return makeIterator(items);
	    };


	    if (iterable) {
	        USPProto[self.Symbol.iterator] = USPProto[self.Symbol.iterator] || USPProto.entries;
	    }


	    function encode(str) {
	        var replace = {
	            '!': '%21',
	            "'": '%27',
	            '(': '%28',
	            ')': '%29',
	            '~': '%7E',
	            '%20': '+',
	            '%00': '\x00'
	        };
	        return encodeURIComponent(str).replace(/[!'\(\)~]|%20|%00/g, function(match) {
	            return replace[match];
	        });
	    }

	    function decode(str) {
	        return str
	            .replace(/[ +]/g, '%20')
	            .replace(/(%[a-f0-9]{2})+/ig, function(match) {
	                return decodeURIComponent(match);
	            });
	    }

	    function makeIterator(arr) {
	        var iterator = {
	            next: function() {
	                var value = arr.shift();
	                return {done: value === undefined, value: value};
	            }
	        };

	        if (iterable) {
	            iterator[self.Symbol.iterator] = function() {
	                return iterator;
	            };
	        }

	        return iterator;
	    }

	    function parseToDict(search) {
	        var dict = {};

	        if (typeof search === "object") {
	            // if `search` is an array, treat it as a sequence
	            if (isArray(search)) {
	                for (var i = 0; i < search.length; i++) {
	                    var item = search[i];
	                    if (isArray(item) && item.length === 2) {
	                        appendTo(dict, item[0], item[1]);
	                    } else {
	                        throw new TypeError("Failed to construct 'URLSearchParams': Sequence initializer must only contain pair elements");
	                    }
	                }

	            } else {
	                for (var key in search) {
	                    if (search.hasOwnProperty(key)) {
	                        appendTo(dict, key, search[key]);
	                    }
	                }
	            }

	        } else {
	            // remove first '?'
	            if (search.indexOf("?") === 0) {
	                search = search.slice(1);
	            }

	            var pairs = search.split("&");
	            for (var j = 0; j < pairs.length; j++) {
	                var value = pairs [j],
	                    index = value.indexOf('=');

	                if (-1 < index) {
	                    appendTo(dict, decode(value.slice(0, index)), decode(value.slice(index + 1)));

	                } else {
	                    if (value) {
	                        appendTo(dict, decode(value), '');
	                    }
	                }
	            }
	        }

	        return dict;
	    }

	    function appendTo(dict, name, value) {
	        var val = typeof value === 'string' ? value : (
	            value !== null && value !== undefined && typeof value.toString === 'function' ? value.toString() : JSON.stringify(value)
	        );

	        // #47 Prevent using `hasOwnProperty` as a property name
	        if (hasOwnProperty(dict, name)) {
	            dict[name].push(val);
	        } else {
	            dict[name] = [val];
	        }
	    }

	    function isArray(val) {
	        return !!val && '[object Array]' === Object.prototype.toString.call(val);
	    }

	    function hasOwnProperty(obj, prop) {
	        return Object.prototype.hasOwnProperty.call(obj, prop);
	    }

	})(typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : (typeof window !== 'undefined' ? window : urlSearchParamsPolyfill));
	return urlSearchParamsPolyfill;
}

requireUrlSearchParamsPolyfill();

Array.prototype.flat||Object.defineProperty(Array.prototype,"flat",{configurable:true,value:function r(){var t=isNaN(arguments[0])?1:Number(arguments[0]);return t?Array.prototype.reduce.call(this,function(a,e){return Array.isArray(e)?a.push.apply(a,r.call(e,t-1)):a.push(e),a},[]):Array.prototype.slice.call(this)},writable:true}),Array.prototype.flatMap||Object.defineProperty(Array.prototype,"flatMap",{configurable:true,value:function(r){return Array.prototype.map.apply(this,arguments).flat()},writable:true});

var global =
  (typeof globalThis !== 'undefined' && globalThis) ||
  (typeof self !== 'undefined' && self) ||
  (typeof global !== 'undefined' && global);

var support = {
  searchParams: 'URLSearchParams' in global,
  iterable: 'Symbol' in global && 'iterator' in Symbol,
  blob:
    'FileReader' in global &&
    'Blob' in global &&
    (function() {
      try {
        new Blob();
        return true
      } catch (e) {
        return false
      }
    })(),
  formData: 'FormData' in global,
  arrayBuffer: 'ArrayBuffer' in global
};

function isDataView(obj) {
  return obj && DataView.prototype.isPrototypeOf(obj)
}

if (support.arrayBuffer) {
  var viewClasses = [
    '[object Int8Array]',
    '[object Uint8Array]',
    '[object Uint8ClampedArray]',
    '[object Int16Array]',
    '[object Uint16Array]',
    '[object Int32Array]',
    '[object Uint32Array]',
    '[object Float32Array]',
    '[object Float64Array]'
  ];

  var isArrayBufferView =
    ArrayBuffer.isView ||
    function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    };
}

function normalizeName(name) {
  if (typeof name !== 'string') {
    name = String(name);
  }
  if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') {
    throw new TypeError('Invalid character in header field name: "' + name + '"')
  }
  return name.toLowerCase()
}

function normalizeValue(value) {
  if (typeof value !== 'string') {
    value = String(value);
  }
  return value
}

// Build a destructive iterator for the value list
function iteratorFor(items) {
  var iterator = {
    next: function() {
      var value = items.shift();
      return {done: value === undefined, value: value}
    }
  };

  if (support.iterable) {
    iterator[Symbol.iterator] = function() {
      return iterator
    };
  }

  return iterator
}

function Headers(headers) {
  this.map = {};

  if (headers instanceof Headers) {
    headers.forEach(function(value, name) {
      this.append(name, value);
    }, this);
  } else if (Array.isArray(headers)) {
    headers.forEach(function(header) {
      this.append(header[0], header[1]);
    }, this);
  } else if (headers) {
    Object.getOwnPropertyNames(headers).forEach(function(name) {
      this.append(name, headers[name]);
    }, this);
  }
}

Headers.prototype.append = function(name, value) {
  name = normalizeName(name);
  value = normalizeValue(value);
  var oldValue = this.map[name];
  this.map[name] = oldValue ? oldValue + ', ' + value : value;
};

Headers.prototype['delete'] = function(name) {
  delete this.map[normalizeName(name)];
};

Headers.prototype.get = function(name) {
  name = normalizeName(name);
  return this.has(name) ? this.map[name] : null
};

Headers.prototype.has = function(name) {
  return this.map.hasOwnProperty(normalizeName(name))
};

Headers.prototype.set = function(name, value) {
  this.map[normalizeName(name)] = normalizeValue(value);
};

Headers.prototype.forEach = function(callback, thisArg) {
  for (var name in this.map) {
    if (this.map.hasOwnProperty(name)) {
      callback.call(thisArg, this.map[name], name, this);
    }
  }
};

Headers.prototype.keys = function() {
  var items = [];
  this.forEach(function(value, name) {
    items.push(name);
  });
  return iteratorFor(items)
};

Headers.prototype.values = function() {
  var items = [];
  this.forEach(function(value) {
    items.push(value);
  });
  return iteratorFor(items)
};

Headers.prototype.entries = function() {
  var items = [];
  this.forEach(function(value, name) {
    items.push([name, value]);
  });
  return iteratorFor(items)
};

if (support.iterable) {
  Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
}

function consumed(body) {
  if (body.bodyUsed) {
    return Promise.reject(new TypeError('Already read'))
  }
  body.bodyUsed = true;
}

function fileReaderReady(reader) {
  return new Promise(function(resolve, reject) {
    reader.onload = function() {
      resolve(reader.result);
    };
    reader.onerror = function() {
      reject(reader.error);
    };
  })
}

function readBlobAsArrayBuffer(blob) {
  var reader = new FileReader();
  var promise = fileReaderReady(reader);
  reader.readAsArrayBuffer(blob);
  return promise
}

function readBlobAsText(blob) {
  var reader = new FileReader();
  var promise = fileReaderReady(reader);
  reader.readAsText(blob);
  return promise
}

function readArrayBufferAsText(buf) {
  var view = new Uint8Array(buf);
  var chars = new Array(view.length);

  for (var i = 0; i < view.length; i++) {
    chars[i] = String.fromCharCode(view[i]);
  }
  return chars.join('')
}

function bufferClone(buf) {
  if (buf.slice) {
    return buf.slice(0)
  } else {
    var view = new Uint8Array(buf.byteLength);
    view.set(new Uint8Array(buf));
    return view.buffer
  }
}

function Body() {
  this.bodyUsed = false;

  this._initBody = function(body) {
    /*
      fetch-mock wraps the Response object in an ES6 Proxy to
      provide useful test harness features such as flush. However, on
      ES5 browsers without fetch or Proxy support pollyfills must be used;
      the proxy-pollyfill is unable to proxy an attribute unless it exists
      on the object before the Proxy is created. This change ensures
      Response.bodyUsed exists on the instance, while maintaining the
      semantic of setting Request.bodyUsed in the constructor before
      _initBody is called.
    */
    this.bodyUsed = this.bodyUsed;
    this._bodyInit = body;
    if (!body) {
      this._bodyText = '';
    } else if (typeof body === 'string') {
      this._bodyText = body;
    } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
      this._bodyBlob = body;
    } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
      this._bodyFormData = body;
    } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
      this._bodyText = body.toString();
    } else if (support.arrayBuffer && support.blob && isDataView(body)) {
      this._bodyArrayBuffer = bufferClone(body.buffer);
      // IE 10-11 can't handle a DataView body.
      this._bodyInit = new Blob([this._bodyArrayBuffer]);
    } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
      this._bodyArrayBuffer = bufferClone(body);
    } else {
      this._bodyText = body = Object.prototype.toString.call(body);
    }

    if (!this.headers.get('content-type')) {
      if (typeof body === 'string') {
        this.headers.set('content-type', 'text/plain;charset=UTF-8');
      } else if (this._bodyBlob && this._bodyBlob.type) {
        this.headers.set('content-type', this._bodyBlob.type);
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
      }
    }
  };

  if (support.blob) {
    this.blob = function() {
      var rejected = consumed(this);
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return Promise.resolve(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(new Blob([this._bodyArrayBuffer]))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as blob')
      } else {
        return Promise.resolve(new Blob([this._bodyText]))
      }
    };

    this.arrayBuffer = function() {
      if (this._bodyArrayBuffer) {
        var isConsumed = consumed(this);
        if (isConsumed) {
          return isConsumed
        }
        if (ArrayBuffer.isView(this._bodyArrayBuffer)) {
          return Promise.resolve(
            this._bodyArrayBuffer.buffer.slice(
              this._bodyArrayBuffer.byteOffset,
              this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
            )
          )
        } else {
          return Promise.resolve(this._bodyArrayBuffer)
        }
      } else {
        return this.blob().then(readBlobAsArrayBuffer)
      }
    };
  }

  this.text = function() {
    var rejected = consumed(this);
    if (rejected) {
      return rejected
    }

    if (this._bodyBlob) {
      return readBlobAsText(this._bodyBlob)
    } else if (this._bodyArrayBuffer) {
      return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
    } else if (this._bodyFormData) {
      throw new Error('could not read FormData body as text')
    } else {
      return Promise.resolve(this._bodyText)
    }
  };

  if (support.formData) {
    this.formData = function() {
      return this.text().then(decode)
    };
  }

  this.json = function() {
    return this.text().then(JSON.parse)
  };

  return this
}

// HTTP methods whose capitalization should be normalized
var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

function normalizeMethod(method) {
  var upcased = method.toUpperCase();
  return methods.indexOf(upcased) > -1 ? upcased : method
}

function Request(input, options) {
  if (!(this instanceof Request)) {
    throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
  }

  options = options || {};
  var body = options.body;

  if (input instanceof Request) {
    if (input.bodyUsed) {
      throw new TypeError('Already read')
    }
    this.url = input.url;
    this.credentials = input.credentials;
    if (!options.headers) {
      this.headers = new Headers(input.headers);
    }
    this.method = input.method;
    this.mode = input.mode;
    this.signal = input.signal;
    if (!body && input._bodyInit != null) {
      body = input._bodyInit;
      input.bodyUsed = true;
    }
  } else {
    this.url = String(input);
  }

  this.credentials = options.credentials || this.credentials || 'same-origin';
  if (options.headers || !this.headers) {
    this.headers = new Headers(options.headers);
  }
  this.method = normalizeMethod(options.method || this.method || 'GET');
  this.mode = options.mode || this.mode || null;
  this.signal = options.signal || this.signal;
  this.referrer = null;

  if ((this.method === 'GET' || this.method === 'HEAD') && body) {
    throw new TypeError('Body not allowed for GET or HEAD requests')
  }
  this._initBody(body);

  if (this.method === 'GET' || this.method === 'HEAD') {
    if (options.cache === 'no-store' || options.cache === 'no-cache') {
      // Search for a '_' parameter in the query string
      var reParamSearch = /([?&])_=[^&]*/;
      if (reParamSearch.test(this.url)) {
        // If it already exists then set the value with the current time
        this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
      } else {
        // Otherwise add a new '_' parameter to the end with the current time
        var reQueryString = /\?/;
        this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
      }
    }
  }
}

Request.prototype.clone = function() {
  return new Request(this, {body: this._bodyInit})
};

function decode(body) {
  var form = new FormData();
  body
    .trim()
    .split('&')
    .forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=');
        var name = split.shift().replace(/\+/g, ' ');
        var value = split.join('=').replace(/\+/g, ' ');
        form.append(decodeURIComponent(name), decodeURIComponent(value));
      }
    });
  return form
}

function parseHeaders(rawHeaders) {
  var headers = new Headers();
  // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
  // https://tools.ietf.org/html/rfc7230#section-3.2
  var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
  // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
  // https://github.com/github/fetch/issues/748
  // https://github.com/zloirock/core-js/issues/751
  preProcessedHeaders
    .split('\r')
    .map(function(header) {
      return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header
    })
    .forEach(function(line) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
  return headers
}

Body.call(Request.prototype);

function Response(bodyInit, options) {
  if (!(this instanceof Response)) {
    throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
  }
  if (!options) {
    options = {};
  }

  this.type = 'default';
  this.status = options.status === undefined ? 200 : options.status;
  this.ok = this.status >= 200 && this.status < 300;
  this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
  this.headers = new Headers(options.headers);
  this.url = options.url || '';
  this._initBody(bodyInit);
}

Body.call(Response.prototype);

Response.prototype.clone = function() {
  return new Response(this._bodyInit, {
    status: this.status,
    statusText: this.statusText,
    headers: new Headers(this.headers),
    url: this.url
  })
};

Response.error = function() {
  var response = new Response(null, {status: 0, statusText: ''});
  response.type = 'error';
  return response
};

var redirectStatuses = [301, 302, 303, 307, 308];

Response.redirect = function(url, status) {
  if (redirectStatuses.indexOf(status) === -1) {
    throw new RangeError('Invalid status code')
  }

  return new Response(null, {status: status, headers: {location: url}})
};

var DOMException$1 = global.DOMException;
try {
  new DOMException$1();
} catch (err) {
  DOMException$1 = function(message, name) {
    this.message = message;
    this.name = name;
    var error = Error(message);
    this.stack = error.stack;
  };
  DOMException$1.prototype = Object.create(Error.prototype);
  DOMException$1.prototype.constructor = DOMException$1;
}

function fetch(input, init) {
  return new Promise(function(resolve, reject) {
    var request = new Request(input, init);

    if (request.signal && request.signal.aborted) {
      return reject(new DOMException$1('Aborted', 'AbortError'))
    }

    var xhr = new XMLHttpRequest();

    function abortXhr() {
      xhr.abort();
    }

    xhr.onload = function() {
      var options = {
        status: xhr.status,
        statusText: xhr.statusText,
        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
      };
      options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
      var body = 'response' in xhr ? xhr.response : xhr.responseText;
      setTimeout(function() {
        resolve(new Response(body, options));
      }, 0);
    };

    xhr.onerror = function() {
      setTimeout(function() {
        reject(new TypeError('Network request failed'));
      }, 0);
    };

    xhr.ontimeout = function() {
      setTimeout(function() {
        reject(new TypeError('Network request failed'));
      }, 0);
    };

    xhr.onabort = function() {
      setTimeout(function() {
        reject(new DOMException$1('Aborted', 'AbortError'));
      }, 0);
    };

    function fixUrl(url) {
      try {
        return url === '' && global.location.href ? global.location.href : url
      } catch (e) {
        return url
      }
    }

    xhr.open(request.method, fixUrl(request.url), true);

    if (request.credentials === 'include') {
      xhr.withCredentials = true;
    } else if (request.credentials === 'omit') {
      xhr.withCredentials = false;
    }

    if ('responseType' in xhr) {
      if (support.blob) {
        xhr.responseType = 'blob';
      } else if (
        support.arrayBuffer &&
        request.headers.get('Content-Type') &&
        request.headers.get('Content-Type').indexOf('application/octet-stream') !== -1
      ) {
        xhr.responseType = 'arraybuffer';
      }
    }

    if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers)) {
      Object.getOwnPropertyNames(init.headers).forEach(function(name) {
        xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
      });
    } else {
      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value);
      });
    }

    if (request.signal) {
      request.signal.addEventListener('abort', abortXhr);

      xhr.onreadystatechange = function() {
        // DONE (success or failure)
        if (xhr.readyState === 4) {
          request.signal.removeEventListener('abort', abortXhr);
        }
      };
    }

    xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
  })
}

fetch.polyfill = true;

if (!global.fetch) {
  global.fetch = fetch;
  global.Headers = Headers;
  global.Request = Request;
  global.Response = Response;
}

var polyfillPatchFetch = {};

var hasRequiredPolyfillPatchFetch;

function requirePolyfillPatchFetch () {
	if (hasRequiredPolyfillPatchFetch) return polyfillPatchFetch;
	hasRequiredPolyfillPatchFetch = 1;
	(function (factory) {
	  factory();
	})((function () {
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }

	  function _defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }

	  function _createClass(Constructor, protoProps, staticProps) {
	    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	    Object.defineProperty(Constructor, "prototype", {
	      writable: false
	    });
	    return Constructor;
	  }

	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function");
	    }

	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        writable: true,
	        configurable: true
	      }
	    });
	    Object.defineProperty(subClass, "prototype", {
	      writable: false
	    });
	    if (superClass) _setPrototypeOf(subClass, superClass);
	  }

	  function _getPrototypeOf(o) {
	    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
	      return o.__proto__ || Object.getPrototypeOf(o);
	    };
	    return _getPrototypeOf(o);
	  }

	  function _setPrototypeOf(o, p) {
	    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
	      o.__proto__ = p;
	      return o;
	    };
	    return _setPrototypeOf(o, p);
	  }

	  function _isNativeReflectConstruct() {
	    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
	    if (Reflect.construct.sham) return false;
	    if (typeof Proxy === "function") return true;

	    try {
	      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }

	  function _assertThisInitialized(self) {
	    if (self === void 0) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }

	    return self;
	  }

	  function _possibleConstructorReturn(self, call) {
	    if (call && (typeof call === "object" || typeof call === "function")) {
	      return call;
	    } else if (call !== void 0) {
	      throw new TypeError("Derived constructors may only return object or undefined");
	    }

	    return _assertThisInitialized(self);
	  }

	  function _createSuper(Derived) {
	    var hasNativeReflectConstruct = _isNativeReflectConstruct();

	    return function _createSuperInternal() {
	      var Super = _getPrototypeOf(Derived),
	          result;

	      if (hasNativeReflectConstruct) {
	        var NewTarget = _getPrototypeOf(this).constructor;

	        result = Reflect.construct(Super, arguments, NewTarget);
	      } else {
	        result = Super.apply(this, arguments);
	      }

	      return _possibleConstructorReturn(this, result);
	    };
	  }

	  function _superPropBase(object, property) {
	    while (!Object.prototype.hasOwnProperty.call(object, property)) {
	      object = _getPrototypeOf(object);
	      if (object === null) break;
	    }

	    return object;
	  }

	  function _get() {
	    if (typeof Reflect !== "undefined" && Reflect.get) {
	      _get = Reflect.get.bind();
	    } else {
	      _get = function _get(target, property, receiver) {
	        var base = _superPropBase(target, property);

	        if (!base) return;
	        var desc = Object.getOwnPropertyDescriptor(base, property);

	        if (desc.get) {
	          return desc.get.call(arguments.length < 3 ? target : receiver);
	        }

	        return desc.value;
	      };
	    }

	    return _get.apply(this, arguments);
	  }

	  var Emitter = /*#__PURE__*/function () {
	    function Emitter() {
	      _classCallCheck(this, Emitter);

	      Object.defineProperty(this, 'listeners', {
	        value: {},
	        writable: true,
	        configurable: true
	      });
	    }

	    _createClass(Emitter, [{
	      key: "addEventListener",
	      value: function addEventListener(type, callback, options) {
	        if (!(type in this.listeners)) {
	          this.listeners[type] = [];
	        }

	        this.listeners[type].push({
	          callback: callback,
	          options: options
	        });
	      }
	    }, {
	      key: "removeEventListener",
	      value: function removeEventListener(type, callback) {
	        if (!(type in this.listeners)) {
	          return;
	        }

	        var stack = this.listeners[type];

	        for (var i = 0, l = stack.length; i < l; i++) {
	          if (stack[i].callback === callback) {
	            stack.splice(i, 1);
	            return;
	          }
	        }
	      }
	    }, {
	      key: "dispatchEvent",
	      value: function dispatchEvent(event) {
	        if (!(event.type in this.listeners)) {
	          return;
	        }

	        var stack = this.listeners[event.type];
	        var stackToCall = stack.slice();

	        for (var i = 0, l = stackToCall.length; i < l; i++) {
	          var listener = stackToCall[i];

	          try {
	            listener.callback.call(this, event);
	          } catch (e) {
	            Promise.resolve().then(function () {
	              throw e;
	            });
	          }

	          if (listener.options && listener.options.once) {
	            this.removeEventListener(event.type, listener.callback);
	          }
	        }

	        return !event.defaultPrevented;
	      }
	    }]);

	    return Emitter;
	  }();

	  var AbortSignal = /*#__PURE__*/function (_Emitter) {
	    _inherits(AbortSignal, _Emitter);

	    var _super = _createSuper(AbortSignal);

	    function AbortSignal() {
	      var _this;

	      _classCallCheck(this, AbortSignal);

	      _this = _super.call(this); // Some versions of babel does not transpile super() correctly for IE <= 10, if the parent
	      // constructor has failed to run, then "this.listeners" will still be undefined and then we call
	      // the parent constructor directly instead as a workaround. For general details, see babel bug:
	      // https://github.com/babel/babel/issues/3041
	      // This hack was added as a fix for the issue described here:
	      // https://github.com/Financial-Times/polyfill-library/pull/59#issuecomment-477558042

	      if (!_this.listeners) {
	        Emitter.call(_assertThisInitialized(_this));
	      } // Compared to assignment, Object.defineProperty makes properties non-enumerable by default and
	      // we want Object.keys(new AbortController().signal) to be [] for compat with the native impl


	      Object.defineProperty(_assertThisInitialized(_this), 'aborted', {
	        value: false,
	        writable: true,
	        configurable: true
	      });
	      Object.defineProperty(_assertThisInitialized(_this), 'onabort', {
	        value: null,
	        writable: true,
	        configurable: true
	      });
	      Object.defineProperty(_assertThisInitialized(_this), 'reason', {
	        value: undefined,
	        writable: true,
	        configurable: true
	      });
	      return _this;
	    }

	    _createClass(AbortSignal, [{
	      key: "toString",
	      value: function toString() {
	        return '[object AbortSignal]';
	      }
	    }, {
	      key: "dispatchEvent",
	      value: function dispatchEvent(event) {
	        if (event.type === 'abort') {
	          this.aborted = true;

	          if (typeof this.onabort === 'function') {
	            this.onabort.call(this, event);
	          }
	        }

	        _get(_getPrototypeOf(AbortSignal.prototype), "dispatchEvent", this).call(this, event);
	      }
	    }]);

	    return AbortSignal;
	  }(Emitter);
	  var AbortController = /*#__PURE__*/function () {
	    function AbortController() {
	      _classCallCheck(this, AbortController);

	      // Compared to assignment, Object.defineProperty makes properties non-enumerable by default and
	      // we want Object.keys(new AbortController()) to be [] for compat with the native impl
	      Object.defineProperty(this, 'signal', {
	        value: new AbortSignal(),
	        writable: true,
	        configurable: true
	      });
	    }

	    _createClass(AbortController, [{
	      key: "abort",
	      value: function abort(reason) {
	        var event;

	        try {
	          event = new Event('abort');
	        } catch (e) {
	          if (typeof document !== 'undefined') {
	            if (!document.createEvent) {
	              // For Internet Explorer 8:
	              event = document.createEventObject();
	              event.type = 'abort';
	            } else {
	              // For Internet Explorer 11:
	              event = document.createEvent('Event');
	              event.initEvent('abort', false, false);
	            }
	          } else {
	            // Fallback where document isn't available:
	            event = {
	              type: 'abort',
	              bubbles: false,
	              cancelable: false
	            };
	          }
	        }

	        var signalReason = reason;

	        if (signalReason === undefined) {
	          if (typeof document === 'undefined') {
	            signalReason = new Error('This operation was aborted');
	            signalReason.name = 'AbortError';
	          } else {
	            try {
	              signalReason = new DOMException('signal is aborted without reason');
	            } catch (err) {
	              // IE 11 does not support calling the DOMException constructor, use a
	              // regular error object on it instead.
	              signalReason = new Error('This operation was aborted');
	              signalReason.name = 'AbortError';
	            }
	          }
	        }

	        this.signal.reason = signalReason;
	        this.signal.dispatchEvent(event);
	      }
	    }, {
	      key: "toString",
	      value: function toString() {
	        return '[object AbortController]';
	      }
	    }]);

	    return AbortController;
	  }();

	  if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	    // These are necessary to make sure that we get correct output for:
	    // Object.prototype.toString.call(new AbortController())
	    AbortController.prototype[Symbol.toStringTag] = 'AbortController';
	    AbortSignal.prototype[Symbol.toStringTag] = 'AbortSignal';
	  }

	  function polyfillNeeded(self) {
	    if (self.__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL) {
	      console.log('__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL=true is set, will force install polyfill');
	      return true;
	    } // Note that the "unfetch" minimal fetch polyfill defines fetch() without
	    // defining window.Request, and this polyfill need to work on top of unfetch
	    // so the below feature detection needs the !self.AbortController part.
	    // The Request.prototype check is also needed because Safari versions 11.1.2
	    // up to and including 12.1.x has a window.AbortController present but still
	    // does NOT correctly implement abortable fetch:
	    // https://bugs.webkit.org/show_bug.cgi?id=174980#c2


	    return typeof self.Request === 'function' && !self.Request.prototype.hasOwnProperty('signal') || !self.AbortController;
	  }

	  /**
	   * Note: the "fetch.Request" default value is available for fetch imported from
	   * the "node-fetch" package and not in browsers. This is OK since browsers
	   * will be importing umd-polyfill.js from that path "self" is passed the
	   * decorator so the default value will not be used (because browsers that define
	   * fetch also has Request). One quirky setup where self.fetch exists but
	   * self.Request does not is when the "unfetch" minimal fetch polyfill is used
	   * on top of IE11; for this case the browser will try to use the fetch.Request
	   * default value which in turn will be undefined but then then "if (Request)"
	   * will ensure that you get a patched fetch but still no Request (as expected).
	   * @param {fetch, Request = fetch.Request}
	   * @returns {fetch: abortableFetch, Request: AbortableRequest}
	   */

	  function abortableFetchDecorator(patchTargets) {
	    if ('function' === typeof patchTargets) {
	      patchTargets = {
	        fetch: patchTargets
	      };
	    }

	    var _patchTargets = patchTargets,
	        fetch = _patchTargets.fetch,
	        _patchTargets$Request = _patchTargets.Request,
	        NativeRequest = _patchTargets$Request === void 0 ? fetch.Request : _patchTargets$Request,
	        NativeAbortController = _patchTargets.AbortController,
	        _patchTargets$__FORCE = _patchTargets.__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL,
	        __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL = _patchTargets$__FORCE === void 0 ? false : _patchTargets$__FORCE;

	    if (!polyfillNeeded({
	      Request: NativeRequest,
	      AbortController: NativeAbortController,
	      __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL: __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL
	    })) {
	      return {
	        fetch: fetch,
	        Request: Request
	      };
	    }

	    var Request = NativeRequest; // Note that the "unfetch" minimal fetch polyfill defines fetch() without
	    // defining window.Request, and this polyfill need to work on top of unfetch
	    // hence we only patch it if it's available. Also we don't patch it if signal
	    // is already available on the Request prototype because in this case support
	    // is present and the patching below can cause a crash since it assigns to
	    // request.signal which is technically a read-only property. This latter error
	    // happens when you run the main5.js node-fetch example in the repo
	    // "abortcontroller-polyfill-examples". The exact error is:
	    //   request.signal = init.signal;
	    //   ^
	    // TypeError: Cannot set property signal of #<Request> which has only a getter

	    if (Request && !Request.prototype.hasOwnProperty('signal') || __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL) {
	      Request = function Request(input, init) {
	        var signal;

	        if (init && init.signal) {
	          signal = init.signal; // Never pass init.signal to the native Request implementation when the polyfill has
	          // been installed because if we're running on top of a browser with a
	          // working native AbortController (i.e. the polyfill was installed due to
	          // __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL being set), then passing our
	          // fake AbortSignal to the native fetch will trigger:
	          // TypeError: Failed to construct 'Request': member signal is not of type AbortSignal.

	          delete init.signal;
	        }

	        var request = new NativeRequest(input, init);

	        if (signal) {
	          Object.defineProperty(request, 'signal', {
	            writable: false,
	            enumerable: false,
	            configurable: true,
	            value: signal
	          });
	        }

	        return request;
	      };

	      Request.prototype = NativeRequest.prototype;
	    }

	    var realFetch = fetch;

	    var abortableFetch = function abortableFetch(input, init) {
	      var signal = Request && Request.prototype.isPrototypeOf(input) ? input.signal : init ? init.signal : undefined;

	      if (signal) {
	        var abortError;

	        try {
	          abortError = new DOMException('Aborted', 'AbortError');
	        } catch (err) {
	          // IE 11 does not support calling the DOMException constructor, use a
	          // regular error object on it instead.
	          abortError = new Error('Aborted');
	          abortError.name = 'AbortError';
	        } // Return early if already aborted, thus avoiding making an HTTP request


	        if (signal.aborted) {
	          return Promise.reject(abortError);
	        } // Turn an event into a promise, reject it once `abort` is dispatched


	        var cancellation = new Promise(function (_, reject) {
	          signal.addEventListener('abort', function () {
	            return reject(abortError);
	          }, {
	            once: true
	          });
	        });

	        if (init && init.signal) {
	          // Never pass .signal to the native implementation when the polyfill has
	          // been installed because if we're running on top of a browser with a
	          // working native AbortController (i.e. the polyfill was installed due to
	          // __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL being set), then passing our
	          // fake AbortSignal to the native fetch will trigger:
	          // TypeError: Failed to execute 'fetch' on 'Window': member signal is not of type AbortSignal.
	          delete init.signal;
	        } // Return the fastest promise (don't need to wait for request to finish)


	        return Promise.race([cancellation, realFetch(input, init)]);
	      }

	      return realFetch(input, init);
	    };

	    return {
	      fetch: abortableFetch,
	      Request: Request
	    };
	  }

	  (function (self) {

	    if (!polyfillNeeded(self)) {
	      return;
	    }

	    if (!self.fetch) {
	      console.warn('fetch() is not available, cannot install abortcontroller-polyfill');
	      return;
	    }

	    var _abortableFetch = abortableFetchDecorator(self),
	        fetch = _abortableFetch.fetch,
	        Request = _abortableFetch.Request;

	    self.fetch = fetch;
	    self.Request = Request;
	    Object.defineProperty(self, 'AbortController', {
	      writable: true,
	      enumerable: false,
	      configurable: true,
	      value: AbortController
	    });
	    Object.defineProperty(self, 'AbortSignal', {
	      writable: true,
	      enumerable: false,
	      configurable: true,
	      value: AbortSignal
	    });
	  })(typeof self !== 'undefined' ? self : commonjsGlobal);

	}));
	return polyfillPatchFetch;
}

requirePolyfillPatchFetch();

function _define_property$C(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
// home-rolled polyfills.
if (!Element.prototype.matches) {
    //@ts-ignore
    Element.prototype.matches = Element.prototype.msMatchesSelector;
}
if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
        var el = this;
        do {
            if (Element.prototype.matches.call(el, s)) return el;
            el = el.parentElement || el.parentNode;
        }while (el !== null && el.nodeType === 1)
        return null;
    };
}
if (!window.BroadcastChannel) {
    //@ts-ignore
    window.BroadcastChannel = class BroadcastChannel {
        onmessage() {}
        addEventListener() {}
        removeEventListener() {}
        close() {}
        onmessageerror() {}
        dispatchEvent() {}
        postMessage() {}
        constructor(name){
            _define_property$C(this, "name", void 0);
            this.name = 'BroadcastChannel SHIM: no functionality';
        }
    };
}
// custom event polyfill
(function() {
    if (typeof window.CustomEvent === 'function') return false;
    function CustomEvent(event, params) {
        params = params || {
            bubbles: false,
            cancelable: false,
            detail: undefined
        };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }
    CustomEvent.prototype = window.Event.prototype;
    //@ts-ignore
    window.CustomEvent = CustomEvent;
})();
// find Index polyfill
Array.prototype.findIndex = Array.prototype.findIndex || function(callback) {
    if (this === null) {
        throw new TypeError('Array.prototype.findIndex called on null or undefined');
    } else if (typeof callback !== 'function') {
        throw new TypeError('Callback must be a function');
    }
    var list = Object(this);
    var length = list.length >>> 0;
    var thisArg = arguments[1];
    for(var i = 0; i < length; i++){
        if (callback.call(thisArg, list[i], i, list)) {
            return i;
        }
    }
    return -1;
};
// array includes polyfill
if (!Array.prototype.includes) {
    Array.prototype.includes = function(search) {
        return !!~this.indexOf(search);
    };
}

function _define_property$B(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$y(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$B(target, key, source[key]);
        });
    }
    return target;
}
// Runtime overrides are arguments/flags passed in as a query parameter.
// The structure of the runtimeOverrides is a JSON object that is converted
// to a string and encoded via the encodeURIComponent
// Example encoding process:
//  const runtimeConfig = { fileSystemId: 'c730b61e-38a4-4eb7-b2f6-f6f805ac03c0' }
//  const param = encodeURIComponent(JSON.stringify(runtimeConfig))
//  -> '%7B%22fileSystemId%22%3A%22c730b61e-38a4-4eb7-b2f6-f6f8058b03c0%22%7D'
// Used in URL:
//  <url-goes-here>?runtimeOverrides=%7B%22fileSystemId%22%3A%22c730b61e-38a4-4eb7-b2f6-f6f8058b03c0%22%7D
const RUNTIME_OVERRIDE_KEY = 'runtimeOverrides';
const parseProps = (props, values = {})=>{
    try {
        const decoded = decodeURIComponent(props);
        const parsed = JSON.parse(decoded);
        values = _object_spread$y({}, values, parsed);
    } catch (e) {} finally{
        return values;
    }
};
/**
 * Function to run once on page load to add runtime overrides.
 * Has a side effect that it will store runtime overrides in session
 * storage for page refreshes.  If you want to override the overrides,
 * you just set the value again in the URL and the latest value will take
 * effect.
 * @param searchString {string} - the query string from the URL.
 * @returns
 */ const getRuntimeOverrides = (searchString)=>{
    // first hydrate runtime overrides with session storage values.
    // if session storage is null, the runtime overrides will simply be
    // empty.
    let runtimeOverrides = parseProps(`${sessionStorage.getItem(RUNTIME_OVERRIDE_KEY)}`);
    // second, allow any newly passed properties to take precedence.
    const search = new URLSearchParams(searchString);
    if (search.has(RUNTIME_OVERRIDE_KEY)) {
        runtimeOverrides = parseProps(`${search.get(RUNTIME_OVERRIDE_KEY)}`, runtimeOverrides);
    }
    return runtimeOverrides;
};
// In the application this is run once at page load.
const runtimeOverrides = getRuntimeOverrides(window.location.search.slice(1));
// we need to make this available to included libraries
//@ts-ignore
window.runtimeOverrides = runtimeOverrides;

var runtimeOverrides$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  RUNTIME_OVERRIDE_KEY: RUNTIME_OVERRIDE_KEY,
  getRuntimeOverrides: getRuntimeOverrides,
  runtimeOverrides: runtimeOverrides
});

const partialUrls = [
    `/cmx/jump`,
    `/tests/`
];
const exactUrls = [
    `/`
];

var authenticationContext$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  exactUrls: exactUrls,
  partialUrls: partialUrls
});

const exportable = {
    authenticationContext: authenticationContext$1
};

var index$a = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: exportable
});

function _define_property$A(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$x(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$A(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$p(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$p(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$p(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const shimContext = (context)=>{
    // the API returns a data structure that includes an activeContextId, but
    // not an activeContext as an object.  this shim adds an activeContext so
    // that UI code can expect a full object and not have to hunt for the object from the id.
    const { activeContextId } = context;
    if (activeContextId === null) {
        return _object_spread_props$p(_object_spread$x({}, context), {
            activeContext: null
        });
    } else {
        const { contexts } = context;
        if (contexts.length === 1) {
            return _object_spread_props$p(_object_spread$x({}, context), {
                activeContext: contexts[0]
            });
        } else {
            return _object_spread_props$p(_object_spread$x({}, context), {
                activeContext: contexts.find((ctx)=>ctx.organizationId === context.activeContextId) || null
            });
        }
    }
};

var _actionUtilities = /*#__PURE__*/Object.freeze({
  __proto__: null,
  shimContext: shimContext
});

// src/devModeChecks/identityFunctionCheck.ts
function assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
  if (typeof func !== "function") {
    throw new TypeError(errorMessage);
  }
}
function assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
  if (typeof object !== "object") {
    throw new TypeError(errorMessage);
  }
}
function assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
  if (!array.every((item) => typeof item === "function")) {
    const itemTypes = array.map(
      (item) => typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item
    ).join(", ");
    throw new TypeError(`${errorMessage}[${itemTypes}]`);
  }
}
var ensureIsArray = (item) => {
  return Array.isArray(item) ? item : [item];
};
function getDependencies(createSelectorArgs) {
  const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
  assertIsArrayOfFunctions(
    dependencies,
    `createSelector expects all input-selectors to be functions, but received the following types: `
  );
  return dependencies;
}
function collectInputSelectorResults(dependencies, inputSelectorArgs) {
  const inputSelectorResults = [];
  const { length } = dependencies;
  for (let i = 0; i < length; i++) {
    inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
  }
  return inputSelectorResults;
}

// src/weakMapMemoize.ts
var StrongRef = class {
  constructor(value) {
    this.value = value;
  }
  deref() {
    return this.value;
  }
};
var Ref = typeof WeakRef !== "undefined" ? WeakRef : StrongRef;
var UNTERMINATED = 0;
var TERMINATED = 1;
function createCacheNode() {
  return {
    s: UNTERMINATED,
    v: void 0,
    o: null,
    p: null
  };
}
function weakMapMemoize(func, options = {}) {
  let fnNode = createCacheNode();
  const { resultEqualityCheck } = options;
  let lastResult;
  let resultsCount = 0;
  function memoized() {
    let cacheNode = fnNode;
    const { length } = arguments;
    for (let i = 0, l = length; i < l; i++) {
      const arg = arguments[i];
      if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
        let objectCache = cacheNode.o;
        if (objectCache === null) {
          cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
        }
        const objectNode = objectCache.get(arg);
        if (objectNode === void 0) {
          cacheNode = createCacheNode();
          objectCache.set(arg, cacheNode);
        } else {
          cacheNode = objectNode;
        }
      } else {
        let primitiveCache = cacheNode.p;
        if (primitiveCache === null) {
          cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
        }
        const primitiveNode = primitiveCache.get(arg);
        if (primitiveNode === void 0) {
          cacheNode = createCacheNode();
          primitiveCache.set(arg, cacheNode);
        } else {
          cacheNode = primitiveNode;
        }
      }
    }
    const terminatedNode = cacheNode;
    let result;
    if (cacheNode.s === TERMINATED) {
      result = cacheNode.v;
    } else {
      result = func.apply(null, arguments);
      resultsCount++;
      if (resultEqualityCheck) {
        const lastResultValue = lastResult?.deref?.() ?? lastResult;
        if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
          result = lastResultValue;
          resultsCount !== 0 && resultsCount--;
        }
        const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
        lastResult = needsWeakRef ? new Ref(result) : result;
      }
    }
    terminatedNode.s = TERMINATED;
    terminatedNode.v = result;
    return result;
  }
  memoized.clearCache = () => {
    fnNode = createCacheNode();
    memoized.resetResultsCount();
  };
  memoized.resultsCount = () => resultsCount;
  memoized.resetResultsCount = () => {
    resultsCount = 0;
  };
  return memoized;
}

// src/createSelectorCreator.ts
function createSelectorCreator(memoizeOrOptions, ...memoizeOptionsFromArgs) {
  const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
    memoize: memoizeOrOptions,
    memoizeOptions: memoizeOptionsFromArgs
  } : memoizeOrOptions;
  const createSelector2 = (...createSelectorArgs) => {
    let recomputations = 0;
    let dependencyRecomputations = 0;
    let lastResult;
    let directlyPassedOptions = {};
    let resultFunc = createSelectorArgs.pop();
    if (typeof resultFunc === "object") {
      directlyPassedOptions = resultFunc;
      resultFunc = createSelectorArgs.pop();
    }
    assertIsFunction(
      resultFunc,
      `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`
    );
    const combinedOptions = {
      ...createSelectorCreatorOptions,
      ...directlyPassedOptions
    };
    const {
      memoize,
      memoizeOptions = [],
      argsMemoize = weakMapMemoize,
      argsMemoizeOptions = []} = combinedOptions;
    const finalMemoizeOptions = ensureIsArray(memoizeOptions);
    const finalArgsMemoizeOptions = ensureIsArray(argsMemoizeOptions);
    const dependencies = getDependencies(createSelectorArgs);
    const memoizedResultFunc = memoize(function recomputationWrapper() {
      recomputations++;
      return resultFunc.apply(
        null,
        arguments
      );
    }, ...finalMemoizeOptions);
    const selector = argsMemoize(function dependenciesChecker() {
      dependencyRecomputations++;
      const inputSelectorResults = collectInputSelectorResults(
        dependencies,
        arguments
      );
      lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
      return lastResult;
    }, ...finalArgsMemoizeOptions);
    return Object.assign(selector, {
      resultFunc,
      memoizedResultFunc,
      dependencies,
      dependencyRecomputations: () => dependencyRecomputations,
      resetDependencyRecomputations: () => {
        dependencyRecomputations = 0;
      },
      lastResult: () => lastResult,
      recomputations: () => recomputations,
      resetRecomputations: () => {
        recomputations = 0;
      },
      memoize,
      argsMemoize
    });
  };
  Object.assign(createSelector2, {
    withTypes: () => createSelector2
  });
  return createSelector2;
}
var createSelector = /* @__PURE__ */ createSelectorCreator(weakMapMemoize);

// src/createStructuredSelector.ts
var createStructuredSelector = Object.assign(
  (inputSelectorsObject, selectorCreator = createSelector) => {
    assertIsObject(
      inputSelectorsObject,
      `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`
    );
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map(
      (key) => inputSelectorsObject[key]
    );
    const structuredSelector = selectorCreator(
      dependencies,
      (...inputSelectorResults) => {
        return inputSelectorResults.reduce((composition, value, index) => {
          composition[inputSelectorKeys[index]] = value;
          return composition;
        }, {});
      }
    );
    return structuredSelector;
  },
  { withTypes: () => createStructuredSelector }
);

const { ChargeTypes } = commonEnums;
const serviceLineMap = Object.freeze({
    SURG: 'surgery',
    PATH: 'pathology',
    RAD: 'radiology'
});
const FOUR_LETTER_SERVICE_LINE_MAP = Object.freeze({
    SURG: 'surgery',
    PATH: 'pathology',
    RADI: 'radiology'
});
const unknownServiceLine = determineServiceLineConfig({
    name: 'unknown'
});
const handleTracking = (match)=>{
    if (match.length !== 6) {
        throw new Error(`tracking charge format not matched`);
    }
    if (!(match[2] in serviceLineMap)) {
        throw new Error(`Unknown service line: ${match[2]}`);
    }
    const serviceLine = determineServiceLineConfig({
        name: serviceLineMap[match[2]]
    });
    return {
        identifier: match[3],
        chargeType: ChargeTypes.TRACKING,
        serviceLine
    };
};
const handleStandard = (match)=>{
    if (!(match[5] in FOUR_LETTER_SERVICE_LINE_MAP)) {
        throw new Error(`Unknown service line: ${match[4]}`);
    }
    const serviceLine = determineServiceLineConfig({
        name: serviceLineMap[match[5]]
    });
    return {
        identifier: match[4],
        chargeType: ChargeTypes.STANDARD,
        serviceLine
    };
};
const handleLegacy = (match)=>{
    return {
        identifier: match[3],
        chargeType: ChargeTypes.LEGACY,
        serviceLine: unknownServiceLine
    };
};
const handleUnknown = (unparsedUcl108)=>{
    return {
        identifier: unparsedUcl108,
        chargeType: ChargeTypes.UNKNOWN,
        serviceLine: unknownServiceLine
    };
};
const parseUCL108 = (ucl108)=>{
    if (typeof ucl108 !== 'string') throw new Error(`requires string, receieved ${ucl108}`);
    if (ucl108.length === 0) throw new Error(`received empty string for ucl108`);
    const fragments = ucl108.split('^');
    const matches = fragments.map((fragment)=>{
        // See: https://codametrix.atlassian.net/wiki/spaces/DEV/pages/2629304385/Case+Launch+Sequence
        // ------------------ Tracking Charges ------------------
        // CMX-<service_line_short_name>-<process_instance_id>-<invoice_short_guid>-<counter>
        // CMX-RAD-273894-ae389fd-5
        // 0: "CMX-RAD-273894-ae389fd-5"
        // 1: "CMX" // company
        // 2: "RAD" // service line
        // 3: "273894" // process instance
        // 4: "ae389fd" // invoice short guid
        // 5: "5" // counter
        const TRACKING_CHARGE_REGEX = /([a-zA-Z0-9]+)\-([a-zA-Z0-9]+)\-([a-zA-Z0-9]+)\-([a-zA-Z0-9]+)\-([a-zA-Z0-9]+)/gm;
        // ------------------ Standard Charges ------------------
        // CMX_INT1-T-12345-RADI
        // 0: "CMX_INT1-T12345-RADI"
        // 1: "CMX" // company
        // 2: "INT1" // environment
        // 3: "T" // charge type
        // 4: "12345" // transaction id
        // 5: "RADI" // four letter service line identifier
        const STANDARD_CHARGE_REGEX = /([a-zA-Z0-9]+)\_([a-zA-Z0-9]+)\-([T|P])[\-]?([a-zA-Z0-9]+)\-([a-zA-Z0-9]+)/gm;
        // ------------------ Legacy Format  ------------------
        // Ex: CMX-P474-PATH
        // 0: "CMX-P474-PATH"
        // 1: "CMX" // company
        // 2: "T" // charge type
        // 3: "474" // transaction id
        // 4: "PATH" // four letter service line identifier
        const LEGACY_FORMAT_REGEX = /([a-zA-Z0-9]+)\-([T|P])([0-9]+)\-([a-zA-Z0-9]{4})/gm;
        const trackingMatch = TRACKING_CHARGE_REGEX.exec(fragment);
        const standardMatch = STANDARD_CHARGE_REGEX.exec(fragment);
        const legacyMatch = LEGACY_FORMAT_REGEX.exec(fragment);
        try {
            if (trackingMatch) {
                return handleTracking(trackingMatch);
            } else if (standardMatch) {
                return handleStandard(standardMatch);
            } else if (legacyMatch) {
                return handleLegacy(legacyMatch);
            } else {
                return handleUnknown(fragment);
            }
        } catch (e) {
            // in the case of a parse exception treat as unknown.
            return handleUnknown(fragment);
        }
    });
    return groupBy(matches, 'chargeType');
};

const { Launch: Launch$1 } = commonActions;
const { LaunchParams } = commonEnums;
const caseSearchAvailable = createAction(Launch$1.CASE_SEARCH);
const caseLookupError = createAction(Launch$1.CASE_LOOKUP_ERROR);
const loadCaseFromUCLs = async (resultSet)=>{
    if (resultSet.tracking) {
        for(let i = 0; i < resultSet.tracking.length; i++){
            const procedureInfo = resultSet.tracking[i];
            try {
                const caseDetail = await requestJSON(`${procedureInfo.serviceLine.path}/processinstance/${procedureInfo.identifier}/details/v1`);
                if (caseDetail) {
                    set$1(procedureInfo.serviceLine);
                    return caseDetail;
                }
            } catch (e) {
            /** squelch */ }
        }
    }
    if (resultSet.standard) {
        for(let i = 0; i < resultSet.standard.length; i++){
            const procedureInfo = resultSet.standard[i];
            let caseDetail;
            try {
                // radiology
                if (procedureInfo.serviceLine.path === '') {
                    caseDetail = await requestJSON(`${procedureInfo.serviceLine.path}/caseinstance/procedureid/${procedureInfo.identifier}/v1`);
                } else {
                    caseDetail = await requestJSON(`${procedureInfo.serviceLine.path}/caseinstance/transactionid/${procedureInfo.identifier}/v1`);
                }
                if (caseDetail) {
                    set$1(procedureInfo.serviceLine);
                    return caseDetail;
                }
            } catch (e) {
            /** squelch */ }
        }
    }
    throw new Error(`unable to locate a case from parsed ucl108 ids.`);
};
const runConxtextSearch = async (searchParams, dispatch)=>{
    var _ref;
    const searchResults = await backupCaseSearch(searchParams);
    const resultCount = (_ref = searchResults === null || searchResults === void 0 ? void 0 : searchResults.length) !== null && _ref !== void 0 ? _ref : 0;
    if (resultCount === 1) {
        const [caseRun] = searchResults;
        const contextResult = await loadCase(caseRun, dispatch);
        dispatch(navigationIntent({
            intent: 'CASE_DETAIL',
            url: contextResult.url
        }));
    } else if (resultCount > 1) {
        dispatch(caseSearchAvailable(searchResults));
        dispatch(navigationIntent({
            intent: 'CASE_CHOOSER'
        }));
    } else {
        dispatch(navigationIntent({
            intent: 'CASE_NOT_FOUND'
        }));
    }
};
const backupCaseSearch = async (searchParams)=>{
    const options = {
        method: 'POST',
        body: JSON.stringify({
            patientMrn: `${searchParams.get(LaunchParams.PATIENT_ID)}`,
            dateOfService: `${searchParams.get(LaunchParams.VISIT_DATE)}`,
            providerNumber: `${searchParams.get(LaunchParams.PROVIDER_ID)}`,
            visitNumber: `${searchParams.get(LaunchParams.VISIT_CSN)}`
        })
    };
    const searchResults = await requestJSON(`${get().path}/caseinstance/listbycontext/v1`, options);
    return searchResults;
};
const fetchCases = async (externalApp, dispatch)=>{
    let caseJson;
    try {
        const launchParams = new URLSearchParams(externalApp);
        const hasUCL108 = launchParams.has(LaunchParams.TRANSACTION_IDS);
        if (hasUCL108 && launchParams.get(LaunchParams.TRANSACTION_IDS) !== '') {
            // Lookup flow:
            // 1. parse UCL108
            // 2. attempt UCL108 search
            // 3. if no case found, do a context search
            const ucl108List = launchParams.get(LaunchParams.TRANSACTION_IDS);
            try {
                // 1. parse UCL108
                const results = parseUCL108(ucl108List);
                // 2. attempt UCL108 search
                const caseRun = await loadCaseFromUCLs(results);
                if (caseRun) {
                    const fetchResult = await loadCase(caseRun, dispatch);
                    dispatch(navigationIntent({
                        intent: 'CASE_DETAIL',
                        url: fetchResult.url
                    }));
                }
            } catch (e) {
                // 3. if no case found, do a context search
                await runConxtextSearch(launchParams, dispatch);
            }
        } else if (launchParams.get(LaunchParams.PATIENT_ID)) {
            await runConxtextSearch(launchParams, dispatch);
        } else {
            throw new Error(`Not enough information to lookup a case`);
        }
    } catch (e) {
        dispatch(navigationIntent({
            intent: 'CASE_NOT_FOUND'
        }));
        dispatch(caseLookupError(e));
    }
    return caseJson;
};

const { AmplifyAuthenticate: AmplifyAuthenticate$1, Eula } = commonActions;
const saveEula = createAction(Eula.SAVE_EULA);
const cancelEula = createAction(Eula.CANCEL_EULA);
const acceptInitial = createAction(Eula.ACCEPT_INIT);
const userDetailsAvailable$1 = createAction(AmplifyAuthenticate$1.USER_DETAILS);
const fetchEula = createAsyncThunk(Eula.FETCH_EULA, async (contextAPI, _thunkAPI)=>{
    const shimmedContext = shimContext(contextAPI);
    const userId = shimmedContext.user.id;
    const orgId = shimmedContext.activeContext.organizationId;
    const eula = await requestJSON(`/users/eula/v1?userId=${userId}&orgId=${orgId}`);
    return eula;
});
const acceptEula = createAsyncThunk(Eula.ACCEPT_EULA, async (payload, { dispatch })=>{
    const { context, eula, optional: launchParams } = payload;
    dispatch(acceptInitial(eula));
    const user = await requestJSON('/users/eula/v1', {
        method: Methods.POST,
        body: JSON.stringify(eula)
    });
    dispatch(saveEula(eula));
    const organizationId = context.organizationId;
    const freshContexts = await requestJSON(`/contexts/v1`, {
        method: Methods.PUT,
        body: JSON.stringify({
            organizationId
        })
    });
    dispatch(userDetailsAvailable$1(freshContexts));
    _authHandler.token = freshContexts.jwtToken;
    fetchCases(launchParams, dispatch);
    return user;
});

var eula_actions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  acceptEula: acceptEula,
  cancelEula: cancelEula,
  fetchEula: fetchEula,
  saveEula: saveEula
});

var index$9 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  normalizeDescriptions: normalizeDescriptions
});

function _define_property$z(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$w(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$z(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$o(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$o(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$o(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const _Authorization = {
    token: null,
    contextId: null,
    expiryTimeToLive: null
};
const getAuthorization = ()=>{
    return _object_spread_props$o(_object_spread$w({}, _Authorization), {
        token: _authHandler.token || _Authorization.token || null
    });
};
const setAuthorization = (authContext)=>{
    var _authContext_expiryTimeToLive;
    _authHandler.token = _Authorization.token = authContext.token || null;
    _Authorization.contextId = authContext.contextId;
    _Authorization.expiryTimeToLive = (_authContext_expiryTimeToLive = authContext.expiryTimeToLive) !== null && _authContext_expiryTimeToLive !== void 0 ? _authContext_expiryTimeToLive : _Authorization.expiryTimeToLive;
};
const setContextId = (contextId)=>{
    _Authorization.contextId = contextId;
};
const setToken = (token)=>{
    _authHandler.token = _Authorization.token = token || null;
    if (token === null) {
        setContextId(null);
    }
};
const getToken = ()=>{
    return _authHandler.token;
};
const getContextId = ()=>{
    return _Authorization.contextId;
};

var authenticationContext = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getAuthorization: getAuthorization,
  getContextId: getContextId,
  getToken: getToken,
  setAuthorization: setAuthorization,
  setContextId: setContextId,
  setToken: setToken
});

const { UserSession } = commonActions;
const sessionTimeout$1 = createAction(UserSession.TIMEOUT);
const sessionRefresh$1 = createAction(UserSession.REFRESH);
const sessionReset$1 = createAction(UserSession.RESET);
const sessionActivityPrompt$1 = createAction(UserSession.ACTIVITY_PROMPT);

var sessionActions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  sessionActivityPrompt: sessionActivityPrompt$1,
  sessionRefresh: sessionRefresh$1,
  sessionReset: sessionReset$1,
  sessionTimeout: sessionTimeout$1
});

// Import or access runtime overrides
/**
 * Log level constants used to control logging verbosity.
 * Lower numbers are more verbose, higher numbers are more restrictive.
 */ const LOG_LEVELS = {
    /** Detailed diagnostic information, typically only of interest when diagnosing problems */ DEBUG: 1,
    /** General information about application flow and state changes */ INFO: 2,
    /** Potentially harmful situations or deprecated usage */ WARN: 3,
    /** Error events that might still allow the application to continue running */ ERROR: 4,
    /** Completely disable logging output */ NO_LOG: 100
};
const getLogLevel = ()=>{
    var _window_runtimeOverrides, _window;
    // Check runtime overrides first, then fall back to default
    const runtimeLogLevel = (_window = window) === null || _window === void 0 ? void 0 : (_window_runtimeOverrides = _window.runtimeOverrides) === null || _window_runtimeOverrides === void 0 ? void 0 : _window_runtimeOverrides.logLevel;
    if (runtimeLogLevel !== undefined) {
        return typeof runtimeLogLevel === 'string' ? LOG_LEVELS[runtimeLogLevel.toUpperCase()] || LOG_LEVELS.WARN : runtimeLogLevel;
    }
    return LOG_LEVELS.WARN; // default
};
const doLog = (requestedLevel)=>{
    if (process.env.JEST_WORKER_ID) {
        return false;
    }
    const currentLevel = getLogLevel();
    return requestedLevel >= currentLevel;
};
const timestamp = ()=>new Date().toISOString().replace('T', ' ').replace('Z', '');
// Cache for storing prefixed loggers
const loggerCache = new Map();
/**
  * logging prototype
  */ const logger$3 = {
    error: (...args)=>{
        args.unshift(timestamp());
        doLog(LOG_LEVELS.ERROR) && console.error.apply(null, args);
    },
    warn: (...args)=>{
        args.unshift(timestamp());
        doLog(LOG_LEVELS.WARN) && console.warn.apply(null, args);
    },
    debug: (...args)=>{
        args.unshift(timestamp());
        doLog(LOG_LEVELS.DEBUG) && console.log.apply(null, args);
    },
    log: (...args)=>{
        args.unshift(timestamp());
        doLog(LOG_LEVELS.INFO) && console.log.apply(null, args);
    }
};
/**
 * Creates a prefixed logger instance that prepends a component/module identifier to all log messages.
 * The returned logger maintains the same interface as the base logger but adds the prefix for better
 * log organization and filtering.
 * 
 * @param prefix - The string identifier to prepend to all log messages (will be wrapped in brackets)
 * @returns A logger instance with the same methods as the base logger but with prefixed output
 * 
 * @example
 * 
 * // Create a logger for a specific component
 * const componentLogger = loggerFactory('DataGrid');
 * 
 * // Use it like the regular logger
 * componentLogger.log('Component initialized');
 * // Output: "2023-12-07 10:30:45.123 [DataGrid] Component initialized"
 * 
 * componentLogger.error('Failed to load data', error);
 * // Output: "2023-12-07 10:30:45.456 [DataGrid] Failed to load data Error: ..."
 * 
 * // Create loggers for different modules
 * const apiLogger = loggerFactory('API');
 * const uiLogger = loggerFactory('UI');
 * 
 * apiLogger.debug('Making request to /users');
 * uiLogger.warn('Deprecated prop usage detected');
 * 
 */ const loggerFactory = (prefix)=>{
    // Check if we already have a logger for this prefix
    if (loggerCache.has(prefix)) {
        return loggerCache.get(prefix);
    }
    // Create a new logger that prepends the string to all the log statements
    const prefixedLogger = Object.create(logger$3);
    Object.keys(logger$3).forEach((method)=>{
        prefixedLogger[method] = (...args)=>logger$3[method](`[${prefix}]`, ...args);
    });
    // Store in cache before returning
    loggerCache.set(prefix, prefixedLogger);
    return prefixedLogger;
};

const TIMER_PREFIX = `timerFor`;
const logger$2 = loggerFactory(`PersistentTimers`);
/**
 * Function to provide a mechanism to run timeout functions with support
 * for page reloads.
 * @param callback - the function to execute
 * @param delay - the set time (in milliseconds) to run the function
 * @param optName - a name to use for the timer.  In the case that the callback does
 *  not have a name property, this must be supplied.
 * @returns
 */ const setPersistentTimeout = (callback, delay, optName)=>{
    var _callback_name;
    const callbackName = optName ? optName : (_callback_name = callback.name) !== null && _callback_name !== void 0 ? _callback_name : false;
    if (!callbackName) {
        logger$2.error(`no callback name found, unable to set persistent timer`);
        throw new Error(`unable to set persistent timer`);
    } else {
        const d = new Date();
        const targetTime = d.getTime() + delay;
        const targetDate = new Date(targetTime);
        // each page can have their own timers.
        sessionStorage.setItem(`${TIMER_PREFIX}_${callbackName}`, targetTime);
        logger$2.debug(`Set timeout for ${callbackName}: ${targetTime} (${targetDate.toISOString()})`);
        return setTimeout(callback, delay);
    }
};
/**
 * Function to provide a timeout value for a registered persistent timer.
 * @param callbackName - the name of the timer to check for presence.
 * @returns
 */ const checkPersistentTimeout = (callbackName)=>{
    const cbKey = `${TIMER_PREFIX}_${callbackName}`;
    const cbValue = sessionStorage.getItem(cbKey);
    if (!cbValue) {
        logger$2.debug(`no persistent timer found for ${callbackName} - using cbKey ${cbKey}`);
    } else {
        const targetTime = parseInt(cbValue, 10);
        const currentTime = new Date().getTime();
        const timeDelta = targetTime - currentTime;
        logger$2.debug(`Target time for ${callbackName}: ${targetTime} (target) - ${currentTime} (current) = ${timeDelta / 1000}s`);
        if (targetTime && timeDelta > 0) {
            return timeDelta;
        }
    }
    return null;
};
/**
 * Remove any persistence for page reload timers.
 * @param callbackName - The name of the function.
 */ const clearPersistentTimeout = (callbackName)=>{
    sessionStorage.removeItem(`${TIMER_PREFIX}_${callbackName}`);
};

function _define_property$y(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
const activityMonitorLogger = loggerFactory('ActivityMonitor');
// There are two times we check for activity.
// The first one is at 90%.  This should give us a good
// buffer to grab another session.
const CHECK_ACTIVITY_FACTOR = 0.95;
// The second timeout is at the limit of when we can call
// for a new session and expect to reasonably succeed.
const LAST_CALL_FACTOR = 0.97;
const formatLogTime = (date)=>date.toISOString().replace('T', ' ').replace('Z', '');
let ActivityMonitor$1 = class ActivityMonitor extends EventEmitter {
    /**
   * Checks if an authenticated browsing context is active.
   */ checkIfActive() {
        activityMonitorLogger.debug(`ActivityMonitor checkIfActive ${this._isActive}`);
        const active = this._isActive;
        if (active) {
            this.beginRefresh();
        } else {
            // if there hasn't been activity, prompt the user.
            // if they are there at their keyboard, they can always
            // click something to let us know.
            activityMonitorLogger.log(`ActivityMonitor.events.ACTIVITY_PROMPT`);
            this.emit(ActivityMonitor.events.ACTIVITY_PROMPT);
        }
    }
    /**
   * Emit an event for consumers to take a new update of the application context.
   * @param appContext
   */ shouldRefresh(appContext) {
        activityMonitorLogger.debug(`DID_REFRESH`);
        this.emit(ActivityMonitor.events.DID_REFRESH, appContext);
    }
    /**
   * Log the user out of the application.  Non-reversible!
   */ logout() {
        this.emit(ActivityMonitor.events.LOGOUT);
    }
    /**
   * Emit an event that application should refresh the token.
   */ beginRefresh() {
        activityMonitorLogger.debug(`BEGIN_REFRESH`);
        this.emit(ActivityMonitor.events.BEGIN_REFRESH);
        this.reset(`beginRefresh`);
    }
    /**
   * Refresh was requested by another browsing context; do not re-broadcast.
   */ beginRefreshFromPeer() {
        this._refreshFromPeer = true;
        this.beginRefresh();
    }
    /**
   * Skip peer broadcast for the next refresh (e.g. child bootstrap).
   */ suppressNextRefreshBroadcast() {
        this._suppressRefreshBroadcast = true;
    }
    /**
   * Whether this refresh should notify peer windows before running locally.
   */ shouldBroadcastRefreshToPeers() {
        const broadcast = !this._refreshFromPeer && !this._suppressRefreshBroadcast;
        this._refreshFromPeer = false;
        this._suppressRefreshBroadcast = false;
        return broadcast;
    }
    /**
   * Transfer a portion of the state to the new redux state tree.
   * @param stateUpdate
   */ replaceState(stateUpdate) {
        this.emit(ActivityMonitor.events.STATE_UPDATE, stateUpdate);
    }
    /**
   *  No longer monitor for activity.
   */ stop() {
        if (this._ifActiveTimeout) {
            if (window.clearTimeout) {
                activityMonitorLogger.debug(`checkIfActive: clearTimeout`);
                window.clearTimeout(this._ifActiveTimeout);
            }
            this._ifActiveTimeout = 0;
            clearPersistentTimeout('checkIfActive');
        }
        if (this._lastCallTimeout) {
            if (window.clearTimeout) {
                activityMonitorLogger.debug(`checkIfActive: _lastCallTimeout`);
                window.clearTimeout(this._lastCallTimeout);
            }
            this._lastCallTimeout = 0;
            clearPersistentTimeout('lastCall');
        }
    }
    /**
   * Reset the timers for monitoring the application activity.
   */ reset(optResetReason) {
        activityMonitorLogger.debug(`reset: ${optResetReason}`, optResetReason);
        this.stop();
        // reset activity watch.
        this._isActive = false;
        this.emit(ActivityMonitor.events.RESET);
    }
    /**
   * Emit one last call to see if the application context/token should be refreshed.
   */ lastCall() {
        activityMonitorLogger.debug(`lastCall: ${this._isActive}`);
        const active = this._isActive;
        if (!active) {
            this.emit(ActivityMonitor.events.TIMEOUT);
        } else {
            this.emit(ActivityMonitor.events.BEGIN_REFRESH);
            this.reset(`lastCall: ${ActivityMonitor.events.BEGIN_REFRESH}`);
        }
    }
    /**
   * The time (in milliseconds) by which the application should monitor for user activity.
   */ set expiryTimeout(expiryTime) {
        // start over again with activity.
        activityMonitorLogger.debug(`setting expiryTime: ${expiryTime}`);
        const runTimeout = expiryTime * CHECK_ACTIVITY_FACTOR;
        const runLastCall = expiryTime * LAST_CALL_FACTOR;
        this._setTimers(runTimeout, runLastCall);
    }
    _setTimers(runTimeout, runLastCall) {
        this.reset(`setting new timers`);
        const checkIfActiveTarget = new Date(new Date().getTime() + runTimeout);
        const lastCallTarget = new Date(new Date().getTime() + runTimeout);
        activityMonitorLogger.debug(`checkIfActive: will run in ${runTimeout / 1000}s (${formatLogTime(checkIfActiveTarget)})`);
        activityMonitorLogger.debug(`lastCall: will run in ${runLastCall / 1000}s (${formatLogTime(lastCallTarget)})`);
        const checkIfActive = this.checkIfActive.bind(this);
        const lastCall = this.lastCall.bind(this);
        this._ifActiveTimeout = setPersistentTimeout(checkIfActive, runTimeout, 'checkIfActive');
        this._lastCallTimeout = setPersistentTimeout(lastCall, runLastCall, 'lastCall');
    }
    set contextId(id) {
        this._contextId = id;
    }
    get contextId() {
        return this._contextId;
    }
    set isActive(isActive) {
        this._isActive = isActive;
    }
    constructor(){
        super(), _define_property$y(this, "_ifActiveTimeout", void 0), _define_property$y(this, "_lastCallTimeout", void 0), _define_property$y(this, "_isActive", void 0), _define_property$y(this, "_contextId", void 0), _define_property$y(this, "_refreshFromPeer", void 0), _define_property$y(this, "_suppressRefreshBroadcast", void 0);
        // check for the existence of the checkIfActive timer
        const checkIfActiveTimer = checkPersistentTimeout('checkIfActive');
        activityMonitorLogger.debug(`Existing timer for checking activity: ${checkIfActiveTimer}`);
        if (checkIfActiveTimer) {
            const lastCallTimer = checkPersistentTimeout('lastCall');
            this._setTimers(checkIfActiveTimer, lastCallTimer);
        }
    }
};
_define_property$y(ActivityMonitor$1, "events", {
    /**
     *  A logout event from the application.
     */ LOGOUT: 'LOGOUT',
    /**
     * A timeout from the application due to user inactivity.
     */ TIMEOUT: 'TIMEOUT',
    /**
     * An event signalling that the authentication should be renewed.
     */ SHOULD_REFRESH: 'SHOULD_REFRESH',
    /**
     * Start the process of renewing authentication.
     */ BEGIN_REFRESH: 'BEGIN_REFRESH',
    /**
     * An event signalling that the authentication was renewed.
     */ DID_REFRESH: 'DID_REFRESH',
    /**
     * Transfer a portion of the state from one Browsing Context to another.
     */ STATE_UPDATE: 'STATE_UPDATE',
    /**
     * An event signalling that the activity monitoring period has been renewed.
     */ RESET: 'RESET',
    /**
     * An event that activity has not been registered and that we need the user's
     * input that they want to continue their session.
     */ ACTIVITY_PROMPT: 'ACTIVITY_PROMPT'
});

const { sessionTimeout, sessionActivityPrompt, sessionReset, sessionRefresh } = sessionActions;
/**
 * This function observes the events (TIMEOUT, INACTIVITY WARNINGS, REFRESH) on a session.
 * @param activityMonitor - the session to be observed
 * @param store - the store on which to dispatch activities
 * @param authHandler - for token updates
 */ const observeActivity = (activityMonitor, store, authHandler, onTimeout)=>{
    activityMonitor.on(ActivityMonitor$1.events.BEGIN_REFRESH, async ()=>{
        // On a refresh, we get a new token by choosing the same context that we
        // have in the current context.  The net effect is that the app context
        // does not change on the user, but a new token is retrieved.
        store.dispatch(sessionRefresh());
        const freshContext = await requestJSON(`/contexts/v1`, {
            method: Methods.PUT,
            body: JSON.stringify({
                organizationId: activityMonitor.contextId
            })
        });
        // expiryTimeToLive is a configurable property per environment and
        // perhaps in the future per tenant.
        activityMonitor.expiryTimeout = freshContext.expiryTimeToLive;
        authHandler.token = freshContext.jwtToken;
        store.dispatch(sessionReset());
    });
    activityMonitor.on(ActivityMonitor$1.events.ACTIVITY_PROMPT, ()=>{
        // dispatch prompt for user to refresh session.
        store.dispatch(sessionActivityPrompt());
    });
    activityMonitor.on(ActivityMonitor$1.events.TIMEOUT, ()=>{
        // also clear up any data that may have been stored
        sessionStorage.clear();
        authHandler.token = '';
        store.dispatch(sessionTimeout());
        onTimeout === null || onTimeout === void 0 ? void 0 : onTimeout();
    });
};
// creating the session once so that it is importable
// into other places (ie. actions);
const activityMonitor = new ActivityMonitor$1();

var sessionManager = /*#__PURE__*/Object.freeze({
  __proto__: null,
  activityMonitor: activityMonitor,
  observeActivity: observeActivity
});

function _define_property$x(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$v(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$x(target, key, source[key]);
        });
    }
    return target;
}
const authenticatedEvents = new Set([
    AuthenticationChannelEvents.BOOTSTRAP_AUTH_RESPONSE
]);
const logger$1 = loggerFactory('AuthenticationChannel');
const isTrustedChannelOrigin = (message)=>message.origin === globalThis.location.origin;
// logger.log statements are left commented out here bc debugging
// the channel is a pain.
class AuthenticationChannel extends BroadcastChannel {
    setStore(store) {
        this.store = store;
    }
    getStore() {
        return this.store;
    }
    messageListener(message) {
        var _ref;
        var _message_data;
        if (!isTrustedChannelOrigin(message)) {
            return;
        }
        const messageType = (_ref = (_message_data = message.data) === null || _message_data === void 0 ? void 0 : _message_data.type) !== null && _ref !== void 0 ? _ref : '';
        logger$1.debug(`AuthenticationChannel ${this.browsingContextId} (${this.shortName}) messageListener: `, messageType);
        if (messageType === UserInterface.LOGOUT) {
            activityMonitor.logout();
        } else if (messageType === ActivityMonitor$1.events.SHOULD_REFRESH) {
            activityMonitor.beginRefreshFromPeer();
        }
    }
    _init() {
        logger$1.debug(`Browsing context: ${this.browsingContextId} joined ${this.shortName} as ${this.isChild ? 'child' : 'parent'}`);
        if (!this.isChild) {
            this.addEventListener('message', (message)=>{
                var _message_data;
                if (!isTrustedChannelOrigin(message)) {
                    return;
                }
                // BroadcastChannel is same-origin by design; validate message structure
                // as defense-in-depth.
                if (!((_message_data = message.data) === null || _message_data === void 0 ? void 0 : _message_data.type)) {
                    return;
                }
                // Child windows consume bootstrapAuthResponse; parent must not refresh.
                if (message.data.type === AuthenticationChannelEvents.BOOTSTRAP_AUTH) {
                    var _ref;
                    var _message_data1;
                    // v1 only!
                    const version = (_ref = (_message_data1 = message.data) === null || _message_data1 === void 0 ? void 0 : _message_data1.version) !== null && _ref !== void 0 ? _ref : null;
                    if (version === null) {
                        this.postMessage({
                            type: AuthenticationChannelEvents.BOOTSTRAP_AUTH_RESPONSE,
                            payload: this.authenticationContext.getAuthorization(),
                            shortName: this.shortName
                        });
                    } else {
                        var _ref1, _ref2;
                        var _this_store_getState, _this_store, _this_store_getState1, _this_store1;
                        // Send authorization separately from UI state. Child windows can receive
                        // partial UI context during bootstrap, so relying on ui.context.jwtToken
                        // alone can drop the active token or refresh timeout.
                        const transferStateData = {
                            ui: JSON.parse(JSON.stringify((_ref1 = (_this_store = this.store) === null || _this_store === void 0 ? void 0 : (_this_store_getState = _this_store.getState()) === null || _this_store_getState === void 0 ? void 0 : _this_store_getState.ui) !== null && _ref1 !== void 0 ? _ref1 : {})),
                            organization: JSON.parse(JSON.stringify((_ref2 = (_this_store1 = this.store) === null || _this_store1 === void 0 ? void 0 : (_this_store_getState1 = _this_store1.getState()) === null || _this_store_getState1 === void 0 ? void 0 : _this_store_getState1.organization) !== null && _ref2 !== void 0 ? _ref2 : {})),
                            authorization: this.authenticationContext.getAuthorization()
                        };
                        this.postMessage({
                            type: AuthenticationChannelEvents.BOOTSTRAP_AUTH_RESPONSE,
                            payload: _object_spread$v({}, transferStateData),
                            version: 2,
                            shortName: this.shortName
                        });
                    }
                }
            });
        }
        const promise = new Promise((resolve, reject)=>{
            if (!this.isChild) {
                resolve(true);
            } else {
                let bootstrapComplete = false;
                const authListener = (message)=>{
                    var _ref;
                    var _message_data;
                    if (bootstrapComplete || !isTrustedChannelOrigin(message)) {
                        return;
                    }
                    logger$1.log(`AuthenticationChannel ${this.browsingContextId} (${this.shortName}) authListener: ${message.data}`);
                    const messageType = (_ref = (_message_data = message.data) === null || _message_data === void 0 ? void 0 : _message_data.type) !== null && _ref !== void 0 ? _ref : '';
                    if (authenticatedEvents.has(messageType)) {
                        var _ref1;
                        var _message_data1;
                        const version = (_ref1 = (_message_data1 = message.data) === null || _message_data1 === void 0 ? void 0 : _message_data1.version) !== null && _ref1 !== void 0 ? _ref1 : null;
                        if (version === null) {
                            var _message_data_payload;
                            logger$1.log(`AuthenticationChannel ${this.browsingContextId} (${this.shortName} Creds:`, message.data);
                            this.authenticationContext.setAuthorization(message.data.payload);
                            activityMonitor.expiryTimeout = (_message_data_payload = message.data.payload) === null || _message_data_payload === void 0 ? void 0 : _message_data_payload.expiryTimeToLive;
                            bootstrapComplete = true;
                            this.removeEventListener('message', authListener);
                            resolve(true);
                        } else {
                            var _ref2, _ref3, _ref4;
                            var _message_data_payload1, _message_data2, _message_data_payload2, _message_data3, _message_data_payload3, _message_data4, _uiState_context_activeContext, _uiState_context, _uiState_context1, _uiState_context2;
                            // run sync
                            const uiState = message === null || message === void 0 ? void 0 : (_message_data2 = message.data) === null || _message_data2 === void 0 ? void 0 : (_message_data_payload1 = _message_data2.payload) === null || _message_data_payload1 === void 0 ? void 0 : _message_data_payload1.ui;
                            if (!!uiState) {
                                var _this_store, _transferData_context_activeContext, _transferData_context, _this_store1;
                                const transferData = JSON.parse(JSON.stringify(uiState));
                                (_this_store = this.store) === null || _this_store === void 0 ? void 0 : _this_store.dispatch({
                                    type: 'REPLACE_UI_STATE',
                                    payload: _object_spread$v({}, transferData)
                                });
                                (_this_store1 = this.store) === null || _this_store1 === void 0 ? void 0 : _this_store1.dispatch({
                                    type: 'SAVE_SERVICE_LINE_CAPABILITY',
                                    payload: transferData === null || transferData === void 0 ? void 0 : (_transferData_context = transferData.context) === null || _transferData_context === void 0 ? void 0 : (_transferData_context_activeContext = _transferData_context.activeContext) === null || _transferData_context_activeContext === void 0 ? void 0 : _transferData_context_activeContext.serviceLineName
                                });
                            }
                            const organizationState = message === null || message === void 0 ? void 0 : (_message_data3 = message.data) === null || _message_data3 === void 0 ? void 0 : (_message_data_payload2 = _message_data3.payload) === null || _message_data_payload2 === void 0 ? void 0 : _message_data_payload2.organization;
                            if (!!organizationState) {
                                var _this_store2;
                                const transferData = JSON.parse(JSON.stringify(organizationState));
                                (_this_store2 = this.store) === null || _this_store2 === void 0 ? void 0 : _this_store2.dispatch({
                                    type: 'REPLACE_ORGANIZATION_STATE',
                                    payload: _object_spread$v({}, transferData)
                                });
                            }
                            // Prefer the explicit auth payload because UI context state may not
                            // carry the active token in embedded/new-window flows.
                            const authPayload = message === null || message === void 0 ? void 0 : (_message_data4 = message.data) === null || _message_data4 === void 0 ? void 0 : (_message_data_payload3 = _message_data4.payload) === null || _message_data_payload3 === void 0 ? void 0 : _message_data_payload3.authorization;
                            const contextId = (_ref2 = authPayload === null || authPayload === void 0 ? void 0 : authPayload.contextId) !== null && _ref2 !== void 0 ? _ref2 : uiState === null || uiState === void 0 ? void 0 : (_uiState_context = uiState.context) === null || _uiState_context === void 0 ? void 0 : (_uiState_context_activeContext = _uiState_context.activeContext) === null || _uiState_context_activeContext === void 0 ? void 0 : _uiState_context_activeContext.organizationId;
                            if (contextId == null) {
                                logger$1.debug(`AuthenticationChannel ${this.browsingContextId} (${this.shortName}) bootstrapAuthResponse v2 missing organizationId; waiting for a complete payload`);
                                return;
                            }
                            const authorization = {
                                token: (_ref3 = authPayload === null || authPayload === void 0 ? void 0 : authPayload.token) !== null && _ref3 !== void 0 ? _ref3 : uiState === null || uiState === void 0 ? void 0 : (_uiState_context1 = uiState.context) === null || _uiState_context1 === void 0 ? void 0 : _uiState_context1.jwtToken,
                                contextId,
                                expiryTimeToLive: (_ref4 = authPayload === null || authPayload === void 0 ? void 0 : authPayload.expiryTimeToLive) !== null && _ref4 !== void 0 ? _ref4 : uiState === null || uiState === void 0 ? void 0 : (_uiState_context2 = uiState.context) === null || _uiState_context2 === void 0 ? void 0 : _uiState_context2.expiryTimeToLive
                            };
                            this.authenticationContext.setAuthorization(authorization);
                            // as soon as the channel has received it's credentials, it should
                            // establish it's own credentials.
                            activityMonitor.suppressNextRefreshBroadcast();
                            activityMonitor.emit(ActivityMonitor$1.events.BEGIN_REFRESH);
                            bootstrapComplete = true;
                            this.removeEventListener('message', authListener);
                            resolve(true);
                        }
                    }
                };
                this.addEventListener('message', authListener);
                this.postMessage({
                    type: AuthenticationChannelEvents.BOOTSTRAP_AUTH,
                    version: 2,
                    shortName: this.shortName
                });
            }
        });
        return promise;
    }
    constructor(channelDefinition){
        let { channelName, child, browsingContext } = channelDefinition;
        super(channelName), _define_property$x(this, "ready", void 0), _define_property$x(this, "isChild", void 0), _define_property$x(this, "url", void 0), _define_property$x(this, "authenticationContext", void 0 // just exposed here for testing purposes.
        ), _define_property$x(this, "store", void 0), _define_property$x(this, "shortName", void 0), _define_property$x(this, "browsingContextId", void 0);
        this.browsingContextId = browsingContext;
        this.shortName = `${channelName}`.slice(-10);
        this.isChild = child;
        this.authenticationContext = authenticationContext;
        this.ready = this._init();
        this.addEventListener('message', this.messageListener.bind(this));
    }
}

// This is a hacky implementation of the uuidv4
// It is entirely cribbed from stackoverflow.
// At this point in time, it is there to merely
// satisfy a need for being able to signify evidence
// uniquely.  The need for real guid-ness does not exist.
const uuidv4 = function() {
    // Public Domain/MIT
    var d = new Date().getTime(); //Timestamp
    var d2 = typeof performance !== 'undefined' && performance.now && performance.now() * 1000 || 0; //Time in microseconds since page-load or 0 if unsupported
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16; //random number between 0 and 16
        if (d > 0) {
            //Use timestamp until depleted
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            //Use microseconds since page-load if supported
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
};

function _define_property$w(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$u(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$w(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$n(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$n(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$n(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const getURL = ()=>{
    var _ref;
    var _window_location;
    const loc = (_ref = (_window_location = window.location) === null || _window_location === void 0 ? void 0 : _window_location.toString()) !== null && _ref !== void 0 ? _ref : '';
    return new URL(loc);
};
const getChannel = (url)=>{
    const channelDef = {
        browsingContext: uuidv4().slice(-10)
    };
    // Step 1: read parameter from the url
    // Step 2: if the parametere is not found on the url, fall back to
    //  sessionStorage.
    // Step 3: if no channel is available, a new channel will be created.
    const childChannel = url.searchParams.has('channel');
    if (childChannel) {
        return _object_spread_props$n(_object_spread$u({}, channelDef), {
            channelName: url.searchParams.get('channel'),
            child: true
        });
    }
    const fromSession = sessionStorage.getItem('channel');
    if (fromSession) {
        return _object_spread_props$n(_object_spread$u({}, channelDef), {
            channelName: fromSession,
            child: false
        });
    }
    return _object_spread_props$n(_object_spread$u({}, channelDef), {
        channelName: uuidv4(),
        child: false
    });
};
const channelDefinition = getChannel(getURL());
const authenticationChannel = new AuthenticationChannel(channelDefinition);
sessionStorage.setItem('channel', authenticationChannel.name);
// indicate that there is activity.
// this covers an edge case, where the user
// launches a new window, does not interact
// with it and then chooses to refresh.
authenticationChannel.postMessage({
    type: AuthenticatedWindow.ACTIVITY,
    payload: true,
    meta: {
        suppressRedux: true
    }
});

const updateValue = createAction(CaseEdits.UPDATE_VALUE);
/**
 * Sets a value in the caseUpdates object based on a label-to-value mapping.
 * This is not the ideal way to do this, adding support for CDMX-1832
 * This needs to be handled from field-editor component
 * to deal with label - value combination in the dropdown iteself
 *
 * @param caseUpdateFields - The object containing case update information
 * @param fieldName - The field name to check in caseUpdates
 * @param paramNameToAdd - The parameter name to add the mapped value to in caseUpdates
 */ const setEncounterValueForLabel = (caseUpdateFields, fieldName, paramNameToAdd)=>{
    const { caseUpdates, mappedValues } = caseUpdateFields;
    if (Object.keys(caseUpdates).includes(fieldName)) {
        var _mappedValues_find;
        const encounterVal = (_mappedValues_find = mappedValues.find((map)=>{
            return map.label === caseUpdates[fieldName];
        })) === null || _mappedValues_find === void 0 ? void 0 : _mappedValues_find.value;
        caseUpdates[paramNameToAdd] = encounterVal;
    }
};
const updateCase = createAsyncThunk(CaseEdits.UPDATE_CASE, async (params, { dispatch })=>{
    const { caseRunUid, serviceLine, caseUpdates, initialVal } = params;
    setEncounterValueForLabel(params, 'scheduling_department', 'scheduling_department_code');
    setEncounterValueForLabel(params, 'billing_location', 'billing_location');
    try {
        const updatedProcessInstance = await requestJSON(`/coding-api/processinstance/${serviceLine}/${caseRunUid}/v1`, {
            method: Methods.PUT,
            body: JSON.stringify(caseUpdates)
        });
        dispatch(updateProcessInstance({
            serviceLine,
            guid: caseRunUid.toString()
        }));
    } catch (e) {
        dispatch(updateValue(initialVal));
    }
});
const patientDetailDictionaries = {
    billing_location: {
        dictionaryName: 'Facility',
        columnName: 'Facility'
    },
    patient_type: {
        dictionaryName: 'Patient Class',
        columnName: 'Patient Type'
    },
    em_category: {
        dictionaryName: 'EM Category',
        columnName: 'E/M Category'
    },
    scheduling_department: {
        dictionaryName: 'Department',
        columnName: ''
    },
    note_specialty_designation: {
        dictionaryName: 'Note Specialty',
        columnName: 'Note Specialty'
    },
    financial_status_class: {
        dictionaryName: 'Financial Class',
        columnName: 'Financial Status Class'
    }
};
const loadPatientDetailOptions = createAsyncThunk(CaseEdits.LOAD_PATIENT_DETAIL_OPTIONS, async (payload, _thunkAPI)=>{
    const { activeTenantId, facility, dictionary } = payload;
    const dictionaryInfo = patientDetailDictionaries[dictionary];
    let fieldOptions = {
        standardFields: [],
        additionalFields: []
    };
    try {
        if (dictionaryInfo) {
            var _res_rowValues;
            let { dictionaryName, columnName } = dictionaryInfo;
            const searchParams = new URLSearchParams({
                tenantId: activeTenantId,
                derivedIndicator: 'true',
                effectiveDate: format(new Date(), FORMATS.DATE),
                dictionaryName: dictionaryName,
                columnName: columnName
            });
            const res = await requestJSON(`/dictionary/row/unrestricted/v2?${searchParams.toString()}`, {
                method: Methods.GET
            });
            const billing_location_label = dictionaryName === 'Facility' && ((_res_rowValues = res.rowValues) === null || _res_rowValues === void 0 ? void 0 : _res_rowValues.some((item)=>'Display Name' in item)) ? 'Display Name' : columnName;
            const dictionaryFieldHandlers = {
                Department: (row)=>{
                    fieldOptions.standardFields.push({
                        label: row['Unit/Department'],
                        value: row['Unit/Department ID']
                    });
                },
                'Patient Class': (row)=>{
                    fieldOptions.standardFields.push({
                        label: row[columnName],
                        value: row[columnName]
                    });
                    fieldOptions.additionalFields.push({
                        label: row['Patient Type'],
                        value: row['Patient Class Original']
                    });
                },
                Facility: (row)=>{
                    fieldOptions.standardFields.push({
                        label: row[billing_location_label],
                        value: row[columnName]
                    });
                },
                'Note Specialty': (row)=>{
                    if ((row === null || row === void 0 ? void 0 : row['Facility']) === facility) {
                        fieldOptions.standardFields.push({
                            label: row[columnName],
                            value: row[columnName]
                        });
                    }
                },
                default: (row)=>{
                    fieldOptions.standardFields.push({
                        label: row[columnName],
                        value: row[columnName]
                    });
                }
            };
            res.rowValues.forEach((row)=>{
                (dictionaryFieldHandlers[dictionaryName] || dictionaryFieldHandlers['default'])(row);
            });
        }
    } catch (e) {
        console.error(e);
    }
    return fieldOptions;
});
const loadAllPatientDetailOptions = createAsyncThunk(CaseEdits.LOAD_ALL_PATIENT_DETAIL_OPTIONS, async (payload, { dispatch })=>{
    const { activeTenantId, facility } = payload;
    Object.keys(patientDetailDictionaries).forEach((dictionary)=>{
        dispatch(loadPatientDetailOptions({
            activeTenantId,
            facility,
            dictionary
        }));
    });
});
const caseEditsActions = {
    updateValue,
    updateCase,
    loadAllPatientDetailOptions,
    loadPatientDetailOptions
};

var caseEdits_actions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  caseEditsActions: caseEditsActions
});

function _define_property$v(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$t(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$v(target, key, source[key]);
        });
    }
    return target;
}
const { AmplifyAuthenticate, Launch } = commonActions;
// --------------------- sync actions  --------------------- //
const userDetailsAvailable = createAction(AmplifyAuthenticate.USER_DETAILS);
const launchParamsAvailable = createAction(Launch.PARAMS_AVAILABLE);
const contextParams$1 = createAction(Launch.CONTEXT_PARAMS);
const hostCaseId = createAction(Launch.PARENT_CASE);
const billingGroupAvailable = createAction(Launch.BILLING_GROUP);
const caseRunAvailable = createAction(Launch.CASE_DETAIL);
const caseRunWithRefreshAvailable = createAction(Launch.CASE_DETAIL_WITH_REFRESH);
const epicToken = createAction(Launch.EPIC_TOKEN);
const selectCase = createAsyncThunk(Launch.CASE_SELECTED, async (caseRun, { dispatch })=>{
    const { path: slPath, caseDetailVersion } = get();
    const url = `${slPath}/caseinstance/${caseRun.case_id}/details/${caseDetailVersion}?evidence=true&processTypes=PREDICTION&processTypes=ADDENDUM`;
    const withDetails = await requestJSON(url);
    //
    const activeItem = withDetails.caseRuns[0];
    await loadCase(activeItem, dispatch);
    return activeItem;
});
const fetchContextJSON = async ()=>{
    const userDetailsResponse = await request('/contexts/v1');
    const contextJSON = await userDetailsResponse.json();
    return contextJSON;
};
const getLoadedContext = (state)=>{
    var _state_ui;
    const context = state === null || state === void 0 ? void 0 : (_state_ui = state.ui) === null || _state_ui === void 0 ? void 0 : _state_ui.context;
    return (context === null || context === void 0 ? void 0 : context.activeContext) ? context : null;
};
const getStateAuthToken = (state)=>{
    var _ref;
    var _state_login_auth, _state_login, _state_ui_context, _state_ui;
    return (_ref = state === null || state === void 0 ? void 0 : (_state_login = state.login) === null || _state_login === void 0 ? void 0 : (_state_login_auth = _state_login.auth) === null || _state_login_auth === void 0 ? void 0 : _state_login_auth.token) !== null && _ref !== void 0 ? _ref : state === null || state === void 0 ? void 0 : (_state_ui = state.ui) === null || _state_ui === void 0 ? void 0 : (_state_ui_context = _state_ui.context) === null || _state_ui_context === void 0 ? void 0 : _state_ui_context.jwtToken;
};
const syncAuthTokenFromState = (state)=>{
    if (_authHandler.token) {
        return;
    }
    const token = getStateAuthToken(state);
    if (token) {
        _authHandler.token = token;
    }
};
const tokenAvailable = createAsyncThunk(Launch.LOAD_CASE_WITH_TOKEN, async (launchParams, { dispatch })=>{
    _authHandler.token = launchParams.token;
    const sl = determineServiceLineConfig({
        name: launchParams.serviceLine,
        caseIdentifier: `${launchParams.caseId}`
    });
    set$1(sl);
    const contextJSON = await fetchContextJSON();
    dispatch(userDetailsAvailable(contextJSON));
    const { path: slPath, caseDetailVersion } = get();
    const url = `${slPath}/caseinstance/${launchParams.caseId}/details/${caseDetailVersion}?evidence=true&processTypes=PREDICTION&processTypes=ADDENDUM`;
    const withDetails = await requestJSON(url);
    //
    const activeItem = withDetails.caseRuns[0];
    const caseUrl = (await loadCase(activeItem, dispatch)).url;
    dispatch(caseRunAvailable(activeItem));
    dispatch(navigationIntent({
        intent: 'CASE_DETAIL',
        url: caseUrl
    }));
    return;
});
const loadCaseFromId = createAsyncThunk(Launch.LOAD_CASE_FROM_ID, async (launchParams, { dispatch })=>{
    var _ref;
    var _activeItem_service_line;
    const { path: slPath, caseDetailVersion } = get();
    const url = `${slPath}/caseinstance/${launchParams.caseId}/details/${caseDetailVersion}?evidence=true&processTypes=PREDICTION&processTypes=ADDENDUM`;
    const withDetails = await requestJSON(url);
    //
    const activeItem = withDetails.caseRuns[0];
    await loadCase(activeItem, dispatch);
    const serviceLineConfig = determineServiceLineConfig({
        name: activeItem.service_line,
        caseIdentifier: `${activeItem.case_uid || activeItem.case_id}`
    });
    const caseId = serviceLineConfig.caseIdProp in activeItem ? activeItem[serviceLineConfig.caseIdProp] : activeItem.case_id;
    const sl = (_ref = (_activeItem_service_line = activeItem.service_line) === null || _activeItem_service_line === void 0 ? void 0 : _activeItem_service_line.toLowerCase()) !== null && _ref !== void 0 ? _ref : '';
    dispatch(caseRunAvailable(activeItem));
    const pathname = window.location.pathname;
    const matchWorklist = pathname.match(/^\/cmx\/(worklist|coding-quality)/);
    const basePath = matchWorklist ? matchWorklist[0] : '/cmx/worklist';
    dispatch(navigationIntent({
        intent: 'CASE_DETAIL',
        url: `${basePath}/${sl}/case/${caseId}/case-run/${activeItem.process_instance_id}`,
        replace: true
    }));
    return;
});
const loadCaseRunWithRefresh = async (url, processInstanceIdProp, match, dispatch)=>{
    if (!url) return;
    const urlWithRefresh = `${url}&refresh=true`;
    const withRefreshDetails = await requestJSON(urlWithRefresh, {}, true);
    let activeItemWithRefresh = withRefreshDetails.caseRuns.find((caseRun)=>caseRun[processInstanceIdProp].toString() === match.params.id.toString());
    if (!activeItemWithRefresh) {
        activeItemWithRefresh = withRefreshDetails.caseRuns[0];
    }
    dispatch(caseRunWithRefreshAvailable(activeItemWithRefresh));
};
const loadFromURLMatch = createAsyncThunk(Launch.LOAD_FROM_URL, async (match, { dispatch, getState, rejectWithValue })=>{
    var _match_params;
    const state = getState();
    // CDMX-17209: A logout teardown can transiently re-mount the bench and fire
    // this load. The login reducer clears auth state on LOGOUT before that mount,
    // so an empty Redux token means we are tearing down. Bail before any network
    // call to avoid a doomed GET /contexts/v1 (403) and the resulting RUM noise.
    // authHandler.token is unreliable here (still set mid-logout), so key off state.
    if (!getStateAuthToken(state)) {
        return rejectWithValue({
            name: 'UnauthenticatedError',
            message: 'No active session; skipping LOAD_FROM_URL during logout teardown',
            errors: {}
        });
    }
    syncAuthTokenFromState(state);
    const loadedContext = getLoadedContext(state);
    const contextJSON = loadedContext !== null && loadedContext !== void 0 ? loadedContext : await fetchContextJSON();
    const shimmedContext = loadedContext !== null && loadedContext !== void 0 ? loadedContext : shimContext(contextJSON);
    dispatch(userDetailsAvailable(contextJSON));
    // Check feature flag for display_all_case_runs
    const useV3Endpoint = shimmedContext.activeContext ? isResourceAllowed(shimmedContext.activeContext, ResourceId.DISPLAY_ALL_CASE_RUNS, match.params.serviceLine) : false;
    const sl = determineServiceLineConfig({
        name: match.params.serviceLine,
        displayAllCaseRuns: useV3Endpoint
    });
    const processInstanceIdProp = determineProcessInstanceId({
        name: match.params.serviceLine
    });
    // Use utility function to build URL
    const url = buildCaseDetailUrl(match.params.caseId, sl);
    const withDetails = await requestJSON(url, {}, true);
    // Use v3 logic for pathology
    let activeItem = withDetails.caseRuns.find((caseRun)=>caseRun[processInstanceIdProp].toString() === match.params.id.toString());
    if (!activeItem) {
        activeItem = withDetails.caseRuns[0];
    }
    if (isIPC(activeItem.service_line)) {
        await dispatch(getDocumentsAsHtml(activeItem));
    }
    await loadCaseFromURL(activeItem, dispatch);
    if (!!withDetails && ((_match_params = match.params) === null || _match_params === void 0 ? void 0 : _match_params.getCaserunWithRefresh)) {
        loadCaseRunWithRefresh(url, processInstanceIdProp, match, dispatch).catch((error)=>{
            console.error('Error while trying to load case run with refresh ', error === null || error === void 0 ? void 0 : error.message);
        });
    }
    let processInstance;
    try {
        processInstance = await dispatch(fetchProcessInstance(activeItem)).unwrap();
    } catch (e) {
    // ignore
    }
    if (isIPC(activeItem.service_line) || isSurgery(activeItem.service_line)) {
        dispatch(caseEditsActions.loadAllPatientDetailOptions({
            activeTenantId: activeItem.tenant_uid,
            facility: activeItem.facility
        }));
    }
    // ------------ xcaliber token fetch ------------
    await loadXCaliber(dispatch);
    try {
        if (isIPC(activeItem === null || activeItem === void 0 ? void 0 : activeItem.service_line)) {
            await dispatch(getFlagItems(activeItem));
        }
    } catch (error) {
        console.error(`Error while fetching flags: ${error.message}`);
    }
    const serviceLineConfig = determineServiceLineConfig({
        name: activeItem.service_line,
        caseIdentifier: `${activeItem.case_uid || activeItem.case_id}`
    });
    try {
        await dispatch(fetchImprovementOptions({
            activeItem: activeItem,
            processInstance: processInstance
        }));
    } catch (error) {
        console.error(`Error while fetching improvement options: ${error.message}`);
    }
    try {
        await dispatch(fetchProviderRoleTypeConfigurations({
            activeItem: activeItem,
            processInstance: processInstance
        }));
    } catch (error) {
        console.error(`Error while fetching provider role type configuration: ${error.message}`);
    }
    try {
        var _activeItem_encounter_identifier;
        if (!isPathology(activeItem === null || activeItem === void 0 ? void 0 : activeItem.service_line)) {
            dispatch(getCCICustomClaimCrossCases({
                activeItem: activeItem,
                processInstance: processInstance
            }));
        }
        dispatch(fetchOrderTypeStatus({
            activeItem: activeItem,
            processInstance: processInstance
        }));
        let filters;
        try {
            filters = await dispatch(fetchRelateCaseFilterDictionaries({
                activeItem: activeItem,
                processInstance: processInstance
            })).unwrap();
        } catch (e) {
        // ignore
        }
        let startDate;
        let endDate;
        if (activeItem.admission_datetime && activeItem.discharge_datetime) {
            startDate = activeItem.admission_datetime;
            endDate = activeItem.discharge_datetime;
        } else {
            startDate = format(new Date(), FORMATS.DATE_TIME_WITH_ZONE, {
                throw: false,
                localized: true,
                offset: {
                    action: DateManipulateOperation.SUBTRACT,
                    delta: [
                        30,
                        DateManipulateUnit.DAY
                    ]
                }
            });
            endDate = new Date();
        }
        const filterSelection = getRelatedCasesInitialFilters(filters, startDate, endDate);
        if (activeItem === null || activeItem === void 0 ? void 0 : (_activeItem_encounter_identifier = activeItem.encounter_identifier) === null || _activeItem_encounter_identifier === void 0 ? void 0 : _activeItem_encounter_identifier.number) {
            var _activeItem_encounter_identifier1, _activeItem_encounter_identifier2, _activeItem_encounter_identifier3;
            // Currently Pathology does not support this method of related cases, therefore skip if Path
            // Added for AUTO-6674
            if (!isPathology(activeItem.service_line)) {
                var _activeItem_encounter_identifier4;
                dispatch(getCasesWithEncounter({
                    encounterId: activeItem === null || activeItem === void 0 ? void 0 : (_activeItem_encounter_identifier4 = activeItem.encounter_identifier) === null || _activeItem_encounter_identifier4 === void 0 ? void 0 : _activeItem_encounter_identifier4.number,
                    sortablePageable: _object_spread$t({}, relatedCasesSortablePageable),
                    serviceLine: serviceLineConfig.amplifyPath,
                    filterSelection
                }));
            }
            dispatch(fetchRelatedCodes({
                encounterId: activeItem === null || activeItem === void 0 ? void 0 : (_activeItem_encounter_identifier1 = activeItem.encounter_identifier) === null || _activeItem_encounter_identifier1 === void 0 ? void 0 : _activeItem_encounter_identifier1.number,
                serviceLine: serviceLineConfig.amplifyPath,
                codeType: 'ICD',
                caseId: activeItem.case_id
            }));
            dispatch(fetchRelatedCodes({
                encounterId: activeItem === null || activeItem === void 0 ? void 0 : (_activeItem_encounter_identifier2 = activeItem.encounter_identifier) === null || _activeItem_encounter_identifier2 === void 0 ? void 0 : _activeItem_encounter_identifier2.number,
                serviceLine: serviceLineConfig.amplifyPath,
                codeType: 'CPT',
                caseId: activeItem.case_id
            }));
            dispatch(fetchRelatedCodes({
                encounterId: activeItem === null || activeItem === void 0 ? void 0 : (_activeItem_encounter_identifier3 = activeItem.encounter_identifier) === null || _activeItem_encounter_identifier3 === void 0 ? void 0 : _activeItem_encounter_identifier3.number,
                serviceLine: serviceLineConfig.amplifyPath,
                codeType: 'MODIFIER',
                caseId: activeItem.case_id
            }));
        }
    } catch (error) {
        console.error(`Error while fetching related cases: ${error.message}`);
    }
    return withDetails;
});
const standaloneLaunch$1 = createAsyncThunk(AmplifyAuthenticate.AUTOMATE, async (searchParams, { dispatch })=>{
    if (searchParams.has('channel')) {
        try {
            var _searchParams_get;
            await authenticationChannel.ready;
            const params = {};
            // Context params can be passed in via a queryString
            [
                ...searchParams.keys()
            ].forEach((key)=>{
                let value;
                // special case for processInstanceGuids which are an
                // array.
                if (key === 'processInstanceGuids') {
                    value = searchParams.get(key).split(',');
                } else {
                    value = searchParams.get(key);
                }
                params[key] = value;
            });
            dispatch(contextParams$1(params));
            const sl = determineServiceLineConfig({
                name: searchParams.get('serviceLine'),
                caseIdentifier: `${searchParams.get('caseId')}`
            });
            set$1(sl);
            const url = `${sl.path}/caseinstance/${searchParams.get('caseId')}/details/${sl.caseDetailVersion}?evidence=true&processTypes=PREDICTION&processTypes=ADDENDUM`;
            const withDetails = await requestJSON(url);
            //
            const processInstanceGuid = searchParams.get('processInstanceGuid');
            let activeItem = withDetails.caseRuns.find((caseRun)=>caseRun.process_instance_guid === processInstanceGuid);
            if (!activeItem) {
                activeItem = withDetails.caseRuns[0];
            }
            const contextJSON = await fetchContextJSON();
            dispatch(userDetailsAvailable(contextJSON));
            const useGuid = (_searchParams_get = searchParams.get('useGuid')) !== null && _searchParams_get !== void 0 ? _searchParams_get : 'false';
            const caseLoadResult = await loadCase(activeItem, dispatch, useGuid);
            dispatch(navigationIntent({
                intent: 'CASE_DETAIL',
                url: caseLoadResult.url
            }));
            await loadXCaliber(dispatch);
            return withDetails;
        } catch (e) {
            dispatch(navigationIntent({
                intent: 'NOT_AUTHORIZED'
            }));
        }
    }
});

var launchPageActions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  billingGroupAvailable: billingGroupAvailable,
  caseLookupError: caseLookupError,
  caseRunAvailable: caseRunAvailable,
  caseRunWithRefreshAvailable: caseRunWithRefreshAvailable,
  caseSearchAvailable: caseSearchAvailable,
  contextParams: contextParams$1,
  epicToken: epicToken,
  fetchCases: fetchCases,
  hostCaseId: hostCaseId,
  launchParamsAvailable: launchParamsAvailable,
  loadCaseFromId: loadCaseFromId,
  loadFromURLMatch: loadFromURLMatch,
  navigationIntent: navigationIntent,
  selectCase: selectCase,
  standaloneLaunch: standaloneLaunch$1,
  tokenAvailable: tokenAvailable,
  userDetailsAvailable: userDetailsAvailable
});

const navigateCreateCase = createAsyncThunk(CreateCase.NAVIGATE_CREATE_CASE, async (_caseRun, _thunkAPI)=>{
    return [];
});
const fetchNotesSpecialty = createAsyncThunk(CreateCase.FETCH_NOTES_SPECIALTY, async (tenantId, _thunkAPI)=>{
    const effectiveDate = format(new Date(), FORMATS.DATE);
    const searchParams = new URLSearchParams({
        tenantId: tenantId,
        effectiveDate: effectiveDate,
        dictionaryName: 'Note Specialty',
        columnName: 'Key'
    });
    return fetchDictionaryRows(searchParams);
});
const submitCreateCase = createAsyncThunk(CreateCase.SUBMIT_CREATE_CASE, async ({ createCase, activeCaseRun }, { dispatch })=>{
    let response;
    const serviceLineConfig = determineServiceLineConfig({
        name: activeCaseRun.service_line,
        caseIdentifier: `${activeCaseRun.case_uid || activeCaseRun.case_id}`
    });
    try {
        response = await requestJSON(`/coding-api/processinstance/${serviceLineConfig.amplifyPath}/${activeCaseRun.process_instance_guid}/createcase/v1`, {
            method: Methods.POST,
            body: JSON.stringify({
                notes_specialty: createCase.notesSpecialty,
                date_of_service: createCase.dateOfService,
                alternate_visit_id: createCase.alternate_visit_id,
                comments: createCase.comments
            })
        });
        // need to remove this once case-automate does this work.
        dispatch(toggleChargeableCase({
            serviceLine: response === null || response === void 0 ? void 0 : response.serviceLine,
            processInstanceGuid: response === null || response === void 0 ? void 0 : response.guid.uuid,
            isChargeable: true
        }));
        dispatch(amplifyFeedback$2({
            message: `The case has been created successfully.`,
            meta: FeedbackMeta.SUCCESS,
            dismissable: true
        }));
    } catch (error) {
        dispatch(amplifyFeedback$2({
            message: 'There was an error creating this case',
            meta: FeedbackMeta.ERROR,
            dismissable: true
        }));
        throw error;
    }
    return response;
});

var createCase_actions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  fetchNotesSpecialty: fetchNotesSpecialty,
  navigateCreateCase: navigateCreateCase,
  submitCreateCase: submitCreateCase
});

function _define_property$u(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$s(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$u(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$m(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$m(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$m(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const REQUEST_INIT_OPTIONS$1 = {
    method: 'GET',
    cache: 'no-cache',
    redirect: 'follow',
    referrer: 'no-referrer'
};
const showMergeCasesModal = createAction(MergeCases.SHOW_MERGE_CASES_MODAL);
const hideMergeCasesModal = createAction(MergeCases.HIDE_MERGE_CASES_MODAL);
const setActiveCaseRun = createAction(MergeCases.SET_ACTIVE_CASE_RUN);
const toggleMergeableCaseSelection = createAction(MergeCases.TOGGLE_MERGEABLE_CASE_SELECTION);
const fetchMergeableCases = createAsyncThunk(MergeCases.FETCH_MERGEABLE_CASES, async ({ encounterId, serviceLine }, _thunkAPI)=>{
    try {
        const result = await requestJSON(`/coding-api/${serviceLine}/mergeablecases/v1?encounterId=${encounterId}`, {
            method: Methods.GET
        });
        return result;
    } catch (error) {
        console.error(error);
    }
});
const getDocumentsByCaseRun = createAsyncThunk(MergeCases.GET_DOCUMENTS_AS_HTML, async (caseRun, _thunkAPI)=>{
    const tenantInfo = await requestJSON(`/organization/by-name/${caseRun.tenant_name}/v1`);
    const docs = await getDocuments(caseRun, tenantInfo);
    let htmlNotes = [];
    let plainTextNotes = [];
    for (const doc of docs){
        const { htmlNotesResult, plainTextNotesResult } = await downloadDoc(doc);
        htmlNotes.push(htmlNotesResult);
        plainTextNotes.push(plainTextNotesResult);
        const { id, mimeType } = doc;
        if (mimeType === 'text/html' || mimeType === 'text/plain') {
            const notes = caseRun === null || caseRun === void 0 ? void 0 : caseRun.notes;
            const caseRunNote = notes === null || notes === void 0 ? void 0 : notes.find((note)=>{
                return note.unique_document_number === doc.uniqueDocumentNumber;
            });
            const endpoint = `/documents/download/${id}/v1`;
            const content = await request(endpoint);
            const text = await content.text();
            if (mimeType === 'text/html') {
                var _ref, _ref1;
                // @ts-expect-error htmlNotes item shape extends string
                htmlNotes.push({
                    description: (_ref = caseRunNote === null || caseRunNote === void 0 ? void 0 : caseRunNote.description) !== null && _ref !== void 0 ? _ref : doc.documentDescription,
                    content: text,
                    filename: (_ref1 = caseRunNote === null || caseRunNote === void 0 ? void 0 : caseRunNote.note_specialty_designation) !== null && _ref1 !== void 0 ? _ref1 : 'Document',
                    type: doc.documentType,
                    document_id: doc.documentId,
                    id,
                    filetype: mimeType,
                    segments: [],
                    spans: []
                });
            }
            if (mimeType === 'text/plain') {
                var _ref2, _ref3;
                // @ts-expect-error plainTextNotes item shape extends string
                plainTextNotes.push({
                    description: (_ref2 = caseRunNote === null || caseRunNote === void 0 ? void 0 : caseRunNote.description) !== null && _ref2 !== void 0 ? _ref2 : doc.documentDescription,
                    content: text,
                    filename: (_ref3 = caseRunNote === null || caseRunNote === void 0 ? void 0 : caseRunNote.note_specialty_designation) !== null && _ref3 !== void 0 ? _ref3 : 'Document',
                    type: doc.documentType,
                    document_id: doc.documentId,
                    id,
                    filetype: mimeType,
                    segments: [],
                    spans: []
                });
            }
        }
    }
    return {
        htmlNotes,
        plainTextNotes
    };
});
const downloadDoc = async (doc)=>{
    let htmlNotesResult = '';
    let plainTextNotesResult = '';
    const { id, mimeType } = doc;
    if (mimeType === 'text/html' || mimeType === 'text/plain') {
        const endpoint = `/documents/download/${id}/v1`;
        const content = await request(endpoint);
        const text = await content.text();
        if (mimeType === 'text/html') {
            htmlNotesResult = text;
        }
        if (mimeType === 'text/plain') {
            plainTextNotesResult = text;
        }
    }
    return {
        htmlNotesResult,
        plainTextNotesResult
    };
};
const requestMergeCases = createAsyncThunk(MergeCases.FETCH_MERGE_CASES, async ({ currentCaseRun, casesToMerge, cursorAPIContext, hasAmplifyCaseRunV2Access }, { dispatch })=>{
    try {
        const mergeResult = await requestJSON(`/coding-api/processinstance/${currentCaseRun.service_line}/${currentCaseRun.process_instance_guid}/merge/v1`, _object_spread_props$m(_object_spread$s({}, REQUEST_INIT_OPTIONS$1), {
            method: Methods.POST,
            body: JSON.stringify({
                componentCases: casesToMerge.map((caseToMerge)=>{
                    return {
                        caseUid: caseToMerge.case_id,
                        processInstanceGuid: caseToMerge.process_instance_guid,
                        primary: caseToMerge.primary
                    };
                })
            })
        }));
        const { serviceLine, caseUid, guid } = mergeResult;
        if (serviceLine && caseUid && guid) {
            setTimeout(()=>{
                dispatch(launchInAmplify({
                    isCodingQuality: false,
                    serviceLine,
                    caseId: caseUid,
                    processId: guid.uuid,
                    cursorAPIContext,
                    hasAmplifyCaseRunV2Access
                }));
            }, 5000);
        }
        return mergeResult;
    } catch (error) {
        throw error;
    }
});
const splitCase = createAsyncThunk(MergeCases.SPLIT_CASE, async (processInstance, { dispatch })=>{
    try {
        const updatedProcessInstance = await requestJSON(`/coding-api/processinstance/${processInstance.serviceLine}/${processInstance.guid.uuid}/split/v1`, _object_spread_props$m(_object_spread$s({}, REQUEST_INIT_OPTIONS$1), {
            method: Methods.POST
        }));
        const serviceLineConfig = determineServiceLineConfig({
            name: processInstance.serviceLine
        });
        const url = `${serviceLineConfig.path}/caseinstance/${updatedProcessInstance.caseUid}/details/${serviceLineConfig.caseDetailVersion}?evidence=true&processTypes=PREDICTION&processTypes=ADDENDUM`;
        const withDetails = await requestJSON(url);
        let activeItem = withDetails.caseRuns.find((caseRun)=>caseRun.process_instance_guid === updatedProcessInstance.guid.uuid);
        if (!!activeItem) {
            dispatch(caseRunAvailable(activeItem));
        }
        dispatch(fetchActivity(updatedProcessInstance));
        return updatedProcessInstance;
    } catch (error) {
        dispatch(amplifyFeedback$2({
            message: 'There were issues while trying to split the case.',
            meta: FeedbackMeta.ERROR,
            dismissable: true
        }));
    }
    return processInstance;
});
const launchInAmplify = createAsyncThunk(MergeCases.LAUNCH_IN_AMPLIFY, async (amplifyLaunchConfig, { dispatch })=>{
    dispatch(navigationIntent({
        intent: 'CASE_DETAIL',
        url: `/cmx/worklist/${amplifyLaunchConfig.serviceLine}/case/${amplifyLaunchConfig.caseId}/case-run/${amplifyLaunchConfig.processId}/${amplifyLaunchConfig.hasAmplifyCaseRunV2Access ? 'v2/' : ''}`,
        state: _object_spread$s({}, amplifyLaunchConfig === null || amplifyLaunchConfig === void 0 ? void 0 : amplifyLaunchConfig.cursorAPIContext)
    }));
});

var mergeCases_actions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  downloadDoc: downloadDoc,
  fetchMergeableCases: fetchMergeableCases,
  getDocumentsByCaseRun: getDocumentsByCaseRun,
  hideMergeCasesModal: hideMergeCasesModal,
  launchInAmplify: launchInAmplify,
  requestMergeCases: requestMergeCases,
  setActiveCaseRun: setActiveCaseRun,
  showMergeCasesModal: showMergeCasesModal,
  splitCase: splitCase,
  toggleMergeableCaseSelection: toggleMergeableCaseSelection
});

const showAttachDocsModal = createAction(AttachDocs.SHOW_ATTACH_DOCS_MODAL);
const hideAttachDocsModal = createAction(AttachDocs.HIDE_ATTACH_DOCS_MODAL);
const fetchAvailableDocs = createAsyncThunk(AttachDocs.GET_DOCS_TO_ATTACH, async (caseRun)=>{
    const tenantInfo = await requestJSON(`/organization/by-name/${caseRun.tenant_name}/v1`);
    return getDocumentsByMRN(caseRun, tenantInfo);
});
const fetchSpecialtiesDictionary = createAsyncThunk(AttachDocs.FETCH_SPECIALTY_DICTIONARY, async (caseRun)=>{
    return fetchDictionary(caseRun.tenant_uid, 'Note Specialty', 'Note Specialty');
});
const fetchNoteTypeDictionary = createAsyncThunk(AttachDocs.FETCH_NOTE_TYPE_DICTIONARY, async (caseRun)=>{
    return fetchDictionary(caseRun.tenant_uid, 'Note Type', 'Note Description');
});
const downloadDocs = createAsyncThunk(AttachDocs.DOWNLOAD_DOCS, async (doc)=>{
    const { htmlNotesResult, plainTextNotesResult } = await downloadDoc(doc);
    return {
        htmlNotes: [
            htmlNotesResult
        ],
        plainTextNotes: [
            plainTextNotesResult
        ],
        doc
    };
});
const fetchDictionary = async (activeTenantId, dictionaryName, columnName)=>{
    const searchParams = new URLSearchParams({
        tenantId: activeTenantId,
        derivedIndicator: 'true',
        effectiveDate: format(new Date(), FORMATS.DATE),
        dictionaryName: dictionaryName,
        columnName: columnName
    });
    const res = await requestJSON(`/dictionary/row/unrestricted/v2?${searchParams.toString()}`, {
        method: Methods.GET
    });
    return res.rowValues;
};
const getDocumentsByMRN = async (caseRun, tenantInfo)=>{
    var _caseRun_patient_identifier;
    // docs metadata filter
    const response = [];
    const docFilter = new URLSearchParams({
        tenantId: tenantInfo.tenantId
    });
    const documentsRequest = await requestJSON(`/documents/v1?${docFilter}`, {
        method: Methods.POST,
        body: JSON.stringify({
            patientMrn: caseRun === null || caseRun === void 0 ? void 0 : (_caseRun_patient_identifier = caseRun.patient_identifier) === null || _caseRun_patient_identifier === void 0 ? void 0 : _caseRun_patient_identifier.number
        })
    });
    const { MimeTypes } = documentUtils;
    // group documents by externalId
    const groupedByExternalId = groupBy(documentsRequest, 'externalId');
    Object.entries(groupedByExternalId).forEach(([externalId, docs])=>{
        // group documents by mimeType
        const groupBydDocs = groupBy(docs, 'mimeType');
        const precedence = [
            MimeTypes.HTML,
            MimeTypes.TEXT,
            MimeTypes.PDF
        ];
        const doc = firstAvailable(groupBydDocs, precedence);
        if (doc) {
            response.push(doc);
        }
    });
    return response;
};

var attachDocs_actions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  downloadDocs: downloadDocs,
  fetchAvailableDocs: fetchAvailableDocs,
  fetchNoteTypeDictionary: fetchNoteTypeDictionary,
  fetchSpecialtiesDictionary: fetchSpecialtiesDictionary,
  hideAttachDocsModal: hideAttachDocsModal,
  showAttachDocsModal: showAttachDocsModal
});

const useHandleRubricAnswerChange = (onAnswerChange, onDeleteAnswer, onClearDownstream)=>{
    return useCallback(async (params)=>{
        const { entityId, entityType, attributes, questionId, answerValueId, answerDisplayText, spanAnnotationIds, downstreamQuestionIds, spanScopeAttributeId, parentQuestionId } = params;
        const scopeAttributeId = spanScopeAttributeId !== null && spanScopeAttributeId !== void 0 ? spanScopeAttributeId : parentQuestionId;
        const matchesSpanScope = (a)=>{
            var _a_spanScopeAttributeId;
            const attributeScopeId = (_a_spanScopeAttributeId = a.spanScopeAttributeId) !== null && _a_spanScopeAttributeId !== void 0 ? _a_spanScopeAttributeId : a.parentQuestionId;
            if (scopeAttributeId != null) {
                return attributeScopeId === scopeAttributeId;
            }
            return attributeScopeId == null;
        };
        const attributesToDelete = (attributes || []).filter((a)=>downstreamQuestionIds.includes(a.questionId)).filter(matchesSpanScope);
        // Optimistic clear in one dispatch — avoids intermediate renders while
        // the per-attribute DELETEs are in flight.
        if (onClearDownstream && downstreamQuestionIds.length > 0) {
            const clearParams = {
                entityId: typeof entityId === 'number' ? String(entityId) : entityId,
                entityType,
                questionIds: downstreamQuestionIds
            };
            if (scopeAttributeId != null) {
                clearParams.spanScopeAttributeId = scopeAttributeId;
            }
            onClearDownstream(clearParams);
        }
        for (const attribute of attributesToDelete){
            const deleteParams = {
                entityId: String(entityId),
                entityType,
                questionId: attribute.questionId
            };
            if (scopeAttributeId != null) {
                deleteParams.spanScopeAttributeId = scopeAttributeId;
            }
            await onDeleteAnswer(deleteParams);
        }
        // SPAN/SPANS cleared (empty array) routes to DELETE; non-empty falls
        // through to the save block below.
        if (spanAnnotationIds != null && spanAnnotationIds.length === 0) {
            const existingAttribute = (attributes || []).find((a)=>a.questionId === questionId && matchesSpanScope(a));
            if (existingAttribute) {
                const deleteParams = {
                    entityId: String(entityId),
                    entityType,
                    questionId
                };
                if (scopeAttributeId != null) {
                    deleteParams.spanScopeAttributeId = scopeAttributeId;
                }
                await onDeleteAnswer(deleteParams);
            }
            return;
        }
        if (answerDisplayText != null && answerDisplayText.trim() === '') {
            const matchingAttributes = (attributes || []).filter((a)=>a.questionId === questionId).filter(matchesSpanScope);
            if (matchingAttributes.length === 1) {
                const deleteParams = {
                    entityId: String(entityId),
                    entityType,
                    questionId
                };
                if (scopeAttributeId != null) {
                    deleteParams.spanScopeAttributeId = scopeAttributeId;
                }
                await onDeleteAnswer(deleteParams);
            }
            return;
        }
        const updateParams = {
            entityId: String(entityId),
            entityType,
            questionId
        };
        if (answerDisplayText != null) {
            updateParams.answerDisplayText = answerDisplayText;
        } else if (spanAnnotationIds != null && spanAnnotationIds.length > 0) {
            updateParams.spanAnnotationIds = spanAnnotationIds;
        } else {
            updateParams.answerValueId = answerValueId;
        }
        if (scopeAttributeId != null) {
            updateParams.spanScopeAttributeId = scopeAttributeId;
        }
        await onAnswerChange(updateParams);
    }, [
        onAnswerChange,
        onDeleteAnswer,
        onClearDownstream
    ]);
};

const selectInvoiceList = (state)=>{
    var _ref;
    return (_ref = state === null || state === void 0 ? void 0 : state.invoices) !== null && _ref !== void 0 ? _ref : [];
};
const selectLooseSpanList = (state)=>{
    var _ref;
    return (_ref = state === null || state === void 0 ? void 0 : state.looseSpans) !== null && _ref !== void 0 ? _ref : [];
};
/**
 * Selector to derive all span annotations from invoices.
 * Memoized so useSelector does not see a new array reference on every render when inputs are unchanged.
 */ const selectSpanAnnotations = createSelector([
    selectInvoiceList,
    selectLooseSpanList
], (invoices, looseSpans)=>{
    if (!invoices.length && !looseSpans.length) {
        return [];
    }
    const codeSpans = getAllSpans(invoices);
    const allSpans = [
        ...codeSpans,
        ...looseSpans
    ];
    return mergeOverlappingSpanAttributes(allSpans);
});
/**
 * Selector to get spans for a specific document ID
 * Useful for filtering spans by document in case-note views
 */ const selectSpansByDocumentId = (state, documentId)=>{
    const spanAnnotations = selectSpanAnnotations(state);
    return spanAnnotations.filter((span)=>span.documentId === documentId);
};
/**
 * Selector to get only loose spans (not attached to any code)
 * Useful for operations that need to distinguish between code-attached and loose spans
 */ const selectLooseSpans = (state)=>{
    return (state === null || state === void 0 ? void 0 : state.looseSpans) || [];
};
/**
 * Step 7: Returns true when no updateAttribute/deleteAttribute thunks are in-flight.
 * Used by the submit handler to await quiescence before calling resolveCQAWorkitem.
 */ const selectAutosavesIdle = (state)=>{
    var _ref;
    return Object.keys((_ref = state === null || state === void 0 ? void 0 : state.pendingAutosaves) !== null && _ref !== void 0 ? _ref : {}).length === 0;
};
const spanSelectors = {
    selectSpanAnnotations,
    selectSpansByDocumentId,
    selectLooseSpans,
    selectAutosavesIdle
};

var spanSelectors$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  selectAutosavesIdle: selectAutosavesIdle,
  selectLooseSpans: selectLooseSpans,
  selectSpanAnnotations: selectSpanAnnotations,
  selectSpansByDocumentId: selectSpansByDocumentId,
  spanSelectors: spanSelectors
});

const processModifiers = (modifiers, caseRun, codeRequests)=>{
    modifiers.codes.forEach((mod)=>{
        codeRequests.push({
            code: mod.modifier_code,
            codeType: "MODIFIER",
            effectiveDate: caseRun.date_of_service || format(new Date(), FORMATS.DATE),
            dictionaryName: 'Modifiers',
            columnName: 'Code'
        });
    });
};
const processICDs = (icds, caseRun, codeRequests)=>{
    icds.codes.forEach((icd)=>{
        codeRequests.push({
            code: icd.diagnosis_code,
            codeType: "ICD",
            effectiveDate: caseRun.date_of_service || format(new Date(), FORMATS.DATE),
            dictionaryName: 'ICD Codes',
            columnName: 'Code'
        });
    });
};
const processCPTs = (procedures, caseRun, codeRequests)=>{
    procedures.codes.forEach((procedure)=>{
        codeRequests.push({
            code: procedure.procedure_code,
            codeType: "CPT",
            effectiveDate: caseRun.date_of_service || format(new Date(), FORMATS.DATE),
            dictionaryName: 'CPT Codes',
            columnName: 'Code'
        });
        if (procedure.modifiers && procedure.modifiers.codes && Array.isArray(procedure.modifiers.codes) && procedure.modifiers.codes.length > 0) {
            processModifiers(procedure.modifiers, caseRun, codeRequests);
        }
        if (procedure.diagnoses && procedure.diagnoses.codes && Array.isArray(procedure.diagnoses.codes) && procedure.diagnoses.codes.length > 0) {
            processICDs(procedure.diagnoses, caseRun, codeRequests);
        }
    });
};
const getCodeRequests = (artifacts, caseRun)=>{
    const codeRequests = [];
    artifacts.forEach((artifact)=>{
        processCPTs(artifact.procedures, caseRun, codeRequests);
        if (artifact.modifiers) {
            processModifiers(artifact.modifiers, caseRun, codeRequests);
        }
        if (artifact.diagnoses) {
            processICDs(artifact.diagnoses, caseRun, codeRequests);
        }
    });
    return uniqBy(codeRequests, (code)=>`${code.code}-${code.effectiveDate}`);
};
const getInvoiceCodeRequests = (caseRuns)=>{
    const codeRequests = [];
    caseRuns.forEach((caseRun)=>{
        (caseRun.invoices || []).forEach((invoice)=>{
            (invoice.transactions || []).forEach((txn)=>{
                if (txn.procedure) {
                    codeRequests.push({
                        code: `${txn.procedure.procedure_code}`,
                        codeType: "CPT",
                        effectiveDate: caseRun.date_of_service || format(new Date(), FORMATS.DATE),
                        dictionaryName: 'CPT Codes',
                        columnName: 'Code'
                    });
                    // Add modifiers for procedure level
                    if (txn.procedure.modifier_codes) {
                        txn.procedure.modifier_codes.forEach((mod)=>{
                            codeRequests.push({
                                code: mod.modifier_code,
                                codeType: "MODIFIER",
                                effectiveDate: caseRun.date_of_service || format(new Date(), FORMATS.DATE),
                                dictionaryName: 'Modifiers',
                                columnName: 'Code'
                            });
                        });
                    }
                }
                if (txn.technical_code) {
                    codeRequests.push({
                        code: `${txn.technical_code.code}`,
                        codeType: "TECH",
                        effectiveDate: caseRun.date_of_service || format(new Date(), FORMATS.DATE),
                        dictionaryName: 'Technical Charge Codes',
                        columnName: 'Code'
                    });
                    // Add modifiers for technical_code level
                    if (txn.technical_code.modifier_codes) {
                        txn.technical_code.modifier_codes.forEach((mod)=>{
                            codeRequests.push({
                                code: mod.modifier_code,
                                codeType: "MODIFIER",
                                effectiveDate: caseRun.date_of_service || format(new Date(), FORMATS.DATE),
                                dictionaryName: 'Modifiers',
                                columnName: 'Code'
                            });
                        });
                    }
                }
                if (txn.diagnoses) {
                    txn.diagnoses.forEach((dx)=>{
                        codeRequests.push({
                            code: dx.diagnosis_code,
                            codeType: "ICD",
                            effectiveDate: caseRun.date_of_service || format(new Date(), FORMATS.DATE),
                            dictionaryName: 'ICD Codes',
                            columnName: 'Code'
                        });
                    });
                }
            });
        });
    });
    return uniqBy(codeRequests, (code)=>`${code.code}-${code.effectiveDate}`);
};

const isReload = (window)=>{
    const { performance } = window;
    return performance && performance.navigation && performance.navigation.type === 1;
};

var navigation = /*#__PURE__*/Object.freeze({
  __proto__: null,
  isReload: isReload
});

const setLocation = (location)=>{
    window.sessionStorage.setItem('location', location);
};
const resetLocation = ()=>{
    window.sessionStorage.setItem('location', '');
};
const getLocation = ()=>{
    const location = window.sessionStorage.getItem('location') || undefined;
    return location;
};

var location = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getLocation: getLocation,
  resetLocation: resetLocation,
  setLocation: setLocation
});

const compareStringsByAlphabetThenASCII = (stringA, stringB)=>{
    const firstLetterA = stringA.charAt(0);
    const firstLetterB = stringB.charAt(0);
    if (firstLetterA.toLowerCase() < firstLetterB.toLowerCase()) {
        return -1;
    } else if (firstLetterA.toLowerCase() > firstLetterB.toLowerCase()) {
        return 1;
    } else {
        if (firstLetterA.charCodeAt(0) < firstLetterB.charCodeAt(0)) {
            return -1;
        } else if (firstLetterA.charCodeAt(0) > firstLetterB.charCodeAt(0)) {
            return 1;
        } else {
            return stringA.toLowerCase().localeCompare(stringB.toLowerCase());
        }
    }
};

var compareStrings = /*#__PURE__*/Object.freeze({
  __proto__: null,
  compareStringsByAlphabetThenASCII: compareStringsByAlphabetThenASCII
});

const pathBuilder = (url)=>{
    let path = `${url.pathname}`;
    // my attempts to get the size of the url.searchParams are
    // not meeting with success in ts.  need to revisit.
    //@ts-ignore
    const keys = Array.from(url.searchParams);
    if (keys.length) {
        path = `${path}?${url.searchParams}`;
    }
    if (url.hash) {
        path = `${path}${url.hash}`;
    }
    return path;
};

var _cmxURL = /*#__PURE__*/Object.freeze({
  __proto__: null,
  pathBuilder: pathBuilder
});

/**
 * This file is really here to make our calls to window unload
 * a little more easy to understand.  If the calls to window.onunload
 * are scattered all over the place, then the calls remain a little
 * difficult to track down.  What this file, a bit of an odd duck, gives
 * us is the ability via typescript to trace those calls.
 */ const terminationEvent = (()=>{
    return typeof window !== 'undefined' && 'onpagehide' in window ? 'pagehide' : 'unload';
})();
const addEventListener = (fn, options)=>{
    return window.addEventListener(terminationEvent, fn, options);
};
const removeEventListener = (fn, options)=>{
    return window.removeEventListener(terminationEvent, fn, options);
};

var _windowTeardownHandler = /*#__PURE__*/Object.freeze({
  __proto__: null,
  addEventListener: addEventListener,
  removeEventListener: removeEventListener
});

const isCoder = (roles)=>{
    return roles && roles.length === 1 && roles.indexOf('coder') !== -1;
};

var _userUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  isCoder: isCoder
});

function _define_property$t(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
class abortControllerManager {
    //Recommend to call getSignal with either the action name
    getSignal(key) {
        if (this.controller[key]) this.controller[key].abort();
        this.controller[key] = new AbortController();
        return this.controller[key].signal;
    }
    constructor(){
        _define_property$t(this, "controller", void 0);
        this.controller = {};
    }
}
var abortController = new abortControllerManager();

const convertBase64 = (base64Content)=>{
    if (base64Content === null || base64Content === undefined) {
        return '';
    }
    try {
        return window.atob(base64Content);
    } catch (e) {
        console.error(e);
        return 'Unable to convert content.';
    }
};

var index$8 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  convertBase64: convertBase64
});

const { CaseArtifactTypes } = commonEnums;
const getArtifactSet = (toggleAll, caseRun)=>{
    if (toggleAll) {
        return completeSet;
    } else {
        var _caseRun_artifacts, _caseRun_invoices;
        const artifacts = (_caseRun_artifacts = caseRun.artifacts) !== null && _caseRun_artifacts !== void 0 ? _caseRun_artifacts : [];
        const artSet = isCaseRunV2(caseRun) ? new Set(((_caseRun_invoices = caseRun.invoices) !== null && _caseRun_invoices !== void 0 ? _caseRun_invoices : []).map((invoice)=>invoice.type)) : new Set(artifacts.map((artifact)=>artifact.type));
        if (artSet.has(CaseArtifactTypes.SUBMITTED) || !caseRun.submitter_process) {
            return submissionSet;
        } else if (artSet.has(CaseArtifactTypes.PROCESSED)) {
            return defaultSet;
        } else {
            return inProgressDefaultSet;
        }
    }
};

var _caseArtifacts = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getArtifactSet: getArtifactSet
});

const ENTER_SUB_PROCESS = 'callActivity';
const PROCESS_REGEX = /Process/i;
const START_REGEX = /Start\s/i;
const { TimelineStatus } = commonEnums;
const isComplete = (step)=>{
    if (!step.activity) {
        return true;
    }
    const { lastStartTimestamp, lastEndTimestamp } = step.activity;
    if (lastEndTimestamp === null) {
        // const {
        //   activity: { activityDefinition }
        // } = step;
        // const readout = `${activityDefinition.processDefinitionKey} - ${activityDefinition.activityId}`;
        // console.log(
        //   `no end time stamp ${readout}`,
        //   activityDefinition.name,
        //   activityDefinition
        // );
        return false;
    }
    if (lastEndTimestamp < lastStartTimestamp) return false;
    return lastEndTimestamp >= lastStartTimestamp;
};
const stepComparitor = (step1, step2)=>{
    var _step1_activity, _step2_activity, _step1_activity1, _step2_activity1;
    const startsBefore = ((_step1_activity = step1.activity) === null || _step1_activity === void 0 ? void 0 : _step1_activity.lastStartTimestamp) < ((_step2_activity = step2.activity) === null || _step2_activity === void 0 ? void 0 : _step2_activity.lastStartTimestamp);
    if (startsBefore) {
        return -1;
    }
    const startsAfter = ((_step1_activity1 = step1.activity) === null || _step1_activity1 === void 0 ? void 0 : _step1_activity1.lastStartTimestamp) > ((_step2_activity1 = step2.activity) === null || _step2_activity1 === void 0 ? void 0 : _step2_activity1.lastStartTimestamp);
    if (startsAfter) {
        return 1;
    }
    return 0;
};
const getLatestItem = (steps)=>{
    return [
        ...steps
    ].sort(stepComparitor)[0];
};
const getStatus = (steps, idx)=>{
    let status;
    if (idx === 0) {
        status = TimelineStatus$1.STARTED;
    } else {
        var _ref;
        const isCompleted = (_ref = steps === null || steps === void 0 ? void 0 : steps.every(isComplete)) !== null && _ref !== void 0 ? _ref : false;
        status = isCompleted ? TimelineStatus.COMPLETE : TimelineStatus.IN_PROGRESS;
    }
    return status;
};
const getTitle = (steps, idx, key)=>{
    let title = key.replace(PROCESS_REGEX, '');
    if (steps !== undefined) {
        const [first] = steps;
        if (first) {
            var _ref;
            var _first_activity_activityDefinition, _first_activity;
            title = (_ref = first === null || first === void 0 ? void 0 : (_first_activity = first.activity) === null || _first_activity === void 0 ? void 0 : (_first_activity_activityDefinition = _first_activity.activityDefinition) === null || _first_activity_activityDefinition === void 0 ? void 0 : _first_activity_activityDefinition.name) !== null && _ref !== void 0 ? _ref : '';
            if (idx !== 0) {
                title = title.replace(START_REGEX, '');
                title = upperFirst(title);
            }
        }
    }
    return title;
};
const stepsToStages = (steps)=>{
    if (!Array.isArray(steps)) {
        return [];
    }
    // build up an ordered list of processDefinitionKey
    const allKeys = steps.map((step)=>{
        var _step_activity_activityDefinition_processDefinitionKey;
        return (_step_activity_activityDefinition_processDefinitionKey = step.activity.activityDefinition.processDefinitionKey) !== null && _step_activity_activityDefinition_processDefinitionKey !== void 0 ? _step_activity_activityDefinition_processDefinitionKey : null;
    });
    const orderedKeys = [
        ...new Set(allKeys)
    ];
    // two major datastructures
    // 1. a list of steps grouped by processDefinitionKey
    // 2. a map of stages.  stages are structures that the UI will use for presentation
    const map = new Map();
    const timelineStages = new Map();
    orderedKeys.forEach((key)=>{
        // stub out list of steps
        map.set(key, []);
        // stub out timeline stages
        timelineStages.set(key, {
            key,
            steps: [],
            children: [],
            depth: 0,
            order: 0,
            displayDate: undefined,
            title: '',
            status: null,
            parent: null
        });
    });
    // 1st pass through steps, add them all to a list
    steps.forEach((step)=>{
        const key = step.activity.activityDefinition.processDefinitionKey;
        const lst = map.get(key);
        if (lst) {
            lst.push(step);
        }
    });
    // 2nd pass through steps, fill out the stage information
    steps.forEach((step, idx)=>{
        var _parent_steps;
        const { activityDefinition } = step.activity;
        const { processDefinitionKey, subprocessName } = activityDefinition;
        const parent = timelineStages.get(processDefinitionKey);
        if (activityDefinition.type === ENTER_SUB_PROCESS) {
            const child = timelineStages.get(`${subprocessName}`);
            if (child && parent) {
                var _ref, _isComplete;
                child.depth = ((_ref = parent === null || parent === void 0 ? void 0 : parent.depth) !== null && _ref !== void 0 ? _ref : 0) + 1;
                child.parent = parent;
                const isCompleted = (_isComplete = isComplete(step)) !== null && _isComplete !== void 0 ? _isComplete : false;
                child.status = isCompleted ? TimelineStatus.COMPLETE : TimelineStatus.IN_PROGRESS;
            }
        }
        // steps need only be assigned once.
        if (parent && !((_parent_steps = parent.steps) === null || _parent_steps === void 0 ? void 0 : _parent_steps.length)) {
            var _map_get;
            parent.steps = (_map_get = map.get(processDefinitionKey)) !== null && _map_get !== void 0 ? _map_get : [];
            if (parent.status === null) {
                parent.status = getStatus(parent.steps, idx);
            }
            const latestItem = getLatestItem(parent.steps);
            //@ts-ignore
            parent.displayDate = latestItem.activity.createdDate;
            parent.title = getTitle(parent.steps, idx, processDefinitionKey);
        }
    });
    // return stages in reverse order
    return orderedKeys.map((key)=>{
        return timelineStages.get(key);
    }).reverse();
};

var _bpmSteps = /*#__PURE__*/Object.freeze({
  __proto__: null,
  stepsToStages: stepsToStages
});

const FieldMap = {
    exam_type: 'exam_description',
    raw_reasonforvisit: 'reason_for_visit',
    reasonforvisit: 'reason_for_visit',
    raw_body: 'body'
};

function _define_property$s(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$r(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$s(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$l(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$l(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$l(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
// as more types become linkable, we can add them here.
const linkableEvidenceTypes$1 = new Set([
    FeatureSources.NOTE,
    FeatureSources.NOTE_CONVERTED,
    FeatureSources.REASON_FOR_VISIT,
    FeatureSources.PROCEDURE_TYPE,
    FeatureSources.EXAM_DESCRIPTION
]);
// ----------------------------------
// sort
// ----------------------------------
const sortValues = {
    CODED: 5,
    SUBMITTED: 10,
    PROCESSED: 20,
    ASSEMBLED: 30,
    MAPPED: 40,
    PREDICTION: 50,
    REFERRAL: 60,
    REMITTANCE: 70,
    CLINICAL: 100,
    CLAIM: 110
};
const MAX_VAL = 1000;
const comparator = (artifactA, artifactB)=>{
    const valA = sortValues[artifactA.type] || MAX_VAL;
    const valB = sortValues[artifactB.type] || MAX_VAL;
    if (valA < valB) {
        return -1;
    }
    if (valA > valB) {
        return 1;
    }
    // a must be equal to b
    return 0;
};
// ----------------------------------
// displayable
// ----------------------------------
const isDisplayable = (artifactSet, artifact)=>artifactSet.has(artifact.type);
const artifactsForDisplay = (artifactList, artifactSet)=>{
    const filtered = artifactList.filter((artifact)=>isDisplayable(artifactSet, artifact));
    const sorted = filtered.sort(comparator);
    return sorted;
};
const OWN_META$1 = {
    imported: false,
    ownerCaseId: null,
    description: 'These codes originated in your system'
};
const LINKED_META$1 = {
    imported: true,
    ownerCaseId: null,
    description: 'These codes come from a different case'
};
const filterAndAssembleArtifactList = ({ caseRun, artifactSet, importedCaseRun, importedSet })=>{
    var _caseRun_artifacts;
    let artifacts = artifactsForDisplay((_caseRun_artifacts = caseRun.artifacts) !== null && _caseRun_artifacts !== void 0 ? _caseRun_artifacts : [], artifactSet).flat();
    let own = artifacts.map((artifact)=>_object_spread_props$l(_object_spread$r({}, artifact), {
            meta: _object_spread$r({}, OWN_META$1)
        }));
    if (importedCaseRun && importedSet) {
        var _ref, _ref1, _ref2;
        var _importedCaseRun_primary_clinical_identifier, _importedCaseRun_primary_clinical_identifier1;
        const alternates = artifactsForDisplay((_ref = importedCaseRun === null || importedCaseRun === void 0 ? void 0 : importedCaseRun.artifacts) !== null && _ref !== void 0 ? _ref : [], importedSet).flat();
        const meta = _object_spread_props$l(_object_spread$r({}, LINKED_META$1), {
            ownerCaseId: importedCaseRun.case_id,
            description: `${importedCaseRun.exam_description} - Acc #: ${(_ref1 = (_importedCaseRun_primary_clinical_identifier = importedCaseRun.primary_clinical_identifier) === null || _importedCaseRun_primary_clinical_identifier === void 0 ? void 0 : _importedCaseRun_primary_clinical_identifier.number) !== null && _ref1 !== void 0 ? _ref1 : 'N/A'} (${(_ref2 = (_importedCaseRun_primary_clinical_identifier1 = importedCaseRun.primary_clinical_identifier) === null || _importedCaseRun_primary_clinical_identifier1 === void 0 ? void 0 : _importedCaseRun_primary_clinical_identifier1.issuer) !== null && _ref2 !== void 0 ? _ref2 : 'N/A'})`
        });
        const linked = alternates.map((artifact)=>_object_spread_props$l(_object_spread$r({}, artifact), {
                meta
            })).flat();
        return [
            ...own,
            ...linked
        ];
    }
    return [
        ...own
    ];
};
// ----------------------------------
// linkable
// ----------------------------------
const isLinkable = (evidenceKey)=>{
    return linkableEvidenceTypes$1.has(evidenceKey);
};
const sortInvoices = comparator;

function _define_property$r(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$q(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$r(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$k(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$k(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$k(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const psuedoCategoricalTypes = new Set([
    'exam_type',
    'raw_reasonforvisit'
]);
const isObject = (obj)=>{
    return obj === Object(obj);
};
const mappedProto = {
    linkable: false,
    displayable: true,
    selectionState: {
        active: false,
        hover: false,
        visible: false
    },
    featureType: 'mapping',
    identifier: null,
    fieldName: null,
    fieldIdentifier: null,
    meta: null
};
const evidenceProto = {
    linkable: true,
    displayable: true,
    selectionState: {
        active: false,
        hover: false,
        visible: false
    },
    featureType: 'complete',
    identifier: null,
    fieldName: 'raw_body',
    fieldIdentifier: null,
    meta: null
};
const isSentence = (span)=>span.level === SpanLevel.SENTENCE;
const expandSpans = (ret, origSpans)=>{
    // deal with spans
    let spans = origSpans === null || origSpans === void 0 ? void 0 : origSpans.filter(isSentence);
    spans = spans.map((span)=>{
        const fieldName = FieldMap[ret.fieldName] || ret.fieldName;
        const { start = '', end = '' } = span;
        // spans won't hash out the same way the fields, they require
        // additional hashing to make sure they're unique.  in this case,
        // there should only be one with a field id and start and end locations
        const hash = `${fieldName}__${ret.fieldIdentifier}__${start}-${end}`;
        return _object_spread_props$k(_object_spread$q({}, span), {
            hash,
            identifier: hash
        });
    });
    // each span will have a corresponding 1:1 mapping with a piece of
    // ChargeSessionEvidence
    return spans.map((span)=>{
        return _object_spread_props$k(_object_spread$q({}, ret), {
            meta: span
        });
    });
};
const filterEvidence$1 = (feature)=>{
    if (!feature) return false;
    if (feature.type === FeatureTypes.MAPPING) {
        return true;
    }
    if (isPrior(feature)) {
        return false;
    }
    if (isNgram(feature)) {
        var _ref;
        var _feature_spans;
        if (psuedoCategoricalTypes.has(feature.field)) {
            return true;
        }
        const spans = (_ref = (_feature_spans = feature.spans) === null || _feature_spans === void 0 ? void 0 : _feature_spans.filter(isSentence)) !== null && _ref !== void 0 ? _ref : [];
        if (spans.length === 0) {
            return false;
        }
    }
    return feature !== null;
};
const preprocessFeature = (feature)=>{
    if (!feature) return;
    if ('feature' in feature) {
        return feature.feature;
    } else if (feature.type === FeatureTypes.MAPPING) {
        return _object_spread$q({}, mappedProto);
    } else if ('field' in feature) {
        return feature;
    }
};
const destructureFeature = (feature)=>{
    return feature.feature;
};
const _processFeature = (identifier, feature)=>{
    let ret = _object_spread_props$k(_object_spread$q({}, evidenceProto), {
        identifier
    });
    try {
        if (isNgram(feature)) {
            const fieldName = FieldMap[feature.field] || feature.field;
            ret.fieldIdentifier = identifier;
            ret.linkable = isLinkable(fieldName);
            // check to see if we should treat it as categorical
            if (psuedoCategoricalTypes.has(feature.field)) {
                //console.error('psuedoe');
                ret.featureType = 'complete';
                ret.fieldName = fieldName;
            } else {
                ret.featureType = 'partial';
                ret.fieldName = fieldName;
                ret = expandSpans(ret, feature.spans);
                ret.forEach((spanFeature)=>{
                    spanFeature.fieldName = fieldName;
                });
            }
        } else if (isCategorical(feature)) {
            ret.featureType = 'complete';
            const fieldName = FieldMap[feature.field] || feature.field;
            ret.fieldName = fieldName;
            ret.linkable = isLinkable(fieldName);
            ret.meta = {
                content: feature.category
            };
        } else {
        //console.error('unknown type');
        }
    } catch (e) {
        console.error('exception process feature', feature);
    }
    return ret;
};
const hashFeature = (evidence)=>{
    const fieldName = FieldMap[evidence.fieldName] || evidence.fieldName;
    if (evidence.featureType === EvidenceType.COMPLETE) {
        return `${fieldName}-${evidence.fieldIdentifier}`;
    } else if (evidence.featureType === EvidenceType.PARTIAL) {
        var _evidence_meta;
        const { start = '', end = '' } = (_evidence_meta = evidence.meta) !== null && _evidence_meta !== void 0 ? _evidence_meta : {};
        return `${fieldName}__${evidence.fieldIdentifier}__${start}-${end}`;
    }
};
const dedupe = (evidence)=>{
    const seen = new Set();
    const filtered = [];
    evidence.forEach((piece)=>{
        const hash = hashFeature(piece);
        if (!seen.has(hash)) {
            piece.hash = hash;
            filtered.push(piece);
        }
        seen.add(hash);
    });
    return filtered;
};
const convertDX = (medicalCode, identifier = '', uniqify = true)=>{
    var _ref;
    var _medicalCode_evidence;
    const features = (_ref = (_medicalCode_evidence = medicalCode.evidence) === null || _medicalCode_evidence === void 0 ? void 0 : _medicalCode_evidence.map(destructureFeature)) !== null && _ref !== void 0 ? _ref : [];
    const evidence = features === null || features === void 0 ? void 0 : features.filter(filterEvidence$1);
    const processedFeatures = evidence.map(_processFeature.bind(null, identifier)).flat();
    const identifiedFeatures = processedFeatures.map((feature)=>{
        // identifiers may be dependent on icd codes which contain decimals
        // guarding against colons as well.
        feature.fieldIdentifier = `${identifier}`;
        return feature;
    });
    return uniqify ? dedupe(identifiedFeatures) : identifiedFeatures;
};
const convertCPT = (medicalCode, identifier = '', uniqify = true)=>{
    var _rawEvidence_map;
    const rawEvidence = Array.isArray(medicalCode.evidence) ? [
        ...medicalCode.evidence
    ] : isObject(medicalCode.evidence) ? [
        _object_spread$q({}, medicalCode.evidence)
    ] : [];
    const preprocessed = (_rawEvidence_map = rawEvidence.map(preprocessFeature)) !== null && _rawEvidence_map !== void 0 ? _rawEvidence_map : [];
    const evidence = preprocessed.filter(filterEvidence$1);
    const processedFeatures = evidence.map(_processFeature.bind(null, identifier)).flat();
    const identifiedFeatures = processedFeatures.map((feature)=>{
        // this shouldn't have decimals, but this is a conservative approach
        feature.fieldIdentifier = `${identifier}`;
        return feature;
    });
    return uniqify ? dedupe(identifiedFeatures) : identifiedFeatures;
};

const emptyInvoice = {
    billing_area: '',
    billing_location: '',
    billing_provider_name: '',
    billing_provider_number: {
        issuer: '',
        number: '',
        type: ''
    },
    date_of_service: '',
    datetime_of_service: '',
    deleted: false,
    department_code: '',
    department: {
        code: '',
        name: ''
    },
    division: '',
    errorMessages: [],
    facility: '',
    filler_number: {
        issuer: '',
        number: '',
        type: ''
    },
    guid: '',
    health_plan_id: '',
    ordering_provider_name: '',
    ordering_provider_number: {
        issuer: '',
        number: '',
        type: ''
    },
    patient_type: '',
    performing_provider_name: '',
    performing_provider_number: {
        issuer: '',
        number: '',
        type: ''
    },
    referring_provider_name: '',
    referring_provider_number: {
        issuer: '',
        number: '',
        type: ''
    },
    transactions: [],
    type: '',
    billing_provider_type: null,
    ordering_provider_type: null,
    referring_provider_type: null,
    performing_provider_type: null
};

const emptyCodableTransaction = {
    guid: '',
    sequence_number: 1,
    source_transaction_id: '',
    deleted: false,
    errorMessages: [],
    technical_code: null,
    procedure: null,
    mapped_procedure: null,
    modifiers: [],
    diagnoses: [],
    fee_schedule: '',
    place_of_service: '',
    codes: [],
    fieldDefinitions: []
};

/**
 * Extracts a description from a code description object, trying multiple possible fields
 * and falling back to 'N/A' if none are found
 * @param codeDescription The code description object from the code descriptions dictionary
 * @returns The extracted description or 'N/A' if none found
 */ const extractCodeDescriptionForCode = (codeDescription)=>{
    if (!codeDescription) {
        return 'N/A';
    }
    return codeDescription.descriptor || codeDescription.description || codeDescription.shortDescription || 'N/A';
};
const extractShortDescriptionForCode = (codeDescription)=>{
    if (!codeDescription) {
        return 'N/A';
    }
    return codeDescription.shortDescription || 'N/A';
};

function _define_property$q(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$p(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$q(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$j(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$j(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$j(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
// --------------- helper functions --------------- //
const _getSharedCodes = ()=>{
    // returns a new object for populating shared codes.
    return {
        diagnoses: [],
        modifiers: []
    };
};
const _getValueOrNull = (prop)=>{
    if (prop === 'null') {
        return null;
    } else if (prop === undefined) {
        return null;
    } else {
        return prop;
    }
};
const _getTechCode = (technical_code)=>{
    return 'code' in technical_code ? technical_code.code : technical_code.technical_code;
};
const _convertTechCode = (txn, editable, codeIssues = [])=>{
    var _technical_code_code_provenances;
    const { technical_code } = txn;
    const codeName = _getTechCode(technical_code);
    return {
        codeType: ChargeSessionCodeType$1.PROCEDURE,
        codeIssues,
        provenance: ChargeSessionCodeProvenance$1.TECH,
        code: codeName,
        units: technical_code.units,
        hash: `${txn.guid}:${codeName}`.replace(/(\.|\:)/gi, '__'),
        unitable: true,
        editable: editable,
        evidence: [],
        description: '',
        codeProvenance: (_technical_code_code_provenances = technical_code.code_provenances) !== null && _technical_code_code_provenances !== void 0 ? _technical_code_code_provenances : []
    };
};
const _convertModifier = (txn, modifier, codeIssues = [])=>{
    return {
        codeType: ChargeSessionCodeType$1.MODIFIER,
        provenance: ChargeSessionCodeProvenance$1.MODIFIER,
        code: modifier.modifier_code,
        hash: `${txn.guid}:${modifier.modifier_code}`,
        units: 0,
        unitable: false,
        editable: true,
        codeIssues,
        evidence: [],
        description: '',
        codeProvenance: modifier.code_provenances
    };
};
const _convertDX = (txn, dx, codeIssues = [])=>{
    var _dx_shared;
    const id = `${txn.guid}:${dx.diagnosis_code}`.replace(/(\.|\:)/gi, '__');
    return {
        //@ts-ignore
        active: !!dx.active,
        codeType: ChargeSessionCodeType$1.DIAGNOSIS,
        provenance: ChargeSessionCodeProvenance$1.ICD,
        code: dx.diagnosis_code,
        units: 0,
        unitable: false,
        editable: true,
        codeIssues,
        hash: id,
        evidence: convertDX(dx, id, true),
        //@ts-ignore
        shared: (_dx_shared = dx.shared) !== null && _dx_shared !== void 0 ? _dx_shared : false,
        description: '',
        codeProvenance: dx.code_provenances
    };
};
const _convertProcedure = (txn, editable = true, codeIssues = [])=>{
    var _procedure_code_provenances;
    const { procedure } = txn;
    const hash = `${txn.guid}:${procedure.procedure_code}`.replace(/(\.|\:)/gi, '__');
    procedure.procedure_code;
    return {
        codeType: ChargeSessionCodeType$1.PROCEDURE,
        provenance: ChargeSessionCodeProvenance$1.CPT,
        code: procedure.procedure_code,
        units: procedure.units,
        unitable: true,
        editable: editable,
        hash,
        codeIssues,
        evidence: convertCPT(procedure, hash, true),
        description: 'procedure_name' in procedure ? procedure.procedure_name : '',
        codeProvenance: (_procedure_code_provenances = procedure.code_provenances) !== null && _procedure_code_provenances !== void 0 ? _procedure_code_provenances : []
    };
};
const getIssues = (code, codeEdits)=>{
    if (codeEdits[code]) {
        return codeEdits[code];
    }
    return [];
};
const _convertCodes = (txn, shared_codes, codeEdits = {})=>{
    var _ref, _getValidModifiers, _getValidModifiers1, _txn_modifiers;
    var _txn_diagnoses, _txn_procedure, _txn_technical_code;
    const codes = [];
    const hasDX = (_ref = (_txn_diagnoses = txn.diagnoses) === null || _txn_diagnoses === void 0 ? void 0 : _txn_diagnoses.length) !== null && _ref !== void 0 ? _ref : false;
    // procedures and technical codes are 1:1 with a transaction
    if (txn.procedure) {
        var _ref1, _ref2;
        var _txn_procedure1, _txn_procedure2;
        const editable = ((_ref1 = (_txn_procedure1 = txn.procedure) === null || _txn_procedure1 === void 0 ? void 0 : _txn_procedure1.units) !== null && _ref1 !== void 0 ? _ref1 : 0) >= 0;
        const code = (_ref2 = (_txn_procedure2 = txn.procedure) === null || _txn_procedure2 === void 0 ? void 0 : _txn_procedure2.procedure_code) !== null && _ref2 !== void 0 ? _ref2 : '';
        const edits = getIssues(`${code}`, codeEdits);
        codes.push(_convertProcedure(txn, editable, edits));
    }
    if (txn.technical_code) {
        const { technical_code } = txn;
        const code = 'code' in technical_code ? technical_code.code : technical_code.technical_code;
        const edits = getIssues(`${code}`, codeEdits);
        codes.push(_convertTechCode(txn, true, edits));
    }
    // txn.modifiers is deprecated.
    const getValidModifiers = (modifiers)=>Array.isArray(modifiers) && modifiers.length > 0 ? modifiers : null;
    const procedureModifiers = (_getValidModifiers = getValidModifiers((_txn_procedure = txn.procedure) === null || _txn_procedure === void 0 ? void 0 : _txn_procedure.modifier_codes)) !== null && _getValidModifiers !== void 0 ? _getValidModifiers : [];
    const technicalModifiers = (_getValidModifiers1 = getValidModifiers((_txn_technical_code = txn.technical_code) === null || _txn_technical_code === void 0 ? void 0 : _txn_technical_code.modifier_codes)) !== null && _getValidModifiers1 !== void 0 ? _getValidModifiers1 : [];
    const allModifiers = procedureModifiers.length > 0 || technicalModifiers.length > 0 ? [
        ...procedureModifiers,
        ...technicalModifiers
    ] : (_txn_modifiers = txn.modifiers) !== null && _txn_modifiers !== void 0 ? _txn_modifiers : [];
    const uniqueModifiers = Array.from(new Set(allModifiers.map((mod)=>mod.modifier_code))).map((modifier_code)=>allModifiers.find((mod)=>mod.modifier_code === modifier_code));
    const modifierCodes = uniqueModifiers;
    if (modifierCodes) {
        _convertModifiers(modifierCodes, shared_codes, txn, codes, codeEdits);
    }
    if (hasDX) {
        const exemptDX = new Set([
            ...shared_codes.diagnoses
        ].map((code)=>code.diagnosis_code));
        txn.diagnoses.forEach((dx)=>{
            var _dx_diagnosis_code;
            const code = (_dx_diagnosis_code = dx.diagnosis_code) !== null && _dx_diagnosis_code !== void 0 ? _dx_diagnosis_code : '';
            if (!exemptDX.has(code)) {
                const edits = getIssues(`${code}`, codeEdits);
                codes.push(_convertDX(txn, dx, edits));
            }
        });
    }
    return codes;
};
const _convertModifiers = (modifierCodes, shared_codes, txn, codes, codeEdits)=>{
    if (modifierCodes === null || modifierCodes === void 0 ? void 0 : modifierCodes.length) {
        const exemptMods = new Set([
            ...shared_codes.modifiers
        ].map((code)=>code.modifier_code));
        modifierCodes.forEach((mod)=>{
            var _mod_modifier_code;
            const modCode = (_mod_modifier_code = mod.modifier_code) !== null && _mod_modifier_code !== void 0 ? _mod_modifier_code : '';
            if (!exemptMods.has(modCode)) {
                const modEdits = getIssues(`${modCode}`, codeEdits);
                codes.push(_convertModifier(txn, mod, modEdits));
            }
        });
    }
};
const _determineChargeSessionType = (txn)=>{
    if (txn.procedure && txn.technical_code) {
        return ChargeSessionType.PRO_TECH;
    } else if (txn.procedure) {
        return ChargeSessionType.PROFESSIONAL;
    } else if (txn.technical_code) {
        return ChargeSessionType.TECHNICAL;
    } else {
        // this will need to be changed once we have to support
        // empty charge sessions.  at that point we will be unable
        // to determine the charge session type just from the presence or
        // absence of a charge.  for now, just to default to professional
        // our most common charge type
        return ChargeSessionType.PROFESSIONAL;
    }
};
const _assembleProviders = (invoice)=>{
    // for the moment, this is just the billing provider,
    // we might need to add more here.
    const billingProvider = {
        provider: {
            name: invoice.billing_provider_name,
            number: invoice.billing_provider_number,
            specialty: `not available` // this was never used afaict
        },
        providerRole: ChargeSessionProviderRole.BILLING
    };
    return [
        billingProvider
    ];
};
const _assembleBillingInformation = (invoice)=>{
    return {
        billingArea: invoice.billing_area,
        billingLocation: invoice.billing_location
    };
};
const _buildChargeFromInvoiceAndTransaction = (invoice, txn, codeEdits, shared_codes)=>{
    const chargeSession = {
        // field definitions will be filled out in the
        // applications, not ui-common.  it's just easier
        // not to have partials.
        fieldDefinitions: [],
        chargeType: _determineChargeSessionType(txn),
        providers: _assembleProviders(invoice),
        billingInformation: _assembleBillingInformation(invoice),
        codes: _convertCodes(txn, shared_codes, codeEdits),
        transactionType: 'type' in txn ? txn.type : 'ASSEMBLED',
        transactionId: txn.guid,
        invoiceId: invoice.guid,
        processInstanceId: '' // process instance will be attached later.
    };
    return chargeSession;
};
const _assemebledFilter = (invoice, issueMap)=>{
    if (invoice.type === 'ASSEMBLED' && issueMap.ASSEMBLED) {
        return issueMap.ASSEMBLED;
    }
    return {};
};
// Helper function to process modifiers
const _processModifiers = (modifiers, invoices, getModifiers, sharedCodes)=>{
    modifiers.forEach((modifier)=>{
        const inEvery = invoices.every((invoice)=>{
            var _invoice_transactions;
            return ((_invoice_transactions = invoice.transactions) !== null && _invoice_transactions !== void 0 ? _invoice_transactions : []).every((txn)=>{
                var _getModifiers;
                return ((_getModifiers = getModifiers(txn)) !== null && _getModifiers !== void 0 ? _getModifiers : []).find((targetMod)=>targetMod.modifier_code === modifier.modifier_code);
            });
        });
        if (inEvery) {
            sharedCodes.modifiers.push(modifier);
        }
    });
};
const _determineSharedCodes = (invoices)=>{
    const invoiceTypes = groupBy(invoices, 'type');
    const sharedCodeMap = {};
    Object.keys(invoiceTypes).forEach((key)=>{
        const invoices = invoiceTypes[key];
        const sharedCodes = {
            diagnoses: [],
            modifiers: []
        };
        sharedCodeMap[key] = sharedCodes;
        const totalLen = invoices.map((invoice)=>{
            var _ref;
            var _invoice_transactions;
            return (_ref = (_invoice_transactions = invoice.transactions) === null || _invoice_transactions === void 0 ? void 0 : _invoice_transactions.length) !== null && _ref !== void 0 ? _ref : 0;
        }).reduce((partialSum, a)=>partialSum + a, 0);
        if (totalLen > 1) {
            var _firstTxn_diagnoses, _firstTxn_procedure_modifier_codes, _firstTxn_procedure, _firstTxn_technical_code_modifier_codes, _firstTxn_technical_code, _firstTxn_modifiers;
            const [firstInvoice] = invoices;
            const [firstTxn] = firstInvoice.transactions;
            if (firstTxn === null || firstTxn === void 0 ? void 0 : (_firstTxn_diagnoses = firstTxn.diagnoses) === null || _firstTxn_diagnoses === void 0 ? void 0 : _firstTxn_diagnoses.length) {
                firstTxn.diagnoses.forEach((dx)=>{
                    const inEvery = invoices.every((invoice)=>{
                        var _invoice_transactions;
                        //@ts-ignore
                        return ((_invoice_transactions = invoice.transactions) !== null && _invoice_transactions !== void 0 ? _invoice_transactions : []).every((txn)=>{
                            return txn.diagnoses.find((diag)=>diag.diagnosis_code === dx.diagnosis_code);
                        });
                    });
                    if (inEvery) {
                        sharedCodes.diagnoses.push(dx);
                    }
                });
            }
            if ((_firstTxn_procedure = firstTxn.procedure) === null || _firstTxn_procedure === void 0 ? void 0 : (_firstTxn_procedure_modifier_codes = _firstTxn_procedure.modifier_codes) === null || _firstTxn_procedure_modifier_codes === void 0 ? void 0 : _firstTxn_procedure_modifier_codes.length) {
                _processModifiers(firstTxn.procedure.modifier_codes, invoices, (txn)=>{
                    var _txn_procedure;
                    return (_txn_procedure = txn.procedure) === null || _txn_procedure === void 0 ? void 0 : _txn_procedure.modifier_codes;
                }, sharedCodes);
            }
            if ((_firstTxn_technical_code = firstTxn.technical_code) === null || _firstTxn_technical_code === void 0 ? void 0 : (_firstTxn_technical_code_modifier_codes = _firstTxn_technical_code.modifier_codes) === null || _firstTxn_technical_code_modifier_codes === void 0 ? void 0 : _firstTxn_technical_code_modifier_codes.length) {
                _processModifiers(firstTxn.technical_code.modifier_codes, invoices, (txn)=>{
                    var _txn_technical_code;
                    return (_txn_technical_code = txn.technical_code) === null || _txn_technical_code === void 0 ? void 0 : _txn_technical_code.modifier_codes;
                }, sharedCodes);
            }
            // Support txn.modifiers for backwards compatibility
            if ((_firstTxn_modifiers = firstTxn.modifiers) === null || _firstTxn_modifiers === void 0 ? void 0 : _firstTxn_modifiers.length) {
                _processModifiers(firstTxn.modifiers, invoices, (txn)=>txn.modifiers, sharedCodes);
            }
        }
    });
    return sharedCodeMap;
};
// --------------- api --------------- //
const convertInvoicesToCharges = (processInstance, codeEdits = {}, findSharedCodes = false)=>{
    var _processInstance_invoices;
    if (!Array.isArray(processInstance.invoices)) {
        throw new Error(`no invoices array `);
    }
    const chargeSessions = [];
    processInstance === null || processInstance === void 0 ? void 0 : (_processInstance_invoices = processInstance.invoices) === null || _processInstance_invoices === void 0 ? void 0 : _processInstance_invoices.forEach((invoice)=>{
        var _invoice_transactions;
        const sharedCodes = _getSharedCodes();
        invoice === null || invoice === void 0 ? void 0 : (_invoice_transactions = invoice.transactions) === null || _invoice_transactions === void 0 ? void 0 : _invoice_transactions.forEach((txn)=>{
            const chargeSession = _buildChargeFromInvoiceAndTransaction(invoice, txn, codeEdits, sharedCodes);
            chargeSession.processInstanceId = processInstance.guid.uuid;
            chargeSessions.push(chargeSession);
        });
    });
    return chargeSessions;
};
const convertInvoicesToCodable = (processInstance, codeEdits = {}, findSharedCodes = false)=>{
    if (!Array.isArray(processInstance.invoices)) {
        throw new Error(`no invoices array `);
    }
    const invoices = cloneDeep(processInstance.invoices);
    const codableInvoices = invoices.map((invoice)=>{
        var _invoice_errorMessages;
        var _invoice_transactions, _invoice_transactions1;
        const transactions = (invoice === null || invoice === void 0 ? void 0 : (_invoice_transactions = invoice.transactions) === null || _invoice_transactions === void 0 ? void 0 : _invoice_transactions.length) > 0 ? invoice === null || invoice === void 0 ? void 0 : (_invoice_transactions1 = invoice.transactions) === null || _invoice_transactions1 === void 0 ? void 0 : _invoice_transactions1.map((txn)=>{
            var _txn_errorMessages;
            const { codes } = _buildChargeFromInvoiceAndTransaction(invoice, txn, codeEdits, _getSharedCodes());
            return _object_spread_props$j(_object_spread$p({}, txn), {
                codes,
                // this is necessary to get around a typescript issue.
                errorMessages: (_txn_errorMessages = txn.errorMessages) !== null && _txn_errorMessages !== void 0 ? _txn_errorMessages : [],
                fieldDefinitions: []
            });
        }) : [];
        return _object_spread_props$j(_object_spread$p({}, invoice), {
            // this is necessary to get around a typescript issue.
            errorMessages: (_invoice_errorMessages = invoice.errorMessages) !== null && _invoice_errorMessages !== void 0 ? _invoice_errorMessages : [],
            transactions
        });
    });
    const codable = CodableStatus.has(processInstance.status) || processInstance.status === AccelerateProcessStatus$1.SUBMITTED && processInstance.qaStatus === ProcessQAStatus$1.IN_QA;
    const { sharedDiagnosisCodes = [] } = processInstance;
    if (sharedDiagnosisCodes.length || codable) {
        const diagnosis = sharedDiagnosisCodes.map((dx, idx)=>{
            var _dx_diagnosis_code;
            const code = (_dx_diagnosis_code = dx.diagnosis_code) !== null && _dx_diagnosis_code !== void 0 ? _dx_diagnosis_code : '';
            const codeIssues = getIssues(`${code}`, codeEdits);
            const id = `SHARED_CODES:${dx.diagnosis_code}`.replace(/(\.|\:)/gi, '__');
            return {
                codeType: ChargeSessionCodeType$1.DIAGNOSIS,
                provenance: ChargeSessionCodeProvenance$1.ICD,
                code: dx.diagnosis_code,
                diagnosis_code: dx.diagnosis_code,
                sequence_number: dx.sequence_number,
                active: true,
                additionalProperties: {},
                shared: true,
                units: 0,
                unitable: false,
                editable: true,
                codeIssues,
                hash: id,
                evidence: convertDX(dx, id, true),
                description: '',
                codeProvenance: dx.code_provenances
            };
        });
        codableInvoices.unshift(_object_spread_props$j(_object_spread$p({}, emptyInvoice), {
            type: InvoiceTypes$1.SHARED_CODES,
            transactions: [
                _object_spread_props$j(_object_spread$p({}, emptyCodableTransaction), {
                    codes: diagnosis
                })
            ]
        }));
    }
    return codableInvoices;
};
const addDescriptionsToCodableInvoices = (codableInvoices, codeDescriptions)=>{
    return [
        ...codableInvoices
    ].map((codableInvoice)=>{
        codableInvoice.transactions.forEach((txn)=>{
            txn.codes.forEach((code)=>{
                const description = codeDescriptions[code.code];
                code.description = extractCodeDescriptionForCode(description);
            });
        });
        return codableInvoice;
    });
};
const addCategoricalDataToCodableInvoices = (codableInvoices, caseRun)=>{
    return [
        ...codableInvoices
    ].map((codableInvoice)=>{
        codableInvoice.transactions = codableInvoice.transactions.map((txn)=>{
            txn.codes = txn.codes.map((code)=>{
                const c = _object_spread$p({}, code);
                c.evidence = c.evidence.map((orig)=>{
                    const e = _object_spread$p({}, orig);
                    if (e.featureType === EvidenceType.COMPLETE) {
                        e.meta = e.meta ? _object_spread$p({}, e.meta) : {};
                        if (!e.meta.content) {
                            var _caseRun_e_fieldName;
                            e.meta.content = (_caseRun_e_fieldName = caseRun[e.fieldName]) !== null && _caseRun_e_fieldName !== void 0 ? _caseRun_e_fieldName : 'UNKNOWN';
                        }
                    }
                    return e;
                });
                return c;
            });
            return txn;
        });
        return codableInvoice;
    });
};
const simplifiedInvoices = (caseRun, findSharedCodes = false, issueMap = {}, issueFilter = _assemebledFilter)=>{
    if (!Array.isArray(caseRun.invoices)) {
        return [];
    } else {
        const sharedCodeMap = findSharedCodes ? _determineSharedCodes(caseRun.invoices) : {};
        const simplifiedInvoices = caseRun.invoices.map((invoice)=>{
            var _invoice_transactions;
            const shared_codes = sharedCodeMap[invoice.type] || _getSharedCodes();
            const codeEdits = issueFilter(invoice, issueMap);
            const transactions = ((_invoice_transactions = invoice.transactions) !== null && _invoice_transactions !== void 0 ? _invoice_transactions : []).map((txn)=>{
                var _txn_alt_transaction_description;
                return {
                    guid: txn.guid,
                    type: _determineChargeSessionType(txn),
                    department_code: txn.department_code,
                    date_of_service: txn.date_of_service,
                    codes: _convertCodes(txn, shared_codes, codeEdits),
                    description: (_txn_alt_transaction_description = txn.alt_transaction_description) !== null && _txn_alt_transaction_description !== void 0 ? _txn_alt_transaction_description : null
                };
            });
            if (shared_codes.diagnoses.length || shared_codes.modifiers.length) {
                const stubbedTxn = _object_spread$p({}, shared_codes);
                transactions.push({
                    guid: 'not applicable',
                    type: 'SHARED_CODES',
                    department_code: 'department_code',
                    codes: _convertCodes(stubbedTxn, _getSharedCodes(), codeEdits),
                    description: 'shared codes'
                });
            }
            const { guid, billing_provider_number, ordering_provider_number, performing_provider_number, referring_provider_number } = invoice;
            return {
                processInstanceGuid: caseRun.process_instance_guid,
                type: invoice.type,
                // Plucked as-is from original invoice
                guid,
                billing_provider_number,
                ordering_provider_number,
                performing_provider_number,
                referring_provider_number,
                transactions,
                // The following are not always present in Automate
                // or if they are present, they are sometimes present
                // as the string 'null'.
                billing_area: _getValueOrNull(invoice.billing_area),
                billing_provider_name: _getValueOrNull(invoice.billing_provider_name),
                ordering_provider_name: _getValueOrNull(invoice.ordering_provider_name),
                performing_provider_name: _getValueOrNull(invoice.performing_provider_name),
                referring_provider_name: _getValueOrNull(invoice.referring_provider_name),
                // Automate only for the time being.
                shared_codes: shared_codes,
                // Amplify only
                billing_location: null,
                patient_type: null,
                billing_provider_type: _getValueOrNull(invoice === null || invoice === void 0 ? void 0 : invoice.billing_provider_type),
                ordering_provider_type: _getValueOrNull(invoice === null || invoice === void 0 ? void 0 : invoice.ordering_provider_type),
                referring_provider_type: _getValueOrNull(invoice === null || invoice === void 0 ? void 0 : invoice.referring_provider_type),
                performing_provider_type: _getValueOrNull(invoice === null || invoice === void 0 ? void 0 : invoice.performing_provider_type)
            };
        });
        return simplifiedInvoices;
    }
};

var _chargeConverters = /*#__PURE__*/Object.freeze({
  __proto__: null,
  addCategoricalDataToCodableInvoices: addCategoricalDataToCodableInvoices,
  addDescriptionsToCodableInvoices: addDescriptionsToCodableInvoices,
  convertInvoicesToCharges: convertInvoicesToCharges,
  convertInvoicesToCodable: convertInvoicesToCodable,
  simplifiedInvoices: simplifiedInvoices
});

/**
 * Method that set errors on a processInstance after the case was submitted
 * @param errorList
 * @param processInstance
 */ const setErrors = (errorList, processInstance)=>{
    // synthetically create issues for vitalware
    processInstance.errorMessages = [];
    const groupedErrorlist = groupBy(errorList, 'field');
    Object.keys(groupedErrorlist).forEach((errorField)=>{
        var _groupedErrorlist_errorField_;
        var _fieldObject_field;
        // change the last element for errorMessages key
        const fieldObject = (_groupedErrorlist_errorField_ = groupedErrorlist[errorField][0]) !== null && _groupedErrorlist_errorField_ !== void 0 ? _groupedErrorlist_errorField_ : {
            field: ''
        };
        let pathChange = fieldObject === null || fieldObject === void 0 ? void 0 : (_fieldObject_field = fieldObject.field) === null || _fieldObject_field === void 0 ? void 0 : _fieldObject_field.split('.');
        if ((pathChange === null || pathChange === void 0 ? void 0 : pathChange.length) >= 1) {
            pathChange[(pathChange === null || pathChange === void 0 ? void 0 : pathChange.length) - 1] = 'errorMessages';
            const existingErrorMessages = get$1(processInstance, pathChange.join('.'), []);
            const combinedErrorMessages = [
                ...existingErrorMessages,
                ...groupedErrorlist[errorField]
            ];
            //Need to pick the selected props from error object due version inclusion and extra info addition to error dto
            const partialCombinedErrorMessages = combinedErrorMessages.map((error)=>pick(error, [
                    'field',
                    'message_key',
                    'message',
                    'source'
                ]));
            // set the list of error to the required level when path exists
            //if global errors set errors else set errors when path exists
            if (has(processInstance, pathChange.slice(0, -1).join('.')) || pathChange.slice(0, -1).length === 0) {
                set$2(processInstance, pathChange.join('.'), uniqWith(partialCombinedErrorMessages, isEqual));
            }
        }
    });
    return processInstance;
};

var _chargeErrors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  setErrors: setErrors
});

function _define_property$p(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$o(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$p(target, key, source[key]);
        });
    }
    return target;
}
const summarize = (chargeSessions)=>{
    // filter only for TECH provenances procedures
    let allCodes = chargeSessions.map((session)=>session.codes).flat().filter((code)=>!(code.provenance === 'TECH' && code.codeType === 'procedure'));
    // create auxilary unique diagnosis array
    let uniqueDiagnosis = [];
    allCodes = allCodes.filter((code)=>{
        // just check for diagnosis
        if (code.codeType === 'diagnosis') {
            // if the diagnosis wasn't added, push to the array.
            if (!uniqueDiagnosis.includes(code.code)) {
                uniqueDiagnosis.push(code.code);
                return true;
            } else {
                return false;
            }
        } else {
            // push for other cases
            uniqueDiagnosis.push(code.code);
            return true;
        }
    });
    // sum all codes by code type
    const counts = allCodes.reduce((last, code)=>{
        const current = _object_spread$o({}, last);
        if (code.codeType === ChargeSessionCodeType$1.DIAGNOSIS) {
            current.diagnosis++;
        } else if (code.codeType === ChargeSessionCodeType$1.MODIFIER) {
            current.modifiers++;
        } else if (code.codeType === ChargeSessionCodeType$1.PROCEDURE) {
            if (code.units !== 0) {
                current.procedures += code.units;
            }
        }
        return current;
    }, {
        diagnosis: 0,
        procedures: 0,
        modifiers: 0
    });
    return counts;
};

var _chargeSummarizer = /*#__PURE__*/Object.freeze({
  __proto__: null,
  summarize: summarize
});

function _define_property$o(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$n(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$o(target, key, source[key]);
        });
    }
    return target;
}
// There are two implementations of drag managers
// 1. a sessionStorage backed storage manager
// 2. one backed only in memory.  this is only used for testing.
const _parse = (data)=>{
    try {
        return JSON.parse(data);
    } catch (e) {
        return {};
    }
};
const load = (namespace)=>{
    return {
        clear: ()=>{
            sessionStorage.removeItem(namespace);
        },
        parseEvent: (ev)=>{
            const data = ev.dataTransfer.getData('text');
            return _parse(data);
        },
        get: (key)=>{
            const data = _parse(sessionStorage.getItem(namespace));
            return key ? data[key] : data;
        },
        set: (data, key)=>{
            if (!key) {
                sessionStorage.setItem(namespace, JSON.stringify(_object_spread$n({}, data)));
            } else {
                // implement keys
                const retrieved = _parse(sessionStorage.getItem(namespace)) || {};
                retrieved[key] = retrieved[key] || {};
                retrieved[key] = data;
                sessionStorage.setItem(namespace, JSON.stringify(_object_spread$n({}, retrieved)));
            }
        }
    };
};
// dragOver events do NOT give access to the getData from the
// dataTransfer object.  Instead, we keep a simple object that
// points to the data in the event being dragged.
// The reason that this is an object is so that we can call
// delete on it's property on drag end.
const DRAG_DATA = {};
const getDraggedObject = ()=>{
    const keys = Object.keys(DRAG_DATA);
    if (keys.length === 0) return {};
    return DRAG_DATA[keys[0]];
};
// just used for testing presently.
const loadMemory = (namespace)=>{
    DRAG_DATA[namespace] = DRAG_DATA[namespace] || {};
    return {
        clear: ()=>{
            delete DRAG_DATA[namespace];
        },
        parseEvent: (ev)=>{
            const data = ev.dataTransfer.getData('text');
            return _parse(data);
        },
        get: (optKey)=>{
            const data = getDraggedObject();
            return optKey ? data[optKey] : data;
        },
        set: (data, optKey)=>{
            if (!optKey) {
                DRAG_DATA[namespace] = data;
            } else {
                DRAG_DATA[namespace][optKey] = DRAG_DATA[namespace][optKey] || {};
                DRAG_DATA[namespace][optKey] = data;
            }
        }
    };
};

var _dragManager = /*#__PURE__*/Object.freeze({
  __proto__: null,
  load: load,
  loadMemory: loadMemory
});

const automatableTypes = new Set([
    CaseArtifactTypes$1.PREDICTION,
    CaseArtifactTypes$1.PROCESSED,
    CaseArtifactTypes$1.SUBMITTED
]);

const codeEditFilter = (codeEdits)=>{
    return {
        filterIssues: (match = {})=>{
            const values = Object.values(codeEdits);
            const issues = [
                ...values
            ].flat();
            return issues.filter(matches(match));
        },
        getIssuesForCode: (code, match = {})=>{
            const keySet = new Set(Object.keys(codeEdits));
            const issues = keySet.has(code) ? codeEdits[code] : [];
            if (!(issues === null || issues === void 0 ? void 0 : issues.length)) {
                return issues;
            } else {
                const matcherFn = (obj)=>{
                    return Object.entries(match).every(([key, value])=>{
                        if (Array.isArray(value)) {
                            // allow partial matches on arrays
                            // [a, b] will match [a, b, c], but not vice-versa
                            let arrays = [
                                value,
                                obj[key]
                            ];
                            return arrays.reduce((a, b)=>a.filter((c)=>!b.includes(c))).length === 0;
                        }
                        return value === obj[key];
                    });
                };
                const matched = issues.filter(matcherFn);
                return matched;
            }
        }
    };
};

// as more types become linkable, we can add them here.
const linkableEvidenceTypes = new Set([
    FeatureSources.NOTE,
    FeatureSources.REASON_FOR_VISIT,
    FeatureSources.PROCEDURE_TYPE
]);
// ---------------- feature types  --------------------- //
const isSubhighlight = (feature)=>{
    return isNgram(feature) && `spans` in feature;
};
const isBlockHighlight = (feature)=>{
    if (isCategorical(feature)) {
        return true;
    }
    return isNgram(feature) && !(`spans` in feature);
};
const getDescription = (feature)=>{
    if (isNgram(feature)) {
        var _feature_spans, _ref;
        const found = ((_feature_spans = feature.spans) !== null && _feature_spans !== void 0 ? _feature_spans : []).find(hasSentence);
        return (_ref = found === null || found === void 0 ? void 0 : found.content) !== null && _ref !== void 0 ? _ref : feature.ngram;
    }
    if (isCategorical(feature)) {
        return feature.category;
    }
    return 'Unknown';
};
const hasSentence = (span)=>span.level === 'sentence';
// ---------------- selection --------------------- //
const isSingleSelection = (selection)=>{
    return `evidence` in selection && !Array.isArray(selection.evidence);
};
const isMultipleSelection = (selection)=>{
    return `evidence` in selection && Array.isArray(selection.evidence);
};
// ---------------- features  --------------------- //
const getFeature = (evidence)=>{
    if (isUnknownEvidence(evidence)) {
        return evidence.details;
    } else if (isIndividualEvidence(evidence)) {
        return evidence.feature;
    } else {
        throw new Error('indeterminate evidence type');
    }
};
const getFeatureForSelection = (selection)=>{
    if (isSingleSelection(selection)) {
        return getFeature(selection.evidence);
    }
    throw new Error('feature selection not supported for multiples');
};
const isDisplayedFeature = (feature)=>isNgram(feature) || isCategorical(feature);
const filterEvidence = (evidence)=>{
    // filter out priors
    const noPriors = evidence.filter((pieceOfEvidence)=>{
        return !isPrior(pieceOfEvidence);
    });
    const onlyDisplayable = noPriors.filter((pieceOfEvidence)=>{
        const feature = getFeature(pieceOfEvidence);
        if (!isDisplayedFeature(feature)) {
            return false;
        } else if (isCategorical(feature)) {
            return true;
        } else if (isNgram(feature)) {
            return true;
        }
        return false;
    });
    return onlyDisplayable;
};
const buildEvidenceFeatures = (caseDetail, artifactSet = completeSet)=>{
    // construct "Features" from raw evidence.
    const featureSelections = [];
    const artifacts = filterAndAssembleArtifactList({
        caseRun: caseDetail,
        artifactSet
    });
    artifacts.forEach((artifact)=>{
        const { identifier: artifactId, procedures: { codes }, diagnoses: { codes: standaloneDiagnosticCodes }, modifiers: { codes: standaloneModifierCodes } } = artifact;
        const _generate = (codeType)=>(code)=>{
                if (code.evidence !== undefined) {
                    const evidence = filterEvidence(code.evidence);
                    if (evidence.length) {
                        featureSelections.push({
                            code,
                            artifactId: artifactId,
                            codeType,
                            display: true,
                            evidence
                        });
                    }
                }
            };
        const generateDiagnosis = _generate(CodeType.ICD);
        const generateModifier = _generate(CodeType.MODIFIER);
        const generateCPT = _generate(CodeType.CPT);
        codes.forEach((code)=>{
            var _code_diagnoses, _code_modifiers;
            generateCPT(code);
            (_code_diagnoses = code.diagnoses) === null || _code_diagnoses === void 0 ? void 0 : _code_diagnoses.codes.forEach(generateDiagnosis);
            (_code_modifiers = code.modifiers) === null || _code_modifiers === void 0 ? void 0 : _code_modifiers.codes.forEach(generateModifier);
        });
        standaloneDiagnosticCodes.forEach(generateDiagnosis);
        standaloneModifierCodes.forEach(generateModifier);
    });
    return featureSelections;
};

const EMPTY_DESCRIPTION = 'CODE DESCRIPTION FORTHCOMING';
const EMPTY_CODE = 'UNKNOWN';
const getCode = (code)=>{
    let codeStr = EMPTY_CODE;
    if (isCPT(code)) {
        codeStr = code.procedure_code;
    } else if (isICD(code)) {
        codeStr = code.diagnosis_code;
    } else if (isModifier(code)) {
        codeStr = code.modifier_code;
    }
    return codeStr;
};
const getArtifactDescripton = (code, descriptions)=>{
    let found = false;
    let description = EMPTY_DESCRIPTION;
    const key = getCode(code);
    if (descriptions) {
        const def = descriptions[key] || false;
        if (def) {
            found = true;
            if (def.description !== null && def.description.length) {
                description = def.description;
            } else if (def.shortDescription !== null && def.shortDescription.length) {
                description = def.shortDescription;
            }
        }
    }
    return {
        found,
        description
    };
};

function _define_property$n(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$m(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$n(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$i(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$i(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$i(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties$1(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = _object_without_properties_loose$1(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose$1(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
const logger = loggerFactory('EvidenceManager');
// ---------------------------------
// Utility functions
// ---------------------------------
const identifyFeatureAttr = (feature)=>{
    // this is not going to end up being good enough.
    // we should really resolve whether there's a better
    // identifying feature on a feature.
    if ('field' in feature) {
        return `${getFieldId(feature.field)}`;
    }
    // we should do something better here
    return JSON.stringify(feature);
};
const hashSelection = (featureSelection)=>{
    const { artifactId, code } = featureSelection;
    const codeId = getCode(code);
    if (!isSingleSelection(featureSelection)) {
        return `${artifactId}-${codeId}`;
    } else {
        const feature = getFeatureForSelection(featureSelection);
        return !feature ? `${artifactId}-${code.uuid}` : `${artifactId}-${code.uuid}-${identifyFeatureAttr(feature)}`;
    }
};
// ---------------------------------
// Private class to handle highlight for an individual
// field.  Current behavior means that prior to a field
// indicating a selection, it first has to have a background
// highlight.
// ---------------------------------
class EvidenceHighlighting {
    clone() {
        const cloned = new EvidenceHighlighting();
        cloned._background = _object_spread$m({}, this.highlights);
        cloned._foreground = _object_spread$m({}, this.selections);
        return cloned;
    }
    get selections() {
        return this._foreground;
    }
    get highlights() {
        return this._background;
    }
    hasSelection(optFeature) {
        if (optFeature === undefined) {
            return Object.keys(this._foreground).length !== 0;
        } else {
            const hash = hashSelection(optFeature);
            return this._foreground[hash] !== undefined;
        }
    }
    hasHighlight(optFeature) {
        if (optFeature === undefined) {
            return Object.keys(this._background).length !== 0;
        } else {
            const hash = hashSelection(optFeature);
            return this._background[hash] !== undefined;
        }
    }
    static addToMap(selection, mapper) {
        // adds a feature to a feature map if the feature has not already been added
        const hash = hashSelection(selection);
        if (!Array.isArray(mapper[hash])) {
            mapper[hash] = [];
        }
        const list = mapper[hash];
        const contains = list.some((member)=>member.artifactId === selection.artifactId && member.code.uuid === selection.code.uuid);
        if (!contains) {
            list.push(selection);
        }
    }
    addHighlight(selection) {
        EvidenceHighlighting.addToMap(selection, this._background);
    }
    removeHighlight(selection) {
        const toRmHash = hashSelection(selection);
        delete this._background[toRmHash];
        this.removeSelection(selection);
    }
    addSelection(selection) {
        EvidenceHighlighting.addToMap(selection, this._foreground);
    }
    removeSelection(selection) {
        const toRmHash = hashSelection(selection);
        delete this._foreground[toRmHash];
    }
    constructor(){
        _define_property$n(this, "_background", void 0);
        _define_property$n(this, "_foreground", void 0);
        this._background = {};
        this._foreground = {};
    }
}
class CodeActivations {
    static hash(featureSelection) {
        const { code } = featureSelection;
        return `${code.uuid}`;
    }
    _compareFeatures(featureA, featureB) {
        const { evidence: { feature: featA } } = featureA;
        const { evidence: { feature: featB } } = featureB;
        return isEqual(featA, featB);
    }
    hasFeature(uniqueFeature) {
        const hash = CodeActivations.hash(uniqueFeature);
        const activeSet = this._codeMaps[hash];
        if (!activeSet) {
            return false;
        }
        //@ts-ignore
        const lst = [
            ...activeSet.values()
        ];
        return lst.findIndex((feature)=>this._compareFeatures(feature, uniqueFeature)) !== -1;
    }
    clone() {
        const cloned = new CodeActivations();
        cloned._codeMaps = _object_spread$m({}, this._codeMaps);
        return cloned;
    }
    getSelectionSpans(fieldId, documentId) {
        const selectionSpans = [];
        Object.values(this._codeMaps).forEach((entry)=>{
            Array.from(entry).forEach((featureSelection)=>{
                const feature = getFeatureForSelection(featureSelection);
                if (isDisplayedFeature(feature) && feature.field === fieldId) {
                    if (isNgram(feature)) {
                        var _feature_spans;
                        const spans = (_feature_spans = feature.spans) !== null && _feature_spans !== void 0 ? _feature_spans : [];
                        spans.forEach((span)=>{
                            if (documentId === undefined) {
                                selectionSpans.push(span);
                            } else if (span.document_id === documentId) {
                                selectionSpans.push(span);
                            }
                        });
                    }
                }
            });
        });
        return selectionSpans;
    }
    addSelection(selection) {
        const hash = CodeActivations.hash(selection);
        if (!this._codeMaps[hash]) {
            this._codeMaps[hash] = new Set();
        }
        const activationSet = this._codeMaps[hash];
        activationSet.add(selection);
    }
    removeSelection(selection) {
        const hash = CodeActivations.hash(selection);
        if (this._codeMaps[hash]) {
            const hashSet = this._codeMaps[hash];
            const lst = [
                ...hashSet.values()
            ];
            const featureB = selection;
            const filtered = lst.filter((feature)=>{
                return !this._compareFeatures(feature, featureB);
            });
            this._codeMaps[hash] = new Set(filtered);
        } else {
            delete this._codeMaps[hash];
        }
    }
    constructor(){
        _define_property$n(this, "_codeMaps", void 0);
        this._codeMaps = {};
    }
}
// ---------------------------------
// Public API
// ---------------------------------
class EvidenceManager {
    clone() {
        const cloned = new EvidenceManager();
        //@ts-ignore
        [
            ...this._evidenceMappers.keys()
        ].forEach((fieldId)=>{
            const field = this._evidenceMappers.get(fieldId);
            if (!field) {
                console.error(`no field available`);
            } else {
                cloned._evidenceMappers.set(fieldId, field.clone());
            }
        });
        cloned._codeActivations = this._codeActivations.clone();
        return cloned;
    }
    set artifacts(arts) {
        this._artifacts = arts;
    }
    get artifacts() {
        return this._artifacts;
    }
    get evidence() {
        if (!this._evidence) return [];
        return this._evidence;
    }
    get artifactList() {
        return this.artifacts;
    }
    getHighlights(fieldName) {
        const fieldId = getFieldId(fieldName);
        let mapper = this._evidenceMappers.get(fieldId);
        if (mapper === undefined) {
            return [];
        }
        return [
            ...Object.values(mapper.highlights)
        ].flat();
    }
    getHighlightSpans(fieldName, matchableMetadata = {}) {
        const highlightSpans = [];
        const fieldId = getFieldId(fieldName);
        let highlightedFeatures = this.getHighlights(fieldId);
        if (highlightedFeatures) {
            // ------------------------ closures and data structures ------------------------ //
            // build a matcher to make sure evidence highlights points to current document/etc.
            const keys = Object.keys(matchableMetadata);
            const metadataMatcher = (span)=>{
                return !keys.some(// eslint-disable-next-line
                (key)=>span[key] != matchableMetadata[key]);
            };
            // build a set of activations
            const activationSpans = this._codeActivations.getSelectionSpans(fieldId);
            const activationSet = new Set(activationSpans.map((activation)=>`${activation.hash}`));
            highlightedFeatures.forEach((result)=>{
                var _result_code_evidence;
                const evidence = (_result_code_evidence = result.code.evidence) !== null && _result_code_evidence !== void 0 ? _result_code_evidence : [];
                evidence.forEach((pieceOfEvidence)=>{
                    const feature = getFeature(pieceOfEvidence);
                    if (isDisplayedFeature(feature) && isNgram(feature)) {
                        var _feature_spans;
                        const sentenceSpans = ((_feature_spans = feature.spans) !== null && _feature_spans !== void 0 ? _feature_spans : []).filter(hasSentence);
                        const matchedSpans = sentenceSpans.filter(metadataMatcher);
                        matchedSpans.forEach((span)=>{
                            var _span_hash;
                            highlightSpans.push({
                                span,
                                codeType: result.codeType,
                                code: result.code,
                                active: activationSet.has((_span_hash = span.hash) !== null && _span_hash !== void 0 ? _span_hash : '')
                            });
                        });
                    }
                });
            });
        }
        return highlightSpans;
    }
    getAllHighlights() {
        const highlights = [
            ...this._evidenceMappers.keys()
        ].map((key)=>{
            return this.getHighlights(key);
        }).flat().map((highlight)=>{
            // when multiple-selections are added to the evidence manager, they
            // are added as individual selections.  What this means is that when
            // you go to grab highlights, they can't simply be re-added as is.
            // the code below is converting the single selection to the multiple.
            return _object_spread_props$i(_object_spread$m({}, highlight), {
                evidence: [
                    highlight.evidence
                ]
            });
        });
        return highlights;
    }
    getAllSelections() {
        return [
            ...this._evidenceMappers.keys()
        ].map((key)=>{
            return this.getSelections(key);
        }).flat();
    }
    getSelections(fieldName) {
        const fieldId = getFieldId(fieldName);
        let evidence = this._evidenceMappers.get(fieldId);
        if (evidence === undefined) {
            return [];
        }
        return [
            ...Object.values(evidence.selections)
        ].flat();
    }
    isSelected(fieldName) {
        const fieldId = getFieldId(fieldName);
        let evidence = this._evidenceMappers.get(fieldId);
        return evidence !== undefined && evidence.hasSelection();
    }
    isHighlighted(fieldName) {
        const fieldId = getFieldId(fieldName);
        let mapper = this._evidenceMappers.get(fieldId);
        return mapper !== undefined && mapper.hasHighlight();
    }
    loadEvidence(caseDetail) {
        const featureSelections = buildEvidenceFeatures(caseDetail);
        featureSelections.forEach((featureSelection)=>{
            this.highlightFeatures(featureSelection);
        });
    }
    deselectFeature(toRemove) {
        if (isSingleSelection(toRemove)) {
            const feature = getFeatureForSelection(toRemove);
            const fieldId = identifyFeatureAttr(feature);
            let mapper = this._evidenceMappers.get(fieldId);
            if (!mapper) {
                console.error(`issues with removal, unable to locate evidence for ${toRemove}`);
            } else {
                mapper.removeSelection(toRemove);
                this._codeActivations.removeSelection(toRemove);
            }
        }
    }
    selectFeature(toSelect) {
        if (isSingleSelection(toSelect)) {
            const feature = getFeatureForSelection(toSelect);
            const fieldId = identifyFeatureAttr(feature);
            let mapper = this._evidenceMappers.get(fieldId);
            if (!mapper) {
                // create the evidence structure if it isn't there already
                mapper = new EvidenceHighlighting();
                this._evidenceMappers.set(fieldId, mapper);
            }
            mapper.addSelection(toSelect);
            this._codeActivations.addSelection(toSelect);
        }
    }
    hasSelectedFeature(uniqueFeature) {
        return this._codeActivations.hasFeature(uniqueFeature);
    }
    highlightFeatures(toHighlight) {
        if (isMultipleSelection(toHighlight)) {
            const { evidence } = toHighlight, base = _object_without_properties$1(toHighlight, [
                "evidence"
            ]);
            evidence.forEach((pieceOfEvidence)=>{
                const feature = getFeature(pieceOfEvidence);
                // skipping priors for the moment.
                if (isDisplayedFeature(feature)) {
                    const fieldId = identifyFeatureAttr(feature);
                    let mapper = this._evidenceMappers.get(fieldId);
                    if (!mapper) {
                        // create the evidence structure if it isn't there already
                        mapper = new EvidenceHighlighting();
                        this._evidenceMappers.set(fieldId, mapper);
                    }
                    const item = _object_spread_props$i(_object_spread$m({}, base), {
                        evidence: _object_spread$m({}, pieceOfEvidence)
                    });
                    mapper.addHighlight(item);
                }
            });
        }
    }
    deHighlightFeatures(rmHighlight) {
        if (isMultipleSelection(rmHighlight)) {
            const { evidence } = rmHighlight, base = _object_without_properties$1(rmHighlight, [
                "evidence"
            ]);
            evidence.forEach((pieceOfEvidence)=>{
                const feature = getFeature(pieceOfEvidence);
                if (isDisplayedFeature(feature)) {
                    const fieldId = identifyFeatureAttr(feature);
                    let mapper = this._evidenceMappers.get(fieldId);
                    if (!mapper) {
                        logger.log(`unable to de highlight the feature ${fieldId}`, pieceOfEvidence, fieldId);
                    } else {
                        const item = _object_spread_props$i(_object_spread$m({}, base), {
                            evidence: _object_spread$m({}, pieceOfEvidence)
                        });
                        mapper.removeHighlight(item);
                        this._codeActivations.removeSelection(item);
                    }
                }
            });
        }
    }
    constructor(artifacts = []){
        _define_property$n(this, "_evidenceMappers", void 0);
        _define_property$n(this, "_codeActivations", void 0);
        _define_property$n(this, "_evidence", void 0);
        _define_property$n(this, "_artifacts", void 0);
        this._evidenceMappers = new Map();
        this._codeActivations = new CodeActivations();
        this._artifacts = artifacts;
    }
}

function _define_property$m(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$l(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$m(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$h(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$h(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$h(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
// ---------------------------------
// Transformers and Filters
// ---------------------------------
const procedureCodeTransformer = (code, fn)=>{
    fn(code);
    genericCodeTransformer(code, fn);
    return code;
};
const genericCodeTransformer = (code, fn)=>{
    if ('diagnoses' in code) {
        var _code_diagnoses_codes, _code_diagnoses;
        (_code_diagnoses = code.diagnoses) === null || _code_diagnoses === void 0 ? void 0 : (_code_diagnoses_codes = _code_diagnoses.codes) === null || _code_diagnoses_codes === void 0 ? void 0 : _code_diagnoses_codes.forEach(fn);
    }
    if ('modifiers' in code) {
        var _code_modifiers_codes, _code_modifiers;
        (_code_modifiers = code.modifiers) === null || _code_modifiers === void 0 ? void 0 : (_code_modifiers_codes = _code_modifiers.codes) === null || _code_modifiers_codes === void 0 ? void 0 : _code_modifiers_codes.forEach(fn);
    }
    return code;
};
const procedureEvidenceTransformer = (code, fn)=>{
    var _ref;
    var _code_evidence;
    code.evidence = (_ref = (_code_evidence = code.evidence) === null || _code_evidence === void 0 ? void 0 : _code_evidence.map(fn)) !== null && _ref !== void 0 ? _ref : [];
    if (isCPT(code)) {
        genericEvidenceTransformer(code, fn);
    }
    return code;
};
const genericEvidenceTransformer = (code, fn)=>{
    var _code_diagnoses_codes, _code_diagnoses, _code_modifiers_codes, _code_modifiers;
    (_code_diagnoses = code.diagnoses) === null || _code_diagnoses === void 0 ? void 0 : (_code_diagnoses_codes = _code_diagnoses.codes) === null || _code_diagnoses_codes === void 0 ? void 0 : _code_diagnoses_codes.forEach((icd)=>{
        var _icd_evidence;
        return icd.evidence = (_icd_evidence = icd.evidence) === null || _icd_evidence === void 0 ? void 0 : _icd_evidence.map(fn);
    });
    (_code_modifiers = code.modifiers) === null || _code_modifiers === void 0 ? void 0 : (_code_modifiers_codes = _code_modifiers.codes) === null || _code_modifiers_codes === void 0 ? void 0 : _code_modifiers_codes.forEach((mod)=>{
        var _mod_evidence;
        return mod.evidence = (_mod_evidence = mod.evidence) === null || _mod_evidence === void 0 ? void 0 : _mod_evidence.map(fn);
    });
};
const genericEvidenceFilter = (code, fn)=>{
    var _code_diagnoses_codes, _code_diagnoses, _code_modifiers_codes, _code_modifiers;
    (_code_diagnoses = code.diagnoses) === null || _code_diagnoses === void 0 ? void 0 : (_code_diagnoses_codes = _code_diagnoses.codes) === null || _code_diagnoses_codes === void 0 ? void 0 : _code_diagnoses_codes.forEach((icd)=>{
        var _icd_evidence;
        icd.evidence = (_icd_evidence = icd.evidence) === null || _icd_evidence === void 0 ? void 0 : _icd_evidence.filter(fn);
    });
    (_code_modifiers = code.modifiers) === null || _code_modifiers === void 0 ? void 0 : (_code_modifiers_codes = _code_modifiers.codes) === null || _code_modifiers_codes === void 0 ? void 0 : _code_modifiers_codes.forEach((mod)=>{
        var _mod_evidence;
        mod.evidence = (_mod_evidence = mod.evidence) === null || _mod_evidence === void 0 ? void 0 : _mod_evidence.filter(fn);
    });
};
const procedureEvidenceFilter = (code, fn)=>{
    var _code_evidence;
    const evidence = (_code_evidence = code.evidence) === null || _code_evidence === void 0 ? void 0 : _code_evidence.filter(fn);
    code.evidence = evidence;
    if (isCPT(code)) {
        genericEvidenceFilter(code, fn);
    }
    return code;
};
const buildEvidenceTransformer = (fn)=>{
    return (code)=>{
        genericEvidenceTransformer(code, fn);
        return procedureEvidenceTransformer(code, fn);
    };
};
const buildEvidenceFilter = (fn)=>{
    return (code)=>{
        procedureEvidenceFilter(code, fn);
        genericEvidenceFilter(code, fn);
        return code;
    };
};
const buildCodeTransformer = (fn)=>{
    return (code)=>{
        procedureCodeTransformer(code, fn);
        genericCodeTransformer(code, fn);
        return code;
    };
};
// unused for now.  uncomment if we do need them.
// const procedureCodeFilter = (
//   code: CMxAPI.ProcedureCode,
//   fn: MedicalCodePredicate
// ): boolean => {
//   return fn(code);
// };
// const genericCodeFilter = (code: any, fn: MedicalCodePredicate) => {
//   if ('diagnoses' in code) {
//     code.diagnoses.codes = code.diagnoses?.codes.filter(fn);
//   }
//   if ('modifiers' in code) {
//     code.modifiers.codes = code.modifiers?.codes.filter(fn);
//   }
//   return code;
// };
// ---------------------------------
// Individual transformers and filters
// ---------------------------------
const _onlySentences = (piece)=>{
    const feature = getFeature(piece);
    if (isNgram(feature)) {
        var _ref;
        var _feature_spans;
        feature.spans = (_ref = (_feature_spans = feature.spans) === null || _feature_spans === void 0 ? void 0 : _feature_spans.filter((span)=>span.level === SpanLevel.SENTENCE)) !== null && _ref !== void 0 ? _ref : [];
    }
    return piece;
};
const _uuidEvidence = (piece)=>{
    const feature = getFeature(piece);
    feature.uuid = uuidv4();
    if (isIndividualEvidence(piece)) {
        if (isNgram(feature)) {
            var _feature_spans;
            const spans = (_feature_spans = feature.spans) !== null && _feature_spans !== void 0 ? _feature_spans : [];
            spans.forEach((span)=>{
                span.uuid = uuidv4();
            });
        }
    }
    return piece;
};
const startRe = new RegExp(/^(\r\n|\n|\r)+/gm);
const endRe = new RegExp(/(\r\n|\n|\r)+$/gm);
const _normalizeTextContent = (piece)=>{
    const feature = getFeature(piece);
    if (isIndividualEvidence(piece)) {
        if (isNgram(feature)) {
            var _feature_spans;
            const spans = (_feature_spans = feature.spans) !== null && _feature_spans !== void 0 ? _feature_spans : [];
            spans.forEach((span)=>{
                const { content } = span;
                const matchedStart = content.match(startRe);
                const matchedEnd = content.match(endRe);
                if (matchedStart === null || matchedStart === void 0 ? void 0 : matchedStart.length) {
                    const [first] = matchedStart;
                    span.content = span.content.replace(startRe, '');
                    span.start += first.length;
                }
                if (matchedEnd === null || matchedEnd === void 0 ? void 0 : matchedEnd.length) {
                    const [endTrim] = matchedEnd;
                    span.content = span.content.replace(endRe, '');
                    span.end -= endTrim.length;
                }
            });
        }
    }
    return piece;
};
const _uuidCodes = (code)=>{
    code.uuid = uuidv4();
    return code;
};
const _uniqueSpans = (piece)=>{
    const feature = getFeature(piece);
    const seenFeatures = new Set();
    const seenFilter = (span)=>{
        const hash = `${span.start}-${span.end}`;
        if (seenFeatures.has(hash)) {
            return false;
        }
        seenFeatures.add(hash);
        return true;
    };
    if (isNgram(feature)) {
        feature.spans = feature.spans.filter(seenFilter);
    }
    return piece;
};
const _hasEvidence = (evidence)=>{
    var _feature_spans;
    const feature = getFeature(evidence);
    if (!isNgram(feature)) return true;
    return ((_feature_spans = feature.spans) !== null && _feature_spans !== void 0 ? _feature_spans : []).length > 0;
};
const _normalizeTypeNames = (evidence)=>{
    var _evidence_type;
    evidence.type = ((_evidence_type = evidence.type) !== null && _evidence_type !== void 0 ? _evidence_type : '').toLowerCase();
    return evidence;
};
const codeEvidenceMapper = (code, fn)=>{
    var _code_evidence;
    if ((_code_evidence = code.evidence) === null || _code_evidence === void 0 ? void 0 : _code_evidence.length) {
        const evidence = code.evidence.map(fn);
        const flattened = evidence === null || evidence === void 0 ? void 0 : evidence.flat();
        // if (flattened.length !== code.evidence.length){
        //   console.log(flattened);
        // }
        return flattened;
    }
    return [];
};
const _splitFeatures = (code)=>{
    code.evidence = codeEvidenceMapper(code, (evidence)=>{
        if (isIndividualEvidence(evidence)) {
            let returnEvidence = evidence;
            const { feature } = evidence;
            if (isNgram(feature)) {
                const { spans = [] } = feature;
                //@ts-ignore
                returnEvidence = [
                    ...spans
                ].map((span)=>{
                    const base = _object_spread$l({}, feature);
                    base.spans = [
                        span
                    ];
                    return _object_spread_props$h(_object_spread$l({}, evidence), {
                        feature: base
                    });
                });
            }
            return returnEvidence;
        }
        return evidence;
    });
    return code;
};
const ngramHash = (span, code)=>{
    return `${span.start}-${span.end}-${getCode(code)}`;
};
const _hashNgrams = (code)=>{
    code.evidence = codeEvidenceMapper(code, (evidence)=>{
        if (isIndividualEvidence(evidence)) {
            const { feature } = evidence;
            if (isNgram(feature)) {
                const { spans = [] } = feature;
                spans.forEach((span)=>{
                    // hashing function
                    span.hash = ngramHash(span, code);
                });
            }
        }
        return evidence;
    });
    return code;
};
const mapping = {
    raw_reasonforvisit: 'reason_for_visit',
    exam_type: 'exam_description'
};
const categoricalTypes = new Set([
    'exam_type',
    'raw_reasonforvisit'
]);
const _convertToCategorical = (evidence)=>{
    if (isIndividualEvidence(evidence)) {
        const feature = getFeature(evidence);
        if (categoricalTypes.has(feature.field)) {
            const fieldName = mapping[feature.field] || feature.field;
            const categorical = {
                type: 'categorical',
                score: evidence.score,
                feature: {
                    uuid: uuidv4(),
                    type: FeatureTypes.CATEGORICAL,
                    field: fieldName,
                    category: 'something'
                }
            };
            //console.log(`building categorical: ${fieldName} ${feature.field}`, categorical);
            return categorical;
        }
    }
    return evidence;
};
const dedupeFeatures = (code)=>{
    var _code_evidence, _code_evidence1;
    //
    const seenFeatures = new Set();
    const seenCategories = new Set();
    const seenFeaturesFilter = (span)=>{
        const hash = `${span.start}-${span.end}-${getCode(code)}-${code.uuid}`;
        if (seenFeatures.has(hash)) {
            return false;
        }
        seenFeatures.add(hash);
        return true;
    };
    const seenCategoryFilter = (evidence)=>{
        const feature = getFeature(evidence);
        if (isCategorical(feature)) {
            if (seenCategories.has(feature.field)) {
                return false;
            }
            seenCategories.add(feature.field);
        }
        return true;
    };
    code.evidence = (_code_evidence = code.evidence) === null || _code_evidence === void 0 ? void 0 : _code_evidence.filter(seenCategoryFilter);
    (_code_evidence1 = code.evidence) === null || _code_evidence1 === void 0 ? void 0 : _code_evidence1.forEach((evidence)=>{
        if (isIndividualEvidence(evidence)) {
            const { feature } = evidence;
            if (isNgram(feature)) {
                var _ref;
                var _feature_spans;
                feature.spans = (_ref = (_feature_spans = feature.spans) === null || _feature_spans === void 0 ? void 0 : _feature_spans.filter(seenFeaturesFilter)) !== null && _ref !== void 0 ? _ref : [];
            }
        }
    });
    return code;
};
const deduper = buildCodeTransformer(dedupeFeatures);
const weedOutNonSentenceNgrams = buildEvidenceTransformer(_onlySentences);
const uniqueEvidenceSpans = buildEvidenceTransformer(_uniqueSpans);
const normalizeType = buildEvidenceTransformer(_normalizeTypeNames);
const uuidEvidence = buildEvidenceTransformer(_uuidEvidence);
const convertToCategorical = buildEvidenceTransformer(_convertToCategorical);
const normalizeTextContent = buildEvidenceTransformer(_normalizeTextContent);
const hashNgrams = buildCodeTransformer(_hashNgrams);
const hasEvidenceFilter = buildEvidenceFilter(_hasEvidence);
const onlyKnownEvidence = buildEvidenceFilter(isIndividualEvidence);
const splitFeatures = buildCodeTransformer(_splitFeatures);
const uuidCodes = buildCodeTransformer(_uuidCodes);
const transformers = {
    weedOutNonSentenceNgrams,
    uniqueEvidenceSpans,
    normalizeType,
    uuidEvidence,
    deduper,
    convertToCategorical,
    normalizeTextContent,
    hashNgrams,
    splitFeatures,
    uuidCodes
};
const filters = {
    hasEvidenceFilter,
    onlyKnownEvidence
};

const _transformAndFilter = (codes, artifactFilter)=>{
    const { transformers = [], predicates = [] } = artifactFilter;
    if (transformers.length) {
        transformers.forEach((transformer)=>{
            codes = codes.map(transformer);
        });
    }
    if (predicates.length) {
        predicates.forEach((predicate)=>{
            codes = codes.filter(predicate);
        });
    }
    return codes;
};
const _transformArtifact = (artifact, artifactFilter)=>{
    let { procedures } = artifact;
    procedures.codes = _transformAndFilter(procedures.codes, artifactFilter);
    const { diagnoses: { codes: diagnosticCodes = [] }, modifiers: { codes: modifierCodes = [] } } = artifact;
    if (diagnosticCodes.length) {
        artifact.diagnoses.codes = _transformAndFilter(diagnosticCodes, artifactFilter);
    }
    if (modifierCodes.length) {
        artifact.modifiers.codes = _transformAndFilter(modifierCodes, artifactFilter);
    }
    return artifact;
};
const transformArtifacts = (srcArtifacts, caseRun, includer)=>{
    const artifacts = cloneDeep(srcArtifacts);
    const filterIncluder = buildEvidenceFilter(includer);
    // first pass to get rid of unknown evidence.
    // we _should_ rework further code to know nothing
    // about unknonwn evidence.
    const onlyKnown = artifacts.map((artifact)=>{
        const mutator = {
            transformers: [],
            predicates: [
                filterIncluder,
                filters.onlyKnownEvidence
            ]
        };
        return _transformArtifact(artifact, mutator);
    });
    const processed = onlyKnown.map((artifact)=>{
        const mutator = {
            transformers: [
                transformers.convertToCategorical,
                transformers.normalizeType,
                transformers.weedOutNonSentenceNgrams,
                transformers.splitFeatures,
                transformers.uuidEvidence,
                transformers.deduper,
                transformers.uniqueEvidenceSpans,
                transformers.normalizeTextContent,
                transformers.hashNgrams,
                transformers.uuidCodes
            ],
            predicates: [
                filters.hasEvidenceFilter
            ] //
        };
        return _transformArtifact(artifact, mutator);
    });
    //console.log(JSON.stringify(processed));
    // fix categorical
    // to make the ngrams *look* like categorical features, we
    // need access to the CaseRun data. i have some ideas on how
    // to do this within the transformers frameworker, but it requires
    // a bigger rework than time permits.  so for now, there's
    // kinda hacky solution here.
    const shimCategorical = (piece)=>{
        if (isIndividualEvidence(piece)) {
            const { feature } = piece;
            if (isCategorical(feature) && feature.category === 'something') {
                // @ts-ignore
                feature.category = caseRun[feature.field] || 'unknown value';
            }
        }
    };
    processed.forEach((artifact)=>{
        var _artifact_diagnoses, _artifact_modifiers;
        artifact.procedures.codes.forEach((code)=>{
            var _code_evidence, _code_diagnoses_codes, _code_diagnoses, _code_modifiers_codes, _code_modifiers;
            (_code_evidence = code.evidence) === null || _code_evidence === void 0 ? void 0 : _code_evidence.forEach(shimCategorical);
            (_code_diagnoses = code.diagnoses) === null || _code_diagnoses === void 0 ? void 0 : (_code_diagnoses_codes = _code_diagnoses.codes) === null || _code_diagnoses_codes === void 0 ? void 0 : _code_diagnoses_codes.forEach((code)=>{
                var _code_evidence;
                (_code_evidence = code.evidence) === null || _code_evidence === void 0 ? void 0 : _code_evidence.forEach(shimCategorical);
            });
            (_code_modifiers = code.modifiers) === null || _code_modifiers === void 0 ? void 0 : (_code_modifiers_codes = _code_modifiers.codes) === null || _code_modifiers_codes === void 0 ? void 0 : _code_modifiers_codes.forEach((code)=>{
                var _code_evidence;
                (_code_evidence = code.evidence) === null || _code_evidence === void 0 ? void 0 : _code_evidence.forEach(shimCategorical);
            });
        });
        (_artifact_diagnoses = artifact.diagnoses) === null || _artifact_diagnoses === void 0 ? void 0 : _artifact_diagnoses.codes.forEach((code)=>{
            var _code_evidence;
            (_code_evidence = code.evidence) === null || _code_evidence === void 0 ? void 0 : _code_evidence.forEach(shimCategorical);
        });
        (_artifact_modifiers = artifact.modifiers) === null || _artifact_modifiers === void 0 ? void 0 : _artifact_modifiers.codes.forEach((code)=>{
            var _code_evidence;
            (_code_evidence = code.evidence) === null || _code_evidence === void 0 ? void 0 : _code_evidence.forEach(shimCategorical);
        });
    });
    return processed;
};
const defaultEvidenceFilter = (evidenceItem)=>{
    return true;
};
const preprocessor = (originalRun, evidenceFilter = defaultEvidenceFilter)=>{
    const caseRun = cloneDeep(originalRun);
    // ipc cases no longer have artifacts.
    const { artifacts = [] } = caseRun;
    const filtered = transformArtifacts(artifacts, caseRun, evidenceFilter);
    caseRun.artifacts = filtered;
    return caseRun;
};

function _define_property$l(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$k(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$l(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$g(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$g(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$g(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
// ------------------------------------------
// Base data structures
// ------------------------------------------
const BASE_CODE = {
    codeType: '',
    provenance: '',
    code: '',
    units: 1,
    hash: '',
    unitable: true,
    editable: false,
    codeIssues: [],
    evidence: [],
    description: '',
    codeProvenance: []
};
const BASE_CHARGE_SESSION = {
    type: '',
    guid: '',
    department_code: '',
    description: '',
    codes: []
};
const BASE_INVOICE = _object_spread_props$g(_object_spread$k({}, emptyInvoice), {
    shared_codes: {
        diagnoses: [],
        modifiers: []
    },
    transactions: []
});
const OWN_META = {
    imported: false,
    ownerCaseId: null,
    description: 'These codes originated in your system'
};
const LINKED_META = {
    imported: true,
    ownerCaseId: null,
    description: 'These codes come from a different case'
};
// ------------------------------------------
// Helper functions
// ------------------------------------------
const convertArtifactToInovice = (artifact)=>{
    var _artifact_procedures_codes, _artifact_procedures, _artifact_modifiers_codes, _artifact_modifiers, _artifact_diagnoses_codes, _artifact_diagnoses;
    const invoice = _object_spread_props$g(_object_spread$k({}, BASE_INVOICE), {
        type: artifact.type
    });
    // codes
    const procedureCodes = ((_artifact_procedures = artifact.procedures) === null || _artifact_procedures === void 0 ? void 0 : (_artifact_procedures_codes = _artifact_procedures.codes) === null || _artifact_procedures_codes === void 0 ? void 0 : _artifact_procedures_codes.map((procedure)=>{
        const hash = `${artifact.artifact_id}__${procedure.procedure_code}`;
        const chargeSessionCode = _object_spread_props$g(_object_spread$k({}, BASE_CODE), {
            codeType: ChargeSessionCodeType$1.PROCEDURE,
            provenance: ChargeSessionCodeProvenance$1.CPT,
            code: procedure.procedure_code,
            description: procedure.procedure_name,
            evidence: convertCPT(procedure, hash, true)
        });
        return chargeSessionCode;
    })) || [];
    const modifierCodes = ((_artifact_modifiers = artifact.modifiers) === null || _artifact_modifiers === void 0 ? void 0 : (_artifact_modifiers_codes = _artifact_modifiers.codes) === null || _artifact_modifiers_codes === void 0 ? void 0 : _artifact_modifiers_codes.map((modifier)=>{
        const chargeSessionCode = _object_spread_props$g(_object_spread$k({}, BASE_CODE), {
            codeType: ChargeSessionCodeType$1.MODIFIER,
            provenance: ChargeSessionCodeProvenance$1.MODIFIER,
            code: modifier.modifier_code,
            description: modifier.modifier_code,
            evidence: [] // evidence not supported on modifiers for now.
        });
        return chargeSessionCode;
    })) || [];
    const dxCodes = ((_artifact_diagnoses = artifact.diagnoses) === null || _artifact_diagnoses === void 0 ? void 0 : (_artifact_diagnoses_codes = _artifact_diagnoses.codes) === null || _artifact_diagnoses_codes === void 0 ? void 0 : _artifact_diagnoses_codes.map((diag)=>{
        const id = `${artifact.artifact_id}${diag.diagnosis_code}`.replace(/(\.|\:)/gi, '__');
        const chargeSessionCode = _object_spread_props$g(_object_spread$k({}, BASE_CODE), {
            codeType: ChargeSessionCodeType$1.DIAGNOSIS,
            provenance: ChargeSessionCodeProvenance$1.ICD,
            code: diag.diagnosis_code,
            description: diag.diagnosis_code,
            evidence: convertDX(diag, id, true)
        });
        return chargeSessionCode;
    })) || [];
    // for the prediction artifact, we only have one transaction.  c
    invoice.transactions = [
        _object_spread_props$g(_object_spread$k({}, BASE_CHARGE_SESSION), {
            codes: [
                ...procedureCodes,
                ...modifierCodes,
                ...dxCodes
            ]
        })
    ];
    return invoice;
};
// ------------------------------------------
// Public API
// ------------------------------------------
/**
 * Creates an invoice from an artifact.  This is a UI only construct to allow a prediction
 * to be displayed in the UI when we only show invoices at this point.
 * @param artifacts
 * @returns CMxCommonApp.SimplifiedInvoice[]
 */ const artifactToSimplifiedInvoice = (artifacts)=>{
    return artifacts.map(convertArtifactToInovice);
};
/**
 * A cases codes may be submitted with a different case
 */ const handleImportedCases = (originalInvoices, submitterProcess, submitterSet, originalSet)=>{
    var _ref, _ref1;
    var _simplifiedInvoices, _submitterProcess_primary_clinical_identifier, _submitterProcess_primary_clinical_identifier1;
    // grab only the invoices that we want from the submitter process
    const submitterImportedInvoices = (_simplifiedInvoices = simplifiedInvoices(submitterProcess)) === null || _simplifiedInvoices === void 0 ? void 0 : _simplifiedInvoices.filter((invoice)=>submitterSet.has(invoice.type));
    const importedInvoiceGuids = new Set(submitterImportedInvoices.map((invoice)=>invoice.guid));
    // add in metadata for the new
    const meta = _object_spread_props$g(_object_spread$k({}, LINKED_META), {
        ownerCaseId: submitterProcess.case_id,
        description: `${submitterProcess.exam_description} - Acc #: ${(_ref = (_submitterProcess_primary_clinical_identifier = submitterProcess.primary_clinical_identifier) === null || _submitterProcess_primary_clinical_identifier === void 0 ? void 0 : _submitterProcess_primary_clinical_identifier.number) !== null && _ref !== void 0 ? _ref : 'N/A'} (${(_ref1 = (_submitterProcess_primary_clinical_identifier1 = submitterProcess.primary_clinical_identifier) === null || _submitterProcess_primary_clinical_identifier1 === void 0 ? void 0 : _submitterProcess_primary_clinical_identifier1.issuer) !== null && _ref1 !== void 0 ? _ref1 : 'N/A'})`
    });
    const importedInvoices = submitterImportedInvoices.map((invoice)=>_object_spread_props$g(_object_spread$k({}, invoice), {
            meta: _object_spread$k({}, meta)
        }));
    // make sure we only have a clean set of the old invoices
    const onlyOwnInvoices = originalInvoices.filter((invoice)=>!importedInvoiceGuids.has(invoice.guid));
    if (importedInvoices.length) {
        onlyOwnInvoices.filter((invoice)=>originalSet.has(invoice.type)).forEach((invoice)=>invoice.meta = _object_spread$k({}, OWN_META));
    }
    return [
        ...importedInvoices,
        ...onlyOwnInvoices
    ];
};

const cmxArtifacts = {
    sortInvoices,
    getArtifactSet,
    getInvoiceCodeRequests,
    artifactsForDisplay,
    artifactSets,
    EvidenceManager,
    filterAndAssembleArtifactList,
    codeEditFilter,
    isDisplayedFeature,
    linkableEvidenceTypes,
    isSubhighlight,
    isBlockHighlight,
    getDescription,
    hasSentence,
    isSingleSelection,
    isMultipleSelection,
    getFeature,
    getFeatureForSelection,
    buildEvidenceFeatures,
    getCode,
    getArtifactDescripton,
    preprocessor,
    automatableTypes,
    handleImportedCases,
    artifactToSimplifiedInvoice,
    isLinkable
};

/**
 * selectionToSpans expands an array of selections made into a map
 * of partial selections by key.
 * @param selection
 * @returns
 */ const selectionToSpans = (selection)=>{
    const { evidence, chargeSessionCode, selectionState } = selection;
    const spanActivations = {};
    const partials = evidence.filter((piece)=>piece.featureType === EvidenceType.PARTIAL);
    partials.forEach((piece)=>{
        const span = piece.meta;
        // TODO:
        // this is really dangerous and should not be done under
        // normal circumstances.  The upshot is that I do not believe MedicalCode
        // is used anywhere, and should be removed once we have gotten rid of the
        // the evidence manager.
        const code = chargeSessionCode;
        const codeType = `${chargeSessionCode.codeType}`.toLowerCase();
        const unstructuredSpan = {
            span,
            codeType,
            code,
            active: selectionState.active
        };
        if (!Array.isArray(spanActivations[piece.fieldName])) {
            spanActivations[piece.fieldName] = [];
        }
        spanActivations[piece.fieldName].push(unstructuredSpan);
    });
    return spanActivations;
};

const mergeSpans = (map1, map2)=>{
    const keys2 = Object.keys(map2);
    const targetMap = clone(map1);
    keys2.forEach((key)=>{
        if (!Array.isArray(targetMap[key])) {
            targetMap[key] = map2[key];
        } else {
            const incoming = new Set(map2[key].map((item)=>item.span.hash));
            const filtered = targetMap[key].filter((item)=>!incoming.has(item.span.hash));
            const combined = [
                ...filtered,
                ...map2[key]
            ];
            targetMap[key] = combined.sort(buildSorter());
        }
    });
    return targetMap;
};
const pruneSpans = (map1, map2)=>{
    const keys2 = Object.keys(map2);
    const targetMap = clone(map1);
    keys2.forEach((key)=>{
        const removalArray = map2[key];
        if (targetMap[key]) {
            removalArray.forEach((itemToRemove)=>{
                targetMap[key] = targetMap[key].filter((item)=>item.span.hash !== itemToRemove.span.hash);
            });
        }
    });
    const targetKeys = Object.keys(targetMap);
    targetKeys.forEach((key)=>{
        if (targetMap[key].length === 0) {
            delete targetMap[key];
        }
    });
    return targetMap;
};
const clone = (obj)=>{
    return JSON.parse(JSON.stringify(obj));
};

function _define_property$k(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$j(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$k(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$f(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$f(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$f(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const activationProcessor = (selection, passedPanel, passedProperty, passedSpans)=>{
    const panel = clone(passedPanel);
    const property = clone(passedProperty);
    // spans are a bit different, the SpanActivation map will be built from the
    // selection, and then we'll run merge to add and prune to remove.
    const existingSpanActivations = clone(passedSpans);
    const newSpanActivations = selectionToSpans(selection);
    let spans;
    const action = selection.selectionState;
    const { evidence } = selection;
    if (action.visible) {
        // we are in add or update mode
        // 1. update panel activations
        evidence.forEach((singular)=>{
            panel[singular.hash] = action;
        });
        // 2. update data activations
        evidence.forEach((singular)=>{
            // separate out partials from completes
            // completes will populate dataActivations
            if (singular.featureType === EvidenceType.COMPLETE) {
                var _evidence_meta;
                if (!Array.isArray(property[singular.fieldName])) {
                    property[singular.fieldName] = [];
                }
                const evidence = _object_spread_props$f(_object_spread$j({}, singular), {
                    selectionState: action
                });
                const data = property[singular.fieldName].filter((item)=>item.hash !== evidence.hash);
                evidence.meta = (_evidence_meta = evidence.meta) !== null && _evidence_meta !== void 0 ? _evidence_meta : {};
                evidence.meta.codeType = `${selection.chargeSessionCode.codeType}`.toLowerCase();
                evidence.meta.provenance = `${selection.chargeSessionCode.provenance}`.toLowerCase();
                data.push(evidence);
                property[singular.fieldName] = data;
            }
        });
        // 3. partials will populate spanActivations
        spans = mergeSpans(existingSpanActivations, newSpanActivations);
    } else {
        // we are in removal mode
        // 1. remove panel activations
        evidence.forEach((singular)=>{
            delete panel[singular.hash];
        });
        // 2. remove data activations
        evidence.forEach((singular)=>{
            var _property_singular_fieldName;
            const activations = (_property_singular_fieldName = property[singular.fieldName]) !== null && _property_singular_fieldName !== void 0 ? _property_singular_fieldName : [];
            const data = activations.filter((item)=>item.hash !== singular.hash);
            if (data.length) {
                property[singular.fieldName] = data;
            } else {
                delete property[singular.fieldName];
            }
        });
        spans = pruneSpans(existingSpanActivations, newSpanActivations);
    }
    return {
        panel,
        property,
        spans
    };
};

function _define_property$j(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$i(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$j(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$e(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$e(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$e(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
// standard top columns
const DOB$1 = {
    key: 'patient-dob',
    label: 'DOB',
    property: 'date_of_birth',
    transformer: 'friendly_date',
    dataSize: 'ms'
};
const DOB_AGE_BY_DOS$1 = {
    key: 'patient-dob',
    label: 'DOB',
    property: 'date_of_birth',
    transformer: 'dob_age_by_dos',
    dataSize: 'ms',
    dataSizeHorizontalView: 'l'
};
const GENDER$1 = {
    key: 'patient-gender',
    label: 'Gender',
    property: 'patient_gender',
    dataSize: 'ms'
};
const MRN$1 = {
    key: 'patient-mrn',
    label: 'MRN',
    property: 'patient_identifier',
    transformer: 'mrn',
    dataSize: 'ms'
};
// standard mid columns
const ACCESSION$1 = {
    key: 'accession',
    label: 'Accession',
    property: 'primary_clinical_identifier',
    transformer: 'identifier',
    dataSize: 'ms'
};
const EXAM_CODE$1 = {
    key: 'exam_code',
    label: 'Exam Code',
    property: 'exam_code',
    dataSize: 'ms'
};
const PRIMARY_INSURANCE$1 = {
    key: 'primary_insurance',
    label: 'Primary Insurance',
    property: 'primary_insurance',
    dataSize: 'l'
};
const REASON_FOR_VISIT$1 = {
    key: 'reason_for_visit',
    label: 'Reason for Visit',
    property: 'reason_for_visit',
    dataSize: 'm'
};
const DOS$1 = {
    key: 'date_of_service',
    label: 'Date of Service',
    property: 'date_of_service',
    dataSize: 'ms',
    transformer: 'date_of_service',
    fieldType: 'date'
};
const EXAM_DESCRIPTION$1 = {
    key: 'exam_description',
    label: 'Exam Description',
    property: 'exam_description',
    dataSize: 'l'
};
// standard bottom columns
const ORDERING_PROVIDER$1 = {
    key: 'ordering_provider_name',
    label: 'Ordering Provider',
    property: 'ordering_provider_name',
    dataSize: 'ms'
};
const ORDERING_PROVIDER_NUMBER$1 = {
    key: 'ordering_provider_number',
    label: 'Ordering Provider ID',
    property: 'ordering_provider_number',
    transformer: 'numerical',
    dataSize: 'ms'
};
const ORDER_NUMBER$1 = {
    key: 'order_number',
    label: 'Order ID',
    property: 'order_number',
    transformer: 'numerical',
    dataSize: 'ms'
};
const PLACE_OF_SERVICE$1 = {
    key: 'place_of_service',
    label: 'Place of Service',
    property: 'place_of_service',
    dataSize: 'ms'
};
const TENANT_NAME$1 = {
    key: 'tenant_name',
    label: 'Tenant Name',
    property: 'tenant_name',
    dataSize: 'm'
};
const BILLING_PROVIDER$1 = {
    key: 'billing_provider_name',
    label: 'Billing Provider',
    property: 'billing_provider_name',
    dataSize: 'ms'
};
const BILLING_PROVIDER_NUMBER$1 = {
    key: 'billing_provider_number',
    label: 'Billing Provider ID',
    property: 'billing_provider_number',
    transformer: 'numerical',
    dataSize: 'ms'
};
const PROCEDURE_TYPE$1 = {
    key: 'procedure_type',
    label: 'Procedure Type',
    property: 'procedure_type',
    dataSize: 'ms'
};
const PROCEDURE_TYPE_CATEGORY$1 = {
    key: 'procedure_type_category',
    label: 'Procedure Type',
    property: 'procedure_type_category',
    dataSize: 'ms'
};
const VISIT_NUMBER$1 = {
    key: 'visit_number',
    label: 'Visit Number',
    transformer: 'numerical',
    property: 'visit_number',
    dataSize: 'ms'
};
const CASE_ID$1 = {
    key: 'case_id',
    label: 'CMX Case ID',
    property: 'case_id',
    dataSize: 'ms'
};
// PATH SPECIFIC
const SPECIMEN_SOURCES$1 = {
    key: 'specimen_sources',
    label: 'Primary Specimen Source',
    transformer: 'specimen_sources',
    property: 'specimen_sources',
    dataSize: 'm'
};
const GROUPER$1 = {
    key: 'grouper',
    label: 'Specimen category',
    property: 'grouper',
    dataSize: 'ms'
};
const HAR$1 = {
    key: 'hospital_account_record',
    label: 'Hospital Account Record',
    property: 'hospital_account_record',
    dataSize: 'ms'
};
const ENCOUNTER_NUMBER$1 = _object_spread_props$e(_object_spread$i({}, HAR$1), {
    label: 'Encounter'
});
const PROCESS_ID$1 = {
    key: 'case_json_id',
    label: 'CMX Process ID',
    property: 'case_json_id',
    dataSize: 'ms'
};
const CASE_TYPE$1 = {
    key: 'case_type',
    label: 'Case Type',
    property: 'case_type',
    dataSize: 'ms'
};
const BILLING_AREA$1 = {
    key: 'billing_area',
    label: 'Billing Area',
    property: 'billing_area',
    dataSize: 'ms'
};
const DEPARTMENT$1 = {
    key: 'scheduling_department',
    label: 'Department',
    property: 'scheduling_department',
    dataSize: 'ms'
};
// Automate/IPC columns
const FINANCIAL_STATUS_CLASS$1 = {
    key: 'financial_status_class',
    label: 'Financial Status Class',
    property: 'financial_status_class',
    dataSize: 'ms',
    fieldType: 'dictionary'
};
const FACILITY$1 = {
    key: 'billing_location',
    label: 'Facility',
    property: 'billing_location',
    dataSize: 'ms',
    fieldType: 'dictionary'
};
const PATIENT_CLASS$1 = {
    key: 'patient_class',
    label: 'Patient Class',
    property: 'patient_class',
    dataSize: 'ms'
};
const PATIENT_TYPE$1 = {
    key: 'patient_type',
    label: 'Patient Type',
    property: 'patient_type',
    dataSize: 'ms',
    fieldType: 'dictionary'
};
const AUTHENTICATOR_PROVIDER$1 = {
    key: 'assigned_document_auth_name',
    label: 'Authenticator',
    property: 'assigned_document_auth_name',
    dataSize: 'ms',
    hasLink: true,
    additionalInfo: [
        {
            property: 'assigned_document_auth_number',
            label: 'providerNumber'
        },
        {
            property: 'facility',
            label: 'tenantCode'
        },
        {
            property: 'assigned_document_auth_name',
            label: 'providerName'
        }
    ]
};
const ADMITTING_PROVIDER$1 = {
    key: 'admitting_provider_name',
    label: 'Admitting Provider',
    property: 'admitting_provider_name',
    dataSize: 'ms',
    dataSizeHorizontalView: 'l',
    hasLink: true,
    additionalInfo: [
        {
            property: 'admitting_provider',
            label: 'providerNumber',
            transformer: 'numerical'
        },
        {
            property: 'facility',
            label: 'tenantCode'
        },
        {
            property: 'admitting_provider_name',
            label: 'providerName'
        }
    ]
};
const SERVICE_LINE$1 = {
    key: 'service_line',
    label: 'Service Line',
    property: 'service_line',
    transformer: 'service_line',
    dataSize: 'ms'
};
const ADMISSION_DATE$1 = {
    key: 'admission_datetime',
    label: 'Admission Date',
    property: 'admission_datetime',
    dataSize: 'ms',
    transformer: 'date_of_service',
    fieldType: 'date'
};
const DISCHARGE_DATE$1 = {
    key: 'discharge_datetime',
    label: 'Discharge Date',
    property: 'discharge_datetime',
    dataSize: 'ms',
    transformer: 'date_of_service',
    fieldType: 'date'
};
const EM_CATEGORY$1 = {
    key: 'em_category',
    label: 'Case E/M Category',
    property: 'em_category',
    dataSize: 'ms',
    fieldType: 'dictionary'
};
const AUTHORING_PROVIDER$1 = {
    key: 'authoring_provider_name',
    label: 'Authoring Provider',
    property: 'primary_activity_provider_name',
    dataSize: 'ms',
    hasLink: true,
    additionalInfo: [
        {
            property: 'primary_activity_provider_number',
            label: 'providerNumber'
        },
        {
            property: 'facility',
            label: 'tenantCode'
        },
        {
            property: 'primary_activity_provider_name',
            label: 'providerName'
        }
    ]
};
const FINAL_SIGNING_PROVIDER$1 = {
    key: 'note_final_sign_provider',
    label: 'Final Sign Provider',
    property: 'note_final_sign_provider_name',
    dataSize: 'ms',
    hasLink: true,
    additionalInfo: [
        {
            property: 'note_final_sign_provider_number',
            label: 'providerNumber'
        },
        {
            property: 'facility',
            label: 'tenantCode'
        },
        {
            property: 'note_final_sign_provider_name',
            label: 'providerName'
        }
    ]
};
const NOTE_SPECIALTY$1 = {
    key: 'note_specialty_designation',
    label: 'NOTE SPECIALTY',
    property: 'note_specialty_designation',
    dataSize: 'ms',
    fieldType: 'dictionary'
};
const SCHEDULING_ID$1 = {
    key: 'scheduling_id',
    label: 'SCHEDULING ID',
    property: 'order_filler_number',
    transformer: 'numerical',
    dataSize: 'ms'
};
const OWNER$1 = {
    key: 'owner',
    label: 'CODER',
    property: 'owner',
    dataSize: 'ms'
};
const ASSIGNEE$1 = {
    key: 'assignee',
    label: 'ASSIGNEE',
    property: 'assignee',
    dataSize: 'ms'
};
const AGING_DAYS$1 = {
    key: 'aging_days',
    label: 'AGING DAYS',
    property: 'aging_days',
    dataSize: 'ms'
};
const CODABLE_DAYS$1 = {
    key: 'codable_days',
    label: 'CODABLE DAYS',
    property: 'codable_days',
    dataSize: 'ms'
};
const PATIENT_AGE$1 = {
    key: 'patient_age',
    label: 'Patient Age',
    property: 'patient_age',
    dataSize: 'ms',
    transformer: 'patient_age_by_dos_dob'
};
const ATTENDING_PROVIDER$1 = {
    key: 'attending_provider_name',
    label: 'Attending Provider',
    property: 'attending_provider_name',
    dataSize: 'ms',
    hasLink: true,
    additionalInfo: [
        {
            property: 'attending_provider_number',
            label: 'providerNumber',
            transformer: 'numerical'
        },
        {
            property: 'facility',
            label: 'tenantCode'
        },
        {
            property: 'attending_provider_name',
            label: 'providerName'
        }
    ]
};
// column groups for amplify
const radAmplifyColumns$1 = {
    patient: [
        DOB_AGE_BY_DOS$1,
        GENDER$1,
        MRN$1,
        PRIMARY_INSURANCE$1
    ],
    summary: [],
    expanded: [
        ACCESSION$1,
        EXAM_CODE$1,
        REASON_FOR_VISIT$1,
        DOS$1,
        EXAM_DESCRIPTION$1,
        ORDERING_PROVIDER$1,
        ORDERING_PROVIDER_NUMBER$1,
        ORDER_NUMBER$1,
        PLACE_OF_SERVICE$1,
        TENANT_NAME$1,
        BILLING_AREA$1,
        BILLING_PROVIDER$1,
        BILLING_PROVIDER_NUMBER$1,
        PROCEDURE_TYPE$1,
        VISIT_NUMBER$1,
        CASE_ID$1
    ]
};
const PatientTimelineColumns$1 = {
    patient: [
        DOB$1,
        GENDER$1,
        MRN$1,
        PRIMARY_INSURANCE$1
    ],
    summary: [],
    expanded: []
};
const pathAmplifyColumns$1 = {
    patient: [
        ...radAmplifyColumns$1.patient
    ],
    summary: [],
    expanded: [
        ACCESSION$1,
        CASE_TYPE$1,
        DOS$1,
        SPECIMEN_SOURCES$1,
        ORDERING_PROVIDER$1,
        ORDERING_PROVIDER_NUMBER$1,
        ORDER_NUMBER$1,
        _object_spread_props$e(_object_spread$i({}, PLACE_OF_SERVICE$1), {
            transformer: 'multi_place_of_service'
        }),
        TENANT_NAME$1,
        BILLING_PROVIDER$1,
        BILLING_PROVIDER_NUMBER$1,
        GROUPER$1,
        ENCOUNTER_NUMBER$1,
        PROCESS_ID$1,
        CASE_ID$1
    ]
};
const surgicalAmplifyColumns$1 = {
    patient: [
        ...radAmplifyColumns$1.patient
    ],
    summary: [],
    expanded: [
        SERVICE_LINE$1,
        DOS$1,
        ENCOUNTER_NUMBER$1,
        NOTE_SPECIALTY$1,
        ORDER_NUMBER$1,
        _object_spread_props$e(_object_spread$i({}, PROCEDURE_TYPE_CATEGORY$1), {
            dataSize: 'ms',
            label: 'Scheduled Description'
        }),
        ADMISSION_DATE$1,
        DISCHARGE_DATE$1,
        SCHEDULING_ID$1,
        FINANCIAL_STATUS_CLASS$1,
        PATIENT_CLASS$1,
        PATIENT_TYPE$1,
        ATTENDING_PROVIDER$1,
        AUTHENTICATOR_PROVIDER$1,
        AUTHORING_PROVIDER$1,
        _object_spread_props$e(_object_spread$i({}, FINAL_SIGNING_PROVIDER$1), {
            property: 'authentication_person_name'
        }),
        ORDERING_PROVIDER$1,
        CASE_ID$1,
        FACILITY$1,
        DEPARTMENT$1,
        BILLING_AREA$1,
        OWNER$1,
        ASSIGNEE$1,
        AGING_DAYS$1,
        CODABLE_DAYS$1,
        PATIENT_AGE$1
    ]
};
const ipcAmplifyColumns$1 = {
    patient: [
        DOB_AGE_BY_DOS$1,
        GENDER$1,
        MRN$1,
        PRIMARY_INSURANCE$1
    ],
    summary: [],
    expanded: [
        PATIENT_CLASS$1,
        PATIENT_TYPE$1,
        NOTE_SPECIALTY$1,
        HAR$1,
        FACILITY$1,
        DEPARTMENT$1,
        DOS$1,
        ADMISSION_DATE$1,
        DISCHARGE_DATE$1,
        //SERVICE_PROVIDER,
        AUTHORING_PROVIDER$1,
        AUTHENTICATOR_PROVIDER$1,
        FINAL_SIGNING_PROVIDER$1,
        ADMITTING_PROVIDER$1,
        ORDERING_PROVIDER$1,
        FINANCIAL_STATUS_CLASS$1,
        EM_CATEGORY$1,
        SERVICE_LINE$1,
        CASE_ID$1,
        OWNER$1,
        ASSIGNEE$1,
        AGING_DAYS$1,
        CODABLE_DAYS$1,
        ATTENDING_PROVIDER$1,
        SCHEDULING_ID$1
    ]
};
const PatientAmplifyEncounterColumns$1 = {
    radiology: radAmplifyColumns$1,
    pathology: pathAmplifyColumns$1,
    surgery: surgicalAmplifyColumns$1,
    inpatientprofessionalcoding: ipcAmplifyColumns$1
};
// column groups for accelerate
const radDashboardColumns$1 = {
    patient: [
        DOB$1,
        GENDER$1,
        MRN$1,
        PRIMARY_INSURANCE$1
    ],
    summary: [
        ACCESSION$1,
        EXAM_CODE$1,
        REASON_FOR_VISIT$1,
        DOS$1,
        EXAM_DESCRIPTION$1
    ],
    expanded: [
        ORDERING_PROVIDER$1,
        ORDERING_PROVIDER_NUMBER$1,
        ORDER_NUMBER$1,
        PLACE_OF_SERVICE$1,
        TENANT_NAME$1,
        BILLING_AREA$1,
        BILLING_PROVIDER$1,
        BILLING_PROVIDER_NUMBER$1,
        PROCEDURE_TYPE$1,
        VISIT_NUMBER$1,
        CASE_ID$1
    ]
};
const pathDashboardColumns$1 = {
    patient: [
        ...radDashboardColumns$1.patient
    ],
    summary: [
        ACCESSION$1,
        CASE_TYPE$1,
        DOS$1,
        SPECIMEN_SOURCES$1
    ],
    expanded: [
        ORDERING_PROVIDER$1,
        ORDERING_PROVIDER_NUMBER$1,
        ORDER_NUMBER$1,
        _object_spread_props$e(_object_spread$i({}, PLACE_OF_SERVICE$1), {
            transformer: 'multi_place_of_service'
        }),
        TENANT_NAME$1,
        BILLING_PROVIDER$1,
        BILLING_PROVIDER_NUMBER$1,
        GROUPER$1,
        ENCOUNTER_NUMBER$1,
        PROCESS_ID$1,
        CASE_ID$1
    ]
};
const surgicalDashboardColumns$1 = {
    patient: [
        ...radDashboardColumns$1.patient
    ],
    summary: [
        SERVICE_LINE$1,
        DOS$1,
        ENCOUNTER_NUMBER$1,
        NOTE_SPECIALTY$1,
        ORDER_NUMBER$1,
        _object_spread_props$e(_object_spread$i({}, PROCEDURE_TYPE_CATEGORY$1), {
            dataSize: 's',
            label: 'Scheduled Description'
        })
    ],
    expanded: [
        ADMISSION_DATE$1,
        DISCHARGE_DATE$1,
        SCHEDULING_ID$1,
        FINANCIAL_STATUS_CLASS$1,
        PATIENT_CLASS$1,
        PATIENT_TYPE$1,
        ATTENDING_PROVIDER$1,
        AUTHENTICATOR_PROVIDER$1,
        AUTHORING_PROVIDER$1,
        _object_spread_props$e(_object_spread$i({}, FINAL_SIGNING_PROVIDER$1), {
            property: 'authentication_person_name'
        }),
        ORDERING_PROVIDER$1,
        CASE_ID$1,
        FACILITY$1,
        DEPARTMENT$1,
        BILLING_AREA$1,
        PATIENT_AGE$1
    ]
};
const ipcDashboardColumns$1 = {
    patient: [
        DOB$1,
        GENDER$1,
        MRN$1,
        PRIMARY_INSURANCE$1
    ],
    summary: [
        PATIENT_CLASS$1,
        PATIENT_TYPE$1,
        NOTE_SPECIALTY$1
    ],
    expanded: [
        HAR$1,
        FACILITY$1,
        DEPARTMENT$1,
        DOS$1,
        ADMISSION_DATE$1,
        DISCHARGE_DATE$1,
        //SERVICE_PROVIDER,
        AUTHORING_PROVIDER$1,
        AUTHENTICATOR_PROVIDER$1,
        FINAL_SIGNING_PROVIDER$1,
        ADMITTING_PROVIDER$1,
        ORDERING_PROVIDER$1,
        FINANCIAL_STATUS_CLASS$1,
        EM_CATEGORY$1,
        SERVICE_LINE$1,
        CASE_ID$1,
        ATTENDING_PROVIDER$1,
        SCHEDULING_ID$1
    ]
};
const PatientEncounterDashboardColumns$1 = {
    radiology: radDashboardColumns$1,
    pathology: pathDashboardColumns$1,
    surgery: surgicalDashboardColumns$1,
    inpatientprofessionalcoding: ipcDashboardColumns$1,
    patientTimeline: PatientTimelineColumns$1
};

function _define_property$i(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$h(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$i(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$d(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$d(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$d(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
// standard top columns
const DOB = {
    key: 'patient-dob',
    label: 'DOB',
    property: 'date_of_birth',
    transformer: 'friendly_date',
    dataSize: 'ms',
    dataSizeHorizontalView: 'l'
};
const DOB_AGE_BY_DOS = {
    key: 'patient-dob',
    label: 'DOB',
    property: 'date_of_birth',
    transformer: 'dob_age_by_dos',
    dataSize: 'ms',
    dataSizeHorizontalView: 'l'
};
const GENDER = {
    key: 'patient-gender',
    label: 'Gender',
    property: 'patient_gender',
    dataSize: 'ms',
    dataSizeHorizontalView: 'l'
};
const MRN = {
    key: 'patient-mrn',
    label: 'MRN',
    property: 'patient_identifier',
    transformer: 'mrn',
    dataSize: 'ms',
    dataSizeHorizontalView: 'l'
};
// standard mid columns
const ACCESSION = {
    key: 'accession',
    label: 'Accession',
    property: 'primary_clinical_identifier',
    transformer: 'identifier',
    dataSize: 'ms',
    dataSizeHorizontalView: 'l'
};
const EXAM_CODE = {
    key: 'exam_code',
    label: 'Exam Code',
    property: 'exam_code',
    dataSize: 'ms',
    dataSizeHorizontalView: 'l'
};
const PRIMARY_INSURANCE = {
    key: 'primary_insurance',
    label: 'Primary Insurance',
    property: 'primary_insurance',
    dataSize: 'l',
    dataSizeHorizontalView: 'l'
};
const REASON_FOR_VISIT = {
    key: 'reason_for_visit',
    label: 'Reason for Visit',
    property: 'reason_for_visit',
    dataSize: 'm',
    dataSizeHorizontalView: 'l'
};
const GLOBAL_PERIOD = {
    key: 'global_period',
    label: 'Global Period',
    property: 'global_period',
    dataSize: 'ms',
    dataSizeHorizontalView: 'l'
};
const DOS = {
    key: 'date_of_service',
    label: 'Date of Service',
    property: 'date_of_service',
    dataSize: 'l',
    transformer: 'date_of_service',
    fieldType: 'date',
    dataSizeHorizontalView: 'l'
};
const EXAM_DESCRIPTION = {
    key: 'exam_description',
    label: 'Exam Description',
    property: 'exam_description',
    dataSize: 'l',
    dataSizeHorizontalView: 'l'
};
// standard bottom columns
const ORDERING_PROVIDER = {
    key: 'ordering_provider_name',
    label: 'Ordering Provider',
    property: 'ordering_provider_name',
    dataSize: 'l',
    dataSizeHorizontalView: 'l'
};
const ORDERING_PROVIDER_NUMBER = {
    key: 'ordering_provider_number',
    label: 'Ordering Provider ID',
    property: 'ordering_provider_number',
    transformer: 'numerical',
    dataSize: 'ms',
    dataSizeHorizontalView: 'l'
};
const ORDER_NUMBER = {
    key: 'order_number',
    label: 'Order ID',
    property: 'order_number',
    transformer: 'numerical',
    dataSize: 'ms',
    dataSizeHorizontalView: 'l'
};
const PLACE_OF_SERVICE = {
    key: 'place_of_service',
    label: 'Place of Service',
    property: 'place_of_service',
    dataSize: 'ms',
    dataSizeHorizontalView: 'l'
};
const TENANT_NAME = {
    key: 'tenant_name',
    label: 'Tenant Name',
    property: 'tenant_name',
    dataSize: 'm',
    dataSizeHorizontalView: 'l'
};
const BILLING_PROVIDER = {
    key: 'billing_provider_name',
    label: 'Billing Provider',
    property: 'billing_provider_name',
    dataSize: 'ms',
    dataSizeHorizontalView: 'l'
};
const BILLING_PROVIDER_NUMBER = {
    key: 'billing_provider_number',
    label: 'Billing Provider ID',
    property: 'billing_provider_number',
    transformer: 'numerical',
    dataSize: 'ms',
    dataSizeHorizontalView: 'l'
};
const PROCEDURE_TYPE = {
    key: 'procedure_type',
    label: 'Procedure Type',
    property: 'procedure_type',
    dataSize: 'ms',
    dataSizeHorizontalView: 'l'
};
const PROCEDURE_TYPE_CATEGORY = {
    key: 'procedure_type_category',
    label: 'Procedure Type',
    property: 'procedure_type_category',
    dataSize: 'ms',
    dataSizeHorizontalView: 'l'
};
const VISIT_NUMBER = {
    key: 'visit_number',
    label: 'Visit Number',
    transformer: 'numerical',
    property: 'visit_number',
    dataSize: 'ms',
    dataSizeHorizontalView: 'l'
};
const CASE_ID = {
    key: 'case_id',
    label: 'CMX Case ID',
    property: 'case_id',
    dataSize: 'l',
    dataSizeHorizontalView: 'l'
};
// PATH SPECIFIC
const SPECIMEN_SOURCES = {
    key: 'specimen_sources',
    label: 'Primary Specimen Source',
    transformer: 'specimen_sources',
    property: 'specimen_sources',
    dataSize: 'm',
    dataSizeHorizontalView: 'l'
};
const GROUPER = {
    key: 'grouper',
    label: 'Specimen category',
    property: 'grouper',
    dataSize: 'ms',
    dataSizeHorizontalView: 'l'
};
const HAR = {
    key: 'hospital_account_record',
    label: 'Hospital Account Record',
    property: 'hospital_account_record',
    dataSize: 'l',
    dataSizeHorizontalView: 'l'
};
const ENCOUNTER_NUMBER = _object_spread_props$d(_object_spread$h({}, HAR), {
    label: 'Encounter'
});
const PROCESS_ID = {
    key: 'case_json_id',
    label: 'CMX Process ID',
    property: 'case_json_id',
    dataSize: 'ms',
    dataSizeHorizontalView: 'l'
};
const CASE_TYPE = {
    key: 'case_type',
    label: 'Case Type',
    property: 'case_type',
    dataSize: 'ms',
    dataSizeHorizontalView: 'l'
};
const BILLING_AREA = {
    key: 'billing_area',
    label: 'Billing Area',
    property: 'billing_area',
    dataSize: 'ms',
    dataSizeHorizontalView: 'l'
};
const DEPARTMENT = {
    key: 'scheduling_department',
    label: 'Department',
    property: 'scheduling_department',
    dataSize: 'l',
    dataSizeHorizontalView: 'l'
};
// Automate/IPC columns
const FINANCIAL_STATUS_CLASS = {
    key: 'financial_status_class',
    label: 'Financial Status Class',
    property: 'financial_status_class',
    dataSize: 'l',
    dataSizeHorizontalView: 'l',
    fieldType: 'dictionary'
};
const FACILITY = {
    key: 'billing_location',
    label: 'Facility',
    property: 'billing_location',
    dataSize: 'l',
    dataSizeHorizontalView: 'l',
    fieldType: 'dictionary'
};
const PATIENT_CLASS = {
    key: 'patient_class',
    label: 'Patient Class',
    property: 'patient_class',
    dataSize: 'l',
    dataSizeHorizontalView: 'l'
};
const PATIENT_TYPE = {
    key: 'patient_type',
    label: 'Patient Type',
    property: 'patient_type',
    dataSize: 'l',
    dataSizeHorizontalView: 'l',
    fieldType: 'dictionary'
};
const AUTHENTICATOR_PROVIDER = {
    key: 'assigned_document_auth_name',
    label: 'Authenticator',
    property: 'assigned_document_auth_name',
    dataSize: 'ms',
    dataSizeHorizontalView: 'l',
    hasLink: true,
    additionalInfo: [
        {
            property: 'assigned_document_auth_number',
            label: 'providerNumber'
        },
        {
            property: 'facility',
            label: 'tenantCode'
        },
        {
            property: 'assigned_document_auth_name',
            label: 'providerName'
        }
    ]
};
const ADMITTING_PROVIDER = {
    key: 'admitting_provider_name',
    label: 'Admitting Provider',
    property: 'admitting_provider_name',
    dataSize: 'ms',
    dataSizeHorizontalView: 'l',
    hasLink: true,
    additionalInfo: [
        {
            property: 'admitting_provider',
            label: 'providerNumber',
            transformer: 'numerical'
        },
        {
            property: 'facility',
            label: 'tenantCode'
        },
        {
            property: 'admitting_provider_name',
            label: 'providerName'
        }
    ]
};
const SERVICE_LINE = {
    key: 'service_line',
    label: 'Service Line',
    property: 'service_line',
    transformer: 'service_line',
    dataSize: 'l',
    dataSizeHorizontalView: 'l'
};
const HEALTH_SYSTEM = {
    key: 'health_system_code',
    label: 'Health System',
    property: 'health_system_code',
    dataSize: 'l',
    dataSizeHorizontalView: 'l'
};
const ADMISSION_DATE = {
    key: 'admission_datetime',
    label: 'Admission Date',
    property: 'admission_datetime',
    dataSize: 'l',
    dataSizeHorizontalView: 'l',
    transformer: 'date_of_service',
    fieldType: 'date'
};
const DISCHARGE_DATE = {
    key: 'discharge_datetime',
    label: 'Discharge Date',
    property: 'discharge_datetime',
    dataSize: 'l',
    dataSizeHorizontalView: 'l',
    transformer: 'date_of_service',
    fieldType: 'date'
};
const EM_CATEGORY = {
    key: 'em_category',
    label: 'Case E/M Category',
    property: 'em_category',
    dataSize: 'l',
    dataSizeHorizontalView: 'l',
    fieldType: 'dictionary'
};
const AUTHORING_PROVIDER = {
    key: 'authoring_provider_name',
    label: 'Authoring Provider',
    property: 'primary_activity_provider_name',
    dataSize: 'ms',
    dataSizeHorizontalView: 'l',
    hasLink: true,
    additionalInfo: [
        {
            property: 'primary_activity_provider_number',
            label: 'providerNumber'
        },
        {
            property: 'facility',
            label: 'tenantCode'
        },
        {
            property: 'primary_activity_provider_name',
            label: 'providerName'
        }
    ]
};
const FINAL_SIGNING_PROVIDER = {
    key: 'note_final_sign_provider',
    label: 'Final Sign Provider',
    property: 'note_final_sign_provider_name',
    dataSize: 'l',
    dataSizeHorizontalView: 'l',
    hasLink: true,
    additionalInfo: [
        {
            property: 'note_final_sign_provider_number',
            label: 'providerNumber'
        },
        {
            property: 'facility',
            label: 'tenantCode'
        },
        {
            property: 'note_final_sign_provider_name',
            label: 'providerName'
        }
    ]
};
const NOTE_SPECIALTY = {
    key: 'note_specialty_designation',
    label: 'NOTE SPECIALTY',
    property: 'note_specialty_designation',
    dataSize: 'l',
    dataSizeHorizontalView: 'l',
    fieldType: 'dictionary'
};
const AGE = {
    key: 'patient-dob',
    label: 'Age',
    property: 'date_of_birth',
    transformer: 'age',
    dataSize: 'ms',
    dataSizeHorizontalView: 'l'
};
const SCHEDULING_ID = {
    key: 'scheduling_id',
    label: 'SCHEDULING ID',
    property: 'order_filler_number',
    transformer: 'numerical',
    dataSize: 'ms',
    dataSizeHorizontalView: 'l'
};
const OWNER = {
    key: 'owner',
    label: 'CODER',
    property: 'owner',
    dataSize: 'ms',
    dataSizeHorizontalView: 'l'
};
const ASSIGNEE = {
    key: 'assignee',
    label: 'ASSIGNEE',
    property: 'assignee',
    dataSize: 'ms',
    dataSizeHorizontalView: 'l'
};
const AGING_DAYS = {
    key: 'aging_days',
    label: 'AGING DAYS',
    property: 'aging_days',
    dataSize: 'ms',
    dataSizeHorizontalView: 'l'
};
const CODABLE_DAYS = {
    key: 'codable_days',
    label: 'CODABLE DAYS',
    property: 'codable_days',
    dataSize: 'ms',
    dataSizeHorizontalView: 'l'
};
const PATIENT_AGE = {
    key: 'patient_age',
    label: 'Patient Age',
    property: 'patient_age',
    dataSize: 'ms',
    dataSizeHorizontalView: 'l',
    transformer: 'patient_age_by_dos_dob'
};
const ATTENDING_PROVIDER = {
    key: 'attending_provider_name',
    label: 'Attending Provider',
    property: 'attending_provider_name',
    dataSize: 'ms',
    dataSizeHorizontalView: 'l',
    hasLink: true,
    additionalInfo: [
        {
            property: 'attending_provider_number',
            label: 'providerNumber',
            transformer: 'numerical'
        },
        {
            property: 'facility',
            label: 'tenantCode'
        },
        {
            property: 'attending_provider_name',
            label: 'providerName'
        }
    ]
};
const CQA_IMPORT_ID = {
    key: 'import_id',
    label: 'Import ID',
    property: 'import_id',
    dataSize: 'ms',
    dataSizeHorizontalView: 'l'
};
const NEW_OR_ESTABLISHED = {
    key: 'new_or_established',
    label: 'New or Established',
    property: 'new_or_established',
    dataSize: 'ms',
    dataSizeHorizontalView: 'l'
};
// column groups for amplify
const radAmplifyColumns = {
    patient: [
        DOB_AGE_BY_DOS,
        GENDER,
        MRN,
        PRIMARY_INSURANCE
    ],
    summary: [
        ACCESSION,
        EXAM_CODE,
        REASON_FOR_VISIT,
        DOS,
        EXAM_DESCRIPTION,
        ORDERING_PROVIDER,
        ORDERING_PROVIDER_NUMBER,
        ORDER_NUMBER,
        PLACE_OF_SERVICE,
        TENANT_NAME,
        BILLING_AREA,
        BILLING_PROVIDER,
        BILLING_PROVIDER_NUMBER,
        PROCEDURE_TYPE,
        VISIT_NUMBER,
        CASE_ID
    ],
    expanded: []
};
const PatientTimelineColumns = {
    patient: [
        DOB,
        GENDER,
        MRN,
        PRIMARY_INSURANCE
    ],
    summary: [],
    expanded: []
};
const pathAmplifyColumns = {
    patient: [
        ...radAmplifyColumns.patient
    ],
    summary: [
        ACCESSION,
        CASE_TYPE,
        DOS,
        SPECIMEN_SOURCES,
        ORDERING_PROVIDER,
        ORDERING_PROVIDER_NUMBER,
        ORDER_NUMBER,
        _object_spread_props$d(_object_spread$h({}, PLACE_OF_SERVICE), {
            transformer: 'multi_place_of_service'
        }),
        TENANT_NAME,
        BILLING_PROVIDER,
        BILLING_PROVIDER_NUMBER,
        GROUPER,
        ENCOUNTER_NUMBER,
        PROCESS_ID,
        CASE_ID
    ],
    expanded: []
};
const surgicalAmplifyColumns = {
    patient: [
        ...radAmplifyColumns.patient
    ],
    summary: [
        SERVICE_LINE,
        DOS,
        ENCOUNTER_NUMBER,
        NOTE_SPECIALTY,
        ORDER_NUMBER,
        _object_spread_props$d(_object_spread$h({}, PROCEDURE_TYPE_CATEGORY), {
            dataSize: 'ms',
            label: 'Scheduled Description'
        }),
        ADMISSION_DATE,
        DISCHARGE_DATE,
        SCHEDULING_ID,
        FINANCIAL_STATUS_CLASS,
        PATIENT_CLASS,
        PATIENT_TYPE,
        ATTENDING_PROVIDER,
        AUTHENTICATOR_PROVIDER,
        AUTHORING_PROVIDER,
        _object_spread_props$d(_object_spread$h({}, FINAL_SIGNING_PROVIDER), {
            property: 'authentication_person_name'
        }),
        ORDERING_PROVIDER,
        CASE_ID,
        FACILITY,
        DEPARTMENT,
        BILLING_AREA,
        OWNER,
        ASSIGNEE,
        AGING_DAYS,
        CODABLE_DAYS,
        PATIENT_AGE
    ],
    expanded: []
};
const ipcAmplifyColumns = {
    patient: [
        DOB_AGE_BY_DOS,
        GENDER,
        MRN,
        PRIMARY_INSURANCE
    ],
    summary: [
        HAR,
        DOS,
        ADMISSION_DATE,
        DISCHARGE_DATE,
        PATIENT_TYPE,
        FINANCIAL_STATUS_CLASS,
        NOTE_SPECIALTY,
        //SERVICE_PROVIDER,
        AUTHORING_PROVIDER,
        AUTHENTICATOR_PROVIDER,
        FINAL_SIGNING_PROVIDER,
        ADMITTING_PROVIDER,
        DEPARTMENT,
        ORDERING_PROVIDER,
        FACILITY,
        CASE_ID,
        OWNER,
        ASSIGNEE,
        PATIENT_CLASS,
        SERVICE_LINE,
        SCHEDULING_ID,
        EM_CATEGORY,
        AGING_DAYS,
        CODABLE_DAYS,
        ATTENDING_PROVIDER
    ],
    expanded: []
};
const PatientAmplifyEncounterColumns = {
    radiology: radAmplifyColumns,
    pathology: pathAmplifyColumns,
    surgery: surgicalAmplifyColumns,
    inpatientprofessionalcoding: ipcAmplifyColumns
};
// column groups for accelerate
const radDashboardColumns = {
    patient: [
        DOB,
        GENDER,
        MRN,
        PRIMARY_INSURANCE
    ],
    summary: [
        ACCESSION,
        EXAM_CODE,
        REASON_FOR_VISIT,
        DOS,
        EXAM_DESCRIPTION,
        ORDERING_PROVIDER,
        ORDERING_PROVIDER_NUMBER,
        ORDER_NUMBER,
        PLACE_OF_SERVICE,
        TENANT_NAME,
        BILLING_AREA,
        BILLING_PROVIDER,
        BILLING_PROVIDER_NUMBER,
        PROCEDURE_TYPE,
        VISIT_NUMBER,
        CASE_ID
    ],
    expanded: []
};
const pathDashboardColumns = {
    patient: [
        ...radDashboardColumns.patient
    ],
    summary: [
        ACCESSION,
        CASE_TYPE,
        DOS,
        SPECIMEN_SOURCES,
        ORDERING_PROVIDER,
        ORDERING_PROVIDER_NUMBER,
        ORDER_NUMBER,
        _object_spread_props$d(_object_spread$h({}, PLACE_OF_SERVICE), {
            transformer: 'multi_place_of_service'
        }),
        TENANT_NAME,
        BILLING_PROVIDER,
        BILLING_PROVIDER_NUMBER,
        GROUPER,
        ENCOUNTER_NUMBER,
        PROCESS_ID,
        CASE_ID
    ],
    expanded: []
};
const surgicalDashboardColumns = {
    patient: [
        ...radDashboardColumns.patient
    ],
    summary: [
        SERVICE_LINE,
        DOS,
        ENCOUNTER_NUMBER,
        NOTE_SPECIALTY,
        ORDER_NUMBER,
        _object_spread_props$d(_object_spread$h({}, PROCEDURE_TYPE_CATEGORY), {
            dataSize: 'ms',
            label: 'Scheduled Description'
        }),
        ADMISSION_DATE,
        DISCHARGE_DATE,
        SCHEDULING_ID,
        FINANCIAL_STATUS_CLASS,
        PATIENT_CLASS,
        PATIENT_TYPE,
        ATTENDING_PROVIDER,
        AUTHENTICATOR_PROVIDER,
        AUTHORING_PROVIDER,
        _object_spread_props$d(_object_spread$h({}, FINAL_SIGNING_PROVIDER), {
            property: 'authentication_person_name'
        }),
        ORDERING_PROVIDER,
        CASE_ID,
        FACILITY,
        DEPARTMENT,
        BILLING_AREA,
        PATIENT_AGE
    ],
    expanded: []
};
const ipcDashboardColumns = {
    patient: [
        DOB_AGE_BY_DOS,
        GENDER,
        MRN,
        PRIMARY_INSURANCE
    ],
    summary: [
        HAR,
        DOS,
        ADMISSION_DATE,
        DISCHARGE_DATE,
        PATIENT_TYPE,
        FINANCIAL_STATUS_CLASS,
        NOTE_SPECIALTY,
        //SERVICE_PROVIDER,
        AUTHORING_PROVIDER,
        AUTHENTICATOR_PROVIDER,
        FINAL_SIGNING_PROVIDER,
        ADMITTING_PROVIDER,
        DEPARTMENT,
        ORDERING_PROVIDER,
        FACILITY,
        CASE_ID,
        OWNER,
        ASSIGNEE,
        PATIENT_CLASS,
        SERVICE_LINE,
        SCHEDULING_ID,
        EM_CATEGORY,
        AGING_DAYS,
        CODABLE_DAYS,
        ATTENDING_PROVIDER
    ],
    expanded: []
};
const PatientEncounterDashboardColumns = {
    radiology: radDashboardColumns,
    pathology: pathDashboardColumns,
    surgery: surgicalDashboardColumns,
    inpatientprofessionalcoding: ipcDashboardColumns,
    patientTimeline: PatientTimelineColumns
};
// The encounter column reads from codebench.activeItem since this section is shared with the code bench
// Therefore the property is in snake case rather than camel case
const PatientEncounterGradeBenchColumns = {
    patient: [],
    summary: [
        _object_spread_props$d(_object_spread$h({}, DOS), {
            transformer: 'age_on_date_of_service',
            label: 'Age on Date of Service'
        }),
        GLOBAL_PERIOD,
        GENDER,
        PRIMARY_INSURANCE,
        HAR,
        _object_spread_props$d(_object_spread$h({}, PATIENT_CLASS), {
            fieldType: undefined
        }),
        _object_spread_props$d(_object_spread$h({}, FACILITY), {
            property: 'facility',
            key: 'facility',
            fieldType: undefined
        }),
        HEALTH_SYSTEM,
        SERVICE_LINE,
        _object_spread_props$d(_object_spread$h({}, REASON_FOR_VISIT), {
            property: 'visit_reason',
            key: 'visit_reason',
            dataSize: 'l'
        }),
        PROCESS_ID,
        CQA_IMPORT_ID,
        _object_spread_props$d(_object_spread$h({}, CASE_ID), {
            label: 'Case ID',
            key: 'sd_case_id',
            property: 'sd_case_id'
        }),
        _object_spread_props$d(_object_spread$h({}, SPECIMEN_SOURCES), {
            defaultHide: true
        }),
        _object_spread_props$d(_object_spread$h({}, EXAM_DESCRIPTION), {
            property: 'exam_description',
            key: 'exam_description'
        }),
        AGE,
        NEW_OR_ESTABLISHED
    ],
    expanded: []
};

function _define_property$h(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$g(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$h(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$c(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$c(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$c(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const superBasicActivityFormatter = (activity)=>`${activity.username} ${activity.actionType} ${activity.code}`;
const convertActivityToTimeline = (activity, activityFormattersMap = {})=>{
    // convert to a localized day so that we can group items
    const pregrouped = activity === null || activity === void 0 ? void 0 : activity.map((activity)=>{
        const day = format(activity.timestamp, FORMATS.DATE);
        return _object_spread_props$c(_object_spread$g({}, activity), {
            day
        });
    });
    // group items
    const grouped = groupBy(pregrouped, 'day');
    // get a sorted list of days
    const days = Object.keys(grouped).sort().reverse();
    // working by day, format all the items into
    // a timeline item
    const timelineItems = days === null || days === void 0 ? void 0 : days.map((day)=>{
        const groupedItems = grouped[day];
        const titles = groupedItems === null || groupedItems === void 0 ? void 0 : groupedItems.map((item)=>{
            const formatter = activityFormattersMap[item === null || item === void 0 ? void 0 : item.activityType];
            return formatter ? formatter(item) : superBasicActivityFormatter(item);
        });
        const item = {
            key: day,
            tiles: [
                {
                    subtitle: format(groupedItems[0].timestamp, FORMATS.LONG_DATE),
                    titles
                }
            ]
        };
        return item;
    });
    return timelineItems;
};

var activity = /*#__PURE__*/Object.freeze({
  __proto__: null,
  convertActivityToTimeline: convertActivityToTimeline
});

const { FieldType } = commonEnums$1;
const GripIcon$1 = {
    key: 'gripper',
    path: [],
    readonly: false,
    width: 'minmax(min-content, 10%)',
    value: null,
    svgIconName: 'BiomeGripperSVG20',
    svgIconSize: '20',
    svgIconClass: 'gripper',
    classNames: [
        'units-column',
        'code-gripper',
        'gripper'
    ],
    fieldType: FieldType.Icon
};
const unitIsNotOriginal = {
    path: [
        'original'
    ],
    isNot: null // true to disable for original codes, false to disable for nonOriginal, null to allow both
};
const assessmentIsAdditionalUnits = {
    path: [
        'codeAssessment',
        'assessment'
    ],
    is: 'ADDITIONAL UNIT OF CODED CPT'
};
const UnitCount$1 = {
    key: 'units',
    path: [
        'units'
    ],
    readonly: false,
    width: 'minmax(min-content, 10%)',
    classNames: [
        [
            'code-units-input'
        ],
        [
            'units-column',
            'code-units-populateable',
            'prevent-click'
        ],
        [
            'case-units-numeral'
        ]
    ],
    displayName: null,
    fieldType: FieldType.TextInput,
    validateInputString: '^\\d+$',
    inputEnableRules: [
        unitIsNotOriginal,
        assessmentIsAdditionalUnits
    ]
};
const codeClassNames = [
    'codes-column'
];
const CPTCode$1 = {
    codeType: ChargeSessionCodeType$1.PROCEDURE,
    key: 'code',
    path: [
        'code'
    ],
    readonly: false,
    width: 'minmax(min-content, 20%)',
    fieldType: FieldType.Code,
    onCodeDelete: (value)=>{},
    classNames: codeClassNames
};
const ICDCode$1 = {
    codeType: ChargeSessionCodeType$1.DIAGNOSIS,
    key: 'code',
    path: [
        'code'
    ],
    readonly: false,
    width: 'minmax(min-content, 20%)',
    fieldType: FieldType.Code,
    onCodeDelete: (value)=>{},
    classNames: codeClassNames
};
const ModifierCode$1 = {
    codeType: ChargeSessionCodeType$1.MODIFIER,
    key: 'code',
    path: [
        'code'
    ],
    readonly: false,
    width: 'minmax(min-content, 20%)',
    fieldType: FieldType.Code,
    onCodeDelete: (value)=>{},
    classNames: codeClassNames
};
const defaultAssessmentOptionsTreePath = [
    [
        'original'
    ]
];
const modifierAssessmentOptionsTreePath = [
    [
        'code'
    ],
    [
        'original'
    ]
];
const AssesmentSelect$1 = {
    key: 'assessment',
    path: [
        'codeAssessment',
        'assessment'
    ],
    readonly: false,
    width: '1fr',
    defaultOptions: [],
    optionsPath: 'assessmentOptions',
    placeholder: 'Select Assessment',
    onSelect: (value)=>{},
    fieldType: FieldType.SelectList,
    rerenderFields: [
        'id',
        'code',
        'sequenceNumber'
    ],
    optionsTreePath: defaultAssessmentOptionsTreePath
};
const roleOptionsTreePath = [
    [
        'codeAssessment',
        'assessment'
    ]
];
const modifierRoleOptionsTreePath = [
    [
        'code'
    ],
    [
        'codeAssessment',
        'assessment'
    ]
];
const RoleSelect$1 = {
    key: 'role',
    path: [
        'codeAssessment',
        'role'
    ],
    readonly: false,
    width: '1fr',
    defaultOptions: [],
    optionsPath: 'roleOptions',
    placeholder: 'Select Role',
    onSelect: (value)=>{},
    fieldType: FieldType.SelectList,
    optionsTreePath: roleOptionsTreePath,
    rerenderFields: [
        'id',
        'code',
        'sequenceNumber'
    ]
};
const Icon = {
    key: 'check',
    path: [
        'check'
    ],
    readonly: false,
    width: 'minmax(50px, 10%)',
    value: null,
    svgIconName: 'BiomeCheckSVG20',
    svgIconSize: '20',
    svgIconClass: 'check',
    classNames: [],
    fieldType: FieldType.Icon,
    optionsTree: {}
};
const BaseCQACodeAssessmentIcon$1 = {
    key: 'baseCQACodeAssessmentIcon',
    path: [
        ''
    ],
    readonly: false,
    width: '0fr',
    value: null,
    svgIconName: '',
    svgIconSize: '16',
    svgIconClass: '',
    classNames: [
        'assessment-icon-container'
    ],
    fieldType: FieldType.Icon,
    optionsTree: {}
};

var CommonFields = /*#__PURE__*/Object.freeze({
  __proto__: null,
  AssesmentSelect: AssesmentSelect$1,
  BaseCQACodeAssessmentIcon: BaseCQACodeAssessmentIcon$1,
  CPTCode: CPTCode$1,
  GripIcon: GripIcon$1,
  ICDCode: ICDCode$1,
  Icon: Icon,
  ModifierCode: ModifierCode$1,
  RoleSelect: RoleSelect$1,
  UnitCount: UnitCount$1,
  defaultAssessmentOptionsTreePath: defaultAssessmentOptionsTreePath,
  modifierAssessmentOptionsTreePath: modifierAssessmentOptionsTreePath,
  modifierRoleOptionsTreePath: modifierRoleOptionsTreePath
});

function _define_property$g(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
const CHANNEL_NAME = 'cmx-auth-token-request';
let requestCounter = 0;
class TokenRequestChannel {
    /** Provide the Redux store so the listener can include context state in responses. */ setStore(store) {
        this.store = store;
    }
    /** Start listening for TOKEN_REQUEST messages from peer tabs. */ startListening() {
        if (this.channel) {
            return; // already listening
        }
        try {
            this.channel = new BroadcastChannel(CHANNEL_NAME);
        } catch (unused) {
            return; // BroadcastChannel not supported
        }
        this.channel.onmessage = (event)=>{
            var _ref, _ref1;
            var _this_store, _state_ui, _state_ui1, _this_channel;
            const data = event.data;
            if ((data === null || data === void 0 ? void 0 : data.type) !== AuthToken.REQUEST) {
                return;
            }
            const token = getToken();
            if (!token) {
                return; // not authenticated — don't respond
            }
            const auth = getAuthorization();
            const state = (_this_store = this.store) === null || _this_store === void 0 ? void 0 : _this_store.getState();
            const response = {
                type: AuthToken.RESPONSE,
                requestId: data.requestId,
                authorization: {
                    token: auth.token,
                    contextId: auth.contextId,
                    expiryTimeToLive: auth.expiryTimeToLive,
                    context: (_ref = state === null || state === void 0 ? void 0 : (_state_ui = state.ui) === null || _state_ui === void 0 ? void 0 : _state_ui.context) !== null && _ref !== void 0 ? _ref : undefined,
                    activeUser: (_ref1 = state === null || state === void 0 ? void 0 : (_state_ui1 = state.ui) === null || _state_ui1 === void 0 ? void 0 : _state_ui1.activeUser) !== null && _ref1 !== void 0 ? _ref1 : undefined
                }
            };
            (_this_channel = this.channel) === null || _this_channel === void 0 ? void 0 : _this_channel.postMessage(response);
        };
    }
    /** Stop listening and close the channel. */ stopListening() {
        if (this.channel) {
            this.channel.close();
            this.channel = null;
        }
    }
    /**
   * Broadcast a TOKEN_REQUEST and wait for a TOKEN_RESPONSE from an
   * authenticated peer tab. Resolves with the authorization object or
   * null if no response within the timeout.
   */ static request(timeoutMs = 2000) {
        let channel;
        try {
            channel = new BroadcastChannel(CHANNEL_NAME);
        } catch (unused) {
            return Promise.resolve(null); // BroadcastChannel not supported
        }
        const requestId = `req-${++requestCounter}-${Date.now()}`;
        return new Promise((resolve)=>{
            let settled = false;
            const cleanup = ()=>{
                if (!settled) {
                    settled = true;
                    channel.onmessage = null;
                    channel.close();
                }
            };
            const timer = setTimeout(()=>{
                cleanup();
                resolve(null);
            }, timeoutMs);
            channel.onmessage = (event)=>{
                var _data_authorization;
                const data = event.data;
                if ((data === null || data === void 0 ? void 0 : data.type) !== AuthToken.RESPONSE || data.requestId !== requestId || !((_data_authorization = data.authorization) === null || _data_authorization === void 0 ? void 0 : _data_authorization.token)) {
                    return; // not our response, or empty token
                }
                clearTimeout(timer);
                cleanup();
                resolve(data.authorization);
            };
            const request = {
                type: AuthToken.REQUEST,
                requestId
            };
            channel.postMessage(request);
        });
    }
    constructor(){
        _define_property$g(this, "channel", null);
        _define_property$g(this, "store", null);
    }
}

/// <reference path="../types.d.ts" /
const defaultEula = {
    userId: -1,
    acceptedDate: null,
    organizationId: -1,
    eulaId: null,
    text: ''
};
const eula$1 = {
    eula: defaultEula,
    isCancelled: false
};

function _define_property$f(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$f(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$f(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$b(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$b(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$b(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const { GripIcon, UnitCount, CPTCode, ICDCode, ModifierCode, AssesmentSelect, RoleSelect, BaseCQACodeAssessmentIcon } = CommonFields;
const CPTCodeSection = [
    //Draggable icon
    GripIcon,
    //Units input
    UnitCount,
    //Code Pill
    CPTCode,
    //Dropdown 1
    _object_spread$f({}, AssesmentSelect),
    //Dropdown 2
    _object_spread$f({}, RoleSelect),
    // UI treatment for assessment/role
    BaseCQACodeAssessmentIcon
];
const ICDCodeSection = [
    //Draggable icon
    GripIcon,
    //Code Pill
    ICDCode,
    //Dropdown 1
    _object_spread$f({}, AssesmentSelect),
    //Dropdown 2
    _object_spread$f({}, RoleSelect),
    // UI treatment for assessment/role
    BaseCQACodeAssessmentIcon
];
const ModifierCodeSection = [
    //Draggable icon
    GripIcon,
    //Code Pill
    ModifierCode,
    //Dropdown 1
    _object_spread_props$b(_object_spread$f({}, AssesmentSelect), {
        optionsTreePath: modifierAssessmentOptionsTreePath
    }),
    //Dropdown 2
    _object_spread_props$b(_object_spread$f({}, RoleSelect), {
        optionsTreePath: modifierRoleOptionsTreePath
    }),
    // UI treatment for assessment/role
    BaseCQACodeAssessmentIcon
];
const CodeGradingSections = {
    CPTCodeSection,
    ICDCodeSection,
    ModifierCodeSection
};
const defaultCQAProjectConfiguration = {
    procedure: true,
    diagnosis: true,
    modifier: true,
    assessment: true,
    role: true,
    caseEvaluationLevel: false
};
const defaultQARule = {
    id: '1',
    source: '1',
    status: '1',
    data: {
        qa_collection_id: null,
        qa_collection_uuid: null,
        id: 1,
        guideline: null,
        sample_reason: null,
        project_configuration: defaultCQAProjectConfiguration
    }
};
const gradeBenchPanelState = {
    invoices: [],
    fieldDefinitions: {
        cptFields: CPTCodeSection,
        icdFields: ICDCodeSection,
        modifierFields: ModifierCodeSection
    },
    riskCategories: {
        [ChargeSessionCodeType$1.PROCEDURE]: {},
        [ChargeSessionCodeType$1.DIAGNOSIS]: {},
        [ChargeSessionCodeType$1.MODIFIER]: {}
    },
    qaRule: defaultQARule,
    gradingErrors: {
        addTransaction: false
    },
    cqaCodeAssessmentRiskDictionaries: {
        procedure: {
            columnNames: [],
            rows: []
        },
        diagnosis: {
            columnNames: [],
            rows: []
        },
        modifier: {
            columnNames: [],
            rows: []
        }
    },
    associatedWorkitems: [],
    workerInfo: null,
    activity: [],
    looseSpans: [],
    codeDescriptions: {},
    rubricVersion: null,
    caseAttributes: [],
    attributesFetched: false,
    attributesFetchError: false,
    validationResult: null,
    resolverValidationErrors: null,
    caseLevelComplete: null,
    pendingAutosaves: {},
    attributeLatestRequestId: {},
    pendingSpanNavId: null,
    codeCompletion: {},
    manualActiveCodeId: null
};

var index$7 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  defaultEula: defaultEula,
  defaultQARule: defaultQARule,
  eula: eula$1
});

function _define_property$e(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$e(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$e(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$a(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$a(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$a(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const PROVIDER_STUB = {
    active: false,
    degree: '',
    displayName: '',
    identifiers: [],
    id: -1,
    providerUid: '',
    firstName: '',
    middleName: '',
    lastName: '',
    email: '',
    prefix: '',
    suffix: '',
    providerType: '',
    pager: '',
    isPcpProvider: false,
    encounterId: '',
    providerServiceLocation: '',
    locations: [],
    specialties: [],
    subspecialties: []
};
const IDENTIFIER_STUB = {
    id: -1,
    idNumber: '-1',
    idTypeCode: 'EPIC',
    identifierType: 'IDNO',
    checkDigit: null,
    checkDigitScheme: null,
    assigningAuthority: {
        id: -1,
        guid: {
            uuid: ''
        },
        name: null,
        description: null,
        namespaceId: '',
        universalId: null,
        universalIdType: null,
        defaultIssuer: false,
        assigningFacility: null
    },
    entityId: null,
    entityType: null,
    primary: true
};
const convert = (xcProvider, isIPC, isPathology = false)=>{
    return _object_spread_props$a(_object_spread$e({}, PROVIDER_STUB), {
        active: xcProvider.status === 'ACTIVE',
        displayName: xcProvider.prov_name,
        degree: xcProvider.prov_cred,
        identifiers: [
            _object_spread_props$a(_object_spread$e({}, IDENTIFIER_STUB), {
                identifierType: isIPC ? 'PROVID' : isPathology ? 'EPIC' : 'IDNO',
                idNumber: xcProvider.prov_id
            })
        ]
    });
};
const convertIPC = (xcProvider, isBillableSelectable, isSelectable = true)=>{
    return _object_spread_props$a(_object_spread$e({}, PROVIDER_STUB), {
        displayName: xcProvider.provider_name,
        degree: xcProvider.prov_cred,
        identifiers: [
            _object_spread_props$a(_object_spread$e({}, IDENTIFIER_STUB), {
                identifierType: 'PROVID',
                idNumber: xcProvider.provider_id
            })
        ],
        specialties: xcProvider.specialties,
        isBillableSelectable,
        isSelectable
    });
};
const convertXcaliberEntitiesToCMX = (providers, isIPC = false, isPathology = false)=>{
    return providers.map((provider)=>convert(provider, isIPC, isPathology));
};
const convertXcaliberEntitiesToIPC = (providers, isBillableSelectable, shouldFilterActive = false, shouldFilterOutExternalProviders = false, shouldGreyOutExternalProviders = false, providerType, roleTypeConfig)=>{
    const isPerformigProviderSearch = providerType === ProviderType$1.PERFORMING_PROVIDER;
    const isMatchingRole = (specialty)=>{
        return roleTypeConfig.some((role)=>{
            var _role_ProviderRoleType, _specialty_name;
            return (role === null || role === void 0 ? void 0 : (_role_ProviderRoleType = role['Provider Role Type']) === null || _role_ProviderRoleType === void 0 ? void 0 : _role_ProviderRoleType.toLowerCase()) === (specialty === null || specialty === void 0 ? void 0 : (_specialty_name = specialty.name) === null || _specialty_name === void 0 ? void 0 : _specialty_name.toLowerCase()) && (role === null || role === void 0 ? void 0 : role['Performing Eligible']) === 'T';
        });
    };
    const filters = [];
    if (shouldFilterActive) {
        filters.push((provider)=>(provider === null || provider === void 0 ? void 0 : provider.active) === 'true');
    }
    if (shouldFilterOutExternalProviders) {
        filters.push((provider)=>!isExternalProvider(provider));
    }
    let filteredProviders = [
        ...providers
    ];
    filters.forEach((providerFilter)=>{
        filteredProviders = filteredProviders.filter(providerFilter);
    });
    return filteredProviders.map((provider)=>{
        var _ref;
        const specialties = (_ref = provider === null || provider === void 0 ? void 0 : provider.specialties) !== null && _ref !== void 0 ? _ref : [];
        const hasIncludedRole = isPerformigProviderSearch ? specialties.some(isMatchingRole) : true;
        let isSelectable = (shouldGreyOutExternalProviders ? !isExternalProvider(provider) : true) && hasIncludedRole;
        return convertIPC(provider, isBillableSelectable, isSelectable);
    });
};
const isExternalProvider = (provider)=>{
    var _ref;
    var _provider_specialties;
    return (_ref = provider === null || provider === void 0 ? void 0 : (_provider_specialties = provider.specialties) === null || _provider_specialties === void 0 ? void 0 : _provider_specialties.every((specialty)=>{
        var _specialty_report_grouper_six_toLowerCase, _specialty_report_grouper_six, _specialty_report_grouper_six_toLowerCase1, _specialty_report_grouper_six1, _specialty_employment_designation_toLowerCase, _specialty_employment_designation, _specialty_employment_designation_toLowerCase1, _specialty_employment_designation1;
        return (specialty === null || specialty === void 0 ? void 0 : (_specialty_report_grouper_six = specialty.report_grouper_six) === null || _specialty_report_grouper_six === void 0 ? void 0 : (_specialty_report_grouper_six_toLowerCase = _specialty_report_grouper_six.toLowerCase()) === null || _specialty_report_grouper_six_toLowerCase === void 0 ? void 0 : _specialty_report_grouper_six_toLowerCase.includes('external provider')) || (specialty === null || specialty === void 0 ? void 0 : (_specialty_report_grouper_six1 = specialty.report_grouper_six) === null || _specialty_report_grouper_six1 === void 0 ? void 0 : (_specialty_report_grouper_six_toLowerCase1 = _specialty_report_grouper_six1.toLowerCase()) === null || _specialty_report_grouper_six_toLowerCase1 === void 0 ? void 0 : _specialty_report_grouper_six_toLowerCase1.includes('external physician')) || (specialty === null || specialty === void 0 ? void 0 : (_specialty_employment_designation = specialty.employment_designation) === null || _specialty_employment_designation === void 0 ? void 0 : (_specialty_employment_designation_toLowerCase = _specialty_employment_designation.toLowerCase()) === null || _specialty_employment_designation_toLowerCase === void 0 ? void 0 : _specialty_employment_designation_toLowerCase.includes('external provider')) || (specialty === null || specialty === void 0 ? void 0 : (_specialty_employment_designation1 = specialty.employment_designation) === null || _specialty_employment_designation1 === void 0 ? void 0 : (_specialty_employment_designation_toLowerCase1 = _specialty_employment_designation1.toLowerCase()) === null || _specialty_employment_designation_toLowerCase1 === void 0 ? void 0 : _specialty_employment_designation_toLowerCase1.includes('external physician'));
    })) !== null && _ref !== void 0 ? _ref : false;
};

/**
 * The typeahead cache provides the ability for a response to check
 * if it is the latest in a response chain.
 */ //  -----------------------------------
//  Private vars/functions
//  -----------------------------------
const DOES_NOT_EXIST = -1;
//  -----------------------------------
//  Ledger
//  -----------------------------------
const ledgers = {};
const ledgerFactory = (namespace, hashFn)=>{
    const ledger = {
        setMax: (item)=>{
            var _ref;
            var _ledgers_namespace;
            const identifier = hashFn(item);
            const ledgerMax = (_ref = (_ledgers_namespace = ledgers[namespace]) === null || _ledgers_namespace === void 0 ? void 0 : _ledgers_namespace[identifier]) !== null && _ref !== void 0 ? _ref : DOES_NOT_EXIST;
            const max = Math.max(ledgerMax, item.meta.sequenceNumber);
            if (max > item.meta.sequenceNumber) {
                throw new Error(`max: ${max} already higher than ${item.meta.sequenceNumber}`);
            }
            ledgers[namespace][identifier] = max;
        },
        getMax: (item)=>{
            const identifier = hashFn(item);
            if (!(identifier in ledgers[namespace])) {
                return DOES_NOT_EXIST;
            }
            return ledgers[namespace][identifier];
        },
        isMax: (item)=>{
            const identifier = hashFn(item);
            if (!(identifier in ledgers[namespace])) {
                ledgers[namespace][identifier] = item.meta.sequenceNumber;
                return true;
            }
            return Math.max(ledgers[namespace][identifier], item.meta.sequenceNumber) <= item.meta.sequenceNumber;
        }
    };
    ledgers[namespace] = ledger;
    return ledger;
};
//  -----------------------------------
//  Memory Cache
//  There's really only cache implementation and that's memory backed for now.
//  In the future, we may have caches which are backed by local storage or remote.
//  -----------------------------------
const memoryCacheMap = {};
const ensureCache = (namespace, identifier)=>{
    memoryCacheMap[namespace] = memoryCacheMap[namespace] || {};
    memoryCacheMap[namespace][identifier] = memoryCacheMap[namespace][identifier] || {};
};
const memoryCacheFactory = (namespace, hashFunction, ledger)=>{
    return {
        save: (item)=>{
            const identifier = hashFunction(item);
            ensureCache(namespace, identifier);
            memoryCacheMap[namespace][identifier][item.meta.sequenceNumber] = item;
        },
        fetch: (item)=>{
            const identifier = hashFunction(item);
            ensureCache(namespace, identifier);
            const max = ledger.getMax(item);
            return memoryCacheMap[namespace][identifier][max];
        }
    };
};
//  -----------------------------------
//  Public API
//  -----------------------------------
const caches$1 = {};
/**
 * Retrieves or builds a cache for a namespace if not present.
 * @param cacheNamespace A signifier for the managed responses
 * @param hashFn {CacheHashFunction}
 * @returns {CacheAPI}
 */ const getCache = (cacheNamespace, hashFn)=>{
    if (!caches$1[cacheNamespace]) {
        const ledger = ledgers[cacheNamespace] = ledgerFactory(cacheNamespace, hashFn);
        const memoryCache = memoryCacheFactory(cacheNamespace, hashFn, ledger);
        const set = (item)=>{
            // save all responses
            memoryCache.save(item);
            if (ledger.isMax(item)) {
                ledger.setMax(item);
            }
        };
        const cache = {
            isLatest: (item)=>{
                return ledger.isMax(item);
            },
            getLatest: (item)=>{
                var _memoryCache_fetch;
                set(item);
                const latest = (_memoryCache_fetch = memoryCache.fetch(item)) !== null && _memoryCache_fetch !== void 0 ? _memoryCache_fetch : item;
                return latest ? latest : item;
            },
            // exposed for convenience/testing
            destroy: ()=>{
                delete caches$1[cacheNamespace];
            }
        };
        caches$1[cacheNamespace] = cache;
    }
    return caches$1[cacheNamespace];
};

var typeaheadCache = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getCache: getCache
});

const hashCodeSearches = (response)=>{
    const { searchId } = response.meta;
    const { searchType } = response.codeQuery;
    return `${searchId}:${searchType}`;
};
const hashProviderSearches = (response)=>{
    const { searchType, providerType } = response.meta;
    return `${providerType}:${searchType}`;
};
const searchCache = getCache('codeSearch', hashCodeSearches);
const providerSearchCache = getCache('providerSearch', hashProviderSearches);

var caches = /*#__PURE__*/Object.freeze({
  __proto__: null,
  hashCodeSearches: hashCodeSearches,
  hashProviderSearches: hashProviderSearches,
  providerSearchCache: providerSearchCache,
  searchCache: searchCache
});

const formErrors$1 = {
    status: '',
    message: null,
    errors: [],
    fieldErrors: {}
};
const invoiceMetadata$1 = {
    // billing area options are currently unused, but it is anticipated that they
    // will be used in the future.  pbc 9/8/2022.
    billingAreaOptions: [],
    billingProviderSearchResults: [],
    referringProviderSearchResults: [],
    performingProviderSearchResults: [],
    organization: null,
    processInstance: null,
    displayMode: null,
    invoice: null,
    formErrors: formErrors$1,
    providerRoleTypeConfig: [],
    useProviderDirectoryLocations: {
        on: false
    },
    invoiceOptions: {
        invoices: [],
        required_fields: [],
        summary: {
            departments: {},
            fee_schedules: {},
            all_departments: [],
            existing_departments: []
        }
    }
};

const ampUI = {
    contextParams: {},
    epicToken: '',
    confirm: {
        title: 'Remove Transaction',
        display: false
    },
    UIMode: null,
    UIView: UIViewEnum.AUTOMATE,
    coderConfig: []
};

function _define_property$d(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$d(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$d(target, key, source[key]);
        });
    }
    return target;
}
const LAUNCH_PARAMS = {
    launchPoint: null,
    patientIdentifier: null,
    providerID: null,
    providerName: null,
    serviceDate: null,
    transactionIds: null,
    uclIds: null,
    visitNumber: null
};
const launch = {
    text: 'Starting CodaMetrix...',
    launchParams: _object_spread$d({}, LAUNCH_PARAMS)
};

const STUB_ORG_CONTEXT = {
    organizationId: 0,
    organizationName: '',
    organizationCode: '',
    organizationType: '',
    tenantId: '',
    parentLevel: 1,
    healthSystemTenantId: '',
    healthSystemCode: '',
    healthSystemName: '',
    displayName: '',
    cognitoEnabled: false,
    resources: [],
    serviceLines: []
};

function _define_property$c(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$c(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$c(target, key, source[key]);
        });
    }
    return target;
}
const improvements$1 = {
    userContext: _object_spread$c({}, STUB_ORG_CONTEXT),
    improvements: [],
    searchResults: [],
    providerSearchResults: [],
    procedureSearchResults: [],
    dictionaryValues: {
        numRows: 0,
        columnNames: [],
        rowValues: []
    }
};

function _define_property$b(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$b(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$b(target, key, source[key]);
        });
    }
    return target;
}
const baseCapability = {
    on: {
        value: false,
        reasons: []
    },
    actionable: {
        value: false,
        reasons: []
    }
};
const holdCase = {
    hold_reason: '',
    comment: '',
    coding_manager_id: ''
};
const cursorAPIContext = {
    worklistContext: {},
    servicedeskMode: false,
    workitemId: '',
    sessionId: '',
    qaCollectionUuid: '',
    launchConfigServiceLine: ''
};
const baseCapabilities = {
    noteUnavailableReason: _object_spread$b({}, baseCapability),
    coding: _object_spread$b({}, baseCapability),
    improvements: _object_spread$b({}, baseCapability),
    pagination: _object_spread$b({}, baseCapability),
    actionMenuCancelButton: _object_spread$b({}, baseCapability),
    submitCase: _object_spread$b({}, baseCapability),
    viewOnlyCase: _object_spread$b({}, baseCapability),
    holdCase: _object_spread$b({}, baseCapability),
    removeHoldCase: _object_spread$b({}, baseCapability),
    toggleCaseComment: _object_spread$b({}, baseCapability),
    toggleChargeableCase: _object_spread$b({}, baseCapability),
    caseEdit: _object_spread$b({}, baseCapability),
    actionMenu: _object_spread$b({}, baseCapability),
    generalCancelButton: _object_spread$b({}, baseCapability),
    improvementsAction: _object_spread$b({}, baseCapability),
    productivityTracker: _object_spread$b({}, baseCapability),
    oldCaseLoadedAlert: _object_spread$b({}, baseCapability),
    previousSentCaseAlert: _object_spread$b({}, baseCapability),
    servicedeskAction: _object_spread$b({}, baseCapability),
    mergeCapability: _object_spread$b({}, baseCapability),
    splitCapability: _object_spread$b({}, baseCapability),
    createCase: _object_spread$b({}, baseCapability),
    coderFeedback: _object_spread$b({}, baseCapability),
    timelineInfiniteLoad: _object_spread$b({}, baseCapability),
    attachDocs: _object_spread$b({}, baseCapability),
    diagnosisCodeSuggestion: _object_spread$b({}, baseCapability),
    coderNotes: _object_spread$b({}, baseCapability),
    actionBarSelectMultipleWorkitems: _object_spread$b({}, baseCapability),
    viewScoreDetail: _object_spread$b({}, baseCapability)
};
const capabilities$1 = {
    userContext: _object_spread$b({}, STUB_ORG_CONTEXT),
    roles: [],
    holdCaseStatus: _object_spread$b({}, holdCase),
    cursorAPIContext: _object_spread$b({}, cursorAPIContext),
    parentCaserunUid: null,
    parentCase: false,
    activeItem: {},
    submitInProgress: false,
    activeServiceLineName: '',
    capabilities: {
        noteUnavailableReason: _object_spread$b({}, baseCapability),
        coding: _object_spread$b({}, baseCapability),
        improvements: _object_spread$b({}, baseCapability),
        pagination: _object_spread$b({}, baseCapability),
        actionMenuCancelButton: _object_spread$b({}, baseCapability),
        submitCase: _object_spread$b({}, baseCapability),
        viewOnlyCase: _object_spread$b({}, baseCapability),
        holdCase: _object_spread$b({}, baseCapability),
        removeHoldCase: _object_spread$b({}, baseCapability),
        toggleCaseComment: _object_spread$b({}, baseCapability),
        toggleChargeableCase: _object_spread$b({}, baseCapability),
        caseEdit: _object_spread$b({}, baseCapability),
        actionMenu: _object_spread$b({}, baseCapability),
        generalCancelButton: _object_spread$b({}, baseCapability),
        improvementsAction: _object_spread$b({}, baseCapability),
        productivityTracker: _object_spread$b({}, baseCapability),
        oldCaseLoadedAlert: _object_spread$b({}, baseCapability),
        previousSentCaseAlert: _object_spread$b({}, baseCapability),
        servicedeskAction: _object_spread$b({}, baseCapability),
        mergeCapability: _object_spread$b({}, baseCapability),
        splitCapability: _object_spread$b({}, baseCapability),
        createCase: _object_spread$b({}, baseCapability),
        coderFeedback: _object_spread$b({}, baseCapability),
        timelineInfiniteLoad: _object_spread$b({}, baseCapability),
        attachDocs: _object_spread$b({}, baseCapability),
        diagnosisCodeSuggestion: _object_spread$b({}, baseCapability),
        coderNotes: _object_spread$b({}, baseCapability),
        transactionV2: _object_spread$b({}, baseCapability),
        actionBarSelectMultipleWorkitems: _object_spread$b({}, baseCapability),
        getCaseRunWithRefresh: _object_spread$b({}, baseCapability),
        useProviderDirectoryLocations: _object_spread$b({}, baseCapability),
        codeSourcesFeatures: _object_spread$b({}, baseCapability),
        lateCaseClearNotification: _object_spread$b({}, baseCapability),
        viewScoreDetail: _object_spread$b({}, baseCapability)
    },
    excludeCasePermissionsConfig: null
};

var index$6 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  CodeGradingSections: CodeGradingSections,
  DEFAULT_BENCH_EDITABLE: DEFAULT_BENCH_EDITABLE,
  DEFAULT_SUGGESTED_CODES: DEFAULT_SUGGESTED_CODES,
  ampUI: ampUI,
  baseCapabilities: baseCapabilities,
  capabilities: capabilities$1,
  codeBenchState: codeBenchState,
  cursorAPIContext: cursorAPIContext,
  defaultCQAProjectConfiguration: defaultCQAProjectConfiguration,
  defaultQARule: defaultQARule,
  gradeBenchPanelState: gradeBenchPanelState,
  improvements: improvements$1,
  invoiceMetadata: invoiceMetadata$1,
  launch: launch
});

function _define_property$a(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$a(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$a(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$9(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$9(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$9(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * Method to get default department
 * if there's only one existing department, returns that department
 * otherwise returns empty department
 * @param invoiceOptions
 * @returns
 */ const getDefaultDepartment = (invoiceOptions)=>{
    var _ref;
    var _invoiceOptions_summary, _existingDepartments_;
    const existingDepartments = (_ref = invoiceOptions === null || invoiceOptions === void 0 ? void 0 : (_invoiceOptions_summary = invoiceOptions.summary) === null || _invoiceOptions_summary === void 0 ? void 0 : _invoiceOptions_summary.existing_departments) !== null && _ref !== void 0 ? _ref : [];
    const departmentCode = (existingDepartments === null || existingDepartments === void 0 ? void 0 : existingDepartments.length) === 1 ? (_existingDepartments_ = existingDepartments[0]) === null || _existingDepartments_ === void 0 ? void 0 : _existingDepartments_.code : null;
    if (departmentCode) {
        return getDepartmentFromCode(invoiceOptions, departmentCode);
    }
    return {
        code: null,
        name: null
    };
};
/**
 * Method to return department object for a given department code
 * @param invoiceOptions
 * @param departmentCode
 * @returns
 */ const getDepartmentFromCode = (invoiceOptions, departmentCode)=>{
    const allDepartments = getAllDepartments(invoiceOptions);
    let department;
    if (departmentCode) {
        department = allDepartments.find((item)=>item.code === departmentCode);
    }
    return department !== null && department !== void 0 ? department : {
        code: null,
        name: null
    };
};
/**
 * Method to return all departments as union of all_departments and all_departments
 * In case of invoice with old deprtament data existing_departments has departments that are not present in all_departments
 * @param invoiceOptions
 * @returns
 */ const getAllDepartments = (invoiceOptions)=>{
    var _ref, _ref1;
    var _invoiceOptions_summary, _invoiceOptions_summary1;
    const allDepartments = (_ref = invoiceOptions === null || invoiceOptions === void 0 ? void 0 : (_invoiceOptions_summary = invoiceOptions.summary) === null || _invoiceOptions_summary === void 0 ? void 0 : _invoiceOptions_summary.all_departments) !== null && _ref !== void 0 ? _ref : [];
    const existingDepartments = (_ref1 = invoiceOptions === null || invoiceOptions === void 0 ? void 0 : (_invoiceOptions_summary1 = invoiceOptions.summary) === null || _invoiceOptions_summary1 === void 0 ? void 0 : _invoiceOptions_summary1.existing_departments) !== null && _ref1 !== void 0 ? _ref1 : [];
    const combinedAllDepartments = unionBy([
        ...allDepartments,
        ...existingDepartments
    ], (department)=>department.code);
    return combinedAllDepartments;
};
/**
 * Method to return  department options
 * In case of invoice with old deprtament data existing_departments has department with name= null, this is prepared for UI purpose to have department name and code as department code
 * @param departments
 * @returns
 */ const getPreparedDepartmentOptions = (departments, existingDepartments)=>{
    const updatedDepartments = departments.map((item)=>{
        var _item_name, _ref;
        return {
            value: item.code,
            label: (_item_name = item.name) !== null && _item_name !== void 0 ? _item_name : item.code,
            highlight: (_ref = existingDepartments === null || existingDepartments === void 0 ? void 0 : existingDepartments.has(item.code)) !== null && _ref !== void 0 ? _ref : false
        };
    });
    return updatedDepartments;
};
/** Function to compare properties of two objects */ const compareObjectProperties = (obj1, obj2, propertiesToCompare)=>{
    for (const prop of propertiesToCompare){
        if (!isEqual(get$1(obj1, prop), get$1(obj2, prop))) {
            return false;
        }
    }
    return true;
};
/** Function to check if a field has value upon a given string is present in list */ const isFieldValid = (listObj, compareValue, field, defaultVal = true)=>{
    return (listObj === null || listObj === void 0 ? void 0 : listObj.includes(compareValue)) ? field !== null && field !== undefined && field !== '' : defaultVal;
};
function procedureCodeToCQATaskCode(procedure) {
    return {
        code: procedure.procedure_code,
        codeType: ChargeSessionCodeType$1.PROCEDURE,
        description: '',
        codeCorrection: null,
        assessment: null,
        role: null,
        units: procedure.units,
        editable: false,
        sequence_number: procedure.sequence_number
    };
}
function modifierCodeToCQATaskCode(modifier) {
    return {
        code: modifier.modifier_code,
        codeType: ChargeSessionCodeType$1.MODIFIER,
        description: '',
        codeCorrection: null,
        assessment: null,
        role: null,
        editable: false,
        sequence_number: modifier.sequence_number
    };
}
function diagnosisCodeToCQATaskCode(diagnosis) {
    return {
        code: diagnosis.diagnosis_code,
        codeType: ChargeSessionCodeType$1.DIAGNOSIS,
        description: '',
        codeCorrection: null,
        assessment: null,
        role: null,
        editable: false,
        sequence_number: diagnosis.sequence_number
    };
}
//Takes an invoice used in amplify and converts it to a gradeable invoice for CQA
function translateInvoiceToGradeableInvoice(invoice) {
    const { transactions } = invoice, rest = _object_without_properties(invoice, [
        "transactions"
    ]);
    const gradeableTransactions = transactions.map((transaction)=>{
        return _object_spread_props$9(_object_spread$a({}, transaction), {
            codes: [
                ...transaction.procedure ? [
                    procedureCodeToCQATaskCode(transaction.procedure)
                ] : [],
                ...transaction.diagnoses.map(diagnosisCodeToCQATaskCode),
                ...transaction.modifiers.map(modifierCodeToCQATaskCode)
            ]
        });
    });
    // Return the new GradeableInvoice with transformed transactions
    return _object_spread_props$9(_object_spread$a({}, rest), {
        transactions: gradeableTransactions,
        errorMessages: []
    });
}
const createCodeProvenanceForInvoice = (invoice, transaction)=>{
    if (invoice.type.toLowerCase() == InvoiceTypes$1.CLINICAL.toLowerCase()) {
        return {
            artifact_type: InvoiceTypes$1.CLINICAL,
            source_id: transaction.guid,
            source_id_type: 'transaction.guid'
        };
    }
    if (invoice.type.toLowerCase() == InvoiceTypes$1.PREDICTION.toLowerCase()) {
        return {
            artifact_type: InvoiceTypes$1.PREDICTION,
            // Invoices from the predicted artifiact do not have transactions, the invoice guid is the artifact guid
            source_id: invoice.guid,
            source_id_type: 'artifact.guid'
        };
    }
    if (invoice.type.toLowerCase() == InvoiceTypes$1.ASSEMBLED.toLowerCase()) {
        return {
            artifact_type: InvoiceTypes$1.ASSEMBLED,
            source_id: transaction.guid,
            source_id_type: 'transaction.guid'
        };
    }
    if (invoice.type.toLowerCase() == InvoiceTypes$1.MAPPED.toLowerCase()) {
        return {
            artifact_type: InvoiceTypes$1.MAPPED,
            source_id: transaction.guid,
            source_id_type: 'transaction.guid'
        };
    }
};
// Ensure that code provenances are uniformly ordered across suggested codes
const orderCodeProvenance = (codeProvenance)=>{
    return [
        ...codeProvenance
    ].sort((a, b)=>{
        return InvoiceTypes$1[a.artifact_type].localeCompare(InvoiceTypes$1[b.artifact_type]);
    });
};
//Take existing code provenance for the code and optionally add the code provenance for the source invoice, sort it
const getUpdatedCodeProvenance = (baseProvenance, additionalProvenance)=>{
    const newProvenance = [
        ...baseProvenance !== null && baseProvenance !== void 0 ? baseProvenance : []
    ];
    if (additionalProvenance) {
        newProvenance.push(additionalProvenance);
    }
    return orderCodeProvenance(newProvenance);
};
/**
 * Transforms source invoices into separate lists of CPT, ICD, and modifier codes
 * @param sourceInvoices Array of source invoices to process
 * @returns Object containing separate lists for CPT, ICD, and modifier codes
 *
 *
 * transaction_guids is not relevent to CodeSourcesList
 * code_source and code_recent_date are not relevent to CodeSourcesList
 */ const sourceInvoicesToCodeSourceList = (sourceInvoices, codeDescriptions)=>{
    const cptSourceList = [];
    const icdSourceList = [];
    const modSourceList = [];
    sourceInvoices.forEach((sourceInvoice)=>{
        sourceInvoice.transactions.forEach((transaction)=>{
            //Add a code provenance for the source invoice the code currently belongs to
            const additionalCodeProvenance = createCodeProvenanceForInvoice(sourceInvoice, transaction);
            // Process procedures (CPT codes)
            if (transaction.procedure) {
                // Check if this CPT + modifiers combination already exists
                const existingCptIndex = cptSourceList.findIndex((item)=>{
                    const itemModifierCodes = item.modifiers.map((mod)=>mod.code).sort().join(',');
                    const transactionModifierCodes = transaction.modifiers.map((mod)=>mod.modifier_code).sort().join(',');
                    return item.code === transaction.procedure.procedure_code && itemModifierCodes === transactionModifierCodes;
                });
                //Take existing code provenance for the code and optionally add the code provenance for the source invoice
                const codeProvenance = getUpdatedCodeProvenance(transaction.procedure.code_provenances, additionalCodeProvenance);
                if (existingCptIndex === -1) {
                    cptSourceList.push({
                        code: transaction.procedure.procedure_code,
                        codeType: ChargeSessionCodeProvenance$1.CPT,
                        description: extractCodeDescriptionForCode(codeDescriptions[transaction.procedure.procedure_code]),
                        units: transaction.procedure.units || 1,
                        shortDescription: extractShortDescriptionForCode(codeDescriptions[transaction.procedure.procedure_code]),
                        effectiveDate: '',
                        tenantDefined: true,
                        code_source: '',
                        code_recent_date: '',
                        suggested_code_type: SugggestedCodeType.FROM_SOURCES,
                        transaction_guids: [],
                        codeProvenances: codeProvenance,
                        modifiers: transaction.modifiers.map((mod)=>({
                                code: mod.modifier_code,
                                codeType: ChargeSessionCodeProvenance$1.MODIFIER,
                                effectiveDate: '',
                                description: extractCodeDescriptionForCode(codeDescriptions[mod.modifier_code]),
                                shortDescription: extractShortDescriptionForCode(codeDescriptions[mod.modifier_code]),
                                tenantDefined: true,
                                code_source: '',
                                code_recent_date: '',
                                suggested_code_type: SugggestedCodeType.FROM_SOURCES,
                                transaction_guids: [],
                                codeProvenances: codeProvenance
                            }))
                    });
                } else {
                    var _cptSourceList_existingCptIndex_codeProvenances;
                    //If there is a match we want to copy code provenances to this existing suggested code
                    const updatedCodeProvenance = orderCodeProvenance([
                        ...(_cptSourceList_existingCptIndex_codeProvenances = cptSourceList[existingCptIndex].codeProvenances) !== null && _cptSourceList_existingCptIndex_codeProvenances !== void 0 ? _cptSourceList_existingCptIndex_codeProvenances : [],
                        ...codeProvenance
                    ]);
                    const existingCpt = cptSourceList[existingCptIndex];
                    existingCpt.codeProvenances = updatedCodeProvenance;
                    existingCpt.modifiers = existingCpt.modifiers.map((mod)=>_object_spread_props$9(_object_spread$a({}, mod), {
                            codeProvenances: codeProvenance
                        }));
                }
            }
            // Process diagnoses (ICD codes)
            transaction.diagnoses.forEach((diagnosis)=>{
                //Take existing code provenance for the code and optionally add the code provenance for the source invoice
                const codeProvenance = getUpdatedCodeProvenance(diagnosis.code_provenances, additionalCodeProvenance);
                const existingIcdIndex = icdSourceList.findIndex((item)=>item.code === diagnosis.diagnosis_code);
                if (existingIcdIndex === -1) {
                    icdSourceList.push({
                        code: diagnosis.diagnosis_code,
                        codeType: ChargeSessionCodeProvenance$1.ICD,
                        description: extractCodeDescriptionForCode(codeDescriptions[diagnosis.diagnosis_code]),
                        shortDescription: extractShortDescriptionForCode(codeDescriptions[diagnosis.diagnosis_code]),
                        effectiveDate: '',
                        tenantDefined: true,
                        code_source: '',
                        code_recent_date: '',
                        suggested_code_type: SugggestedCodeType.FROM_SOURCES,
                        transaction_guids: [],
                        codeProvenances: codeProvenance
                    });
                } else {
                    var _icdSourceList_existingIcdIndex_codeProvenances;
                    //If there is a match we want to copy code provenances to this existing suggested code
                    const updatedCodeProvenance = orderCodeProvenance([
                        ...(_icdSourceList_existingIcdIndex_codeProvenances = icdSourceList[existingIcdIndex].codeProvenances) !== null && _icdSourceList_existingIcdIndex_codeProvenances !== void 0 ? _icdSourceList_existingIcdIndex_codeProvenances : [],
                        ...codeProvenance
                    ]);
                    icdSourceList[existingIcdIndex].codeProvenances = updatedCodeProvenance;
                }
            });
            // Process modifiers
            transaction.modifiers.forEach((modifier)=>{
                const existingModIndex = modSourceList.findIndex((item)=>item.code === modifier.modifier_code);
                const codeProvenance = getUpdatedCodeProvenance(modifier.code_provenances, additionalCodeProvenance);
                if (existingModIndex === -1) {
                    modSourceList.push({
                        code: modifier.modifier_code,
                        codeType: ChargeSessionCodeType$1.MODIFIER,
                        description: extractCodeDescriptionForCode(codeDescriptions[modifier.modifier_code]),
                        shortDescription: extractShortDescriptionForCode(codeDescriptions[modifier.modifier_code]),
                        effectiveDate: '',
                        tenantDefined: true,
                        code_source: '',
                        code_recent_date: '',
                        suggested_code_type: SugggestedCodeType.FROM_SOURCES,
                        transaction_guids: [],
                        codeProvenances: codeProvenance
                    });
                } else {
                    var _modSourceList_existingModIndex_codeProvenances;
                    //If there is a match we want to copy code provenances to this existing suggested code
                    const updatedCodeProvenance = orderCodeProvenance([
                        ...(_modSourceList_existingModIndex_codeProvenances = modSourceList[existingModIndex].codeProvenances) !== null && _modSourceList_existingModIndex_codeProvenances !== void 0 ? _modSourceList_existingModIndex_codeProvenances : [],
                        ...codeProvenance
                    ]);
                    modSourceList[existingModIndex].codeProvenances = updatedCodeProvenance;
                }
            });
        });
    });
    return {
        cptSourceList,
        icdSourceList,
        modSourceList
    };
};
const providerOrder = (providers)=>{
    return [
        ...providers !== null && providers !== void 0 ? providers : []
    ].sort((a, b)=>{
        var _b_displayName, _a_displayName;
        return a === null || a === void 0 ? void 0 : (_a_displayName = a.displayName) === null || _a_displayName === void 0 ? void 0 : _a_displayName.toUpperCase().localeCompare(b === null || b === void 0 ? void 0 : (_b_displayName = b.displayName) === null || _b_displayName === void 0 ? void 0 : _b_displayName.toUpperCase());
    });
};

var invoiceUtilities = /*#__PURE__*/Object.freeze({
  __proto__: null,
  compareObjectProperties: compareObjectProperties,
  getAllDepartments: getAllDepartments,
  getDefaultDepartment: getDefaultDepartment,
  getDepartmentFromCode: getDepartmentFromCode,
  getPreparedDepartmentOptions: getPreparedDepartmentOptions,
  isFieldValid: isFieldValid,
  providerOrder: providerOrder,
  sourceInvoicesToCodeSourceList: sourceInvoicesToCodeSourceList,
  translateInvoiceToGradeableInvoice: translateInvoiceToGradeableInvoice
});

function _define_property$9(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$9(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$9(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$8(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$8(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$8(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const { amplifyFeedback: amplifyFeedback$1 } = uiActions;
const REQUEST_INIT_OPTIONS = {
    method: 'GET',
    cache: 'no-cache',
    redirect: 'follow',
    referrer: 'no-referrer'
};
const CONSTELLATION_SERVICES_LOCATION = '/constellation';
const cancelChargeEdit = createAction(InvoiceEditor.CANCEL_INVOICE);
const removeProvider = createAction(InvoiceEditor.REMOVE_PROVIDER);
const addProvider = createAction(InvoiceEditor.ADD_PROVIDER);
const billingAreaOptions = createAction(InvoiceEditor.BILLING_AREA_OPTIONS);
// Action initializers
const removeAdditionPerformer = createAction(InvoiceEditor.REMOVE_PERFORMER);
const removeAdditionReferringPerformer = createAction(InvoiceEditor.REMOVE_REFERRING_PERFORMER);
const addAdditionPerformer = createAction(InvoiceEditor.ADD_PERFORMER);
const addAdditionReferringPerformer = createAction(InvoiceEditor.ADD_REFERRING_PERFORMER);
const changePerformDate = createAction(InvoiceEditor.CHANGE_DATE_PERFORMER);
const departmentChange = createAction(InvoiceEditor.DEPARTMENT_CHANGE);
const feeScheduleChange = createAction(InvoiceEditor.FEE_SCHEDULE_CHANGE);
// Action for choose a performer
const chooseAdditionPerformer = createAsyncThunk(InvoiceEditor.CHOOSE_PERFORMER, async (provider, { dispatch })=>{
    return dispatch(addAdditionPerformer(provider));
});
// Action for choose a referring performer
const chooseAdditionReferringPerformer = createAsyncThunk(InvoiceEditor.CHOOSE_REFERRING_PERFORMER, async (provider, { dispatch })=>{
    dispatch(addAdditionReferringPerformer(provider));
});
const buildXCaliberQuery = (lookupQuery, limit = 25)=>{
    var _lookupQuery_text;
    const lookupText = ((_lookupQuery_text = lookupQuery.text) !== null && _lookupQuery_text !== void 0 ? _lookupQuery_text : '').trim();
    const query = [
        'select * from provider where'
    ];
    if (lookupQuery.searchType === 'id') {
        query.push(`provider.prov_id = '${lookupText}'`);
    } else {
        query.push(`prov_name like '%${lookupText}%'`);
    }
    query.push(`limit ${limit}`);
    query.push(`;`);
    return {
        query: query.join(' ')
    };
};
const providerSearchXCaliber = createAsyncThunk(InvoiceEditor.SEARCH_PROVIDERS_XCALIBER, async (lookupQuery, { getState })=>{
    var _appServiceLines_isIPC, _appServiceLines_isSurgery;
    const { context: { searchType, meetsMinimum, processInstance, providerType } } = lookupQuery;
    const sequenceNumber = sequenceGenerator.next(searchType);
    const isIPCServiceLine = (_appServiceLines_isIPC = isIPC(processInstance === null || processInstance === void 0 ? void 0 : processInstance.serviceLine)) !== null && _appServiceLines_isIPC !== void 0 ? _appServiceLines_isIPC : false;
    const isSurgery$1 = (_appServiceLines_isSurgery = isSurgery(processInstance === null || processInstance === void 0 ? void 0 : processInstance.serviceLine)) !== null && _appServiceLines_isSurgery !== void 0 ? _appServiceLines_isSurgery : false;
    const state = getState();
    let providers = [];
    if (meetsMinimum) {
        var _appServiceLines_isPathology;
        const isPathology$1 = (_appServiceLines_isPathology = isPathology(processInstance === null || processInstance === void 0 ? void 0 : processInstance.serviceLine)) !== null && _appServiceLines_isPathology !== void 0 ? _appServiceLines_isPathology : false;
        if (isIPCServiceLine || isSurgery$1) {
            providers = await getProviderFromDirectoryV2XCaliber(lookupQuery);
        } else {
            providers = await getProviderFromDirectoryXCaliber(lookupQuery, state, false, isPathology$1);
        }
    }
    return {
        providers: providerOrder(providers),
        meta: {
            searchType,
            providerType,
            sequenceNumber
        }
    };
});
const getProviderFromDirectoryXCaliber = async (lookupQuery, state, isIPCServiceLine, isPathology)=>{
    var _lookupQuery_text, _ref;
    var _xcaliberToken_status;
    const lookupText = ((_lookupQuery_text = lookupQuery.text) !== null && _lookupQuery_text !== void 0 ? _lookupQuery_text : '').trim();
    if (!lookupText.length) return [];
    const providerQuery = buildXCaliberQuery(lookupQuery);
    const xcaliberToken = fetchXcaliberToken();
    const status = (_ref = xcaliberToken === null || xcaliberToken === void 0 ? void 0 : (_xcaliberToken_status = xcaliberToken.status) === null || _xcaliberToken_status === void 0 ? void 0 : _xcaliberToken_status.toUpperCase()) !== null && _ref !== void 0 ? _ref : '';
    if (status !== 'SUCCESS') return [];
    const queryURL = `${CONSTELLATION_SERVICES_LOCATION}/${xcaliberToken.tenantPath}/directory/api/v1/entities/provider/entries/query`;
    const response = await requestJSON(queryURL, _object_spread_props$8(_object_spread$9({}, REQUEST_INIT_OPTIONS), {
        headers: {
            Authorization: `Bearer ${xcaliberToken.token}`
        },
        method: Methods.POST,
        body: JSON.stringify(providerQuery)
    }));
    return convertXcaliberEntitiesToCMX(response, isIPCServiceLine, isPathology);
};
const getProviderFromDirectoryV2XCaliber = async (lookupQuery, state)=>{
    var _lookupQuery_text, _ref, _ref1;
    var _xcaliberToken_status;
    const lookupText = ((_lookupQuery_text = lookupQuery.text) !== null && _lookupQuery_text !== void 0 ? _lookupQuery_text : '').trim();
    if (!lookupText.length) return [];
    const { providerRoleTypeConfig, providerType, invoice, shouldFilterActive, shouldFilterOutExternalProviders, shouldGreyOutExternalProviders, useProviderDirectoryLocations } = lookupQuery.context;
    const isBillingProviderSearch = providerType === ProviderType$1.BILLING_PROVIDER;
    const isPerformingProviderSearch = providerType === ProviderType$1.PERFORMING_PROVIDER;
    const roleTypeConfig = isPerformingProviderSearch ? providerRoleTypeConfig : [];
    const xcaliberToken = fetchXcaliberToken();
    const status = (_ref = xcaliberToken === null || xcaliberToken === void 0 ? void 0 : (_xcaliberToken_status = xcaliberToken.status) === null || _xcaliberToken_status === void 0 ? void 0 : _xcaliberToken_status.toUpperCase()) !== null && _ref !== void 0 ? _ref : '';
    if (status !== 'SUCCESS') return [];
    const queryURL = `${CONSTELLATION_SERVICES_LOCATION}/${xcaliberToken.tenantPath}/directory/api/v1/entities/provider/entries/functions/search_billing_providers/execute`;
    let body = {
        provider_name: `%${lookupText}%`
    };
    if (isBillingProviderSearch) {
        body.service_date = invoice === null || invoice === void 0 ? void 0 : invoice.date_of_service;
        if (capabilityValue(useProviderDirectoryLocations === null || useProviderDirectoryLocations === void 0 ? void 0 : useProviderDirectoryLocations.on)) {
            var _ref2;
            body.location_name = (_ref2 = invoice === null || invoice === void 0 ? void 0 : invoice.facility) !== null && _ref2 !== void 0 ? _ref2 : '';
        }
    }
    const response = await requestJSON(queryURL, _object_spread_props$8(_object_spread$9({}, REQUEST_INIT_OPTIONS), {
        headers: {
            Authorization: `Bearer ${xcaliberToken.token}`
        },
        method: Methods.POST,
        body: JSON.stringify(body)
    }));
    return convertXcaliberEntitiesToIPC((_ref1 = response === null || response === void 0 ? void 0 : response.content) !== null && _ref1 !== void 0 ? _ref1 : [], isBillingProviderSearch, shouldFilterActive, shouldFilterOutExternalProviders, shouldGreyOutExternalProviders, providerType, roleTypeConfig);
};
const providerSearchDataAccess = createAsyncThunk(InvoiceEditor.SEARCH_PROVIDERS_DATAACCESS, async (lookupQuery, { getState })=>{
    var _appServiceLines_isIPC, _appServiceLines_isSurgery, _appServiceLines_isPathology;
    const { context: { searchType, meetsMinimum, processInstance, providerType } } = lookupQuery;
    const sequenceNumber = sequenceGenerator.next(searchType);
    const state = getState();
    if (!meetsMinimum) {
        return {
            providers: [],
            meta: {
                searchType,
                providerType,
                sequenceNumber
            }
        };
    }
    const isIPCServiceLine = (_appServiceLines_isIPC = isIPC(processInstance === null || processInstance === void 0 ? void 0 : processInstance.serviceLine)) !== null && _appServiceLines_isIPC !== void 0 ? _appServiceLines_isIPC : false;
    const isSurgery$1 = (_appServiceLines_isSurgery = isSurgery(processInstance === null || processInstance === void 0 ? void 0 : processInstance.serviceLine)) !== null && _appServiceLines_isSurgery !== void 0 ? _appServiceLines_isSurgery : false;
    const isPathology$1 = (_appServiceLines_isPathology = isPathology(processInstance === null || processInstance === void 0 ? void 0 : processInstance.serviceLine)) !== null && _appServiceLines_isPathology !== void 0 ? _appServiceLines_isPathology : false;
    let providers = [];
    if (isIPCServiceLine || isSurgery$1) {
        providers = await getProviderFromDirectoryV2DataAccess(lookupQuery, state);
    } else {
        providers = await getProviderFromDirectoryDataAccess(lookupQuery, state, false, isPathology$1);
    }
    return {
        providers: providerOrder(providers),
        meta: {
            searchType,
            providerType,
            sequenceNumber
        }
    };
});
const getProviderFromDirectoryDataAccess = async (lookupQuery, state, isIPCServiceLine, isPathology)=>{
    var _lookupQuery_text;
    const lookupText = ((_lookupQuery_text = lookupQuery.text) !== null && _lookupQuery_text !== void 0 ? _lookupQuery_text : '').trim();
    if (!lookupText.length) return [];
    const queryURL = '/dataaccess/read/v1';
    const providerSearchBody = lookupQuery.searchType === "id" ? _object_spread_props$8(_object_spread$9({}, buildDataAccessRequestObject(state, "getProvider", "provider")), {
        filterFields: [
            lookupText
        ]
    }) : _object_spread_props$8(_object_spread$9({}, buildDataAccessRequestObject(state, "queryForProvidersByName", "provider")), {
        filterFields: [
            lookupText
        ]
    });
    const response = await requestJSON(queryURL, {
        method: Methods.POST,
        body: JSON.stringify(providerSearchBody)
    });
    return convertXcaliberEntitiesToCMX(response, isIPCServiceLine, isPathology);
};
const getProviderFromDirectoryV2DataAccess = async (lookupQuery, state)=>{
    var _lookupQuery_text, _ref;
    const lookupText = ((_lookupQuery_text = lookupQuery.text) !== null && _lookupQuery_text !== void 0 ? _lookupQuery_text : '').trim();
    if (!lookupText.length) return [];
    const { providerRoleTypeConfig, providerType, invoice, shouldFilterActive, shouldFilterOutExternalProviders, shouldGreyOutExternalProviders, useProviderDirectoryLocations } = lookupQuery.context;
    const isBillingProviderSearch = providerType === ProviderType$1.BILLING_PROVIDER;
    const isPerformingProviderSearch = providerType === ProviderType$1.PERFORMING_PROVIDER;
    const roleTypeConfig = isPerformingProviderSearch ? providerRoleTypeConfig : [];
    const queryURL = '/dataaccess/read/v1';
    const providerSearchBody = _object_spread_props$8(_object_spread$9({}, buildDataAccessRequestObject(state, "searchForProvidersByName", "searchbillingprovider")), {
        filterFieldsMap: {
            provider_name: `%${lookupText}%`
        }
    });
    if (isBillingProviderSearch) {
        providerSearchBody.filterFieldsMap.service_date = invoice === null || invoice === void 0 ? void 0 : invoice.date_of_service;
        if (capabilityValue(useProviderDirectoryLocations === null || useProviderDirectoryLocations === void 0 ? void 0 : useProviderDirectoryLocations.on)) {
            var _ref1;
            providerSearchBody.filterFieldsMap.location_name = (_ref1 = invoice === null || invoice === void 0 ? void 0 : invoice.facility) !== null && _ref1 !== void 0 ? _ref1 : '';
        }
    }
    const response = await requestJSON(queryURL, {
        method: Methods.POST,
        body: JSON.stringify(providerSearchBody)
    });
    return convertXcaliberEntitiesToIPC((_ref = response === null || response === void 0 ? void 0 : response.content) !== null && _ref !== void 0 ? _ref : [], isBillingProviderSearch, shouldFilterActive, shouldFilterOutExternalProviders, shouldGreyOutExternalProviders, providerType, roleTypeConfig);
};
const providerSearch = createAsyncThunk(InvoiceEditor.SEARCH_PROVIDERS, async (lookupQuery, { dispatch, getState })=>{
    const state = getState();
    if (shouldFetchFromDataAccess(state)) {
        return dispatch(providerSearchDataAccess(lookupQuery)).unwrap();
    } else {
        return dispatch(providerSearchXCaliber(lookupQuery)).unwrap();
    }
});
// action for create a new invoice
const createInvoice = createAsyncThunk(InvoiceEditor.CREATE_INVOICE, async (createbleInvoice, { dispatch, rejectWithValue })=>{
    var _ref, _ref1, _ref2, _ref3;
    const { invoice, processInstance } = createbleInvoice;
    // The invoice may originate from Redux state, which Redux Toolkit freezes
    // via Immer. Build a new payload instead of mutating the input.
    const invoicePayload = _object_spread_props$8(_object_spread$9({}, invoice), {
        transactions: [],
        billing_provider_type: (_ref = invoice === null || invoice === void 0 ? void 0 : invoice.billing_provider_type) !== null && _ref !== void 0 ? _ref : null,
        ordering_provider_type: (_ref1 = invoice === null || invoice === void 0 ? void 0 : invoice.ordering_provider_type) !== null && _ref1 !== void 0 ? _ref1 : null,
        performing_provider_type: (_ref2 = invoice === null || invoice === void 0 ? void 0 : invoice.performing_provider_type) !== null && _ref2 !== void 0 ? _ref2 : null,
        referring_provider_type: (_ref3 = invoice === null || invoice === void 0 ? void 0 : invoice.referring_provider_type) !== null && _ref3 !== void 0 ? _ref3 : null,
        billing_provider_credentials: (invoice === null || invoice === void 0 ? void 0 : invoice.billing_provider_credentials) || null,
        performing_provider_credentials: (invoice === null || invoice === void 0 ? void 0 : invoice.performing_provider_credentials) || null
    });
    try {
        // create a new invoice
        const newInvoice = await requestJSON(`/coding-api/processinstance/${processInstance.serviceLine}/${processInstance.guid.uuid}/invoice/v1`, _object_spread_props$8(_object_spread$9({}, REQUEST_INIT_OPTIONS), {
            method: Methods.POST,
            body: JSON.stringify(invoicePayload)
        }));
        // create an empty transaction with new invoices guid
        const addTxnURL = `/coding-api/processinstance/${processInstance.serviceLine}/${processInstance.guid.uuid}/transaction/v1?invoiceGuid=${newInvoice.guid}`;
        await requestJSON(addTxnURL, _object_spread_props$8(_object_spread$9({}, REQUEST_INIT_OPTIONS), {
            method: Methods.POST
        }));
        // get data
        let updatedProcessInstance = await requestJSON(`/coding-api/processinstance/${processInstance.serviceLine}/${processInstance.guid.uuid}/v1?evidence=true&errors=true`, _object_spread$9({}, REQUEST_INIT_OPTIONS));
        dispatch(fetchActivity(updatedProcessInstance));
        dispatch(fetchAllInvoices(updatedProcessInstance));
        return updatedProcessInstance;
    } catch (error) {
        if (!checkInvoiceFieldErrors(error, dispatch)) {
            dispatch(amplifyFeedback$1({
                message: 'There were errors creating the invoice.',
                meta: FeedbackMeta.ERROR,
                dismissable: true
            }));
        }
        throw error;
    }
});
/**
 * Checks if there are any field errors in the given error object and dispatches
 * a feedback message with the list of fields that are not properly filled.
 *
 * @param {ErrorWithFieldErrors} error
 * @param {Function} dispatch
 * @returns {boolean}
 */ const checkInvoiceFieldErrors = (error, dispatch)=>{
    const fieldsErrorsList = [];
    if ((error === null || error === void 0 ? void 0 : error.errors) && 'fieldErrors' in (error === null || error === void 0 ? void 0 : error.errors)) {
        var _error_errors, _error_errors1;
        // Check for errors in the 'feeSchedule' field.
        if (Object.keys(error === null || error === void 0 ? void 0 : (_error_errors = error.errors) === null || _error_errors === void 0 ? void 0 : _error_errors.fieldErrors).includes('feeSchedule')) {
            fieldsErrorsList.push('Billing Area');
        }
        // Check for errors in the 'departmentCode' field.
        if (Object.keys(error === null || error === void 0 ? void 0 : (_error_errors1 = error.errors) === null || _error_errors1 === void 0 ? void 0 : _error_errors1.fieldErrors).includes('departmentCode')) {
            fieldsErrorsList.push('Department');
        }
        let errorMessage;
        switch(fieldsErrorsList.length){
            case 0:
                errorMessage = 'Unknown field errors.';
                break;
            case 1:
                errorMessage = `The field '${fieldsErrorsList[0]}' is not properly filled.`;
                break;
            default:
                errorMessage = `These fields are not properly filled: ${fieldsErrorsList.join(', ')}.`;
        }
        /**
     * The feedback message to dispatch.
     * @type {AmplifyFeedbackParams}
     */ const feedbackMessage = {
            message: errorMessage,
            meta: FeedbackMeta.ERROR,
            dismissable: true
        };
        dispatch(amplifyFeedback$1(feedbackMessage));
        return true;
    }
    return false;
};
// action for get a invoice option
const getInvoiceOptions = createAsyncThunk(InvoiceEditor.INVOICE_OPTIONS, async (processInstance)=>{
    // create a new invoice
    const invoiceOptions = await requestJSON(`/coding-api/processinstance/${processInstance.serviceLine}/${processInstance.guid.uuid}/invoice/v1`, _object_spread_props$8(_object_spread$9({}, REQUEST_INIT_OPTIONS), {
        method: Methods.GET
    }));
    return invoiceOptions;
});
const chooseProvider = createAsyncThunk(InvoiceEditor.CHOOSE_PROVIDER, async (provider, { dispatch })=>{
    // leaving this as async for now even though it doesn't need to be.
    // in the future, it's expected that we'll do some sort of check to
    // make sure that the
    dispatch(addProvider(provider));
});
const removeTransaction = createAsyncThunk(InvoiceEditor.REMOVE_TRANSACTION, async (chargeSessionAction, { dispatch })=>{
    const serviceLine = chargeSessionAction.meta.processInstance.serviceLine;
    const processInstanceGuid = chargeSessionAction.meta.processInstance.guid.uuid;
    const deletedTxnURL = `/coding-api/processinstance/${serviceLine}/${processInstanceGuid}/transaction/v1?transactionGuid=${chargeSessionAction.meta.transaction.guid}`;
    const invoiceURL = `/coding-api/processinstance/${serviceLine}/${processInstanceGuid}/v1?evidence=true&errors=true`;
    // 1. delete transaction
    await request(deletedTxnURL, _object_spread_props$8(_object_spread$9({}, REQUEST_INIT_OPTIONS), {
        method: Methods.DELETE
    }));
    // 2. grab the full invoice
    let processInstance = await requestJSON(invoiceURL, _object_spread_props$8(_object_spread$9({}, REQUEST_INIT_OPTIONS), {
        method: Methods.GET
    }));
    dispatch(fetchActivity(processInstance));
    dispatch(fetchAllInvoices(processInstance));
    return processInstance;
});
const saveInvoice = createAsyncThunk(InvoiceEditor.SAVE_INVOICE, async (savableInvoice, { dispatch })=>{
    var _ref, _ref1, _ref2, _ref3;
    const { invoice, processInstance } = savableInvoice;
    // The invoice may originate from Redux state, which Redux Toolkit freezes
    // via Immer. Build a new payload instead of mutating the input.
    const invoicePayload = _object_spread_props$8(_object_spread$9({}, invoice), {
        billing_provider_type: (_ref = invoice === null || invoice === void 0 ? void 0 : invoice.billing_provider_type) !== null && _ref !== void 0 ? _ref : null,
        ordering_provider_type: (_ref1 = invoice === null || invoice === void 0 ? void 0 : invoice.ordering_provider_type) !== null && _ref1 !== void 0 ? _ref1 : null,
        performing_provider_type: (_ref2 = invoice === null || invoice === void 0 ? void 0 : invoice.performing_provider_type) !== null && _ref2 !== void 0 ? _ref2 : null,
        referring_provider_type: (_ref3 = invoice === null || invoice === void 0 ? void 0 : invoice.referring_provider_type) !== null && _ref3 !== void 0 ? _ref3 : null,
        billing_provider_credentials: (invoice === null || invoice === void 0 ? void 0 : invoice.billing_provider_credentials) || null,
        performing_provider_credentials: (invoice === null || invoice === void 0 ? void 0 : invoice.performing_provider_credentials) || null
    });
    try {
        await requestJSON(`/coding-api/processinstance/${processInstance.serviceLine}/${processInstance.guid.uuid}/invoice/v1`, _object_spread_props$8(_object_spread$9({}, REQUEST_INIT_OPTIONS), {
            method: Methods.PUT,
            body: JSON.stringify(invoicePayload)
        }));
    } catch (error) {
        if (!checkInvoiceFieldErrors(error, dispatch)) {
            dispatch(amplifyFeedback$1({
                message: 'There were errors saving changes.',
                meta: FeedbackMeta.ERROR,
                dismissable: true
            }));
        }
    } finally{
        const updatedProcessInstance = await requestJSON(`/coding-api/processinstance/${processInstance.serviceLine}/${processInstance.guid.uuid}/v1?evidence=true&errors=true`, _object_spread$9({}, REQUEST_INIT_OPTIONS));
        dispatch(fetchActivity(updatedProcessInstance));
        dispatch(fetchAllInvoices(updatedProcessInstance));
        return updatedProcessInstance;
    }
});

var index$5 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  addAdditionPerformer: addAdditionPerformer,
  addAdditionReferringPerformer: addAdditionReferringPerformer,
  addProvider: addProvider,
  billingAreaOptions: billingAreaOptions,
  cancelChargeEdit: cancelChargeEdit,
  changePerformDate: changePerformDate,
  chooseAdditionPerformer: chooseAdditionPerformer,
  chooseAdditionReferringPerformer: chooseAdditionReferringPerformer,
  chooseProvider: chooseProvider,
  createInvoice: createInvoice,
  departmentChange: departmentChange,
  feeScheduleChange: feeScheduleChange,
  getInvoiceOptions: getInvoiceOptions,
  providerSearch: providerSearch,
  removeAdditionPerformer: removeAdditionPerformer,
  removeAdditionReferringPerformer: removeAdditionReferringPerformer,
  removeProvider: removeProvider,
  removeTransaction: removeTransaction,
  saveInvoice: saveInvoice
});

const coderConfig$1 = [
    {
        id: 145,
        section: 'coder_config',
        keyname: 'amplify_invoice_types',
        values: [
            {
                id: 642,
                value: '',
                jsonValue: {
                    invoice_type_order: [
                        'assembled',
                        'mapped',
                        'clinical'
                    ]
                },
                tenantId: '*',
                configurationKeyname: 'amplify_invoice_types',
                configurationId: 145,
                version: 0,
                serviceLines: [
                    'Radiology'
                ],
                createdDate: null,
                updatedDate: null,
                sourceType: null
            }
        ]
    },
    {
        id: 145,
        section: 'coder_config',
        keyname: ConfigurationKeyName.MULTI_CODESET_GENERAL,
        values: [
            {
                id: 642,
                value: 'true',
                jsonValue: {},
                tenantId: '*',
                configurationKeyname: ConfigurationKeyName.MULTI_CODESET_GENERAL,
                configurationId: 145,
                version: 0,
                serviceLines: [
                    '*'
                ],
                createdDate: null,
                updatedDate: null,
                sourceType: null
            }
        ]
    }
];

var index$4 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  AssesmentSelect: AssesmentSelect$1,
  BaseCQACodeAssessmentIcon: BaseCQACodeAssessmentIcon$1,
  CPTCode: CPTCode$1,
  EMPTY_NOTE: EMPTY_NOTE,
  GripIcon: GripIcon$1,
  ICDCode: ICDCode$1,
  Icon: Icon,
  ModifierCode: ModifierCode$1,
  RoleSelect: RoleSelect$1,
  UnitCount: UnitCount$1,
  coderConfig: coderConfig$1,
  defaultAssessmentOptionsTreePath: defaultAssessmentOptionsTreePath,
  modifierAssessmentOptionsTreePath: modifierAssessmentOptionsTreePath,
  modifierRoleOptionsTreePath: modifierRoleOptionsTreePath
});

const { AccelerateProcessStatus, ProcessQAStatus, Gen2CaseStatus, Gen2ProcessStatus, HoldReasonType } = commonEnums;
const ipcStatusMapList = [
    {
        chargeable: false,
        caseStatus: Gen2CaseStatus.MANUAL,
        displayStatus: "Non-Chargeable"
    },
    {
        chargeable: false,
        caseStatus: Gen2CaseStatus.IN_PROGRESS,
        displayStatus: "Predicted Codes: Non-Chargeable"
    },
    {
        chargeable: false,
        caseStatus: Gen2CaseStatus.CANCELLED,
        displayStatus: "Voided"
    },
    {
        chargeable: false,
        caseStatus: Gen2CaseStatus.MANUAL,
        processStatus: Gen2ProcessStatus.AT_CODER,
        processInstanceStatus: AccelerateProcessStatus.CANCELLED,
        displayStatus: "Voided"
    },
    {
        chargeable: true,
        caseStatus: Gen2CaseStatus.IN_PROGRESS,
        processStatus: Gen2ProcessStatus.IN_PROGRESS,
        displayStatus: "Analyzing"
    },
    {
        chargeable: true,
        caseStatus: Gen2CaseStatus.IN_PROGRESS,
        processStatus: Gen2ProcessStatus.DATA_COLLECTED,
        displayStatus: "Analyzing"
    },
    {
        chargeable: true,
        caseStatus: Gen2CaseStatus.IN_PROGRESS,
        processStatus: Gen2ProcessStatus.PREDICTED,
        displayStatus: "Analysis Complete"
    },
    {
        chargeable: true,
        caseStatus: Gen2CaseStatus.IN_PROGRESS,
        processStatus: Gen2ProcessStatus.PREDICTION_FAILED,
        displayStatus: "Analysis Complete"
    },
    {
        chargeable: true,
        caseStatus: Gen2CaseStatus.IN_PROGRESS,
        processStatus: Gen2ProcessStatus.SENDING_TO_CODER,
        displayStatus: "Predicted Codes: Ready for Distribution"
    },
    {
        chargeable: true,
        caseStatus: Gen2CaseStatus.IN_PROGRESS,
        processStatus: Gen2ProcessStatus.AT_CODER,
        displayStatus: "Predicted Codes In QA"
    },
    {
        chargeable: true,
        caseStatus: Gen2CaseStatus.IN_PROGRESS,
        processStatus: Gen2ProcessStatus.AT_CODER,
        processInstanceStatus: AccelerateProcessStatus.SUBMITTED,
        qaStatus: ProcessQAStatus.IN_QA,
        holdStatus: HoldReasonType.HOLD,
        displayStatus: "Predicted Codes In QA: On Hold"
    },
    {
        chargeable: true,
        caseStatus: Gen2CaseStatus.IN_PROGRESS,
        processStatus: Gen2ProcessStatus.AT_CODER,
        processInstanceStatus: AccelerateProcessStatus.SUBMITTED,
        qaStatus: ProcessQAStatus.IN_QA,
        holdStatus: HoldReasonType.HOLD_FOR_DOCUMENTATION_QUERY,
        displayStatus: "Predicted Codes In QA: On Hold - Documentation Request"
    },
    {
        chargeable: true,
        caseStatus: Gen2CaseStatus.IN_PROGRESS,
        processStatus: Gen2ProcessStatus.AT_CODER,
        processInstanceStatus: AccelerateProcessStatus.SUBMITTED,
        qaStatus: ProcessQAStatus.IN_QA,
        holdStatus: HoldReasonType.HOLD_FOR_MANAGER_REVIEW,
        displayStatus: "Predicted Codes In QA: On Hold"
    },
    {
        chargeable: true,
        caseStatus: Gen2CaseStatus.IN_PROGRESS,
        processStatus: Gen2ProcessStatus.AT_CODER,
        processInstanceStatus: AccelerateProcessStatus.SUBMITTED,
        qaStatus: ProcessQAStatus.IN_QA,
        holdStatus: HoldReasonType.OFF_HOLD,
        displayStatus: "Predicted Codes In QA: Off Hold"
    },
    {
        chargeable: true,
        caseStatus: Gen2CaseStatus.IN_PROGRESS,
        processStatus: Gen2ProcessStatus.AT_CODER,
        processInstanceStatus: AccelerateProcessStatus.SUBMITTED,
        qaStatus: ProcessQAStatus.QA_COMPLETE,
        displayStatus: "Predicted Codes QA Complete"
    },
    {
        chargeable: true,
        caseStatus: Gen2CaseStatus.IN_PROGRESS,
        processStatus: Gen2ProcessStatus.CODES_RECEIVED,
        displayStatus: "Predicted Codes Received"
    },
    {
        chargeable: true,
        caseStatus: Gen2CaseStatus.IN_PROGRESS,
        processStatus: Gen2ProcessStatus.DONE,
        displayStatus: "Error"
    },
    {
        chargeable: true,
        caseStatus: Gen2CaseStatus.IN_PROGRESS,
        displayStatus: "Collecting Data"
    },
    {
        chargeable: true,
        caseStatus: Gen2CaseStatus.CANCELLED,
        displayStatus: "Voided"
    },
    {
        chargeable: true,
        caseStatus: Gen2CaseStatus.MANUAL,
        processStatus: Gen2ProcessStatus.SENDING_TO_CODER,
        displayStatus: "Ready for Distribution"
    },
    {
        chargeable: true,
        caseStatus: Gen2CaseStatus.MANUAL,
        processStatus: Gen2ProcessStatus.AT_CODER,
        processInstanceStatus: AccelerateProcessStatus.NEW,
        displayStatus: "Ready for Coding"
    },
    {
        chargeable: true,
        caseStatus: Gen2CaseStatus.MANUAL,
        processStatus: Gen2ProcessStatus.AT_CODER,
        processInstanceStatus: AccelerateProcessStatus.IN_PROGRESS,
        displayStatus: "Coding In Progress"
    },
    {
        chargeable: true,
        caseStatus: Gen2CaseStatus.MANUAL,
        processStatus: Gen2ProcessStatus.AT_CODER,
        processInstanceStatus: AccelerateProcessStatus.IN_PROGRESS,
        holdStatus: HoldReasonType.HOLD,
        displayStatus: "Coding In Progress: On Hold"
    },
    {
        chargeable: true,
        caseStatus: Gen2CaseStatus.MANUAL,
        processStatus: Gen2ProcessStatus.AT_CODER,
        processInstanceStatus: AccelerateProcessStatus.IN_PROGRESS,
        holdStatus: HoldReasonType.HOLD_FOR_DOCUMENTATION_QUERY,
        displayStatus: "Coding In Progress: On Hold - Documentation Requested"
    },
    {
        chargeable: true,
        caseStatus: Gen2CaseStatus.MANUAL,
        processStatus: Gen2ProcessStatus.AT_CODER,
        processInstanceStatus: AccelerateProcessStatus.IN_PROGRESS,
        holdStatus: HoldReasonType.HOLD_FOR_MANAGER_REVIEW,
        displayStatus: "Coding In Progress: On Hold"
    },
    {
        chargeable: true,
        caseStatus: Gen2CaseStatus.MANUAL,
        processStatus: Gen2ProcessStatus.AT_CODER,
        processInstanceStatus: AccelerateProcessStatus.IN_PROGRESS,
        holdStatus: HoldReasonType.OFF_HOLD,
        displayStatus: "Coding In Progress: Off Hold"
    },
    {
        chargeable: true,
        caseStatus: Gen2CaseStatus.MANUAL,
        processStatus: Gen2ProcessStatus.AT_CODER,
        processInstanceStatus: AccelerateProcessStatus.SUBMITTED,
        displayStatus: "Manual Coded"
    },
    {
        chargeable: true,
        caseStatus: Gen2CaseStatus.MANUAL,
        processStatus: Gen2ProcessStatus.AT_CODER,
        processInstanceStatus: AccelerateProcessStatus.REMOVED,
        displayStatus: "Child Case"
    },
    {
        chargeable: true,
        caseStatus: Gen2CaseStatus.MANUAL,
        processStatus: Gen2ProcessStatus.AT_CODER,
        processInstanceStatus: AccelerateProcessStatus.REPLACED,
        displayStatus: "Case has update"
    },
    {
        chargeable: true,
        caseStatus: Gen2CaseStatus.MANUAL,
        processStatus: Gen2ProcessStatus.AT_CODER,
        processInstanceStatus: AccelerateProcessStatus.REPLACED_CANCELLED,
        displayStatus: "Case has update"
    },
    {
        chargeable: true,
        caseStatus: Gen2CaseStatus.MANUAL,
        processStatus: Gen2ProcessStatus.AT_CODER,
        processInstanceStatus: AccelerateProcessStatus.SUBMITTED,
        qaStatus: ProcessQAStatus.IN_QA,
        displayStatus: "Manual Codes In QA"
    },
    {
        chargeable: true,
        caseStatus: Gen2CaseStatus.MANUAL,
        processStatus: Gen2ProcessStatus.AT_CODER,
        processInstanceStatus: AccelerateProcessStatus.SUBMITTED,
        qaStatus: ProcessQAStatus.QA_COMPLETE,
        displayStatus: "Manual Codes QA Complete"
    },
    {
        chargeable: true,
        caseStatus: Gen2CaseStatus.MANUAL,
        processStatus: Gen2ProcessStatus.CODES_RECEIVED,
        displayStatus: "Manual Codes Received"
    },
    {
        chargeable: true,
        caseStatus: Gen2CaseStatus.MANUAL,
        processStatus: Gen2ProcessStatus.DONE,
        displayStatus: "Sent to Billing (Client)"
    },
    {
        chargeable: true,
        caseStatus: Gen2CaseStatus.MANUAL,
        processStatus: Gen2ProcessStatus.DONE,
        processInstanceStatus: AccelerateProcessStatus.LATE_CASE_UPDATE,
        displayStatus: "Billed Case Updated (Client)"
    },
    {
        chargeable: true,
        caseStatus: Gen2CaseStatus.MANUAL,
        displayStatus: "Error"
    },
    {
        chargeable: true,
        caseStatus: Gen2CaseStatus.AUTOMATED,
        processStatus: Gen2ProcessStatus.DONE,
        displayStatus: "Sent to Billing (CMX)"
    },
    {
        chargeable: true,
        caseStatus: Gen2CaseStatus.AUTOMATED,
        processStatus: Gen2ProcessStatus.DONE,
        processInstanceStatus: AccelerateProcessStatus.LATE_CASE_UPDATE,
        displayStatus: "Billed Case Updated"
    }
];
const serviceLineStatusMap = {};
// this list of service line mirror the gen2 list in service-lines.ts
serviceLineStatusMap[ServiceLines.IPC] = ipcStatusMapList;
serviceLineStatusMap[ServiceLines.IPC_LONG_NAME] = ipcStatusMapList;
serviceLineStatusMap[ServiceLines.BEDSIDE_PRO] = ipcStatusMapList;
serviceLineStatusMap[ServiceLines.BEDSIDE_PRO_NO_SPACE] = ipcStatusMapList;
serviceLineStatusMap[ServiceLines.AUTOMATE] = ipcStatusMapList;
const fieldMatch = (fieldValue, inputValue)=>{
    return !valueUndefined(fieldValue) && fieldValue === inputValue;
};
const valueUndefined = (fieldValue)=>{
    return typeof fieldValue === 'undefined' || fieldValue === null;
};
const lookupCaseDisplayStatus = (serviceLine, chargeable, caseStatus, processStatus, processInstanceStatus, qaStatus, holdStatus)=>{
    if (!serviceLineStatusMap[serviceLine]) {
        return null;
    }
    const statusMapList = serviceLineStatusMap[serviceLine];
    const tierFullMatch = [];
    const tierQaMatch = [];
    const tierHoldMatch = [];
    const tierProcessInstanceStatusMatch = [];
    const tierProcessStatusMatch = [];
    const tierCaseStatus = [];
    const tierChargeableMatch = [];
    statusMapList.forEach((record)=>{
        if (fieldMatch(record.chargeable, chargeable) && fieldMatch(record.caseStatus, caseStatus) && fieldMatch(record.processStatus, processStatus) && fieldMatch(record.processInstanceStatus, processInstanceStatus) && fieldMatch(record.qaStatus, qaStatus) && fieldMatch(record.holdStatus, holdStatus)) {
            tierFullMatch.push(record);
        } else if (fieldMatch(record.chargeable, chargeable) && fieldMatch(record.caseStatus, caseStatus) && fieldMatch(record.processStatus, processStatus) && fieldMatch(record.processInstanceStatus, processInstanceStatus) && fieldMatch(record.qaStatus, qaStatus) && valueUndefined(record.holdStatus)) {
            tierQaMatch.push(record);
        } else if (fieldMatch(record.chargeable, chargeable) && fieldMatch(record.caseStatus, caseStatus) && fieldMatch(record.processStatus, processStatus) && fieldMatch(record.processInstanceStatus, processInstanceStatus) && valueUndefined(record.qaStatus) && fieldMatch(record.holdStatus, holdStatus)) {
            tierHoldMatch.push(record);
        } else if (fieldMatch(record.chargeable, chargeable) && fieldMatch(record.caseStatus, caseStatus) && fieldMatch(record.processStatus, processStatus) && fieldMatch(record.processInstanceStatus, processInstanceStatus) && valueUndefined(record.qaStatus) && valueUndefined(record.holdStatus)) {
            tierProcessInstanceStatusMatch.push(record);
        } else if (fieldMatch(record.chargeable, chargeable) && fieldMatch(record.caseStatus, caseStatus) && fieldMatch(record.processStatus, processStatus) && valueUndefined(record.processInstanceStatus) && valueUndefined(record.qaStatus) && valueUndefined(record.holdStatus)) {
            tierProcessStatusMatch.push(record);
        } else if (fieldMatch(record.chargeable, chargeable) && fieldMatch(record.caseStatus, caseStatus) && valueUndefined(record.processStatus) && valueUndefined(record.processInstanceStatus) && valueUndefined(record.qaStatus) && valueUndefined(record.holdStatus)) {
            tierCaseStatus.push(record);
        } else if (fieldMatch(record.chargeable, chargeable) && valueUndefined(record.caseStatus) && valueUndefined(record.processStatus) && valueUndefined(record.processInstanceStatus) && valueUndefined(record.qaStatus) && valueUndefined(record.holdStatus)) {
            tierChargeableMatch.push(record);
        }
    });
    if (tierFullMatch.length) {
        return tierFullMatch.pop().displayStatus;
    } else if (tierQaMatch.length) {
        return tierQaMatch.pop().displayStatus;
    } else if (tierHoldMatch.length) {
        return tierHoldMatch.pop().displayStatus;
    } else if (tierProcessInstanceStatusMatch.length) {
        return tierProcessInstanceStatusMatch.pop().displayStatus;
    } else if (tierProcessStatusMatch.length) {
        return tierProcessStatusMatch.pop().displayStatus;
    } else if (tierCaseStatus.length) {
        return tierCaseStatus.pop().displayStatus;
    } else if (tierChargeableMatch.length) {
        return tierChargeableMatch.pop().displayStatus;
    } else {
        return null;
    }
};

function _define_property$8(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$8(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$8(target, key, source[key]);
        });
    }
    return target;
}
/**
 * Converts the top-level keys of an object from camelCase to snake_case.
 * @param {Object} obj - The object to process.
 * @returns {Object} - A new object with snake_cased keys.
 */ function convertKeysToSnakeCase(obj, initialObject = {}) {
    const newObj = _object_spread$8({}, initialObject);
    for(const key in obj){
        if (obj.hasOwnProperty(key)) {
            const snakeCasedKey = key.replace(/([A-Z])/g, '_$1').toLowerCase();
            newObj[snakeCasedKey] = obj[key];
        }
    }
    return newObj;
}

function _define_property$7(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$7(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$7(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$7(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$7(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$7(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
enableMapSet();
const CODER_SET = new Set([
    CaseArtifactTypes$1.PROCESSED,
    CaseArtifactTypes$1.SUBMITTED,
    CaseArtifactTypes$1.CODED
]);
const { InvoiceTypes, ChargeSessionCodeType, ChargeSessionCodeProvenance, CodeSearchType } = commonEnums;
// This copy/pasted code will be removed in
// https://codametrix.atlassian.net/browse/SURG-188
const getNotes = (caseRun)=>{
    const { notes } = caseRun;
    return decorateNotes(notes);
};
const decorateNotes = (notes)=>{
    return notes.map((note)=>{
        const withDecodedContent = isIPCNote(note) && note.encoding === 'base64' && note.type !== 'text/html' ? _object_spread_props$7(_object_spread$7({}, note), {
            content: convertBase64(note.content)
        }) : note;
        const segments = segmentize(withDecodedContent);
        return decoratedNoteFactory(_object_spread_props$7(_object_spread$7({}, withDecodedContent), {
            segments,
            spans: []
        }));
    });
};
const parseSuggestedCodes = (suggestedResult, previousSuggestedCodes, codeType)=>{
    const { procedure_codes, modifier_codes, diagnosis_codes } = suggestedResult;
    const getFilteredCodes = (codes)=>{
        var _ref, _ref1, _ref2;
        return {
            encounterList: (_ref = codes === null || codes === void 0 ? void 0 : codes.filter((c)=>(c === null || c === void 0 ? void 0 : c.suggested_code_type) === SugggestedCodeType.RELATED_CASE)) !== null && _ref !== void 0 ? _ref : [],
            caseList: (_ref1 = codes === null || codes === void 0 ? void 0 : codes.filter((c)=>(c === null || c === void 0 ? void 0 : c.suggested_code_type) === SugggestedCodeType.CURRENT_CASE)) !== null && _ref1 !== void 0 ? _ref1 : [],
            codeSourceList: (_ref2 = codes === null || codes === void 0 ? void 0 : codes.filter((c)=>(c === null || c === void 0 ? void 0 : c.suggested_code_type) === SugggestedCodeType.FROM_SOURCES)) !== null && _ref2 !== void 0 ? _ref2 : []
        };
    };
    const suggestedCodes = {
        cpt: codeType === CodeSearchType.CPT ? {
            encounterList: [
                ...procedure_codes
            ],
            caseList: [],
            codeSourceList: []
        } : previousSuggestedCodes === null || previousSuggestedCodes === void 0 ? void 0 : previousSuggestedCodes.cpt,
        modifier: codeType === CodeSearchType.MODIFIER ? getFilteredCodes(modifier_codes) : previousSuggestedCodes === null || previousSuggestedCodes === void 0 ? void 0 : previousSuggestedCodes.modifier,
        icd: codeType === CodeSearchType.ICD ? getFilteredCodes(diagnosis_codes) : previousSuggestedCodes === null || previousSuggestedCodes === void 0 ? void 0 : previousSuggestedCodes.icd
    };
    return suggestedCodes;
};
const updateCodes = (state, { result: processInstanceFromAction })=>{
    var _vitalware_parseAndFilterV2Errors;
    var _state_activeItem, _state_activeItem1;
    if (!processInstanceFromAction) {
        return _object_spread$7({}, state);
    }
    // Never mutate action.payload / frozen Immer references — helpers assign to processInstance.
    let processInstance = cloneDeep(processInstanceFromAction);
    const formatedV2Errors = (_vitalware_parseAndFilterV2Errors = parseAndFilterV2Errors(processInstance === null || processInstance === void 0 ? void 0 : processInstance.errors)) !== null && _vitalware_parseAndFilterV2Errors !== void 0 ? _vitalware_parseAndFilterV2Errors : [];
    const errorList = [
        ...processInstance.errors,
        ...formatedV2Errors
    ];
    // default value for isChargeable is true
    if ((processInstance === null || processInstance === void 0 ? void 0 : processInstance.isChargeable) === null) {
        processInstance.isChargeable = true;
    }
    // error handling.
    const codeEdits = parseProcessInstance(processInstance);
    let claimEditErrors = (errorList === null || errorList === void 0 ? void 0 : errorList.filter((error)=>error.message_key === IssueTypeErrors.CLAIMS_EDIT)) || [];
    let cciEditErrors = (errorList === null || errorList === void 0 ? void 0 : errorList.filter((error)=>error.message_key === IssueTypeErrors.CCI_EDIT)) || [];
    const customRuleErrors = (errorList === null || errorList === void 0 ? void 0 : errorList.filter((error)=>error.message_key === IssueTypeErrors.CUSTOM_RULES)) || [];
    const parsedClaimEditErrors = claimEditErrors.map((editError)=>normalizeClaims(parseVWIssues(editError.message)));
    const parsedCciEditErrors = cciEditErrors.map((editError)=>normalizeCCIS(parseVWIssues(editError.message)));
    const parsedCustomRuleErrors = customRuleErrors.map((editError)=>normalizeCustomRules(parseVWIssues(editError.message)));
    const vitalwareIssues = parseVWByStatus([
        ...parsedClaimEditErrors,
        ...parsedCciEditErrors,
        ...parsedCustomRuleErrors
    ]);
    const { unresolved_documents, hold_issue } = parseInvoiceIssues(processInstance);
    // synthetically create issues for vitalware
    const issues = createSyntheticStandardErrors(processInstance);
    const filteredIssues = filterInvoiceIssues(processInstance);
    const mergeSplitHistoryIssues = filterMergeHistoryWarnings(processInstance);
    processInstance.errors = [
        ...filteredIssues,
        ...issues
    ];
    processInstance = setErrors((processInstance === null || processInstance === void 0 ? void 0 : processInstance.errors) || [], processInstance);
    let codableInvoices = convertInvoicesToCodable(processInstance, state.codeEdits);
    codableInvoices = addDescriptionsToCodableInvoices(codableInvoices, state.codeDescriptions);
    codableInvoices = updateFieldDefinitions(codableInvoices);
    codableInvoices = addCategoricalDataToCodableInvoices(codableInvoices, state.activeItem);
    let chargeSessions = convertInvoicesToCharges(processInstance, state.codeEdits);
    const counts = summarize(chargeSessions);
    const benchEditable = determineBenchEditable(processInstance, state.userContext, state.roles, (_state_activeItem = state.activeItem) === null || _state_activeItem === void 0 ? void 0 : _state_activeItem.parent_caserun_uid, state.submitInProgress);
    if (isIPC(state === null || state === void 0 ? void 0 : (_state_activeItem1 = state.activeItem) === null || _state_activeItem1 === void 0 ? void 0 : _state_activeItem1.service_line)) {
        processInstance.caseType = UIModesEnum.STANDALONE;
    }
    return _object_spread_props$7(_object_spread$7({}, state), {
        benchEditable,
        processInstance: processInstance,
        codableInvoices: codableInvoices,
        preCommitChargeSessions: [],
        codeEdits,
        vitalwareIssues,
        mergeSplitHistoryIssues,
        counts,
        documentImprovementIssues: unresolved_documents,
        holdIssues: hold_issue
    });
};
const updateFieldDefinitions = (codableInvoices)=>{
    return [
        ...codableInvoices
    ].map((codableInvoice)=>{
        codableInvoice.transactions = codableInvoice.transactions.map((txn)=>{
            if (codableInvoice.type === InvoiceTypes.SHARED_CODES) {
                return _object_spread_props$7(_object_spread$7({}, txn), {
                    fieldDefinitions: [
                        {
                            label: 'Diagnosis',
                            value: 'ICD',
                            key: 'ICD'
                        }
                    ]
                });
            }
            const hasProcedures = txn.codes.filter(isChargeSessionCode).some((code)=>code.codeType === ChargeSessionCodeType.PROCEDURE && code.provenance === ChargeSessionCodeProvenance.CPT);
            const fieldDefinitions = [
                {
                    label: 'Procedure',
                    value: 'CPT',
                    key: 'CPT',
                    disabled: hasProcedures
                },
                {
                    label: 'Diagnosis',
                    value: 'ICD',
                    key: 'ICD'
                },
                {
                    label: 'Modifier',
                    value: 'MODIFIER',
                    key: 'MODIFIER'
                }
            ];
            return _object_spread_props$7(_object_spread$7({}, txn), {
                fieldDefinitions
            });
        });
        return codableInvoice;
    });
};
const pessimisticallyRevert = (state, res)=>{
    const s = _object_spread$7({}, state);
    s.chargeSessions = [
        ...state.preCommitChargeSessions
    ];
    s.preCommitChargeSessions = [];
    return s;
};
const updateConcurrentCaseAccessBenchEditable = (state, payload, isCaseTakenByAnotherUser)=>{
    var _state_activeItem;
    // Environment variable: ALLOW_CONCURRENT_CASE_EDIT
    // If set to "true" (or not defined), allows editing a case even if it is already opened by another user.
    // If set to "false", such cases will be read-only.
    const isConcurrentCaseEditAllowed = process.env.ALLOW_CONCURRENT_CASE_EDIT == 'true';
    return determineBenchEditable(payload, state.userContext, state.roles, (_state_activeItem = state.activeItem) === null || _state_activeItem === void 0 ? void 0 : _state_activeItem.parent_caserun_uid, state.submitInProgress, !isCaseTakenByAnotherUser || isConcurrentCaseEditAllowed);
};
const initialState = codeBenchState;
const codeBench = createReducer(initialState, (builder)=>{
    builder.addCase(resetCommonState.type, ()=>_object_spread$7({}, initialState));
    builder.addCase('CODE_UPDATE/rejected', pessimisticallyRevert);
    builder.addCase('INVOICE_SUBMITTED/pending', (state, action)=>{
        var _state_activeItem;
        const submitInProgress = true;
        const { processInstance } = action.meta.arg;
        const benchEditable = determineBenchEditable(processInstance, state.userContext, state.roles, (_state_activeItem = state.activeItem) === null || _state_activeItem === void 0 ? void 0 : _state_activeItem.parent_caserun_uid, submitInProgress);
        return _object_spread_props$7(_object_spread$7({}, state), {
            submitInProgress,
            benchEditable
        });
    });
    builder.addCase('INVOICE_SUBMITTED/rejected', (state, action)=>{
        var _state_activeItem;
        const submitInProgress = false;
        const { processInstance } = action.meta.arg;
        const benchEditable = determineBenchEditable(processInstance, state.userContext, state.roles, (_state_activeItem = state.activeItem) === null || _state_activeItem === void 0 ? void 0 : _state_activeItem.parent_caserun_uid, submitInProgress);
        return _object_spread_props$7(_object_spread$7({}, state), {
            submitInProgress,
            benchEditable
        });
    });
    builder.addCase('INVOICE_SUBMITTED/fulfilled', (state, action)=>{
        const processInstance = action.payload;
        return updateCodes(_object_spread_props$7(_object_spread$7({}, state), {
            submitInProgress: false
        }), {
            result: processInstance
        });
    });
    builder.addCase('CODE_UPDATE/fulfilled', (state, action)=>{
        return updateCodes(state, {
            result: action.payload
        });
    });
    builder.addCase('CODE_ADD/fulfilled', (state, action)=>{
        return updateCodes(state, {
            result: action.payload
        });
    });
    builder.addCase('BULK_CODE_ADD/fulfilled', (state, action)=>{
        return updateCodes(state, {
            result: action.payload
        });
    });
    builder.addCase('CODE_REMOVE/fulfilled', (state, action)=>{
        return updateCodes(state, {
            result: action.payload
        });
    });
    builder.addCase('BULK_CODE_REMOVE/fulfilled', (state, action)=>{
        return updateCodes(state, {
            result: action.payload
        });
    });
    builder.addCase('TIME_BASED_CODE_ADD/fulfilled', (state, action)=>{
        return updateCodes(state, {
            result: action.payload
        });
    });
    builder.addCase('CODE_SEARCH_DROP/fulfilled', (state, action)=>{
        return updateCodes(state, {
            result: action.payload
        });
    });
    builder.addCase('TXN_SHARED_CODE/fulfilled', (state, action)=>{
        return updateCodes(state, {
            result: action.payload
        });
    });
    builder.addCase('ENABLE_TECH_PRO/fulfilled', (state, action)=>{
        return updateCodes(state, {
            result: action.payload
        });
    });
    builder.addCase('DISABLE_TECH_PRO/fulfilled', (state, action)=>{
        return updateCodes(state, {
            result: action.payload
        });
    });
    builder.addCase('TOGGLE_CHARGEABLE_CASE/fulfilled', (state, action)=>{
        return updateCodes(state, {
            result: action.payload
        });
    });
    builder.addCase('TRANSACTION_ORDER_CHANGE/fulfilled', (state, action)=>{
        return updateCodes(state, {
            result: action.payload
        });
    });
    builder.addCase(removeTransaction.fulfilled, (state, action)=>{
        return updateCodes(state, {
            result: action.payload
        });
    });
    builder.addCase('CODE_ADD/pending', (state, action)=>{
        var _ref;
        var _action_meta_arg_context_transaction, _action_meta_arg_context, _action_meta_arg;
        // selecting a code to add wipes out the search results for
        // that term.
        const transactionGuid = (_ref = (_action_meta_arg = action.meta.arg) === null || _action_meta_arg === void 0 ? void 0 : (_action_meta_arg_context = _action_meta_arg.context) === null || _action_meta_arg_context === void 0 ? void 0 : (_action_meta_arg_context_transaction = _action_meta_arg_context.transaction) === null || _action_meta_arg_context_transaction === void 0 ? void 0 : _action_meta_arg_context_transaction.guid) !== null && _ref !== void 0 ? _ref : '';
        const newResults = _object_spread$7({}, state.searchResults);
        newResults[transactionGuid] = [];
        return _object_spread_props$7(_object_spread$7({}, state), {
            searchResults: newResults
        });
    });
    builder.addCase('CODE_SEARCH_DROP/pending', (state, action)=>{
        var _ref;
        var _action_meta_arg_context_transaction, _action_meta_arg_context, _action_meta_arg;
        // selecting a code to add wipes out the search results for
        // that term.
        const transactionGuid = (_ref = (_action_meta_arg = action.meta.arg) === null || _action_meta_arg === void 0 ? void 0 : (_action_meta_arg_context = _action_meta_arg.context) === null || _action_meta_arg_context === void 0 ? void 0 : (_action_meta_arg_context_transaction = _action_meta_arg_context.transaction) === null || _action_meta_arg_context_transaction === void 0 ? void 0 : _action_meta_arg_context_transaction.guid) !== null && _ref !== void 0 ? _ref : '';
        const newResults = _object_spread$7({}, state.searchResults);
        newResults[transactionGuid] = [];
        return _object_spread_props$7(_object_spread$7({}, state), {
            searchResults: newResults
        });
    });
    builder.addCase(tokenAvailable.pending, (state)=>{
        return _object_spread$7({}, codeBenchState);
    });
    builder.addCase(loadCaseFromId.pending, (state)=>{
        const { hostCaseId, userContext, roles, showSideNavBar } = state;
        const caseAccessTime = format(new Date().toUTCString().replace('GMT', '[GMT]'), FORMATS.DATE_TIME_WITHOUT_TIMEZONE);
        return _object_spread_props$7(_object_spread$7({}, codeBenchState), {
            hostCaseId,
            userContext,
            roles,
            caseAccessTime,
            showSideNavBar
        });
    });
    builder.addCase(loadFromURLMatch.pending, (state)=>{
        const { hostCaseId, userContext, roles, showSideNavBar } = state;
        const caseAccessTime = format(new Date().toUTCString().replace('GMT', '[GMT]'), FORMATS.DATE_TIME_WITHOUT_TIMEZONE);
        return _object_spread_props$7(_object_spread$7({}, codeBenchState), {
            hostCaseId,
            userContext,
            roles,
            caseAccessTime,
            showSideNavBar
        });
    });
    builder.addCase(getInvoiceOptions.fulfilled, (state, action)=>{
        const invoiceOptions = action.payload;
        return _object_spread_props$7(_object_spread$7({}, state), {
            invoiceOptions
        });
    });
    builder.addCase('ALL_INVOICES/fulfilled', (state, action)=>{
        const invoiceOptions = action.payload;
        return _object_spread_props$7(_object_spread$7({}, state), {
            invoiceOptions
        });
    });
    builder.addCase('POPUP_NAVIGATE', (state, action)=>{
        const caseRequest = action.payload;
        return _object_spread_props$7(_object_spread$7({}, state), {
            modalURL: {
                path: `/accelerate/popup`,
                //@ts-ignore
                queryString: `?${new URLSearchParams({
                    caseId: caseRequest.caseId,
                    hostCaseId: `${caseRequest.hostCaseId}`,
                    popup: 'true',
                    requestToken: 'true',
                    serviceLine: caseRequest.serviceLine
                })}`
            }
        });
    });
    builder.addCase('POPUP_CLOSE', (state)=>{
        return _object_spread_props$7(_object_spread$7({}, state), {
            modalURL: {
                path: ''
            }
        });
    });
    builder.addCase('CANCEL_INVOICES_POPUP', (state)=>{
        return _object_spread_props$7(_object_spread$7({}, state), {
            displayCancellation: true
        });
    });
    builder.addCase('OPEN_ADD_CHARGE_MODAL', (state)=>{
        return _object_spread_props$7(_object_spread$7({}, state), {
            displayAddCharge: true
        });
    });
    builder.addCase('CLOSE_ADD_CHARGE_MODAL', (state)=>{
        return _object_spread_props$7(_object_spread$7({}, state), {
            displayAddCharge: false
        });
    });
    builder.addCase('ADD_TRANSACTION_LOADING', (state)=>{
        return _object_spread_props$7(_object_spread$7({}, state), {
            showAddChargeLoading: true
        });
    });
    builder.addCase('SELECT_INVOICE_TO_ADD', (state)=>{
        return _object_spread_props$7(_object_spread$7({}, state), {
            displayAddCharge: false
        });
    });
    builder.addCase('ADD_TRANSACTION/rejected', (state)=>{
        return _object_spread_props$7(_object_spread$7({}, state), {
            showAddChargeError: true,
            showAddChargeLoading: false
        });
    });
    builder.addCase('ADD_TRANSACTION/fulfilled', (state)=>{
        return _object_spread_props$7(_object_spread$7({}, state), {
            displayAddCharge: false,
            showAddChargeLoading: false
        });
    });
    builder.addCase('SHOW_SUBMITTED_FEEDBACK', (state)=>{
        return _object_spread_props$7(_object_spread$7({}, state), {
            showSubmittedFeedback: true,
            showLoadingSubmission: false,
            showvitalwareIssuesModal: false
        });
    });
    builder.addCase('SHOW_LOADING_SUBMISSION', (state)=>{
        return _object_spread_props$7(_object_spread$7({}, state), {
            showLoadingSubmission: true
        });
    });
    builder.addCase('SHOW_LOADING_CANCELATION', (state)=>{
        return _object_spread_props$7(_object_spread$7({}, state), {
            showLoadingCancelation: true
        });
    });
    builder.addCase('SHOW_CANCELED_MODAL', (state)=>{
        return _object_spread_props$7(_object_spread$7({}, state), {
            showCanceledFeedback: true,
            showLoadingCancelation: false
        });
    });
    builder.addCase('HIDE_LOADING_SUBMISSION', (state)=>{
        return _object_spread_props$7(_object_spread$7({}, state), {
            showLoadingSubmission: false
        });
    });
    builder.addCase('HIDE_SUBMITTED_FEEDBACK', (state)=>{
        return _object_spread_props$7(_object_spread$7({}, state), {
            showSubmittedFeedback: false,
            showCanceledFeedback: false
        });
    });
    builder.addCase('SUBMITTED_MODAL_TIMER', (state)=>{
        return _object_spread_props$7(_object_spread$7({}, state), {
            submittedFeedbackTimer: true
        });
    });
    builder.addCase('CANCEL_INVOICES_DISMISS', (state)=>{
        return _object_spread_props$7(_object_spread$7({}, state), {
            displayCancellation: false
        });
    });
    builder.addCase('SET_BENCH_MODE', (state, action)=>{
        const benchMode = action.payload;
        return _object_spread_props$7(_object_spread$7({}, state), {
            benchMode
        });
    });
    builder.addCase('CASE_OPEN_SUCCESS', (state, action)=>{
        const payload = action.payload;
        const benchEditable = state.benchMode === BenchMode.GRADE ? state.benchEditable : updateConcurrentCaseAccessBenchEditable(state, payload, false);
        return _object_spread_props$7(_object_spread$7({}, state), {
            benchEditable,
            caseAccessState: CaseAccessState.ACQUIRED
        });
    });
    builder.addCase('CASE_OPEN_CONFLICT', (state, action)=>{
        const payload = action.payload;
        return _object_spread_props$7(_object_spread$7({}, state), {
            benchEditable: updateConcurrentCaseAccessBenchEditable(state, payload, true),
            caseAccessState: CaseAccessState.CONFLICT
        });
    });
    builder.addCase(setLockCaseUid.type, (state, action)=>{
        return _object_spread_props$7(_object_spread$7({}, state), {
            lockCaseUid: action.payload
        });
    });
    builder.addCase('RESET_CASE_ACCESS', (state, action)=>{
        const payload = action.payload;
        return _object_spread_props$7(_object_spread$7({}, state), {
            benchEditable: updateConcurrentCaseAccessBenchEditable(state, payload, true),
            caseAccessState: CaseAccessState.NONE
        });
    });
    builder.addCase('CANCEL_INVOICES_CONFIRM/fulfilled', (state, action)=>{
        const processInstance = action.payload;
        const updatedState = updateCodes(state, {
            result: processInstance
        });
        return _object_spread_props$7(_object_spread$7({}, state, updatedState), {
            displayCancellation: false,
            processInstance
        });
    });
    builder.addCase('INVOICE_AVAILABLE/fulfilled', (state, action)=>{
        const processInstance = action.payload;
        const updatedState = updateCodes(state, {
            result: processInstance
        });
        return _object_spread$7({}, state, updatedState);
    });
    builder.addCase(saveInvoice.fulfilled, (state, action)=>{
        const processInstance = action.payload;
        const updatedState = updateCodes(state, {
            result: processInstance
        });
        return _object_spread$7({}, state, updatedState);
    });
    builder.addCase(createInvoice.fulfilled, (state, action)=>{
        const processInstance = action.payload;
        const updatedState = updateCodes(state, {
            result: processInstance
        });
        return _object_spread$7({}, state, updatedState);
    });
    builder.addCase('FETCH_SOURCE_INVOICES/fulfilled', (state, action)=>{
        const invoices = action.payload;
        return _object_spread_props$7(_object_spread$7({}, state), {
            sourceInvoices: {
                sourceInvoices: invoices,
                sourceInvoicesLoadState: LOAD_STATES.done
            }
        });
    });
    builder.addCase('FETCH_SOURCE_INVOICES/pending', (state)=>{
        return _object_spread_props$7(_object_spread$7({}, state), {
            sourceInvoices: {
                sourceInvoices: [],
                sourceInvoicesLoadState: LOAD_STATES.started
            }
        });
    });
    builder.addCase('FETCH_SOURCE_INVOICES/rejected', (state)=>{
        return _object_spread_props$7(_object_spread$7({}, state), {
            sourceInvoices: {
                sourceInvoices: [],
                sourceInvoicesLoadState: LOAD_STATES.failed
            }
        });
    });
    builder.addCase('ACTIVITY/fulfilled', (state, action)=>{
        const activity = action.payload;
        return _object_spread_props$7(_object_spread$7({}, state), {
            activity: activity
        });
    });
    builder.addCase('INVOICE_AVAILABLE/rejected', (state)=>{
        return _object_spread_props$7(_object_spread$7({}, state), {
            codableInvoices: []
        });
    });
    builder.addCase('CODE_SEARCH/fulfilled', (state, action)=>{
        var _state_codeDescriptions, _ref;
        var _searchResponse_codeQuery_context_transaction, _searchResponse_codeQuery_context, _searchResponse_codeQuery_context_transaction1, _searchResponse_codeQuery_context1;
        const params = action.meta.arg;
        const searchResponse = action.payload;
        const existingDescriptions = (_state_codeDescriptions = state.codeDescriptions) !== null && _state_codeDescriptions !== void 0 ? _state_codeDescriptions : {};
        // append the search results to a specific charge session.
        const newResults = _object_spread$7({}, state.searchResults);
        const newResultsV2 = _object_spread$7({}, state.codeSearchResultsV2);
        let primaryResultId = '';
        if ((_searchResponse_codeQuery_context = searchResponse.codeQuery.context) === null || _searchResponse_codeQuery_context === void 0 ? void 0 : (_searchResponse_codeQuery_context_transaction = _searchResponse_codeQuery_context.transaction) === null || _searchResponse_codeQuery_context_transaction === void 0 ? void 0 : _searchResponse_codeQuery_context_transaction.guid) {
            var _searchResponse_codeQuery_context_transaction2, _searchResponse_codeQuery_context2;
            primaryResultId = (_searchResponse_codeQuery_context2 = searchResponse.codeQuery.context) === null || _searchResponse_codeQuery_context2 === void 0 ? void 0 : (_searchResponse_codeQuery_context_transaction2 = _searchResponse_codeQuery_context2.transaction) === null || _searchResponse_codeQuery_context_transaction2 === void 0 ? void 0 : _searchResponse_codeQuery_context_transaction2.guid;
        }
        if ((_searchResponse_codeQuery_context1 = searchResponse.codeQuery.context) === null || _searchResponse_codeQuery_context1 === void 0 ? void 0 : (_searchResponse_codeQuery_context_transaction1 = _searchResponse_codeQuery_context1.transaction) === null || _searchResponse_codeQuery_context_transaction1 === void 0 ? void 0 : _searchResponse_codeQuery_context_transaction1.id) {
            var _searchResponse_codeQuery_context_transaction3, _searchResponse_codeQuery_context3;
            primaryResultId = (_searchResponse_codeQuery_context3 = searchResponse.codeQuery.context) === null || _searchResponse_codeQuery_context3 === void 0 ? void 0 : (_searchResponse_codeQuery_context_transaction3 = _searchResponse_codeQuery_context3.transaction) === null || _searchResponse_codeQuery_context_transaction3 === void 0 ? void 0 : _searchResponse_codeQuery_context_transaction3.id;
        }
        primaryResultId = primaryResultId || (params === null || params === void 0 ? void 0 : params.searchResultsLookupKey) || '';
        // grab the max from the cache.
        newResults[primaryResultId] = searchCache.getLatest(searchResponse).searchResults;
        const existingResultsBySearchType = (_ref = newResultsV2 === null || newResultsV2 === void 0 ? void 0 : newResultsV2[primaryResultId]) !== null && _ref !== void 0 ? _ref : {};
        newResultsV2[primaryResultId] = _object_spread_props$7(_object_spread$7({}, existingResultsBySearchType), {
            [params === null || params === void 0 ? void 0 : params.searchType]: searchCache.getLatest(searchResponse).searchResults
        });
        const codeDescriptions = _object_spread$7({}, existingDescriptions);
        searchResponse.searchResults.forEach((code)=>{
            codeDescriptions[code.code] = codeDescriptions[code.code] || code;
        });
        return _object_spread_props$7(_object_spread$7({}, state), {
            searchResults: newResults,
            codeSearchResultsV2: newResultsV2,
            codeDescriptions
        });
    });
    builder.addCase('PARENT_CASE', (state, action)=>{
        const caseIds = action.payload;
        return _object_spread_props$7(_object_spread$7({}, state), {
            hostCaseId: caseIds.hostCaseId
        });
    });
    builder.addCase('FEATURE_SELECTION', (state, action)=>{
        var _activations_spans_body;
        const selection = action.payload;
        const { notes } = state;
        const activations = activationProcessor(selection, state.activations.panel, state.activations.property, state.activations.spans);
        // Assume we have 0 or 1 notes until surgery or some
        // other situation arises.
        // If we don't have a note, then we use a mock note.
        const note = notes.length > 0 ? notes[0] : _object_spread$7({}, EMPTY_NOTE);
        const boundedSpans = normalizeSpans(note.segments, (_activations_spans_body = activations.spans.body) !== null && _activations_spans_body !== void 0 ? _activations_spans_body : []);
        const returnedNotes = [
            _object_spread_props$7(_object_spread$7({}, note), {
                spans: boundedSpans
            })
        ];
        return _object_spread_props$7(_object_spread$7({}, state), {
            activations,
            notes: returnedNotes
        });
    });
    builder.addCase('CLEAR_SEARCH', (state, action)=>{
        const identifier = action.payload;
        const newResults = _object_spread$7({}, state.searchResults);
        newResults[identifier] = [];
        const newResultsV2 = _object_spread$7({}, state.codeSearchResultsV2);
        newResultsV2[identifier] = {};
        return _object_spread_props$7(_object_spread$7({}, state), {
            searchResults: newResults,
            codeSearchResultsV2: newResultsV2
        });
    });
    builder.addCase('CASE_SEARCH', (state, action)=>{
        const cases = action.payload;
        return _object_spread_props$7(_object_spread$7({}, state), {
            cases
        });
    });
    builder.addCase('CODE_DESCRIPTIONS', (state, action)=>{
        const newDescriptions = action.payload;
        const { codeDescriptions, codableInvoices: originalInvoices, sourceInvoices } = state;
        const updatedDescriptions = _object_spread$7({}, codeDescriptions, newDescriptions);
        const codableInvoices = addDescriptionsToCodableInvoices(cloneDeep(originalInvoices || []), updatedDescriptions);
        return _object_spread_props$7(_object_spread$7({}, state), {
            codeDescriptions: updatedDescriptions,
            codableInvoices,
            sourceInvoices
        });
    });
    builder.addCase('BILLING_GROUP', (state, action)=>{
        const result = action.payload;
        const { activeItem } = state;
        const groupedCases = getGroupedCases(activeItem, result.content, 'billing');
        return _object_spread_props$7(_object_spread$7({}, state), {
            billingGroupLoadState: LOAD_STATES.done,
            groupedCases
        });
    });
    builder.addCase('USER_DETAILS', (state, action)=>{
        const userDetails = action.payload;
        const userContext = userDetails.contexts.find((context)=>context.organizationId === userDetails.activeContextId);
        return _object_spread_props$7(_object_spread$7({}, state), {
            userContext
        });
    });
    builder.addCase('ACTIVITY_PROMPT', (state)=>{
        return _object_spread_props$7(_object_spread$7({}, state), {
            prompt: {
                text: 'Are you still there?'
            }
        });
    });
    builder.addCase('PROMPT_CLOSE', (state)=>{
        return _object_spread_props$7(_object_spread$7({}, state), {
            //@ts-ignore
            prompt: null
        });
    });
    builder.addCase('NAVIGATE_DETAIL/pending', (state)=>{
        const { activations, artifactSet, artifactList, propertyConfig, codeEdits, artifactLoadState, loadState, processInstance, codableInvoices, preCommitChargeSessions, activity, benchEditable, counts } = codeBenchState;
        return _object_spread_props$7(_object_spread$7({}, state), {
            benchEditable,
            activations,
            artifactSet,
            artifactList,
            propertyConfig,
            codeEdits,
            artifactLoadState,
            loadState,
            processInstance,
            codableInvoices,
            preCommitChargeSessions,
            activity,
            billingGroupLoadState: LOAD_STATES.started,
            counts
        });
    });
    builder.addCase('CASE_DETAIL', (state, action)=>{
        const activeItem = action.payload;
        const artifactSet = CODER_SET;
        const codeEdits = parseCodeEdits(activeItem);
        const notes = getNotes(activeItem);
        let slName = `${activeItem.service_line}`.toLowerCase();
        if (isIPC(slName)) {
            slName = 'inpatientprofessionalcoding';
        }
        const encounterColumns = doesPathEndWithV2() ? PatientAmplifyEncounterColumns : PatientAmplifyEncounterColumns$1;
        // Check if slName exists in the chosen object - this is the fallback
        const fallbackPropertyConfig = slName in encounterColumns ? encounterColumns[slName] : state.propertyConfig;
        // Use existing dynamic config if available, otherwise use fallback
        let propertyConfig = fallbackPropertyConfig;
        if (doesPathEndWithV2()) ; else {
            propertyConfig = state.dynamicPropertyConfig || fallbackPropertyConfig;
        }
        const mixin = {};
        // IPC Notes come from a separate process and are not included fully on
        // the case
        if (!isIPC(activeItem === null || activeItem === void 0 ? void 0 : activeItem.service_line)) {
            let newNotes = [
                ...notes
            ];
            newNotes = newNotes.filter((note)=>note.document_id !== null);
            newNotes.sort(compareDecoratedNotesForNav);
            mixin.notes = newNotes;
        }
        return _object_spread_props$7(_object_spread$7({}, state, mixin), {
            activeItem,
            artifactSet,
            propertyConfig,
            fallbackPropertyConfig,
            codeEdits,
            artifactLoadState: LOAD_STATES.done,
            loadState: LOAD_STATES.done
        });
    });
    builder.addCase('CASE_DETAIL_WITH_REFRESH', (state, action)=>{
        const activeItemWithRefresh = action.payload;
        /**
     * Currently updating latest patient_class and patient_type from XC
     * In future we could add more props
     */ let activeItem = state.activeItem;
        if (!!activeItem) {
            var _ref, _ref1;
            activeItem = _object_spread_props$7(_object_spread$7({}, activeItem), {
                patient_class: (_ref = activeItemWithRefresh === null || activeItemWithRefresh === void 0 ? void 0 : activeItemWithRefresh.patient_class) !== null && _ref !== void 0 ? _ref : activeItem === null || activeItem === void 0 ? void 0 : activeItem.patient_class,
                patient_type: (_ref1 = activeItemWithRefresh === null || activeItemWithRefresh === void 0 ? void 0 : activeItemWithRefresh.patient_type) !== null && _ref1 !== void 0 ? _ref1 : activeItem === null || activeItem === void 0 ? void 0 : activeItem.patient_type
            });
        }
        return _object_spread_props$7(_object_spread$7({}, state), {
            activeItem
        });
    });
    builder.addCase('SHOW_SIZE_EXP_WARNING', (state)=>{
        return _object_spread_props$7(_object_spread$7({}, state), {
            showSizeExpWarning: state.showSizeExpWarning === null ? false : true
        });
    });
    builder.addCase('HIDE_SIZE_EXP_WARNING', (state)=>{
        return _object_spread_props$7(_object_spread$7({}, state), {
            showSizeExpWarning: state.showSizeExpWarning === null ? false : false
        });
    });
    builder.addCase('DELETE_SIZE_EXP_WARNING', (state)=>{
        return _object_spread_props$7(_object_spread$7({}, state), {
            showSizeExpWarning: false
        });
    });
    builder.addCase('OPTIMISTIC_PRO_TECH_CHANGE', (state, action)=>{
        const techCodableTransaction = action.payload;
        if (techCodableTransaction === undefined) return _object_spread$7({}, state);
        // store invoices in constant, using 'state' object
        const invoices = cloneDeep(state.processInstance.invoices);
        // find invoice index with matching guid
        const invoiceIndex = invoices.findIndex((invoice)=>{
            var _techCodableTransaction_invoice;
            return invoice.guid === (techCodableTransaction === null || techCodableTransaction === void 0 ? void 0 : (_techCodableTransaction_invoice = techCodableTransaction.invoice) === null || _techCodableTransaction_invoice === void 0 ? void 0 : _techCodableTransaction_invoice.guid);
        });
        // find transaction where code matches either the mapped procedure code or technical code
        const transaction = invoices[invoiceIndex].transactions.find((transaction)=>transaction.guid === techCodableTransaction.transactionGuid);
        if (transaction !== null && transaction !== undefined) {
            // check if mapped procedure property exists and change active state
            if (Object(techCodableTransaction).hasOwnProperty('mappedProcedure')) {
                //@ts-ignore
                transaction.mapped_procedure.active = !transaction.mapped_procedure.active;
            // else check for technical code property and change active state
            } else if (Object(techCodableTransaction).hasOwnProperty('technicalCode')) {
                //@ts-ignore
                transaction.technical_code.active = !transaction.technical_code.active;
            }
        }
        // update codes using spread operator
        const updatedState = updateCodes(state, {
            result: _object_spread_props$7(_object_spread$7({}, state.processInstance), {
                invoices
            })
        });
        return _object_spread$7({}, state, updatedState);
    });
    builder.addCase('SET_LOADING_TECH_PRO', (state, action)=>{
        const options = action.payload;
        // store invoices in constant, using 'state' object
        const invoices = cloneDeep(state.processInstance.invoices);
        // find invoice index with matching guid
        const invoiceIndex = invoices.findIndex((invoice)=>invoice.guid === options.guid);
        // set loading state to invoice
        invoices[invoiceIndex].isLoadingTechPro = options.value;
        // update codes using spread operator
        const updatedState = updateCodes(state, {
            result: _object_spread_props$7(_object_spread$7({}, state.processInstance), {
                invoices
            })
        });
        return _object_spread$7({}, state, updatedState);
    });
    builder.addCase('SHOW_CLAIMS_ISSUES_MODAL', (state)=>{
        return _object_spread_props$7(_object_spread$7({}, state), {
            showvitalwareIssuesModal: true
        });
    });
    builder.addCase('HIDE_CLAIMS_ISSUES_MODAL', (state)=>{
        return _object_spread_props$7(_object_spread$7({}, state), {
            showvitalwareIssuesModal: false
        });
    });
    builder.addCase('SET_CLAIMS_ISSUES', (state, action)=>{
        const vitalwareIssuesArray = action.payload;
        return _object_spread_props$7(_object_spread$7({}, state), {
            vitalwareIssues: parseVWByStatus(vitalwareIssuesArray)
        });
    });
    builder.addCase('HIDE_HOLD_CASE_MODAL', (state)=>{
        return _object_spread_props$7(_object_spread$7({}, state), {
            toggleHoldCaseModal: false
        });
    });
    builder.addCase('SHOW_HOLD_CASE_MODAL', (state)=>{
        return _object_spread_props$7(_object_spread$7({}, state), {
            toggleHoldCaseModal: true
        });
    });
    builder.addCase('SHOW_CASE_COMMENT_MODAL', (state)=>{
        return _object_spread_props$7(_object_spread$7({}, state), {
            toggleCaseCommentModal: true
        });
    });
    builder.addCase('HIDE_CASE_COMMENT_MODAL', (state)=>{
        return _object_spread_props$7(_object_spread$7({}, state), {
            toggleCaseCommentModal: false
        });
    });
    builder.addCase('HIDE_EXCLUSION_CASE_MODAL', (state)=>{
        return _object_spread_props$7(_object_spread$7({}, state), {
            toggleExclusionCaseModal: false
        });
    });
    builder.addCase('TOGGLE_LATE_CASE_CLEAR_MODAL', (state, action)=>{
        const toggle = action.payload;
        return _object_spread_props$7(_object_spread$7({}, state), {
            showLateCaseClearModal: toggle
        });
    });
    builder.addCase('SHOW_EXCLUSION_CASE_MODAL', (state)=>{
        return _object_spread_props$7(_object_spread$7({}, state), {
            toggleExclusionCaseModal: true
        });
    });
    builder.addCase('SHOW_SPLIT_CASE_MODAL', (state)=>{
        return _object_spread_props$7(_object_spread$7({}, state), {
            toggleSplitCaseModal: true
        });
    });
    builder.addCase('HIDE_SPLIT_CASE_MODAL', (state)=>{
        return _object_spread_props$7(_object_spread$7({}, state), {
            toggleSplitCaseModal: false
        });
    });
    builder.addCase('TOGGLE_SUBMIT_OLD_CASE_MODAL', (state)=>{
        return _object_spread_props$7(_object_spread$7({}, state), {
            submitOldCaseModal: !state.submitOldCaseModal
        });
    });
    builder.addCase('SHOW_SIDE_NAV_BAR', (state)=>{
        return _object_spread_props$7(_object_spread$7({}, state), {
            showSideNavBar: true
        });
    });
    builder.addCase('HIDE_SIDE_NAV_BAR', (state)=>{
        return _object_spread_props$7(_object_spread$7({}, state), {
            showSideNavBar: false
        });
    });
    builder.addCase('FETCH_HOLD_CASE/fulfilled', (state, action)=>{
        const holdCaseStatus = action.payload;
        return _object_spread_props$7(_object_spread$7({}, state), {
            holdCaseStatus
        });
    });
    builder.addCase('FETCH_CASE_VERSIONS/pending', (state)=>{
        return _object_spread_props$7(_object_spread$7({}, state), {
            caseVersions: []
        });
    });
    builder.addCase('FETCH_CASE_VERSIONS/fulfilled', (state, action)=>{
        const caseVersions = action.payload;
        return _object_spread_props$7(_object_spread$7({}, state), {
            caseVersions
        });
    });
    builder.addCase('FETCH_CASES_WITH_ENCOUNTER/pending', (state)=>{
        return _object_spread_props$7(_object_spread$7({}, state), {
            relatedCasesLoadState: LOAD_STATES.initial
        });
    });
    builder.addCase('FETCH_CASES_WITH_ENCOUNTER/rejected', (state)=>{
        return _object_spread_props$7(_object_spread$7({}, state), {
            relatedCasesLoadState: LOAD_STATES.failed,
            relatedCases: [
                ...codeBenchState.relatedCases
            ]
        });
    });
    builder.addCase('FETCH_CASES_WITH_ENCOUNTER/fulfilled', (state, action)=>{
        const result = action.payload;
        const { roles, userContext } = state;
        const { content } = result;
        const sp = _object_spread_props$7(_object_spread$7({}, state.relatedCasesPageable), {
            pageableDefinition: result
        });
        const relatedCases = content.map((item)=>{
            var _item_coding_status, _item_coding_status1, _item_coding_status2, _item_coding_status3, _item_coding_status4, _item_coding_status5, _item_coding_status6, _item_coding_status7, _item_coding_status8;
            const chargeable = typeof (item === null || item === void 0 ? void 0 : item.chargeable_indicator) === 'string' ? (item === null || item === void 0 ? void 0 : item.chargeable_indicator) === 'true' : Boolean(item === null || item === void 0 ? void 0 : item.chargeable_indicator);
            const displayStatus = lookupCaseDisplayStatus(item === null || item === void 0 ? void 0 : item.service_line, chargeable, item === null || item === void 0 ? void 0 : item.case_status, item === null || item === void 0 ? void 0 : item.process_status, item === null || item === void 0 ? void 0 : (_item_coding_status = item.coding_status) === null || _item_coding_status === void 0 ? void 0 : _item_coding_status.process_instance_status, item === null || item === void 0 ? void 0 : (_item_coding_status1 = item.coding_status) === null || _item_coding_status1 === void 0 ? void 0 : _item_coding_status1.qa_status, item === null || item === void 0 ? void 0 : (_item_coding_status2 = item.coding_status) === null || _item_coding_status2 === void 0 ? void 0 : _item_coding_status2.hold_status);
            if (!!displayStatus) {
                return _object_spread_props$7(_object_spread$7({}, item), {
                    processStatus: displayStatus
                });
            }
            const processStatus = determineProcessStatus({
                isChargeable: item === null || item === void 0 ? void 0 : (_item_coding_status3 = item.coding_status) === null || _item_coding_status3 === void 0 ? void 0 : _item_coding_status3.is_chargeable,
                processInstanceStatus: item === null || item === void 0 ? void 0 : (_item_coding_status4 = item.coding_status) === null || _item_coding_status4 === void 0 ? void 0 : _item_coding_status4.process_instance_status,
                holdReason: item === null || item === void 0 ? void 0 : (_item_coding_status5 = item.coding_status) === null || _item_coding_status5 === void 0 ? void 0 : _item_coding_status5.hold_status,
                holdComment: item === null || item === void 0 ? void 0 : (_item_coding_status6 = item.coding_status) === null || _item_coding_status6 === void 0 ? void 0 : _item_coding_status6.hold_comment,
                qaStatus: item === null || item === void 0 ? void 0 : (_item_coding_status7 = item.coding_status) === null || _item_coding_status7 === void 0 ? void 0 : _item_coding_status7.qa_status,
                cancelled: item === null || item === void 0 ? void 0 : (_item_coding_status8 = item.coding_status) === null || _item_coding_status8 === void 0 ? void 0 : _item_coding_status8.is_cancelled,
                roles,
                userContext
            }, (item === null || item === void 0 ? void 0 : item.coding_status) !== null, null);
            return _object_spread_props$7(_object_spread$7({}, item), {
                processStatus
            });
        });
        return _object_spread_props$7(_object_spread$7({}, state), {
            relatedCases,
            relatedCasesPageable: sp,
            relatedCasesLoadState: LOAD_STATES.done
        });
    });
    builder.addCase('FETCH_CCI_CUSTOM_CLAIM_CROSS_CASES/pending', (state)=>{
        return _object_spread_props$7(_object_spread$7({}, state), {
            customClaimsRelatedCasesLoadState: LOAD_STATES.initial
        });
    });
    builder.addCase('FETCH_CCI_CUSTOM_CLAIM_CROSS_CASES/rejected', (state)=>{
        return _object_spread_props$7(_object_spread$7({}, state), {
            customClaimsRelatedCasesLoadState: LOAD_STATES.failed,
            customClaimsRelatedCases: [
                ...codeBenchState.customClaimsRelatedCases
            ]
        });
    });
    builder.addCase('FETCH_CCI_CUSTOM_CLAIM_CROSS_CASES/fulfilled', (state, action)=>{
        const result = action.payload;
        // Filter out items with the same case_id as activeItem case_id
        const filteredResult = result === null || result === void 0 ? void 0 : result.filter((item)=>item.case_id !== state.activeItem.case_id);
        return _object_spread_props$7(_object_spread$7({}, state), {
            customClaimsRelatedCases: filteredResult,
            customClaimsRelatedCasesLoadState: LOAD_STATES.done
        });
    });
    builder.addCase('ORGANIZATION_AVAILABLE', (state, action)=>{
        const organization = action.payload;
        //@ts-ignore
        return _object_spread_props$7(_object_spread$7({}, state), {
            organization
        });
    });
    builder.addCase('GET_HTML/fulfilled', (state, action)=>{
        var _state_documentMetadata, _state_documentMetadata1;
        const htmlNotes = action.payload;
        let newNotes = [
            ...htmlNotes
        ].filter((note)=>note.document_id !== null).map(shimSegmentsIfNeeded);
        newNotes.sort(compareDecoratedNotesForNav);
        const sortedNotesDocIds = newNotes.map((note)=>note.document_id);
        const metadataByDocId = new Map(((_state_documentMetadata = state.documentMetadata) !== null && _state_documentMetadata !== void 0 ? _state_documentMetadata : []).map((doc)=>[
                doc.documentId,
                doc
            ]));
        const seenDocIds = new Set();
        const newDocumentMetadata = [];
        for (const docId of sortedNotesDocIds){
            if (docId == null) continue;
            const meta = metadataByDocId.get(docId);
            if (meta && !seenDocIds.has(docId)) {
                newDocumentMetadata.push(meta);
                seenDocIds.add(docId);
            }
        }
        for (const doc of (_state_documentMetadata1 = state.documentMetadata) !== null && _state_documentMetadata1 !== void 0 ? _state_documentMetadata1 : []){
            if (!seenDocIds.has(doc.documentId)) {
                newDocumentMetadata.push(doc);
            }
        }
        return _object_spread_props$7(_object_spread$7({}, state), {
            notes: newNotes,
            activeNote: newNotes[0],
            documentMetadata: newDocumentMetadata
        });
    });
    builder.addCase('DOCUMENT_METADATA', (state, action)=>{
        const docs = action.payload;
        return _object_spread_props$7(_object_spread$7({}, state), {
            documentMetadata: docs
        });
    });
    builder.addCase('SET_ACTIVE_NOTE', (state, action)=>{
        const activeNote = action.payload;
        return _object_spread_props$7(_object_spread$7({}, state), {
            activeNote
        });
    });
    builder.addCase('LOAD_ROLES', (state, action)=>{
        const roles = action.payload;
        return _object_spread_props$7(_object_spread$7({}, state), {
            roles
        });
    });
    builder.addCase('FETCH_FLAGS/fulfilled', (state, action)=>{
        const flagList = action.payload;
        return _object_spread_props$7(_object_spread$7({}, state), {
            flagList
        });
    });
    builder.addCase('UPDATE_PROCESS_INSTANCE/fulfilled', (state, action)=>{
        const processInstance = action.payload;
        const updatedState = updateCodes(state, {
            result: processInstance
        });
        return _object_spread_props$7(_object_spread$7({}, state, updatedState), {
            processInstance
        });
    });
    builder.addCase('FETCH_NOTE_TYPES/fulfilled', (state, action)=>{
        var _ref;
        const dictionaryValues = action.payload;
        return _object_spread_props$7(_object_spread$7({}, state), {
            noteTypes: (_ref = dictionaryValues === null || dictionaryValues === void 0 ? void 0 : dictionaryValues.rowValues) !== null && _ref !== void 0 ? _ref : []
        });
    });
    builder.addCase('PROVIDER_ROLETYPE_CONFIGURATION/fulfilled', (state, action)=>{
        var _ref;
        const dictionaryValues = action.payload;
        return _object_spread_props$7(_object_spread$7({}, state), {
            providerRoleTypeConfig: (_ref = dictionaryValues === null || dictionaryValues === void 0 ? void 0 : dictionaryValues.rowValues) !== null && _ref !== void 0 ? _ref : []
        });
    });
    builder.addCase('SPLIT_CASE/rejected', (state)=>{
        return _object_spread_props$7(_object_spread$7({}, state), {
            toggleSplitCaseModal: false
        });
    });
    builder.addCase('SET_ACTIVE_MINI_TAB', (state, action)=>{
        const tabName = action.payload;
        const activeMiniTab = new Set(Object.values(MiniTabLabels)).has(tabName) ? tabName : MiniTabLabels.CHARGES_LABEL;
        return _object_spread_props$7(_object_spread$7({}, state), {
            activeMiniTab
        });
    });
    builder.addCase('SET_ACTIVE_VERTICAL_MINI_TAB', (state, action)=>{
        const tabName = action.payload;
        const activeVerticalMiniTab = new Set(Object.values(MiniTabLabels)).has(tabName) ? tabName : MiniTabLabels.NOTES_LABEL;
        return _object_spread_props$7(_object_spread$7({}, state), {
            activeVerticalMiniTab
        });
    });
    builder.addCase('SET_UNRESOLVED_DOCUMENTS', (state, action)=>{
        const showUnresolvedDocuments = action.payload;
        return _object_spread_props$7(_object_spread$7({}, state), {
            showUnresolvedDocuments
        });
    });
    builder.addCase('SPLIT_CASE/fulfilled', (state, action)=>{
        const processInstance = action.payload;
        const updatedState = updateCodes(state, {
            result: processInstance
        });
        return _object_spread_props$7(_object_spread$7({}, state, updatedState), {
            processInstance,
            toggleSplitCaseModal: false
        });
    });
    builder.addCase('UPDATE_TRANSACTION', (state, action)=>{
        var _state_processInstance;
        const payload = action.payload;
        const { transaction, invoiceGuid } = payload;
        const invoices = cloneDeep(((_state_processInstance = state.processInstance) === null || _state_processInstance === void 0 ? void 0 : _state_processInstance.invoices) || null);
        const invoiceIndex = invoices ? invoices.findIndex((inv)=>inv.guid === invoiceGuid) : -1;
        if (invoiceIndex !== -1) {
            var _invoices_invoiceIndex_transactions;
            const transactionIndex = (_invoices_invoiceIndex_transactions = invoices[invoiceIndex].transactions) === null || _invoices_invoiceIndex_transactions === void 0 ? void 0 : _invoices_invoiceIndex_transactions.findIndex((txn)=>txn.guid === transaction.guid);
            if (transactionIndex !== -1) {
                invoices[invoiceIndex].transactions[transactionIndex] = transaction;
            }
        }
        const updatedResult = _object_spread_props$7(_object_spread$7({}, state.processInstance), {
            invoices
        });
        // Call updateCodes with the updated result
        const updatedState = updateCodes(state, {
            result: updatedResult
        });
        return _object_spread$7({}, state, updatedState);
    });
    builder.addCase('UPDATE_TRANSACTION_OPTIMISTICALLY', (state, action)=>{
        var _state_processInstance;
        const payload = action.payload;
        const { addDTO, invoiceGuid } = payload;
        const invoices = cloneDeep(((_state_processInstance = state.processInstance) === null || _state_processInstance === void 0 ? void 0 : _state_processInstance.invoices) || null);
        const invoiceIndex = invoices ? invoices.findIndex((inv)=>inv.guid === invoiceGuid) : -1;
        if (invoiceIndex !== -1) {
            var _invoices_invoiceIndex_transactions;
            const transactionIndex = (_invoices_invoiceIndex_transactions = invoices[invoiceIndex].transactions) === null || _invoices_invoiceIndex_transactions === void 0 ? void 0 : _invoices_invoiceIndex_transactions.findIndex((txn)=>txn.guid === addDTO.transactionGuid);
            if (transactionIndex !== -1) {
                const transaction = invoices[invoiceIndex].transactions[transactionIndex];
                // Filter out 'transactionGuid' and assign all other properties
                const filteredAddDTO = Object.fromEntries(Object.entries(addDTO).filter(([key])=>key !== 'transactionGuid'));
                Object.assign(transaction, filteredAddDTO);
            }
        }
        const updatedResult = _object_spread_props$7(_object_spread$7({}, state.processInstance), {
            invoices
        });
        // Call updateCodes with the updated result
        const updatedState = updateCodes(state, {
            result: updatedResult
        });
        return _object_spread$7({}, state, updatedState);
    });
    builder.addCase('CREATE_TRANSACTION_OPTIMISTICALLY', (state, action)=>{
        var _state_processInstance;
        const payload = action.payload;
        const { createDTO, invoiceGuid } = payload;
        const invoices = cloneDeep(((_state_processInstance = state.processInstance) === null || _state_processInstance === void 0 ? void 0 : _state_processInstance.invoices) || []);
        const invoiceIndex = invoices.findIndex((inv)=>inv.guid === invoiceGuid);
        if (invoiceIndex !== -1) {
            const invoice = invoices[invoiceIndex];
            const existingTransactions = Array.isArray(invoice.transactions) ? invoice.transactions : [];
            const newTransaction = {
                procedure: createDTO.procedure,
                sequence_number: existingTransactions.length + 1,
                isTemporary: true
            };
            const updatedInvoice = _object_spread_props$7(_object_spread$7({}, invoice), {
                transactions: [
                    ...existingTransactions,
                    newTransaction
                ]
            });
            invoices[invoiceIndex] = updatedInvoice;
        }
        const updatedResult = _object_spread_props$7(_object_spread$7({}, state.processInstance), {
            invoices
        });
        const updatedState = updateCodes(state, {
            result: updatedResult
        });
        return _object_spread$7({}, state, updatedState);
    });
    builder.addCase('REPLACE_OPTIMISTIC_TRANSACTION', (state, action)=>{
        var _state_processInstance;
        const payload = action.payload;
        const { transaction, invoiceGuid } = payload;
        const invoices = cloneDeep(((_state_processInstance = state.processInstance) === null || _state_processInstance === void 0 ? void 0 : _state_processInstance.invoices) || []);
        const invoiceIndex = invoices.findIndex((inv)=>inv.guid === invoiceGuid);
        if (invoiceIndex !== -1) {
            const invoice = invoices[invoiceIndex];
            const existingTransactions = Array.isArray(invoice.transactions) ? invoice.transactions : [];
            // Find index of the temporary transaction
            const tempTxnIndex = existingTransactions.findIndex((txn)=>txn.isTemporary);
            // If found, replace it with the actual transaction
            if (tempTxnIndex !== -1) {
                const updatedTransactions = [
                    ...existingTransactions
                ];
                updatedTransactions[tempTxnIndex] = transaction;
                const updatedInvoice = _object_spread_props$7(_object_spread$7({}, invoice), {
                    transactions: updatedTransactions
                });
                invoices[invoiceIndex] = updatedInvoice;
                const updatedResult = _object_spread_props$7(_object_spread$7({}, state.processInstance), {
                    invoices
                });
                const updatedState = updateCodes(state, {
                    result: updatedResult
                });
                return _object_spread$7({}, state, updatedState);
            }
        }
        return state;
    });
    builder.addCase(loadCQAItemFromURL.pending, (state)=>{
        return _object_spread_props$7(_object_spread$7({}, state), {
            loadState: LOAD_STATES.started
        });
    });
    // There is a similar reducer for loadCQAItemFromURL action in grade-bench-panel.actions.ts
    builder.addCase(loadCQAItemFromURL.fulfilled, (state, action)=>{
        const result = action.payload;
        return _object_spread_props$7(_object_spread$7({}, state), {
            // used for patient info right bar only
            // activeItem is initialized as {}
            // https://github.com/CodaMetrix/ui-omnibus/blob/44a150472de319e37fb210e9be6a593deea61959/packages/ui-common/src/core/amplify/state/code-bench.ts#L92
            activeItem: _object_spread_props$7(_object_spread$7({}, convertKeysToSnakeCase(result.workItem)), {
                sd_case_id: result.sdCaseId,
                grader_updated_date: result.graderUpdatedDate
            }),
            loadState: LOAD_STATES.done,
            benchEditable: _object_spread_props$7(_object_spread$7({}, state.benchEditable), {
                editable: true,
                submitted: result.workItem.status == 'CQA_COMPLETE'
            })
        });
    });
    builder.addCase(getDocumentsAsHtmlFromCQAWorkItem.fulfilled, (state, action)=>{
        const result = action.payload;
        return _object_spread_props$7(_object_spread$7({}, state), {
            notes: result,
            activeNote: result.length ? result[0] : undefined,
            documentMetadata: []
        });
    });
    builder.addCase('FETCH_CODES_WITH_ENCOUNTER/fulfilled', (state, action)=>{
        var _state_codeDescriptions;
        var _params_codeType;
        const params = action.meta.arg;
        const suggestedCodeResult = action.payload;
        const codeDescriptions = _object_spread$7({}, (_state_codeDescriptions = state.codeDescriptions) !== null && _state_codeDescriptions !== void 0 ? _state_codeDescriptions : {});
        const { diagnosis_codes, modifier_codes, procedure_codes } = suggestedCodeResult || {};
        const addCodeDescriptions = (codes = [])=>codes.forEach((code)=>codeDescriptions[code.code] = codeDescriptions[code.code] || code);
        const codeType = params === null || params === void 0 ? void 0 : (_params_codeType = params.codeType) === null || _params_codeType === void 0 ? void 0 : _params_codeType.toUpperCase();
        const suggestedCodes = parseSuggestedCodes(suggestedCodeResult, state.suggestedCodes, codeType);
        [
            diagnosis_codes,
            modifier_codes,
            procedure_codes
        ].forEach(addCodeDescriptions);
        return _object_spread_props$7(_object_spread$7({}, state), {
            suggestedCodes: _object_spread$7({}, suggestedCodes),
            codeDescriptions
        });
    });
    builder.addCase('GET_RELATED_CODES/fulfilled', (state, action)=>{
        var _ref, _state_codeDescriptions;
        var _params_codeType, _state_suggestedCodes;
        const params = action.meta.arg;
        const result = action.payload;
        const codeTypeKey = params === null || params === void 0 ? void 0 : (_params_codeType = params.codeType) === null || _params_codeType === void 0 ? void 0 : _params_codeType.toLowerCase();
        // New endpoint returns a flat array; fall back to pageable .content for compatibility
        const codesArray = Array.isArray(result) ? result : (_ref = result === null || result === void 0 ? void 0 : result.content) !== null && _ref !== void 0 ? _ref : [];
        const newRelatedCodes = codesArray.map((code)=>{
            var _ref, _ref1;
            return _object_spread_props$7(_object_spread$7({}, code), {
                suggested_code_type: SugggestedCodeType.RELATED_CASE,
                code_source: (_ref = code === null || code === void 0 ? void 0 : code.code_source) !== null && _ref !== void 0 ? _ref : '',
                // Preserve code_recent_date from the API response; sort below activates once backend populates it
                code_recent_date: (_ref1 = code === null || code === void 0 ? void 0 : code.code_recent_date) !== null && _ref1 !== void 0 ? _ref1 : '',
                transaction_guids: []
            });
        }).sort((a, b)=>{
            const dateA = a.code_recent_date ? new Date(a.code_recent_date).getTime() : 0;
            const dateB = b.code_recent_date ? new Date(b.code_recent_date).getTime() : 0;
            return dateB - dateA;
        });
        const updatedSuggestedCodes = _object_spread_props$7(_object_spread$7({}, state.suggestedCodes), {
            [codeTypeKey]: _object_spread_props$7(_object_spread$7({}, (_state_suggestedCodes = state.suggestedCodes) === null || _state_suggestedCodes === void 0 ? void 0 : _state_suggestedCodes[codeTypeKey]), {
                encounterList: newRelatedCodes
            })
        });
        // Build a new codeDescriptions object — do not mutate the draft reference,
        // as this reducer returns a new state value (mixing both causes Immer error #4)
        const newCodeDescriptions = _object_spread$7({}, (_state_codeDescriptions = state.codeDescriptions) !== null && _state_codeDescriptions !== void 0 ? _state_codeDescriptions : {});
        newRelatedCodes.forEach((code)=>{
            newCodeDescriptions[code.code] = newCodeDescriptions[code.code] || code;
        });
        return _object_spread_props$7(_object_spread$7({}, state), {
            suggestedCodes: updatedSuggestedCodes,
            codeDescriptions: newCodeDescriptions
        });
    });
    builder.addCase('FETCH_CODE_BENCH_LAYOUT_CONFIGURATION/fulfilled', (state, action)=>{
        const jsonValue = action.payload;
        if (jsonValue && Object.keys(jsonValue).length > 0) {
            // Convert structure to one the UI expects
            const layoutConfig = {
                patient: Object.values(jsonValue.patient || {}).filter((value)=>value !== null).map((value)=>{
                    return _object_spread$7({}, value);
                }),
                summary: Object.values(jsonValue.summary || {}).filter((value)=>value !== null).map((value)=>{
                    return _object_spread$7({}, value);
                }),
                expanded: Object.values(jsonValue.expanded || {}).filter((value)=>value !== null).map((value)=>{
                    return _object_spread$7({}, value);
                })
            };
            return _object_spread_props$7(_object_spread$7({}, state), {
                dynamicPropertyConfig: layoutConfig,
                propertyConfig: layoutConfig
            });
        }
        return state;
    });
    builder.addCase('SET_CODE_BENCH_PROPERTY_CONFIG', (state, action)=>{
        const propertyConfig = action.payload;
        return _object_spread_props$7(_object_spread$7({}, state), {
            propertyConfig
        });
    });
    builder.addCase('FETCH_RELATED_CASE_FILTER_DICTIONARIES/fulfilled', (state, action)=>{
        const filterData = action.payload;
        const { activeItem } = state;
        const noteTypeOptions = convertToFilterRecord('Note Type', 'Note Type', 'Note Description', 'Note Description', filterData === null || filterData === void 0 ? void 0 : filterData['noteType'], false, 2);
        noteTypeOptions.filterOptions.forEach((option)=>{
            var _filterData_noteType;
            const item = filterData === null || filterData === void 0 ? void 0 : (_filterData_noteType = filterData['noteType']) === null || _filterData_noteType === void 0 ? void 0 : _filterData_noteType.find((item)=>!isEmpty(item === null || item === void 0 ? void 0 : item['Note Description']) && (item === null || item === void 0 ? void 0 : item['Note Description']) === option.key && ((item === null || item === void 0 ? void 0 : item['Filter Default']) === DictionaryFilterDefault.INCLUDE || !item.hasOwnProperty('Filter Default')));
            option.defaultSelection = !!item || option.key === 'noneKey' ? 'INCLUDE' : 'EXCLUDE';
        });
        const patientClassOptions = convertToFilterRecord('Patient Class', 'Patient Class', 'Patient Class', 'Patient Class', filterData === null || filterData === void 0 ? void 0 : filterData['patientClass'], true, 3);
        const noteSpecialtyOptions = convertToFilterRecord('Specialty', 'Specialty', 'Note Specialty', 'Note Specialty', filterData === null || filterData === void 0 ? void 0 : filterData['noteSpecialty'], true, 4);
        const dateOfService = new Date(format(activeItem.date_of_service, FORMATS.DATE_OF_SERVICE));
        let startDate;
        let endDate;
        if ((activeItem === null || activeItem === void 0 ? void 0 : activeItem.admission_datetime) && (activeItem === null || activeItem === void 0 ? void 0 : activeItem.discharge_datetime)) {
            startDate = new Date(format(activeItem.admission_datetime, FORMATS.DATE_OF_SERVICE));
            endDate = new Date(format(activeItem.discharge_datetime, FORMATS.DATE_OF_SERVICE));
        } else {
            endDate = new Date();
            let pastDate = format(endDate, FORMATS.DATE, {
                throw: false,
                localized: true,
                offset: {
                    action: DateManipulateOperation.SUBTRACT,
                    delta: [
                        30,
                        DateManipulateUnit.DAY
                    ]
                }
            });
            startDate = new Date(pastDate);
        }
        const dateFilter = {
            viewType: 'date_range_with_preset',
            type: 'date_range',
            label: 'Date range',
            displayOrder: 1,
            dateFilterOptions: {
                startDate: startDate,
                endDate: endDate,
                datePresets: [
                    {
                        key: 'date_of_service',
                        name: 'Date of Service',
                        displayOrder: 1,
                        startDate: dateOfService,
                        endDate: dateOfService
                    },
                    {
                        key: 'past_7_days',
                        name: 'Past 7 days',
                        displayOrder: 2,
                        duration: 7,
                        durationType: 'days'
                    },
                    {
                        key: 'past_30_days',
                        name: 'Past 30 days',
                        displayOrder: 3,
                        duration: 30,
                        durationType: 'days'
                    },
                    {
                        key: 'past_3_years',
                        name: 'Past 3 years',
                        displayOrder: 4,
                        duration: 3,
                        durationType: 'years'
                    }
                ]
            }
        };
        return _object_spread_props$7(_object_spread$7({}, state), {
            filterData: [
                noteTypeOptions,
                patientClassOptions,
                noteSpecialtyOptions,
                dateFilter
            ]
        });
    });
    builder.addCase('UPDATE_RELATED_CASE_FILTER_SELECTION', (state, action)=>{
        const relatedCasesFilterSelection = action.payload;
        return _object_spread_props$7(_object_spread$7({}, state), {
            relatedCasesFilterSelection
        });
    });
    builder.addCase('REFRESH_HOLD_SUBMISSION', (state)=>{
        const updatedState = updateCodes(state, {
            result: _object_spread$7({}, state.processInstance)
        });
        return _object_spread$7({}, state, updatedState);
    });
});

function _define_property$6(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$6(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$6(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$6(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$6(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$6(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const { ProviderType } = commonEnums;
const formErrors = {
    status: '',
    message: null,
    errors: [],
    fieldErrors: {}
};
/**
 * Returns information about a provider.
 *
 * @param {CMxAPI.Provider} provider
 * @returns {Object} An object containing provider information.
 */ const getProviderInfo = (provider)=>{
    const [identifier] = provider.identifiers;
    return {
        number: identifier.idNumber,
        issuer: identifier.idTypeCode,
        type: identifier.identifierType
    };
};
const invoiceMetadata = createReducer(invoiceMetadata$1, (builder)=>{
    builder.addCase(resetCommonState.type, ()=>_object_spread$6({}, invoiceMetadata$1));
    builder.addCase(providerSearch.pending, (state, action)=>{
        var _codeQuery_context;
        const codeQuery = action.meta.arg;
        const meetsMinimum = codeQuery.context.meetsMinimum;
        const providerType = codeQuery === null || codeQuery === void 0 ? void 0 : (_codeQuery_context = codeQuery.context) === null || _codeQuery_context === void 0 ? void 0 : _codeQuery_context.providerType;
        const isBillingProvideSearch = providerType === ProviderType$1.BILLING_PROVIDER;
        const isPerformingProviderSearch = providerType === ProviderType$1.PERFORMING_PROVIDER;
        const isReferringProviderSearch = providerType === ProviderType$1.REFERRING_PROVIDER;
        const billingProviderSearchResults = isBillingProvideSearch ? meetsMinimum ? state.billingProviderSearchResults : [] : state.billingProviderSearchResults;
        const referringProviderSearchResults = isReferringProviderSearch ? meetsMinimum ? state.referringProviderSearchResults : [] : state.referringProviderSearchResults;
        const performingProviderSearchResults = isPerformingProviderSearch ? meetsMinimum ? state.performingProviderSearchResults : [] : state.performingProviderSearchResults;
        return _object_spread_props$6(_object_spread$6({}, state), {
            billingProviderSearchResults,
            referringProviderSearchResults,
            performingProviderSearchResults
        });
    });
    builder.addCase(providerSearch.fulfilled, (state, action)=>{
        var _action_meta_arg_context, _action_meta_arg;
        const providerResults = action.payload;
        const providerType = (_action_meta_arg = action.meta.arg) === null || _action_meta_arg === void 0 ? void 0 : (_action_meta_arg_context = _action_meta_arg.context) === null || _action_meta_arg_context === void 0 ? void 0 : _action_meta_arg_context.providerType;
        const isBillingProvideSearch = providerType === ProviderType.BILLING_PROVIDER;
        const isPerformingProviderSearch = providerType === ProviderType.PERFORMING_PROVIDER;
        const isReferringProviderSearch = providerType === ProviderType.REFERRING_PROVIDER;
        const fromCache = providerSearchCache.getLatest(providerResults);
        const billingProviderSearchResults = isBillingProvideSearch ? fromCache.providers : state.billingProviderSearchResults;
        const referringProviderSearchResults = isReferringProviderSearch ? fromCache.providers : state.referringProviderSearchResults;
        const performingProviderSearchResults = isPerformingProviderSearch ? fromCache.providers : state.performingProviderSearchResults;
        return _object_spread_props$6(_object_spread$6({}, state), {
            billingProviderSearchResults,
            referringProviderSearchResults,
            performingProviderSearchResults
        });
    });
    builder.addCase(providerSearch.rejected, (state, action)=>{
        var _action_meta_arg_context, _action_meta_arg;
        const providerType = (_action_meta_arg = action.meta.arg) === null || _action_meta_arg === void 0 ? void 0 : (_action_meta_arg_context = _action_meta_arg.context) === null || _action_meta_arg_context === void 0 ? void 0 : _action_meta_arg_context.providerType;
        const isBillingProvideSearch = providerType === ProviderType.BILLING_PROVIDER;
        const isPerformingProviderSearch = providerType === ProviderType.PERFORMING_PROVIDER;
        const isReferringProviderSearch = providerType === ProviderType.REFERRING_PROVIDER;
        return _object_spread_props$6(_object_spread$6({}, state), {
            billingProviderSearchResults: isBillingProvideSearch ? [] : state.billingProviderSearchResults,
            referringProviderSearchResults: isReferringProviderSearch ? [] : state.referringProviderSearchResults,
            performingProviderSearchResults: isPerformingProviderSearch ? [] : state.performingProviderSearchResults
        });
    });
    builder.addCase(saveInvoice.fulfilled, (state)=>{
        // retain organization and processInstance context as this will
        // not change across invoice editing.
        const { organization, processInstance } = state;
        return _object_spread_props$6(_object_spread$6({}, invoiceMetadata$1), {
            organization,
            processInstance,
            displayMode: null
        });
    });
    builder.addCase('INVOICE_AVAILABLE/fulfilled', (state, action)=>{
        const processInstance = action.payload;
        return _object_spread_props$6(_object_spread$6({}, state), {
            processInstance
        });
    });
    builder.addCase(addProvider.type, (state, action)=>{
        const provider = action.payload;
        const invoice = _object_spread$6({}, state.invoice);
        if (provider) {
            var _ref, _ref1;
            var _provider_specialties_, _provider_specialties;
            invoice.billing_provider_name = provider.displayName;
            invoice.billing_provider_number = getProviderInfo(provider);
            //defaulted to first role of the selected provider for the time being
            invoice.billing_provider_type = (_ref = provider === null || provider === void 0 ? void 0 : (_provider_specialties = provider.specialties) === null || _provider_specialties === void 0 ? void 0 : (_provider_specialties_ = _provider_specialties[0]) === null || _provider_specialties_ === void 0 ? void 0 : _provider_specialties_.name) !== null && _ref !== void 0 ? _ref : null;
            invoice.billing_provider_credentials = (_ref1 = provider === null || provider === void 0 ? void 0 : provider.degree) !== null && _ref1 !== void 0 ? _ref1 : null;
        }
        return _object_spread_props$6(_object_spread$6({}, state), {
            invoice,
            billingProviderSearchResults: []
        });
    });
    builder.addCase(billingAreaOptions.type, (state, action)=>{
        return _object_spread_props$6(_object_spread$6({}, state), {
            billingAreaOptions: action.payload
        });
    });
    builder.addCase(removeProvider.type, (state)=>{
        const invoice = _object_spread$6({}, state.invoice);
        invoice.billing_provider_name = '';
        //@ts-ignore
        invoice.billing_provider_number = null;
        invoice.billing_provider_type = null;
        invoice.billing_provider_credentials = null;
        return _object_spread_props$6(_object_spread$6({}, state), {
            invoice
        });
    });
    builder.addCase('SELECT_INVOICE_TO_EDIT', (state, action)=>{
        const invoiceToEdit = cloneDeep(action.payload);
        // set fee schedule at invoice level from any not null transaction level
        if (!(invoiceToEdit === null || invoiceToEdit === void 0 ? void 0 : invoiceToEdit.fee_schedule)) {
            var _invoiceToEdit_transactions_find;
            invoiceToEdit.fee_schedule = (_invoiceToEdit_transactions_find = invoiceToEdit.transactions.find((transaction)=>transaction.fee_schedule !== null)) === null || _invoiceToEdit_transactions_find === void 0 ? void 0 : _invoiceToEdit_transactions_find.fee_schedule;
        }
        return _object_spread_props$6(_object_spread$6({}, state), {
            displayMode: InvoiceEditorMode.EDITOR,
            invoice: invoiceToEdit,
            formErrors: formErrors
        });
    });
    builder.addCase('SELECT_INVOICE_TO_ADD', (state, action)=>{
        const newInvoice = cloneDeep(action.payload);
        const invoiceOptions = cloneDeep(state.invoiceOptions);
        const feeSchedules = convertRecordToOptionList(invoiceOptions.summary.fee_schedules);
        // set default department to the new invoice
        newInvoice.department = getDefaultDepartment(invoiceOptions);
        newInvoice.department_code = newInvoice.department.code;
        // set default fee_schdule to the new invoice
        if (!(newInvoice === null || newInvoice === void 0 ? void 0 : newInvoice.fee_schedule) && feeSchedules.length === 1) {
            newInvoice.fee_schedule = feeSchedules[0].value;
        }
        // if there are more than one option, user should to choose
        if (feeSchedules.length > 1) {
            newInvoice.fee_schedule = null;
        }
        return _object_spread_props$6(_object_spread$6({}, state), {
            displayMode: InvoiceEditorMode.ADDITION,
            invoice: newInvoice,
            formErrors: formErrors
        });
    });
    //@ts-ignore
    builder.addCase(cancelChargeEdit.type, (state)=>{
        return _object_spread_props$6(_object_spread$6({}, state), {
            displayMode: null,
            invoice: null,
            billingProviderSearchResults: [],
            referringProviderSearchResults: [],
            performingProviderSearchResults: [],
            formErrors: formErrors
        });
    });
    builder.addCase('ORGANIZATION_AVAILABLE', (state, action)=>{
        //@ts-ignore
        return _object_spread_props$6(_object_spread$6({}, state), {
            organization: action.payload
        });
    });
    builder.addCase(createInvoice.fulfilled, (state)=>{
        const { organization, processInstance } = state;
        return _object_spread_props$6(_object_spread$6({}, invoiceMetadata$1), {
            organization,
            processInstance,
            displayMode: null
        });
    });
    builder.addCase(removeAdditionPerformer.type, (state)=>{
        const invoice = _object_spread$6({}, state.invoice);
        if (invoice === null) return _object_spread$6({}, state);
        invoice.performing_provider_name = '';
        //@ts-ignore
        invoice.performing_provider_number = null;
        invoice.performing_provider_type = null;
        invoice.performing_provider_credentials = null;
        return _object_spread_props$6(_object_spread$6({}, state), {
            invoice
        });
    });
    builder.addCase(removeAdditionReferringPerformer.type, (state)=>{
        const invoice = _object_spread$6({}, state.invoice);
        invoice.referring_provider_name = '';
        invoice.referring_provider_number = null;
        invoice.referring_provider_type = null;
        return _object_spread_props$6(_object_spread$6({}, state), {
            invoice
        });
    });
    builder.addCase(addAdditionPerformer.type, (state, action)=>{
        const provider = action.payload;
        const invoice = _object_spread$6({}, state.invoice);
        if (provider) {
            var _ref, _ref1;
            var _provider_specialties_, _provider_specialties;
            invoice.performing_provider_name = provider.displayName;
            invoice.performing_provider_number = getProviderInfo(provider);
            //defaulted to first role of the selected provider for the time being
            invoice.performing_provider_type = (_ref = provider === null || provider === void 0 ? void 0 : (_provider_specialties = provider.specialties) === null || _provider_specialties === void 0 ? void 0 : (_provider_specialties_ = _provider_specialties[0]) === null || _provider_specialties_ === void 0 ? void 0 : _provider_specialties_.name) !== null && _ref !== void 0 ? _ref : null;
            invoice.performing_provider_credentials = (_ref1 = provider === null || provider === void 0 ? void 0 : provider.degree) !== null && _ref1 !== void 0 ? _ref1 : null;
        }
        return _object_spread_props$6(_object_spread$6({}, state), {
            invoice,
            performingProviderSearchResults: []
        });
    });
    builder.addCase(addAdditionReferringPerformer.type, (state, action)=>{
        const provider = action.payload;
        const invoice = _object_spread$6({}, state.invoice);
        if (provider) {
            var _ref;
            var _provider_specialties_, _provider_specialties;
            invoice.referring_provider_name = provider.displayName;
            invoice.referring_provider_number = getProviderInfo(provider);
            //defaulted to first role of the selected provider for the time being
            invoice.referring_provider_type = (_ref = provider === null || provider === void 0 ? void 0 : (_provider_specialties = provider.specialties) === null || _provider_specialties === void 0 ? void 0 : (_provider_specialties_ = _provider_specialties[0]) === null || _provider_specialties_ === void 0 ? void 0 : _provider_specialties_.name) !== null && _ref !== void 0 ? _ref : null;
        }
        return _object_spread_props$6(_object_spread$6({}, state), {
            invoice,
            referringProviderSearchResults: []
        });
    });
    builder.addCase(changePerformDate.type, (state, action)=>{
        const invoice = _object_spread$6({}, state.invoice);
        invoice.date_of_service = action.payload;
        invoice.datetime_of_service = undefined;
        return _object_spread_props$6(_object_spread$6({}, state), {
            invoice
        });
    });
    builder.addCase(getInvoiceOptions.fulfilled, (state, action)=>{
        const invoiceOptions = action.payload;
        const invoice = cloneDeep(state.invoice);
        return _object_spread_props$6(_object_spread$6({}, state), {
            invoiceOptions,
            invoice
        });
    });
    builder.addCase('ALL_INVOICES/fulfilled', (state, action)=>{
        const invoiceOptions = action.payload;
        const invoice = cloneDeep(state.invoice);
        return _object_spread_props$6(_object_spread$6({}, state), {
            invoiceOptions,
            invoice
        });
    });
    builder.addCase(departmentChange.type, (state, action)=>{
        const invoice = cloneDeep(state.invoice);
        invoice.department_code = action.payload;
        invoice.department = getDepartmentFromCode(state.invoiceOptions, action.payload);
        return _object_spread_props$6(_object_spread$6({}, state), {
            invoice
        });
    });
    builder.addCase(feeScheduleChange.type, (state, action)=>{
        const invoice = cloneDeep(state.invoice);
        invoice.fee_schedule = action.payload;
        return _object_spread_props$6(_object_spread$6({}, state), {
            invoice
        });
    });
});

function _define_property$5(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$5(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$5(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$5(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$5(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const eula = createReducer(eula$1, (builder)=>{
    builder.addCase(resetCommonState.type, ()=>_object_spread$5({}, eula$1));
    builder.addCase(fetchEula.fulfilled, (state, action)=>({
            isCancelled: false,
            eula: action.payload
        }));
    builder.addCase(cancelEula, (state, action)=>_object_spread_props$5(_object_spread$5({}, state), {
            isCancelled: action.payload
        }));
});

const getCoderConfig = createAsyncThunk(AmplifyUIActions.GET_CODER_CONFIG, async (args)=>{
    return getConfigurationsForSectionV2(args);
});

var coderConfig = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getCoderConfig: getCoderConfig
});

function _define_property$4(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$4(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$4(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$4(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$4(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$4(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const { standaloneLaunch, contextParams } = launchPageActions;
const { dismissConfirm, handleConfirm, showConfirm, amplifyFeedback, hideFeedback, setStandaloneMode, setAmplifyView, setAutomateView } = uiActions;
const ui = createReducer(ampUI, (builder)=>{
    builder.addCase(resetCommonState.type, ()=>_object_spread$4({}, ampUI));
    builder.addCase(dismissConfirm.type, (state)=>{
        return _object_spread_props$4(_object_spread$4({}, state), {
            confirm: {
                display: false,
                title: 'Remove Charge'
            }
        });
    });
    builder.addCase(handleConfirm.type, (state)=>{
        return _object_spread_props$4(_object_spread$4({}, state), {
            confirm: {
                display: false,
                title: 'Remove Charge'
            }
        });
    });
    builder.addCase(contextParams.type, (state, action)=>{
        return _object_spread_props$4(_object_spread$4({}, state), {
            contextParams: action.payload
        });
    });
    builder.addCase(epicToken.type, (state, action)=>{
        return _object_spread_props$4(_object_spread$4({}, state), {
            epicToken: action.payload
        });
    });
    builder.addCase(showConfirm.type, (state, action)=>{
        const actionItem = action.payload;
        return _object_spread_props$4(_object_spread$4({}, state), {
            confirm: {
                display: true,
                title: 'Remove Charge',
                helpText: 'Removing this charge will delete this procedure.',
                actionItem
            }
        });
    });
    builder.addCase(amplifyFeedback.type, (state, action)=>{
        const payload = action.payload;
        return _object_spread_props$4(_object_spread$4({}, state), {
            showFeedBack: true,
            feedback: {
                message: payload.message,
                dismissable: payload.dismissable,
                id: Date.now(),
                meta: {
                    level: payload.meta
                }
            }
        });
    });
    builder.addCase(hideFeedback.type, (state)=>{
        return _object_spread_props$4(_object_spread$4({}, state), {
            showFeedBack: false
        });
    });
    builder.addCase(standaloneLaunch.pending, (state)=>{
        return _object_spread_props$4(_object_spread$4({}, state), {
            UIMode: UIModesEnum.STANDALONE
        });
    });
    builder.addCase(setStandaloneMode.type, (state)=>{
        return _object_spread_props$4(_object_spread$4({}, state), {
            UIMode: UIModesEnum.STANDALONE
        });
    });
    builder.addCase(setAmplifyView.type, (state)=>{
        return _object_spread_props$4(_object_spread$4({}, state), {
            UIView: UIViewEnum.AMPLIFY
        });
    });
    builder.addCase(setAutomateView.type, (state)=>{
        return _object_spread_props$4(_object_spread$4({}, state), {
            UIView: UIViewEnum.AUTOMATE
        });
    });
    builder.addCase(getCoderConfig.pending, (state)=>{
        return _object_spread_props$4(_object_spread$4({}, state), {
            coderConfig: []
        });
    });
    builder.addCase(getCoderConfig.rejected, (state)=>{
        return _object_spread_props$4(_object_spread$4({}, state), {
            coderConfig: []
        });
    });
    builder.addCase(getCoderConfig.fulfilled, (state, action)=>{
        return _object_spread_props$4(_object_spread$4({}, state), {
            coderConfig: action.payload
        });
    });
});

function _define_property$3(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$3(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$3(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$3(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$3(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const updateCapabilities = (state, { result: processInstance, isCaseAccessReadOnly })=>{
    var _state_userContext, _state_userContext1;
    const benchEditable = determineBenchEditable(processInstance, state.userContext, state.roles, state.parentCaserunUid, state.submitInProgress, isCaseAccessReadOnly);
    const improvements = getImprovements();
    const improvementsAction = getImprovementsAction(processInstance, benchEditable);
    const submitCase = getRenderSubmitCase(processInstance, benchEditable);
    const viewOnlyCase = getRenderviewOnlyCase(benchEditable);
    const pagination = getRenderPagination(processInstance, benchEditable);
    const holdCase = getRenderHoldCase(processInstance, state.holdCaseStatus, benchEditable);
    const removeHoldCase = getRenderOffHoldCase(processInstance, state.holdCaseStatus, benchEditable);
    const toggleChargeableCase = getRenderToggleChargeableCase(processInstance, benchEditable, state.roles, state.excludeCasePermissionsConfig);
    const caseEdit = getCaseEditable(processInstance, benchEditable);
    const createCase = getCreateCaseCapability(state.userContext, processInstance);
    const splitCapability = getSplitActionMenuCapability(benchEditable, state.userContext, state.parentCase, state.activeServiceLineName);
    const lateCaseClearNotification = getLateCaseClearNotificationCapability(processInstance);
    // This has dependency on holdCase, toggleChargeableCase, splitCapability from above
    const actionMenu = getActionMenuCapability(holdCase, removeHoldCase, toggleChargeableCase, splitCapability, lateCaseClearNotification, processInstance);
    const diagnosisCodeSuggestion = getDiagnosisCodeSuggestionCapability(state.userContext, processInstance, benchEditable);
    const coderNotes = getCoderNotesCapability(state.userContext, state.activeServiceLineName);
    const transactionV2 = getTransactionV2Capability(state.userContext, state.activeServiceLineName);
    const amplifyCaseRunV2 = getAmplifyCaseRunV2Capability(state.userContext, state.activeServiceLineName);
    const actionMenuCancelButton = getActionMenuCancelCapability(processInstance, benchEditable, actionMenu, state.roles, (_state_userContext = state.userContext) === null || _state_userContext === void 0 ? void 0 : _state_userContext.resources);
    // This has dependency on cancelCase and toggleChargeableCase from above
    const generalCancelButton = getGeneralCancelCapability(actionMenu, actionMenuCancelButton, benchEditable, (_state_userContext1 = state.userContext) === null || _state_userContext1 === void 0 ? void 0 : _state_userContext1.resources, state.activeServiceLineName);
    const servicedeskAction = getServicedeskActions(processInstance, state.cursorAPIContext);
    const mergeCapability = getMergeActionMenuCapability(benchEditable, state.userContext, state.parentCase, state.activeItem, state.activeServiceLineName);
    const coderFeedback = getCoderFeedbackCapability(benchEditable, processInstance, state.userContext);
    const actionBarSelectMultipleWorkitems = getActionBarSelectMultipleWorkitemsCapability(state.roles);
    const codeSourcesFeatures = getCodeSourcesFeaturesCapability(state.userContext, state.activeServiceLineName);
    const relatedCasesFilter = getRelatedCasesFilterCapability(state.userContext, state.activeServiceLineName);
    const useDataAccessAmplify = getUseDataAccessAmplifyCapability(state.userContext, state.activeServiceLineName);
    const capabilities = _object_spread_props$3(_object_spread$3({}, state.capabilities), {
        improvements,
        submitCase,
        actionMenuCancelButton,
        viewOnlyCase,
        pagination,
        holdCase,
        removeHoldCase,
        toggleChargeableCase,
        caseEdit,
        actionMenu,
        generalCancelButton,
        improvementsAction,
        servicedeskAction,
        mergeCapability,
        splitCapability,
        coderFeedback,
        createCase,
        diagnosisCodeSuggestion,
        coderNotes,
        transactionV2,
        amplifyCaseRunV2,
        actionBarSelectMultipleWorkitems,
        codeSourcesFeatures,
        relatedCasesFilter,
        lateCaseClearNotification,
        useDataAccessAmplify
    });
    return capabilities;
};
const updateCapabilitiesOnContext = (activeContext, state, activeServiceLineName = '')=>{
    const timelineInfiniteLoad = getTimelineInfiniteLoadCapability(activeContext, activeServiceLineName);
    const attachDocs = getAttachDocsCapability(activeContext, activeServiceLineName);
    const productivityTracker = getProductivityTrackerCapability(activeContext, activeServiceLineName);
    const getCaseRunWithRefresh = getGetCaserunWithRefreshCapability(activeContext, activeServiceLineName);
    const useProviderDirectoryLocations = getUseProviderDirectoryLocations(activeContext, activeServiceLineName);
    const capabilities = _object_spread_props$3(_object_spread$3({}, state.capabilities), {
        timelineInfiniteLoad,
        attachDocs,
        productivityTracker,
        getCaseRunWithRefresh,
        useProviderDirectoryLocations
    });
    return capabilities;
};
const getConcurrentCaseAccessCapabilities = (state, payload, isCaseAccessReadOnly)=>{
    // Environment variable: ALLOW_CONCURRENT_CASE_EDIT
    // If set to "true" (or not defined), capabilities remain unchanged.
    // If set to "false", capabilities such as action menu, case edit, etc. will be removed.
    const isConcurrentCaseEditAllowed = process.env.ALLOW_CONCURRENT_CASE_EDIT !== 'false'; // default true if not set
    if (isConcurrentCaseEditAllowed) {
        return state.capabilities;
    }
    return updateCapabilities(state, {
        result: payload,
        isCaseAccessReadOnly
    });
};
const capabilities = createReducer(capabilities$1, (builder)=>{
    builder.addCase(resetCommonState.type, ()=>_object_spread$3({}, capabilities$1));
    builder.addCase('FETCH_EXCLUDE_CASE_PERMISSIONS_CONFIG/fulfilled', (state, action)=>{
        return _object_spread_props$3(_object_spread$3({}, state), {
            excludeCasePermissionsConfig: action.payload
        });
    });
    builder.addCase('LOAD_ROLES', (state, action)=>{
        return _object_spread_props$3(_object_spread$3({}, state), {
            roles: action.payload
        });
    });
    builder.addCase('CASE_DETAIL', (state, action)=>{
        const activeItem = action.payload;
        const noteUnavailableReason = getNoteUnavailableReason(activeItem);
        return _object_spread_props$3(_object_spread$3({}, state), {
            parentCaserunUid: activeItem === null || activeItem === void 0 ? void 0 : activeItem.parent_caserun_uid,
            parentCase: activeItem === null || activeItem === void 0 ? void 0 : activeItem.parent_case,
            activeItem: activeItem,
            capabilities: _object_spread_props$3(_object_spread$3({}, state.capabilities), {
                noteUnavailableReason
            })
        });
    });
    builder.addCase('LOAD_CURSOR_API_CONTEXT', (state, action)=>{
        var _action_payload;
        const payload = (_action_payload = action.payload) !== null && _action_payload !== void 0 ? _action_payload : {};
        const cursorAPIContext = _object_spread$3({}, state.cursorAPIContext, payload);
        const servicedeskAction = getServicedeskActions(state.activeItem, cursorAPIContext);
        return _object_spread_props$3(_object_spread$3({}, state), {
            cursorAPIContext,
            capabilities: _object_spread_props$3(_object_spread$3({}, state.capabilities), {
                servicedeskAction
            })
        });
    });
    builder.addCase('RESET_CURSOR_API_CONTEXT', (state)=>{
        const cursorAPIContext = _object_spread$3({}, capabilities$1.cursorAPIContext);
        const servicedeskAction = getServicedeskActions(state.activeItem, cursorAPIContext);
        return _object_spread_props$3(_object_spread$3({}, state), {
            cursorAPIContext,
            capabilities: _object_spread_props$3(_object_spread$3({}, state.capabilities), {
                servicedeskAction
            })
        });
    });
    builder.addCase('SHOW_CASE_COMMENT_MODAL', (state)=>{
        const toggleCaseComment = getToggleCaseComment(state.capabilities.removeHoldCase, true);
        const capabilities = _object_spread_props$3(_object_spread$3({}, state.capabilities), {
            toggleCaseComment
        });
        return _object_spread_props$3(_object_spread$3({}, state), {
            capabilities
        });
    });
    builder.addCase('HIDE_CASE_COMMENT_MODAL', (state)=>{
        const toggleCaseComment = getToggleCaseComment(state.capabilities.removeHoldCase, false);
        const capabilities = _object_spread_props$3(_object_spread$3({}, state.capabilities), {
            toggleCaseComment
        });
        return _object_spread_props$3(_object_spread$3({}, state), {
            capabilities
        });
    });
    builder.addCase('USER_DETAILS', (state, action)=>{
        const userDetails = action.payload;
        const userContext = userDetails.contexts.find((context)=>context.organizationId === userDetails.activeContextId);
        return _object_spread_props$3(_object_spread$3({}, state), {
            userContext,
            capabilities: updateCapabilitiesOnContext(userContext, state, state.activeServiceLineName)
        });
    });
    builder.addCase('FETCH_HOLD_CASE/fulfilled', (state, action)=>{
        const processInstance = action.meta.arg;
        const holdCaseStatus = action.payload;
        const benchEditable = determineBenchEditable(processInstance, state.userContext, state.roles, state.parentCaserunUid, state.submitInProgress);
        const holdCaseCapability = getRenderHoldCase(processInstance, holdCaseStatus, benchEditable);
        const removeHoldCase = getRenderOffHoldCase(processInstance, holdCaseStatus, benchEditable);
        const capabilities = _object_spread_props$3(_object_spread$3({}, state.capabilities), {
            holdCase: holdCaseCapability,
            removeHoldCase
        });
        return _object_spread_props$3(_object_spread$3({}, state), {
            capabilities,
            holdCaseStatus
        });
    });
    builder.addCase('FETCH_CASE_VERSIONS/fulfilled', (state, action)=>{
        const processInstance = action.meta.arg;
        const caseVersions = action.payload;
        const oldCaseLoadedAlert = getOldCaseLoadedAlert(caseVersions, processInstance);
        const previousSentCaseAlert = getPreviousSentCaseAlert(caseVersions, processInstance);
        const capabilities = _object_spread_props$3(_object_spread$3({}, state.capabilities), {
            oldCaseLoadedAlert,
            previousSentCaseAlert
        });
        return _object_spread_props$3(_object_spread$3({}, state), {
            capabilities
        });
    });
    builder.addCase('INVOICE_AVAILABLE/fulfilled', (state, action)=>{
        const processInstance = action.payload;
        const capabilities = updateCapabilities(state, {
            result: processInstance
        });
        return _object_spread_props$3(_object_spread$3({}, state), {
            capabilities
        });
    });
    builder.addCase('CANCEL_INVOICES_CONFIRM/fulfilled', (state, action)=>{
        const processInstance = action.payload;
        const capabilities = updateCapabilities(state, {
            result: processInstance
        });
        return _object_spread_props$3(_object_spread$3({}, state), {
            capabilities
        });
    });
    builder.addCase('TOGGLE_CHARGEABLE_CASE/fulfilled', (state, action)=>{
        const processInstance = action.payload;
        const capabilities = updateCapabilities(state, {
            result: processInstance
        });
        return _object_spread_props$3(_object_spread$3({}, state), {
            capabilities
        });
    });
    builder.addCase('SPLIT_CASE/fulfilled', (state, action)=>{
        const processInstance = action.payload;
        const capabilities = updateCapabilities(state, {
            result: processInstance
        });
        return _object_spread_props$3(_object_spread$3({}, state), {
            capabilities
        });
    });
    builder.addCase(chooseContext.type, (state, action)=>{
        const { activeContext } = action.payload;
        const capabilities = updateCapabilitiesOnContext(activeContext, state, state.activeServiceLineName);
        return _object_spread_props$3(_object_spread$3({}, state), {
            capabilities,
            userContext: activeContext
        });
    });
    builder.addCase('LOAD_CQA_WORK_ITEM_FROM_URL/fulfilled', (state)=>{
        const actionBarSelectMultipleWorkitems = getActionBarSelectMultipleWorkitemsCapability(state.roles);
        return _object_spread_props$3(_object_spread$3({}, state), {
            capabilities: _object_spread_props$3(_object_spread$3({}, state.capabilities), {
                actionBarSelectMultipleWorkitems
            })
        });
    });
    builder.addCase('INVOICE_SUBMITTED/pending', (state, action)=>{
        const { processInstance } = action.meta.arg;
        const submitInProgress = true;
        const capabilities = updateCapabilities(_object_spread_props$3(_object_spread$3({}, state), {
            submitInProgress
        }), {
            result: processInstance
        });
        return _object_spread_props$3(_object_spread$3({}, state), {
            capabilities,
            submitInProgress
        });
    });
    builder.addCase('INVOICE_SUBMITTED/rejected', (state, action)=>{
        const { processInstance } = action.meta.arg;
        const submitInProgress = false;
        const capabilities = updateCapabilities(_object_spread_props$3(_object_spread$3({}, state), {
            submitInProgress
        }), {
            result: processInstance
        });
        return _object_spread_props$3(_object_spread$3({}, state), {
            capabilities,
            submitInProgress
        });
    });
    // Merged handler: sets submitInProgress = false AND updates capabilities
    builder.addCase('INVOICE_SUBMITTED/fulfilled', (state, action)=>{
        const submitInProgress = false;
        const processInstance = action.payload;
        const capabilities = updateCapabilities(_object_spread_props$3(_object_spread$3({}, state), {
            submitInProgress
        }), {
            result: processInstance
        });
        return _object_spread_props$3(_object_spread$3({}, state), {
            capabilities,
            submitInProgress
        });
    });
    builder.addCase(saveServiceLineCapability.type, (state, action)=>{
        const activeServiceLineName = action.payload;
        const activeSL = isEmpty(activeServiceLineName) ? state.activeServiceLineName : activeServiceLineName;
        const capabilities = updateCapabilitiesOnContext(state.userContext, state, activeSL);
        return _object_spread_props$3(_object_spread$3({}, state), {
            activeServiceLineName: activeSL,
            capabilities
        });
    });
    builder.addCase('CASE_OPEN_SUCCESS', (state, action)=>{
        return _object_spread_props$3(_object_spread$3({}, state), {
            capabilities: getConcurrentCaseAccessCapabilities(state, action.payload, false)
        });
    });
    builder.addCase('CASE_OPEN_CONFLICT', (state, action)=>{
        return _object_spread_props$3(_object_spread$3({}, state), {
            capabilities: getConcurrentCaseAccessCapabilities(state, action.payload, true)
        });
    });
    builder.addCase('RESET_CASE_ACCESS', (state, action)=>{
        return _object_spread_props$3(_object_spread$3({}, state), {
            capabilities: getConcurrentCaseAccessCapabilities(state, action.payload, false)
        });
    });
});

function _define_property$2(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$2(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$2(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const { ImprovementDictionaryProps } = commonEnums;
const improvementsFulfilled = (state, action)=>_object_spread_props$2(_object_spread$2({}, state), {
        improvements: action.payload,
        searchResults: []
    });
const improvements = createReducer(improvements$1, (builder)=>{
    builder.addCase(resetCommonState.type, ()=>_object_spread$2({}, improvements$1));
    builder.addCase('USER_DETAILS', (state, action)=>{
        const userDetails = action.payload;
        const userContext = userDetails.contexts.find((context)=>context.organizationId === userDetails.activeContextId);
        return _object_spread_props$2(_object_spread$2({}, state), {
            userContext
        });
    });
    builder.addCase('CODE_SEARCH/fulfilled', (state, action)=>{
        const newResults = searchCache.getLatest(action.payload).searchResults;
        return _object_spread_props$2(_object_spread$2({}, state), {
            procedureSearchResults: newResults
        });
    });
    builder.addCase(getImprovementsForProcessInstance.fulfilled, improvementsFulfilled);
    builder.addCase(addImprovement.fulfilled, improvementsFulfilled);
    builder.addCase(removeImprovement.fulfilled, improvementsFulfilled);
    builder.addCase(updateImprovement.fulfilled, improvementsFulfilled);
    builder.addCase(fetchImprovementOptions.fulfilled, (state, action)=>_object_spread_props$2(_object_spread$2({}, state), {
            dictionaryValues: action.payload
        }));
    builder.addCase(improvementSearch, (state, action)=>{
        const rowValues = state.dictionaryValues.rowValues;
        let searchResults = [];
        if (rowValues !== undefined) {
            searchResults = rowValues === null || rowValues === void 0 ? void 0 : rowValues.filter((o)=>Object.keys(o).some((k)=>(k === ImprovementDictionaryProps.ERROR_CODE || k === ImprovementDictionaryProps.DESCRIPTION) && o[k].toLowerCase().includes(action.payload.text.toLowerCase())));
        }
        return _object_spread_props$2(_object_spread$2({}, state), {
            searchResults
        });
    });
    builder.addCase(providerSearch.fulfilled, (state, action)=>{
        const fromCache = providerSearchCache.getLatest(action.payload);
        const providerSearchResults = fromCache.providers;
        return _object_spread_props$2(_object_spread$2({}, state), {
            providerSearchResults
        });
    });
    builder.addCase(providerSearch.rejected, (state)=>_object_spread_props$2(_object_spread$2({}, state), {
            providerSearchResults: []
        }));
});

function _define_property$1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$1(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$1(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const ASSESMENT_KEY = 'ASSESSMENT';
const ROLE_KEY = 'ROLE';
const categoryToOriginalCodeAssessment = {
    CORRECT: true,
    INCORRECT: true,
    MISSED: false
};
// extracts a list of values from Row Values from CMxAPI.RowData
function GetOptionsFromRowValues(rowData, key) {
    // reduce is favored over map because we want to skip undefined values
    return rowData.reduce((acc, row)=>{
        const value = row[key];
        if (value !== undefined && !acc.includes(value)) {
            acc.push(value);
        }
        return acc;
    }, []);
}
function updateFieldOptionsWithObject(fields, optionsObject) {
    return fields.map((field)=>{
        const matchingOption = optionsObject.find((option)=>option.key.toLowerCase() === field.key.toLowerCase());
        if (matchingOption) {
            return _object_spread_props$1(_object_spread$1({}, field), {
                options: matchingOption.options,
                optionsTree: matchingOption.optionsTree
            });
        }
        return field;
    });
}
// Generic function to process simple risk categories (CPT and ICD)
function processSimpleRiskCategories(rowValues) {
    const riskCategories = {};
    rowValues.forEach((row)=>{
        if (!riskCategories[row['ASSESSMENT']]) {
            riskCategories[row['ASSESSMENT']] = [];
        }
        if (!riskCategories[row['ASSESSMENT']].includes(row['ROLE'])) {
            riskCategories[row['ASSESSMENT']].push(row['ROLE']);
        }
    });
    return riskCategories;
}
const getGetAssessmentTree = (rowValues)=>{
    const assessmentTree = {};
    // Process assessment tree
    rowValues.forEach((row)=>{
        var _categoryToOriginalCodeAssessment_category;
        const category = row['CATEGORY'];
        const originalCode = (_categoryToOriginalCodeAssessment_category = categoryToOriginalCodeAssessment[category]) !== null && _categoryToOriginalCodeAssessment_category !== void 0 ? _categoryToOriginalCodeAssessment_category : true;
        if (!assessmentTree[originalCode]) {
            assessmentTree[originalCode] = [];
        }
        if (!assessmentTree[originalCode].includes(row['ASSESSMENT'])) {
            assessmentTree[originalCode].push(row['ASSESSMENT']);
        }
    });
    return assessmentTree;
};
// Process CPT risk categories
function processCPTRiskCategories(rowData) {
    return {
        riskCategories: processSimpleRiskCategories(rowData.rowValues),
        assessmentOptions: GetOptionsFromRowValues(rowData.rowValues, ASSESMENT_KEY),
        roleOptions: GetOptionsFromRowValues(rowData.rowValues, ROLE_KEY),
        assessmentTree: getGetAssessmentTree(rowData.rowValues)
    };
}
// Process ICD risk categories
function processICDRiskCategories(rowData) {
    return {
        riskCategories: processSimpleRiskCategories(rowData.rowValues),
        assessmentOptions: GetOptionsFromRowValues(rowData.rowValues, ASSESMENT_KEY),
        roleOptions: GetOptionsFromRowValues(rowData.rowValues, ROLE_KEY),
        assessmentTree: getGetAssessmentTree(rowData.rowValues)
    };
}
// Process Modifier risk categories (more complex structure)
function processModifierRiskCategories(rowData) {
    // Process modifier-specific risk categories
    const modifierRiskCategories = {};
    const modifierAssessmentTree = {};
    // Process risk categories
    rowData.rowValues.forEach((row)=>{
        if (!modifierRiskCategories[row['MODIFIER']]) {
            modifierRiskCategories[row['MODIFIER']] = {};
        }
        if (!modifierRiskCategories[row['MODIFIER']][row['ASSESSMENT']]) {
            modifierRiskCategories[row['MODIFIER']][row['ASSESSMENT']] = [];
        }
        if (!modifierRiskCategories[row['MODIFIER']][row['ASSESSMENT']].includes(row['ROLE'])) {
            modifierRiskCategories[row['MODIFIER']][row['ASSESSMENT']].push(row['ROLE']);
        }
    });
    // Process assessment tree
    rowData.rowValues.forEach((row)=>{
        var _categoryToOriginalCodeAssessment_category;
        const category = row['CATEGORY'];
        const originalCode = (_categoryToOriginalCodeAssessment_category = categoryToOriginalCodeAssessment[category]) !== null && _categoryToOriginalCodeAssessment_category !== void 0 ? _categoryToOriginalCodeAssessment_category : true;
        if (!modifierAssessmentTree[row['MODIFIER']]) {
            modifierAssessmentTree[row['MODIFIER']] = {};
        }
        if (!modifierAssessmentTree[row['MODIFIER']][originalCode]) {
            modifierAssessmentTree[row['MODIFIER']][originalCode] = [];
        }
        if (!modifierAssessmentTree[row['MODIFIER']][originalCode].includes(row['ASSESSMENT'])) {
            modifierAssessmentTree[row['MODIFIER']][originalCode].push(row['ASSESSMENT']);
        }
    });
    return {
        riskCategories: modifierRiskCategories,
        assessmentTree: modifierAssessmentTree,
        assessmentOptions: GetOptionsFromRowValues(rowData.rowValues, ASSESMENT_KEY),
        roleOptions: GetOptionsFromRowValues(rowData.rowValues, ROLE_KEY)
    };
}
const processRiskCategories = (fieldDefinitions, riskCategoryData)=>{
    // Process each code type
    const cptResults = processCPTRiskCategories(riskCategoryData.CptRowData);
    const icdResults = processICDRiskCategories(riskCategoryData.IcdRowData);
    const modResults = processModifierRiskCategories(riskCategoryData.ModRowData);
    // Create options objects for field updates
    const modOptions = [
        {
            key: ROLE_KEY,
            options: modResults.roleOptions,
            optionsTree: modResults.riskCategories
        },
        {
            key: ASSESMENT_KEY,
            options: modResults.assessmentOptions,
            optionsTree: modResults.assessmentTree
        }
    ];
    const icdOptions = [
        {
            key: ROLE_KEY,
            options: icdResults.roleOptions,
            optionsTree: icdResults.riskCategories
        },
        {
            key: ASSESMENT_KEY,
            options: icdResults.assessmentOptions,
            optionsTree: icdResults.assessmentTree
        }
    ];
    const cptOptions = [
        {
            key: ROLE_KEY,
            options: cptResults.roleOptions,
            optionsTree: cptResults.riskCategories
        },
        {
            key: ASSESMENT_KEY,
            options: cptResults.assessmentOptions,
            optionsTree: cptResults.assessmentTree
        }
    ];
    // Update fields with new options
    const updateModFields = updateFieldOptionsWithObject(fieldDefinitions.modifierFields, modOptions);
    const updateIcdFields = updateFieldOptionsWithObject(fieldDefinitions.icdFields, icdOptions);
    const updateCptFields = updateFieldOptionsWithObject(fieldDefinitions.cptFields, cptOptions);
    return {
        fields: {
            cpt: updateCptFields,
            modifier: updateModFields,
            icd: updateIcdFields
        },
        riskCategories: {
            [ChargeSessionCodeType$1.PROCEDURE]: cptResults.riskCategories,
            [ChargeSessionCodeType$1.DIAGNOSIS]: icdResults.riskCategories,
            [ChargeSessionCodeType$1.MODIFIER]: modResults.riskCategories
        }
    };
};

var riskCategories = /*#__PURE__*/Object.freeze({
  __proto__: null,
  processRiskCategories: processRiskCategories
});

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const { isSelectionCPT, isSelectionICD, isSelectionModifier } = codePredicates;
const updateAllCodes = (invoices, modifyCode)=>{
    return invoices.map((invoice)=>{
        // Map through transactions to update the specific transaction
        const updatedTransactions = invoice.transactions.map((transaction)=>{
            // Use modifyCode to transform the codes array. entityType lets callers
            // disambiguate code_procedure/code_diagnosis/code_modifier (CDMX-17055).
            const procedures = modifyCode(transaction.procedures, 'code_procedure');
            const diagnoses = modifyCode(transaction.diagnoses, 'code_diagnosis');
            const modifiers = modifyCode(transaction.modifiers, 'code_modifier');
            // Return the updated transaction with the modified codes
            return _object_spread_props(_object_spread({}, transaction), {
                procedures,
                diagnoses,
                modifiers
            });
        });
        // Return the updated invoice with the new transactions
        return _object_spread_props(_object_spread({}, invoice), {
            transactions: updatedTransactions
        });
    });
};
/**
 * Updates attributes on a specific code across all invoices/transactions.
 * Wraps updateAllCodes with ID matching and null-safe attribute handling.
 */ const updateCodeAttributes = (invoices, entityId, entityType, updateFn)=>{
    // [CDMX-17055] only touch codes of the matching entityType — code ids are not unique across
    // code_procedure/code_diagnosis/code_modifier, so id alone cross-contaminates same-id codes.
    return updateAllCodes(invoices, (codes, codeEntityType)=>codeEntityType === entityType ? codes.map((code)=>code.id === entityId ? _object_spread_props(_object_spread({}, code), {
                attributes: updateFn(code.attributes || [])
            }) : code) : codes);
};
/**
 * Updates rubricAttributes on spans within code arrays (procedures, diagnoses, modifiers).
 */ const updateSpansInCodes = (codes, spanId, updateFn)=>{
    return codes.map((code)=>{
        var _code_spans;
        return _object_spread_props(_object_spread({}, code), {
            spans: ((_code_spans = code.spans) === null || _code_spans === void 0 ? void 0 : _code_spans.map((span)=>span.id === spanId ? _object_spread_props(_object_spread({}, span), {
                    rubricAttributes: updateFn(span.rubricAttributes || [])
                }) : span)) || []
        });
    });
};
/**
 * Updates rubricAttributes on a specific span across all locations (looseSpans and code spans in invoices).
 * Spans can exist in looseSpans (unattached) or nested inside code.spans (attached to codes).
 */ const updateSpanRubricAttributes = (invoices, looseSpans, spanId, updateFn)=>{
    const updatedLooseSpans = looseSpans.map((span)=>span.id === spanId ? _object_spread_props(_object_spread({}, span), {
            rubricAttributes: updateFn(span.rubricAttributes || [])
        }) : span);
    const updatedInvoices = invoices.map((invoice)=>_object_spread_props(_object_spread({}, invoice), {
            transactions: invoice.transactions.map((transaction)=>_object_spread_props(_object_spread({}, transaction), {
                    procedures: updateSpansInCodes(transaction.procedures, spanId, updateFn),
                    diagnoses: updateSpansInCodes(transaction.diagnoses, spanId, updateFn),
                    modifiers: updateSpansInCodes(transaction.modifiers, spanId, updateFn)
                }))
        }));
    return {
        invoices: updatedInvoices,
        looseSpans: updatedLooseSpans
    };
};
// Merge only the per-span workflowComplete flag (by id) into existing spans, leaving
// rubricAttributes and all other span/code/invoice state untouched.
const applySpanCompletion = (span, completionById)=>completionById.has(span.id) ? _object_spread_props(_object_spread({}, span), {
        workflowComplete: completionById.get(span.id)
    }) : span;
const mergeSpanCompletionInCodes = (codes, completionById)=>(codes || []).map((code)=>{
        var _code_spans;
        return _object_spread_props(_object_spread({}, code), {
            spans: ((_code_spans = code.spans) === null || _code_spans === void 0 ? void 0 : _code_spans.map((s)=>applySpanCompletion(s, completionById))) || []
        });
    });
const mergeSpanWorkflowCompletion = (invoices, looseSpans, completionById)=>({
        looseSpans: (looseSpans || []).map((s)=>applySpanCompletion(s, completionById)),
        invoices: (invoices || []).map((invoice)=>_object_spread_props(_object_spread({}, invoice), {
                transactions: invoice.transactions.map((transaction)=>_object_spread_props(_object_spread({}, transaction), {
                        procedures: mergeSpanCompletionInCodes(transaction.procedures, completionById),
                        diagnoses: mergeSpanCompletionInCodes(transaction.diagnoses, completionById),
                        modifiers: mergeSpanCompletionInCodes(transaction.modifiers, completionById)
                    }))
            }))
    });
const collectSpanCompletion = (graderWorkItem)=>{
    const completionById = new Map();
    const collect = (spans)=>(spans || []).forEach((s)=>completionById.set(s.id, s.workflowComplete));
    collect(graderWorkItem.looseSpans);
    (graderWorkItem.invoices || []).forEach((invoice)=>(invoice.transactions || []).forEach((transaction)=>[
                transaction.procedures,
                transaction.diagnoses,
                transaction.modifiers
            ].forEach((codes)=>(codes || []).forEach((code)=>collect(code.spans)))));
    return completionById;
};
const getSpanScopeAttributeId = (attribute)=>{
    var _attribute_spanScopeAttributeId;
    return (_attribute_spanScopeAttributeId = attribute.spanScopeAttributeId) !== null && _attribute_spanScopeAttributeId !== void 0 ? _attribute_spanScopeAttributeId : attribute.parentQuestionId;
};
const matchesAttributeSpanScope = (attribute, spanScopeAttributeId)=>spanScopeAttributeId != null ? getSpanScopeAttributeId(attribute) === spanScopeAttributeId : getSpanScopeAttributeId(attribute) == null;
const mergeFetchedAttributes = (existingAttributes, fetchedAttributes)=>{
    const preservedExisting = existingAttributes.filter((existing)=>!fetchedAttributes.some((fetched)=>fetched.questionId === existing.questionId && matchesAttributeSpanScope(existing, getSpanScopeAttributeId(fetched))));
    return [
        ...preservedExisting,
        ...fetchedAttributes
    ];
};
const removeSpanIdFromAttributes = (attributes, spanId)=>{
    return (attributes || []).flatMap((attribute)=>{
        var _attribute_spanAnnotationIds;
        if (!((_attribute_spanAnnotationIds = attribute.spanAnnotationIds) === null || _attribute_spanAnnotationIds === void 0 ? void 0 : _attribute_spanAnnotationIds.includes(spanId))) {
            return [
                attribute
            ];
        }
        const spanAnnotationIds = attribute.spanAnnotationIds.filter((id)=>id !== spanId);
        if (spanAnnotationIds.length === 0) {
            return [];
        }
        return [
            _object_spread_props(_object_spread({}, attribute), {
                spanAnnotationIds
            })
        ];
    });
};
const removeDeletedSpanFromCode = (code, spanId)=>{
    var _code_spans;
    return _object_spread_props(_object_spread({}, code), {
        spans: ((_code_spans = code.spans) === null || _code_spans === void 0 ? void 0 : _code_spans.filter((span)=>span.id !== spanId)) || [],
        attributes: removeSpanIdFromAttributes(code.attributes, spanId)
    });
};
const addCodeToInvoice = (//Removing updateCodes as we pull in api
invoices, codeInfo, modifyCodes)=>{
    return invoices.map((invoice)=>{
        // Check if this is the invoice to update
        if (invoice.id !== codeInfo.context.invoice.id) {
            return invoice; // Return the invoice unchanged if it's not the target
        }
        // Map through transactions to update the specific transaction
        const updatedTransactions = invoice.transactions.map((transaction)=>{
            // Check if this is the transaction to update
            if (transaction.id !== codeInfo.context.transaction.id) {
                return transaction; // Return the transaction unchanged if it's not the target
            }
            // Use modifyCode to transform the codes array
            const updatedTransaction = _object_spread({}, transaction);
            if (isSelectionCPT(codeInfo.codeInfo)) {
                updatedTransaction.procedures = modifyCodes(transaction.procedures);
            }
            if (isSelectionICD(codeInfo.codeInfo)) {
                updatedTransaction.diagnoses = modifyCodes(transaction.diagnoses);
            }
            if (isSelectionModifier(codeInfo.codeInfo)) {
                updatedTransaction.modifiers = modifyCodes(transaction.modifiers);
            }
            // Return the updated transaction with the modified codes
            return updatedTransaction;
        });
        // Return the updated invoice with the new transactions
        return _object_spread_props(_object_spread({}, invoice), {
            transactions: updatedTransactions
        });
    });
};
const updateCode = (//Removing updateCodes as we pull in api
invoices, changeEvent, modifyCodes)=>{
    return invoices.map((invoice)=>{
        // Check if this is the invoice to update
        if (invoice.id !== changeEvent.context.invoice.id) {
            return invoice; // Return the invoice unchanged if it's not the target
        }
        // Map through transactions to update the specific transaction
        const updatedTransactions = invoice.transactions.map((transaction)=>{
            // Check if this is the transaction to update
            if (transaction.id !== changeEvent.context.transaction.id) {
                return transaction; // Return the transaction unchanged if it's not the target
            }
            // Use modifyCode to transform the codes array
            const updatedTransaction = _object_spread({}, transaction);
            if (changeEvent.context.value.codeType == 'procedure') {
                updatedTransaction.procedures = modifyCodes(transaction.procedures);
            }
            if (changeEvent.context.value.codeType == 'diagnosis') {
                updatedTransaction.diagnoses = modifyCodes(transaction.diagnoses);
            }
            if (changeEvent.context.value.codeType == 'modifier') {
                updatedTransaction.modifiers = modifyCodes(transaction.modifiers);
            }
            // Return the updated transaction with the modified codes
            return updatedTransaction;
        });
        // Return the updated invoice with the new transactions
        return _object_spread_props(_object_spread({}, invoice), {
            transactions: updatedTransactions
        });
    });
};
const filterCQACodeAndOrder = (cqaCode, codes)=>{
    if (codes.length === 0) {
        return [];
    }
    if (!cqaCode) {
        return codes;
    }
    const deletedSequenceNumber = cqaCode.sequenceNumber;
    return codes.filter((code)=>code.id !== cqaCode.id) // Filter out the deleted code
    .map((code)=>{
        // Decrement sequence_number for codes with higher sequence numbers
        if (code.sequenceNumber > deletedSequenceNumber) {
            return _object_spread_props(_object_spread({}, code), {
                sequenceNumber: code.sequenceNumber - 1
            });
        }
        return code;
    });
};
//Different state and reducer but still share when you can!
const gradeBenchPanel = createReducer(gradeBenchPanelState, (builder)=>{
    builder.addCase(resetCommonState.type, ()=>_object_spread({}, gradeBenchPanelState));
    builder.addCase(ReduxActions.updateOrAddAssessment.fulfilled, (state, action)=>{
        const result = action.payload;
        const params = action.meta.arg;
        const originalState = _object_spread({}, state);
        const { value } = params.context;
        // Modify the code in the state — prefer stable id when the selection
        // includes it (duplicate code strings on one invoice); else match code.
        const modifyExistingCode = (codes)=>{
            return codes.map((code)=>{
                const matches = value.id == null ? code.code === value.code : code.id === value.id;
                return matches ? _object_spread_props(_object_spread({}, code), {
                    codeAssessment: result
                }) : code;
            });
        };
        const updatedInvoices = updateCode(originalState.invoices, params, modifyExistingCode);
        return _object_spread_props(_object_spread({}, state), {
            invoices: updatedInvoices
        });
    });
    const addCodeHandler = (state, action)=>{
        const result = action.payload;
        const params = action.meta.arg;
        const originalState = _object_spread({}, state);
        const addNewCode = (codes)=>{
            return [
                ...codes,
                _object_spread_props(_object_spread({}, result), {
                    description: params.codeInfo.description
                })
            ];
        };
        const updatedInvoices = addCodeToInvoice(originalState.invoices, params, addNewCode);
        const codeDescriptionsWithNewCode = _object_spread_props(_object_spread({}, state.codeDescriptions), {
            [params.codeInfo.code]: params.codeInfo
        });
        return _object_spread_props(_object_spread({}, state), {
            invoices: updatedInvoices,
            codeDescriptionsWithNewCode
        });
    };
    builder.addCase(ReduxActions.addDiagnosis.fulfilled, addCodeHandler);
    builder.addCase(ReduxActions.addProcedure.fulfilled, addCodeHandler);
    builder.addCase(ReduxActions.addModifier.fulfilled, addCodeHandler);
    builder.addCase(deleteCQACode.fulfilled, (state, action)=>{
        const deleted = action.payload;
        const inputParams = action.meta.arg;
        if (!deleted) {
            return _object_spread({}, state);
        }
        // Extract spans from the code being deleted before filtering it out
        // We need to find the code in the current state to get its spans
        let deletedCodeSpans = [];
        const codeToDelete = inputParams.code;
        // Find the code in the state to extract its spans
        state.invoices.forEach((invoice)=>{
            if (invoice.id === inputParams.context.invoice.id) {
                invoice.transactions.forEach((transaction)=>{
                    if (transaction.id === inputParams.context.transaction.id) {
                        let codeArray = [];
                        if (inputParams.codeType === 'procedure') {
                            codeArray = transaction.procedures || [];
                        } else if (inputParams.codeType === 'diagnosis') {
                            codeArray = transaction.diagnoses || [];
                        } else if (inputParams.codeType === 'modifier') {
                            codeArray = transaction.modifiers || [];
                        }
                        const foundCode = codeArray.find((c)=>c.id === codeToDelete.id);
                        if (foundCode && foundCode.spans) {
                            deletedCodeSpans = [
                                ...foundCode.spans
                            ];
                        }
                    }
                });
            }
        });
        // Process spans: check if they're shared with other codes
        const orphanedSpans = [];
        deletedCodeSpans.forEach((span)=>{
            // Find all codes that have this span attached
            const codesWithSpan = findCodesBySpanId(state.invoices, span.id);
            // Filter out the code being deleted
            const otherCodesWithSpan = codesWithSpan.filter((codeInfo)=>!(codeInfo.code.id === codeToDelete.id && codeInfo.invoice.id === inputParams.context.invoice.id && codeInfo.transaction.id === inputParams.context.transaction.id));
            // If no other codes have this span, it's orphaned and should go to looseSpans
            if (otherCodesWithSpan.length === 0) {
                orphanedSpans.push(span);
            }
        });
        // Update invoices by filtering out the deleted code
        const updatedInvoices = state.invoices.map((invoice)=>{
            if (invoice.id !== inputParams.context.invoice.id) {
                return invoice;
            }
            const updatedTransactions = invoice.transactions.map((transaction)=>{
                if (transaction.id !== inputParams.context.transaction.id) {
                    return transaction;
                }
                if (inputParams.codeType === 'procedure') {
                    return _object_spread_props(_object_spread({}, transaction), {
                        procedures: filterCQACodeAndOrder(inputParams.code, transaction.procedures)
                    });
                }
                if (inputParams.codeType === 'diagnosis') {
                    return _object_spread_props(_object_spread({}, transaction), {
                        diagnoses: filterCQACodeAndOrder(inputParams.code, transaction.diagnoses)
                    });
                }
                if (inputParams.codeType === 'modifier') {
                    return _object_spread_props(_object_spread({}, transaction), {
                        modifiers: filterCQACodeAndOrder(inputParams.code, transaction.modifiers)
                    });
                }
                return _object_spread({}, transaction);
            });
            return _object_spread_props(_object_spread({}, invoice), {
                transactions: updatedTransactions
            });
        });
        // Add orphaned spans to looseSpans
        const updatedLooseSpans = [
            ...state.looseSpans,
            ...orphanedSpans
        ];
        return _object_spread_props(_object_spread({}, state), {
            invoices: updatedInvoices,
            looseSpans: updatedLooseSpans
        });
    });
    builder.addCase(resequenceCode.fulfilled, (state, action)=>{
        const result = action.payload;
        if (result == null) {
            return _object_spread({}, state);
        }
        const params = action.meta.arg;
        const originalState = _object_spread({}, state);
        const { context, code } = params;
        const updatedInvoices = originalState.invoices.map((invoice)=>{
            // Check if this is the invoice to update
            if (invoice.id !== context.invoice.id) {
                return invoice; // Return the invoice unchanged if it's not the target
            }
            // Map through transactions to update the specific transaction
            const updatedTransactions = invoice.transactions.map((transaction)=>{
                // Check if this is the transaction to update
                if (transaction.id !== context.transaction.id) {
                    return transaction; // Return the transaction unchanged if it's not the target
                }
                const map = {
                    procedure: 'procedures',
                    diagnosis: 'diagnoses',
                    modifier: 'modifiers'
                };
                const currentCodes = transaction[map[code.codeType]];
                // The cqa-service does not return descriptions, spans, attributes, or codeAssessment
                // for the reordered codes. Preserve them from current state (find by id, else by code) so that
                // reordering does not reset the workflow form.
                const resultCodes = result;
                const resultsWithPreservedState = resultCodes.map((reorderedCode)=>{
                    var _ref, _ref1, _ref2;
                    const current = reorderedCode.id !== undefined ? currentCodes.find((c)=>c.id === reorderedCode.id) : currentCodes.find((c)=>c.code === reorderedCode.code);
                    return _object_spread_props(_object_spread({}, reorderedCode), {
                        description: current === null || current === void 0 ? void 0 : current.description,
                        spans: (_ref = current === null || current === void 0 ? void 0 : current.spans) !== null && _ref !== void 0 ? _ref : [],
                        attributes: (_ref1 = current === null || current === void 0 ? void 0 : current.attributes) !== null && _ref1 !== void 0 ? _ref1 : [],
                        codeAssessment: (_ref2 = current === null || current === void 0 ? void 0 : current.codeAssessment) !== null && _ref2 !== void 0 ? _ref2 : reorderedCode.codeAssessment
                    });
                });
                const updatedTransaction = _object_spread({}, transaction);
                updatedTransaction[map[code.codeType]] = resultsWithPreservedState;
                // Return the updated transaction with the modified codes
                return updatedTransaction;
            });
            // Return the updated invoice with the new transactions
            return _object_spread_props(_object_spread({}, invoice), {
                transactions: updatedTransactions
            });
        });
        return _object_spread_props(_object_spread({}, originalState), {
            invoices: updatedInvoices
        });
    });
    builder.addCase(refreshSpanCompletion.fulfilled, (state, action)=>{
        const completionById = collectSpanCompletion(action.payload);
        const { invoices, looseSpans } = mergeSpanWorkflowCompletion(state.invoices, state.looseSpans, completionById);
        return _object_spread_props(_object_spread({}, state), {
            invoices,
            looseSpans
        });
    });
    // There is a similar reducer for loadCQAItemFromURL action in code-bench.reducer.ts
    builder.addCase(loadCQAItemFromURL.fulfilled, (state, action)=>{
        const cqaGraderWorkItem = action.payload;
        const sdCaseId = cqaGraderWorkItem.sdCaseId;
        const workItem = cqaGraderWorkItem.workItem;
        const invoices = cqaGraderWorkItem.invoices;
        const graderUpdatedDate = cqaGraderWorkItem.graderUpdatedDate;
        if (invoices.length) {
            // Copy "invoice metadata" to the first invoice
            // This has to do with how CQA workItems are currently imported as only a single invoice
            invoices[0] = _object_spread_props(_object_spread({}, invoices[0], workItem), {
                // workitem.id was overriding invoice.id which causes a bug.
                id: invoices[0].id,
                status: cqaGraderWorkItem.status,
                workitemId: workItem.id,
                sdCaseId: sdCaseId,
                // Store loose spans on the first invoice
                looseSpans: cqaGraderWorkItem.looseSpans || []
            });
        }
        return _object_spread_props(_object_spread({}, state), {
            invoices: invoices,
            // Store loose spans in state for easy access
            looseSpans: cqaGraderWorkItem.looseSpans || [],
            caseAttributes: [],
            attributesFetched: false,
            attributesFetchError: false,
            // Drop autosave bookkeeping from the prior case — otherwise its
            // in-flight .fulfilled can match the new case's stale-guard by key
            // and inject its answer into caseAttributes.
            pendingAutosaves: {},
            attributeLatestRequestId: {},
            resolverValidationErrors: null,
            caseLevelComplete: null,
            graderUpdatedDate
        });
    });
    builder.addCase(resolveCQAWorkitem.pending, (state)=>_object_spread_props(_object_spread({}, state), {
            resolverValidationErrors: null
        }));
    builder.addCase(resolveCQAWorkitem.fulfilled, (state, action)=>{
        var _action_payload_validationErrors;
        return _object_spread_props(_object_spread({}, state), {
            resolverValidationErrors: ((_action_payload_validationErrors = action.payload.validationErrors) === null || _action_payload_validationErrors === void 0 ? void 0 : _action_payload_validationErrors.length) ? action.payload.validationErrors : null
        });
    });
    builder.addCase(fetchQaRule.pending, (state)=>_object_spread_props(_object_spread({}, state), {
            validationResult: null
        }));
    builder.addCase(fetchQaRule.fulfilled, (state, action)=>{
        var _ref;
        var _qaRule_data;
        const qaRule = action.payload;
        // We should not expect qaRule to be not found however we cannot make this assertion for all qaRule Queries
        let updatedQaRule;
        if (qaRule) {
            updatedQaRule = qaRule;
        } else {
            updatedQaRule = _object_spread_props(_object_spread({}, state.qaRule), {
                data: _object_spread_props(_object_spread({}, state.qaRule.data), {
                    project_configuration: defaultCQAProjectConfiguration
                })
            });
        }
        const project_configuration = (_ref = qaRule === null || qaRule === void 0 ? void 0 : (_qaRule_data = qaRule.data) === null || _qaRule_data === void 0 ? void 0 : _qaRule_data.project_configuration) !== null && _ref !== void 0 ? _ref : defaultCQAProjectConfiguration;
        //Creating a fresh object to guarantee a rerender, if there are changes
        const updatedFields = {
            icdFields: [],
            modifierFields: [],
            cptFields: []
        };
        //Hide assesment or role for all code types
        for(const definitionsKey in state.fieldDefinitions){
            updatedFields[definitionsKey] = state.fieldDefinitions[definitionsKey].map((field)=>{
                if (project_configuration.assessment !== undefined && field.key === AssesmentSelect$1.key) {
                    return _object_spread_props(_object_spread({}, field), {
                        hidden: !project_configuration.assessment
                    });
                }
                if (project_configuration.role !== undefined && field.key === RoleSelect$1.key) {
                    return _object_spread_props(_object_spread({}, field), {
                        hidden: !project_configuration.role
                    });
                }
                return _object_spread({}, field);
            });
        }
        //For each field, disable it if the configuration for the codeType is false
        if (project_configuration.procedure !== undefined) {
            updatedFields.cptFields = updatedFields.cptFields.map((cptField)=>{
                cptField.readonly = !project_configuration.procedure;
                if (cptField.key == AssesmentSelect$1.key || cptField.key == RoleSelect$1.key) {
                    // If `cptField.hidden` from the `Hide assesment or role for all code types` step then it should stay disabled
                    cptField.hidden = cptField.hidden || !project_configuration.procedure;
                }
                return cptField;
            });
        }
        if (project_configuration.diagnosis !== undefined) {
            updatedFields.icdFields = updatedFields.icdFields.map((icdField)=>{
                icdField.readonly = !project_configuration.diagnosis;
                if (icdField.key == AssesmentSelect$1.key || icdField.key == RoleSelect$1.key) {
                    icdField.hidden = icdField.hidden || !project_configuration.diagnosis;
                }
                return icdField;
            });
        }
        if (project_configuration.modifier !== undefined) {
            updatedFields.modifierFields = updatedFields.modifierFields.map((modifierField)=>{
                modifierField.readonly = !project_configuration.modifier;
                if (modifierField.key == AssesmentSelect$1.key || modifierField.key == RoleSelect$1.key) {
                    modifierField.hidden = modifierField.hidden || !project_configuration.modifier;
                }
                return modifierField;
            });
        }
        return _object_spread_props(_object_spread({}, state), {
            qaRule: updatedQaRule,
            fieldDefinitions: _object_spread({}, updatedFields)
        });
    });
    /*
    The fetchRiskCategories reducer takes each risk category dictionary and create a mapping from assessments to roles
    The final object looks like
    {
      procedure : [assessment : string] : dictioanryValue[] // dictioanryValue[] are roles
      diagnosis : [assessment : string] : dictioanryValue[] // dictioanryValue[] are roles
      modifier : [assessment : string] : dictioanryValue[] // dictioanryValue[] are roles
    }
  */ builder.addCase(fetchRiskCategories.fulfilled, (state, action)=>{
        const result = action.payload;
        const { fields, riskCategories } = processRiskCategories(state.fieldDefinitions, result);
        return _object_spread_props(_object_spread({}, state), {
            fieldDefinitions: _object_spread_props(_object_spread({}, state.fieldDefinitions), {
                modifierFields: fields.modifier,
                icdFields: fields.icd,
                cptFields: fields.cpt
            }),
            riskCategories: {
                [ChargeSessionCodeType$1.PROCEDURE]: riskCategories.procedure,
                [ChargeSessionCodeType$1.DIAGNOSIS]: riskCategories.diagnosis,
                [ChargeSessionCodeType$1.MODIFIER]: riskCategories.modifier
            },
            cqaCodeAssessmentRiskDictionaries: {
                procedure: {
                    columnNames: result.CptRowData.columnNames,
                    rows: result.CptRowData.rowValues.map((row)=>({
                            assessment: row['ASSESSMENT'],
                            category: row['CATEGORY'],
                            role: row['ROLE']
                        }))
                },
                diagnosis: {
                    columnNames: result.IcdRowData.columnNames,
                    rows: result.IcdRowData.rowValues.map((row)=>({
                            assessment: row['ASSESSMENT'],
                            category: row['CATEGORY'],
                            role: row['ROLE']
                        }))
                },
                modifier: {
                    columnNames: result.ModRowData.columnNames,
                    rows: result.ModRowData.rowValues.map((row)=>({
                            assessment: row['ASSESSMENT'],
                            category: row['CATEGORY'],
                            role: row['ROLE'],
                            description: row['DESCRIPTION'],
                            modifier: row['MODIFIER']
                        }))
                }
            }
        });
    });
    builder.addCase(fetchCodeDescriptions.fulfilled, (state, action)=>{
        const result = action.payload;
        if (Object.keys(result).length == 0) {
            return _object_spread({}, state);
        }
        const addDescriptionsToCodes = (codes)=>{
            return codes.map((code)=>{
                return _object_spread_props(_object_spread({}, code), {
                    description: result[code.code] ? result[code.code].description : undefined
                });
            });
        };
        const updatedInvoices = updateAllCodes(state.invoices, addDescriptionsToCodes);
        // Loose spans don't need code description updates since codes are stored in invoice structure
        const updatedLooseSpans = state.looseSpans;
        //We are storing code descriptions both at the code and as a codeDescriptions object.
        //We should move to just codeDescriptions and have code-layer.tsx recieve this object as a prop and access it
        return _object_spread_props(_object_spread({}, state), {
            invoices: updatedInvoices,
            looseSpans: updatedLooseSpans
        });
    });
    builder.addCase(createCQATransaction.fulfilled, (state, action)=>{
        const transactionResponse = action.payload;
        const inputParams = action.meta.arg;
        if (!transactionResponse) {
            return _object_spread_props(_object_spread({}, state), {
                gradingErrors: {
                    addTransaction: true
                }
            });
        }
        const newTransaction = {
            id: transactionResponse.id,
            diagnoses: [],
            modifiers: [],
            procedures: [],
            original: transactionResponse.original,
            sequenceNumber: transactionResponse.sequenceNumber
        };
        // update transactions with newly created transaction for the matched invoice
        const invoices = state.invoices.map((invoice)=>{
            var _invoice_transactions;
            if (invoice.id !== inputParams.invoiceId) {
                return invoice;
            }
            const updatedTransactions = [
                ...(_invoice_transactions = invoice.transactions) !== null && _invoice_transactions !== void 0 ? _invoice_transactions : [],
                newTransaction
            ];
            return _object_spread_props(_object_spread({}, invoice), {
                transactions: updatedTransactions
            });
        });
        return _object_spread_props(_object_spread({}, state), {
            invoices,
            gradingErrors: {
                addTransaction: false
            }
        });
    });
    builder.addCase(deleteCQATransaction.fulfilled, (state, action)=>{
        const deleted = action.payload;
        const inputParams = action.meta.arg;
        if (!deleted) {
            return _object_spread({}, state);
        }
        const invoices = state.invoices.map((invoice)=>{
            if (invoice.id !== inputParams.invoiceId) {
                return invoice;
            }
            // Remove the transaction and order the remaining transactions
            const updatedTransactions = invoice.transactions.filter((transaction)=>transaction.id !== inputParams.transactionId).map((transaction, index)=>{
                // Original transaction should not be modified here
                // and will always be sequenceNumber 1
                if (!transaction.original) {
                    return _object_spread_props(_object_spread({}, transaction), {
                        sequenceNumber: index + 1
                    });
                }
                return transaction;
            });
            return _object_spread_props(_object_spread({}, invoice), {
                transactions: updatedTransactions
            });
        });
        return _object_spread_props(_object_spread({}, state), {
            invoices
        });
    });
    builder.addCase(retrieveAssociatedWorkitems.fulfilled, (state, action)=>{
        const result = action.payload;
        return _object_spread_props(_object_spread({}, state), {
            associatedWorkitems: result
        });
    });
    builder.addCase(fetchWorkerInfoForUser.fulfilled, (state, action)=>{
        const result = action.payload;
        return _object_spread_props(_object_spread({}, state), {
            workerInfo: result.data.QueryWorker
        });
    });
    builder.addCase(getGraderWorkItemActivity.fulfilled, (state, action)=>{
        const result = action.payload;
        const { activity: graderActivity, comments: coderNotes } = result;
        // Filter and transform grader activity
        const transformedActivity = graderActivity.filter((item)=>{
            if ('code' in item) {
                if (!item.code.original && [
                    'ADD',
                    'DEL'
                ].includes(item.revisionType)) {
                    return true;
                }
            }
            if ('codeAssessment' in item && [
                'ADD',
                'MOD'
            ].includes(item.revisionType)) {
                return true;
            }
            return false;
        }).map((item)=>_object_spread_props(_object_spread({}, item), {
                activityType: 'CQA',
                timestamp: item.revInfo.datetime
            }));
        const transformedCoderNotes = (coderNotes || []).map((note)=>_object_spread_props(_object_spread({}, note), {
                activityType: note.lookup_type,
                timestamp: note.created_date
            }));
        // Merge and sort
        const mergedActivity = [
            ...transformedActivity,
            ...transformedCoderNotes
        ].sort((a, b)=>sortByDate(a.timestamp, b.timestamp));
        return _object_spread_props(_object_spread({}, state), {
            activity: mergedActivity
        });
    });
    builder.addCase(addEmptySpan.fulfilled, (state, action)=>{
        const result = action.payload;
        const updatedLooseSpans = [
            ...state.looseSpans,
            ...result.spans
        ];
        return _object_spread_props(_object_spread({}, state), {
            looseSpans: updatedLooseSpans
        });
    });
    builder.addCase(attachCodeToSpan.fulfilled, (state, action)=>{
        action.payload;
        const params = action.meta.arg;
        // First check if span is in loose spans
        let spanToAttach = state.looseSpans.find((span)=>span.id === params.spanId);
        let spanSource = 'looseSpans';
        // If not in loose spans, search in all code spans using utility function
        if (!spanToAttach) {
            spanToAttach = findSpanById(state.invoices, params.spanId);
            spanSource = 'codeSpans';
        }
        if (!spanToAttach) {
            return state; // Span not found anywhere
        }
        // Find and update the code in invoices
        const updatedInvoices = state.invoices.map((invoice)=>{
            const updatedTransactions = invoice.transactions.map((transaction)=>{
                const codeTypeMap = {
                    'PROCEDURE': 'procedures',
                    'DIAGNOSIS': 'diagnoses',
                    'MODIFIER': 'modifiers'
                };
                const codeArray = codeTypeMap[params.codeType];
                if (!codeArray) return transaction;
                const updatedCodes = transaction[codeArray].map((code)=>{
                    if (code.id === params.codeId) {
                        var _ref;
                        var _code_spans;
                        // Check if span is already attached to this code
                        const existingSpanIndex = (_ref = (_code_spans = code.spans) === null || _code_spans === void 0 ? void 0 : _code_spans.findIndex((span)=>span.id === params.spanId)) !== null && _ref !== void 0 ? _ref : -1;
                        if (existingSpanIndex >= 0) {
                            // Span already attached, no change needed
                            return code;
                        } else {
                            var _code_spans1;
                            // Add new span
                            return _object_spread_props(_object_spread({}, code), {
                                spans: [
                                    ...(_code_spans1 = code.spans) !== null && _code_spans1 !== void 0 ? _code_spans1 : [],
                                    spanToAttach
                                ]
                            });
                        }
                    }
                    return code;
                });
                return _object_spread_props(_object_spread({}, transaction), {
                    [codeArray]: updatedCodes
                });
            });
            return _object_spread_props(_object_spread({}, invoice), {
                transactions: updatedTransactions
            });
        });
        // Remove span from loose spans only if it was originally there
        const updatedLooseSpans = spanSource === 'looseSpans' ? state.looseSpans.filter((span)=>span.id !== params.spanId) : state.looseSpans;
        return _object_spread_props(_object_spread({}, state), {
            invoices: updatedInvoices,
            looseSpans: updatedLooseSpans
        });
    });
    builder.addCase(detachCodeFromSpan.fulfilled, (state, action)=>{
        const params = action.meta.arg;
        // Find the span in the code's spans array and move it back to loose spans
        // ONLY if it's not attached to any other codes
        let loosenedSpan = null;
        // First, check if span is attached to any other codes besides this one
        const codesWithSpan = findCodesBySpanId(state.invoices, params.spanId);
        const isAttachedToOtherCodes = codesWithSpan.some(({ code, codeType })=>code.id !== params.codeId || codeType.toLowerCase() !== params.codeType.toLowerCase());
        // Search through all codes to find the span
        const updatedInvoices = state.invoices.map((invoice)=>{
            const updatedTransactions = invoice.transactions.map((transaction)=>{
                const codeTypeMap = {
                    'PROCEDURE': 'procedures',
                    'DIAGNOSIS': 'diagnoses',
                    'MODIFIER': 'modifiers'
                };
                const codeArray = codeTypeMap[params.codeType];
                if (!codeArray) return transaction;
                const updatedCodes = transaction[codeArray].map((code)=>{
                    if (code.id === params.codeId) {
                        var _code_spans;
                        const spanIndex = (_code_spans = code.spans) === null || _code_spans === void 0 ? void 0 : _code_spans.findIndex((span)=>span.id === params.spanId);
                        if (spanIndex !== undefined && spanIndex >= 0) {
                            // Found the span, remove it from code
                            const remainingSpans = code.spans.filter((span)=>span.id !== params.spanId);
                            // Only store for moving to loose spans if span is not attached to other codes
                            if (!isAttachedToOtherCodes) {
                                loosenedSpan = code.spans[spanIndex];
                            }
                            return _object_spread_props(_object_spread({}, code), {
                                spans: remainingSpans
                            });
                        }
                    }
                    return code;
                });
                return _object_spread_props(_object_spread({}, transaction), {
                    [codeArray]: updatedCodes
                });
            });
            return _object_spread_props(_object_spread({}, invoice), {
                transactions: updatedTransactions
            });
        });
        // If span was found and detached, add it back to loose spans
        let updatedLooseSpans = state.looseSpans;
        if (loosenedSpan) {
            updatedLooseSpans = [
                ...state.looseSpans,
                loosenedSpan
            ];
        }
        return _object_spread_props(_object_spread({}, state), {
            invoices: updatedInvoices,
            looseSpans: updatedLooseSpans
        });
    });
    builder.addCase(deleteSpan.fulfilled, (state, action)=>{
        const params = action.meta.arg;
        // Remove span from both loose spans and code spans
        const updatedLooseSpans = state.looseSpans.filter((span)=>span.id !== params.spanId);
        // Also remove from any code spans
        const updatedInvoices = state.invoices.map((invoice)=>{
            const updatedTransactions = invoice.transactions.map((transaction)=>{
                const updatedProcedures = transaction.procedures.map((procedure)=>removeDeletedSpanFromCode(procedure, params.spanId));
                const updatedDiagnoses = transaction.diagnoses.map((diagnosis)=>removeDeletedSpanFromCode(diagnosis, params.spanId));
                const updatedModifiers = transaction.modifiers.map((modifier)=>removeDeletedSpanFromCode(modifier, params.spanId));
                return _object_spread_props(_object_spread({}, transaction), {
                    procedures: updatedProcedures,
                    diagnoses: updatedDiagnoses,
                    modifiers: updatedModifiers
                });
            });
            return _object_spread_props(_object_spread({}, invoice), {
                transactions: updatedTransactions
            });
        });
        return _object_spread_props(_object_spread({}, state), {
            invoices: updatedInvoices,
            looseSpans: updatedLooseSpans,
            caseAttributes: state.caseAttributes ? removeSpanIdFromAttributes(state.caseAttributes, params.spanId) : state.caseAttributes
        });
    });
    builder.addCase(clearRubricVersion.type, (state)=>{
        return _object_spread_props(_object_spread({}, state), {
            rubricVersion: null
        });
    });
    builder.addCase(fetchRubricVersion.fulfilled, (state, action)=>{
        var _state_qaRule_data_project_configuration, _state_qaRule_data, _state_qaRule;
        const result = action.payload;
        const params = action.meta.arg;
        const rubricVersionId = (_state_qaRule = state.qaRule) === null || _state_qaRule === void 0 ? void 0 : (_state_qaRule_data = _state_qaRule.data) === null || _state_qaRule_data === void 0 ? void 0 : (_state_qaRule_data_project_configuration = _state_qaRule_data.project_configuration) === null || _state_qaRule_data_project_configuration === void 0 ? void 0 : _state_qaRule_data_project_configuration.rubricVersionId;
        //Rubric version may be stale by the time fetch rubric is done, https://codametrix.atlassian.net/browse/CDMX-10884
        if (rubricVersionId !== params.versionId) {
            return state;
        }
        return _object_spread_props(_object_spread({}, state), {
            rubricVersion: result
        });
    });
    builder.addCase(updateAttribute.pending, (state, action)=>{
        var _state_pendingAutosaves, _state_attributeLatestRequestId;
        const params = action.meta.arg;
        const key = `${params.entityType}:${params.entityId}:${params.questionId}`;
        return _object_spread_props(_object_spread({}, state), {
            pendingAutosaves: _object_spread_props(_object_spread({}, (_state_pendingAutosaves = state.pendingAutosaves) !== null && _state_pendingAutosaves !== void 0 ? _state_pendingAutosaves : {}), {
                [action.meta.requestId]: true
            }),
            attributeLatestRequestId: _object_spread_props(_object_spread({}, (_state_attributeLatestRequestId = state.attributeLatestRequestId) !== null && _state_attributeLatestRequestId !== void 0 ? _state_attributeLatestRequestId : {}), {
                [key]: action.meta.requestId
            })
        });
    });
    // Aborted thunks dispatch .rejected (not .fulfilled), so this handles
    // cancellation cleanup for both updateAttribute and deleteAttribute below.
    builder.addCase(updateAttribute.rejected, (state, action)=>{
        var _state_pendingAutosaves;
        const pending = _object_spread({}, (_state_pendingAutosaves = state.pendingAutosaves) !== null && _state_pendingAutosaves !== void 0 ? _state_pendingAutosaves : {});
        delete pending[action.meta.requestId];
        return _object_spread_props(_object_spread({}, state), {
            pendingAutosaves: pending
        });
    });
    builder.addCase(updateAttribute.fulfilled, (state, action)=>{
        var _state_pendingAutosaves, _state_attributeLatestRequestId;
        const result = action.payload;
        const params = action.meta.arg;
        const pending = _object_spread({}, (_state_pendingAutosaves = state.pendingAutosaves) !== null && _state_pendingAutosaves !== void 0 ? _state_pendingAutosaves : {});
        delete pending[action.meta.requestId];
        // Stale-guard: discard a fulfilled write that was superseded mid-flight.
        // Opt-in — only fires when the slice tracked the .pending dispatch (the
        // map is empty for callers that synthesize .fulfilled directly).
        const key = `${params.entityType}:${params.entityId}:${params.questionId}`;
        const latestRequestId = ((_state_attributeLatestRequestId = state.attributeLatestRequestId) !== null && _state_attributeLatestRequestId !== void 0 ? _state_attributeLatestRequestId : {})[key];
        if (latestRequestId !== undefined && action.meta.requestId !== latestRequestId) {
            return _object_spread_props(_object_spread({}, state), {
                pendingAutosaves: pending
            });
        }
        if (params.entityType === 'case') {
            const existingAttributes = state.caseAttributes || [];
            const attributeIndex = existingAttributes.findIndex((a)=>a.questionId === params.questionId);
            const caseAttributes = attributeIndex >= 0 ? existingAttributes.map((a, idx)=>idx === attributeIndex ? result : a) : [
                ...existingAttributes,
                result
            ];
            return _object_spread_props(_object_spread({}, state), {
                pendingAutosaves: pending,
                caseAttributes
            });
        }
        // Handle span-level attributes
        if (params.entityType === 'span') {
            const { invoices: updatedInvoices, looseSpans: updatedLooseSpans } = updateSpanRubricAttributes(state.invoices, state.looseSpans, Number(params.entityId), (attrs)=>{
                const idx = attrs.findIndex((a)=>{
                    var _params_spanScopeAttributeId;
                    return a.questionId === params.questionId && matchesAttributeSpanScope(a, (_params_spanScopeAttributeId = params.spanScopeAttributeId) !== null && _params_spanScopeAttributeId !== void 0 ? _params_spanScopeAttributeId : params.parentQuestionId);
                });
                return idx >= 0 ? attrs.map((a, i)=>i === idx ? result : a) : [
                    ...attrs,
                    result
                ];
            });
            return _object_spread_props(_object_spread({}, state), {
                pendingAutosaves: pending,
                invoices: updatedInvoices,
                looseSpans: updatedLooseSpans
            });
        }
        // Only process code entity types (code_procedure, code_diagnosis, code_modifier)
        if (!params.entityType.startsWith('code_')) return _object_spread_props(_object_spread({}, state), {
            pendingAutosaves: pending
        });
        const updatedInvoices = updateCodeAttributes(state.invoices, Number(params.entityId), params.entityType, (attrs)=>{
            const idx = attrs.findIndex((a)=>a.questionId === params.questionId);
            return idx >= 0 ? attrs.map((a, i)=>i === idx ? result : a) : [
                ...attrs,
                result
            ];
        });
        return _object_spread_props(_object_spread({}, state), {
            pendingAutosaves: pending,
            invoices: updatedInvoices
        });
    });
    builder.addCase(fetchAttributes.fulfilled, (state, action)=>{
        const result = action.payload;
        const params = action.meta.arg;
        // Handle case-level attributes
        if (params.entityType === 'case') {
            return _object_spread_props(_object_spread({}, state), {
                caseAttributes: result
            });
        }
        // Handle span-level attributes
        if (params.entityType === 'span') {
            const { invoices: updatedInvoices, looseSpans: updatedLooseSpans } = updateSpanRubricAttributes(state.invoices, state.looseSpans, Number(params.entityId), (attrs)=>[
                    ...attrs.filter((a)=>{
                        var _params_spanScopeAttributeId;
                        return !matchesAttributeSpanScope(a, (_params_spanScopeAttributeId = params.spanScopeAttributeId) !== null && _params_spanScopeAttributeId !== void 0 ? _params_spanScopeAttributeId : params.parentQuestionId);
                    }),
                    ...result
                ]);
            return _object_spread_props(_object_spread({}, state), {
                invoices: updatedInvoices,
                looseSpans: updatedLooseSpans
            });
        }
        // Only process code entity types (code_procedure, code_diagnosis, code_modifier)
        if (!params.entityType.startsWith('code_')) return state;
        const updatedInvoices = updateCodeAttributes(state.invoices, Number(params.entityId), params.entityType, (attrs)=>mergeFetchedAttributes(attrs, result));
        return _object_spread_props(_object_spread({}, state), {
            invoices: updatedInvoices
        });
    });
    builder.addCase(deleteAttribute.pending, (state, action)=>{
        var _state_pendingAutosaves, _state_attributeLatestRequestId;
        const params = action.meta.arg;
        const key = `${params.entityType}:${params.entityId}:${params.questionId}`;
        return _object_spread_props(_object_spread({}, state), {
            pendingAutosaves: _object_spread_props(_object_spread({}, (_state_pendingAutosaves = state.pendingAutosaves) !== null && _state_pendingAutosaves !== void 0 ? _state_pendingAutosaves : {}), {
                [action.meta.requestId]: true
            }),
            attributeLatestRequestId: _object_spread_props(_object_spread({}, (_state_attributeLatestRequestId = state.attributeLatestRequestId) !== null && _state_attributeLatestRequestId !== void 0 ? _state_attributeLatestRequestId : {}), {
                [key]: action.meta.requestId
            })
        });
    });
    builder.addCase(deleteAttribute.rejected, (state, action)=>{
        var _state_pendingAutosaves;
        const pending = _object_spread({}, (_state_pendingAutosaves = state.pendingAutosaves) !== null && _state_pendingAutosaves !== void 0 ? _state_pendingAutosaves : {});
        delete pending[action.meta.requestId];
        return _object_spread_props(_object_spread({}, state), {
            pendingAutosaves: pending
        });
    });
    builder.addCase(deleteAttribute.fulfilled, (state, action)=>{
        var _state_pendingAutosaves, _state_attributeLatestRequestId;
        const params = action.meta.arg;
        const pending = _object_spread({}, (_state_pendingAutosaves = state.pendingAutosaves) !== null && _state_pendingAutosaves !== void 0 ? _state_pendingAutosaves : {});
        delete pending[action.meta.requestId];
        // Stale-guard: see updateAttribute.fulfilled above.
        const key = `${params.entityType}:${params.entityId}:${params.questionId}`;
        const latestRequestId = ((_state_attributeLatestRequestId = state.attributeLatestRequestId) !== null && _state_attributeLatestRequestId !== void 0 ? _state_attributeLatestRequestId : {})[key];
        if (latestRequestId !== undefined && action.meta.requestId !== latestRequestId) {
            return _object_spread_props(_object_spread({}, state), {
                pendingAutosaves: pending
            });
        }
        if (params.entityType === 'case') {
            const caseAttributes = (state.caseAttributes || []).filter((a)=>a.questionId !== params.questionId);
            return _object_spread_props(_object_spread({}, state), {
                pendingAutosaves: pending,
                caseAttributes
            });
        }
        // Handle span-level attributes
        if (params.entityType === 'span') {
            const { invoices: updatedInvoices, looseSpans: updatedLooseSpans } = updateSpanRubricAttributes(state.invoices, state.looseSpans, Number(params.entityId), (attrs)=>attrs.filter((a)=>{
                    var _params_spanScopeAttributeId;
                    return !(a.questionId === params.questionId && matchesAttributeSpanScope(a, (_params_spanScopeAttributeId = params.spanScopeAttributeId) !== null && _params_spanScopeAttributeId !== void 0 ? _params_spanScopeAttributeId : params.parentQuestionId));
                }));
            return _object_spread_props(_object_spread({}, state), {
                pendingAutosaves: pending,
                invoices: updatedInvoices,
                looseSpans: updatedLooseSpans
            });
        }
        // Only process code entity types (code_procedure, code_diagnosis, code_modifier)
        if (!params.entityType.startsWith('code_')) return _object_spread_props(_object_spread({}, state), {
            pendingAutosaves: pending
        });
        const updatedInvoices = updateCodeAttributes(state.invoices, Number(params.entityId), params.entityType, (attrs)=>attrs.filter((a)=>a.questionId !== params.questionId));
        return _object_spread_props(_object_spread({}, state), {
            pendingAutosaves: pending,
            invoices: updatedInvoices
        });
    });
    builder.addCase(clearDownstreamAttributes.type, (state, action)=>{
        const params = action.payload;
        const questionIdSet = new Set(params.questionIds);
        if (params.entityType === 'case') {
            const caseAttributes = (state.caseAttributes || []).filter((a)=>!questionIdSet.has(a.questionId));
            return _object_spread_props(_object_spread({}, state), {
                caseAttributes
            });
        }
        if (params.entityType === 'span') {
            var _params_spanScopeAttributeId;
            const spanScopeAttributeId = (_params_spanScopeAttributeId = params.spanScopeAttributeId) !== null && _params_spanScopeAttributeId !== void 0 ? _params_spanScopeAttributeId : params.parentQuestionId;
            const { invoices: updatedInvoices, looseSpans: updatedLooseSpans } = updateSpanRubricAttributes(state.invoices, state.looseSpans, Number(params.entityId), (attrs)=>attrs.filter((a)=>!(questionIdSet.has(a.questionId) && matchesAttributeSpanScope(a, spanScopeAttributeId))));
            return _object_spread_props(_object_spread({}, state), {
                invoices: updatedInvoices,
                looseSpans: updatedLooseSpans
            });
        }
        if (!params.entityType.startsWith('code_')) return state;
        const updatedInvoices = updateCodeAttributes(state.invoices, Number(params.entityId), params.entityType, (attrs)=>attrs.filter((a)=>!questionIdSet.has(a.questionId)));
        return _object_spread_props(_object_spread({}, state), {
            invoices: updatedInvoices
        });
    });
    builder.addCase(setValidationResult.type, (state, action)=>_object_spread_props(_object_spread({}, state), {
            validationResult: action.payload
        }));
    builder.addCase(setCaseLevelComplete.type, (state, action)=>_object_spread_props(_object_spread({}, state), {
            caseLevelComplete: action.payload
        }));
    builder.addCase(setPendingSpanNav.type, (state, action)=>_object_spread_props(_object_spread({}, state), {
            pendingSpanNavId: action.payload
        }));
    builder.addCase(setCodeCompletion.type, (state, action)=>{
        var _state_codeCompletion;
        const { codeId, complete } = action.payload;
        // No-op when unchanged to avoid extra renders of every code row.
        if (((_state_codeCompletion = state.codeCompletion) !== null && _state_codeCompletion !== void 0 ? _state_codeCompletion : {})[codeId] === complete) {
            return state;
        }
        return _object_spread_props(_object_spread({}, state), {
            codeCompletion: _object_spread_props(_object_spread({}, state.codeCompletion), {
                [codeId]: complete
            })
        });
    });
    builder.addCase(setManualActiveCode.type, (state, action)=>_object_spread_props(_object_spread({}, state), {
            manualActiveCodeId: action.payload
        }));
    builder.addCase(fetchAllAttributes.fulfilled, (state, action)=>{
        const result = action.payload;
        const { caseAttributes, codeAttributesMap, spanAttributesMap } = result;
        // Update each code's attributes across all invoices
        // [CDMX-17055] look up code attributes by entityType+id (matches the action's
        // normKey) so same-id codes of different types don't clobber each other.
        const codeAttrKey = (entityType, id)=>`${String(entityType).toUpperCase()}:${id}`;
        let updatedInvoices = updateAllCodes(state.invoices, (codes, entityType)=>codes.map((code)=>_object_spread_props(_object_spread({}, code), {
                    attributes: codeAttributesMap[codeAttrKey(entityType, code.id)] || code.attributes || []
                })));
        // Update span rubricAttributes across invoices and looseSpans
        let updatedLooseSpans = state.looseSpans;
        if (spanAttributesMap) {
            // Update spans in code arrays within invoices
            updatedInvoices = updatedInvoices.map((invoice)=>_object_spread_props(_object_spread({}, invoice), {
                    transactions: invoice.transactions.map((transaction)=>_object_spread_props(_object_spread({}, transaction), {
                            procedures: transaction.procedures.map((code)=>{
                                var _code_spans;
                                return _object_spread_props(_object_spread({}, code), {
                                    spans: ((_code_spans = code.spans) === null || _code_spans === void 0 ? void 0 : _code_spans.map((span)=>_object_spread_props(_object_spread({}, span), {
                                            rubricAttributes: spanAttributesMap[span.id] || span.rubricAttributes || []
                                        }))) || []
                                });
                            }),
                            diagnoses: transaction.diagnoses.map((code)=>{
                                var _code_spans;
                                return _object_spread_props(_object_spread({}, code), {
                                    spans: ((_code_spans = code.spans) === null || _code_spans === void 0 ? void 0 : _code_spans.map((span)=>_object_spread_props(_object_spread({}, span), {
                                            rubricAttributes: spanAttributesMap[span.id] || span.rubricAttributes || []
                                        }))) || []
                                });
                            }),
                            modifiers: transaction.modifiers.map((code)=>{
                                var _code_spans;
                                return _object_spread_props(_object_spread({}, code), {
                                    spans: ((_code_spans = code.spans) === null || _code_spans === void 0 ? void 0 : _code_spans.map((span)=>_object_spread_props(_object_spread({}, span), {
                                            rubricAttributes: spanAttributesMap[span.id] || span.rubricAttributes || []
                                        }))) || []
                                });
                            })
                        }))
                }));
            // Update loose spans
            updatedLooseSpans = state.looseSpans.map((span)=>_object_spread_props(_object_spread({}, span), {
                    rubricAttributes: spanAttributesMap[span.id] || span.rubricAttributes || []
                }));
        }
        return _object_spread_props(_object_spread({}, state), {
            caseAttributes,
            invoices: updatedInvoices,
            looseSpans: updatedLooseSpans,
            attributesFetched: true,
            attributesFetchError: false
        });
    });
    builder.addCase(fetchAllAttributes.rejected, (state)=>_object_spread_props(_object_spread({}, state), {
            // [CDMX-17055] A failed attribute load must NOT mark attributes as fetched —
            // otherwise the bench renders blank rubric answers as if complete. Flag the
            // error so the UI can surface a retry instead of a silent empty state.
            attributesFetched: false,
            attributesFetchError: true
        }));
});

var index$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ampUI: ui,
  capabilities: capabilities,
  codeBench: codeBench,
  decorateNotes: decorateNotes,
  eula: eula,
  getProviderInfo: getProviderInfo,
  gradeBenchPanel: gradeBenchPanel,
  improvements: improvements,
  invoiceMetadata: invoiceMetadata
});

// Define a map of service line type detectors to their corresponding lookup configurations
const LookupConfigMap = [
    {
        matches: (serviceLine)=>isIPC(serviceLine),
        getConfig: (item)=>({
                lookupType: CoderNotesLookupType.ENCOUNTER_UID,
                lookupValue: item === null || item === void 0 ? void 0 : item.encounter_uid,
                titleName: 'Encounter',
                titleText: item === null || item === void 0 ? void 0 : item.alternate_visit_number
            })
    },
    {
        matches: (serviceLine)=>isPathology(serviceLine),
        getConfig: (item)=>{
            var _item_primary_clinical_identifier, _item_primary_clinical_identifier1;
            return {
                lookupType: CoderNotesLookupType.ACCESSION_NUMBER,
                lookupValue: item === null || item === void 0 ? void 0 : (_item_primary_clinical_identifier = item.primary_clinical_identifier) === null || _item_primary_clinical_identifier === void 0 ? void 0 : _item_primary_clinical_identifier.number,
                titleName: 'Accession',
                titleText: item === null || item === void 0 ? void 0 : (_item_primary_clinical_identifier1 = item.primary_clinical_identifier) === null || _item_primary_clinical_identifier1 === void 0 ? void 0 : _item_primary_clinical_identifier1.number
            };
        }
    }
];
// Default configuration
/**
 * Default configuration for coder notes lookup when no service line matches
 *
 * @param caseRun - The case run item containing encounter and visit information
 * @returns An object with default lookup parameters for coder notes
 */ const defaultConfig = (caseRun)=>({
        lookupType: CoderNotesLookupType.ENCOUNTER_UID,
        lookupValue: caseRun === null || caseRun === void 0 ? void 0 : caseRun.encounter_uid,
        titleName: 'Encounter',
        titleText: caseRun === null || caseRun === void 0 ? void 0 : caseRun.alternate_visit_number
    });
/**
 * Determines the appropriate lookup parameters for coder notes based on the service line of the active case run
 *
 * @param activeItem - The active case run item containing service line and other relevant data
 * @returns An object with lookupType, lookupValue, titleName, and titleText properties
 */ const getCoderNotesLookupParams = (activeItem)=>{
    // Find the first matching configuration or use default
    const matchingConfig = LookupConfigMap.find((config)=>config.matches(activeItem === null || activeItem === void 0 ? void 0 : activeItem.service_line));
    return matchingConfig ? matchingConfig.getConfig(activeItem) : defaultConfig(activeItem);
};

var coderNotesUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getCoderNotesLookupParams: getCoderNotesLookupParams
});

var index$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  XcaliberTokenManager: xcaliberTokenManager,
  actions: index$5,
  benchEditable: benchEditable,
  caches: caches,
  coderNotesUtils: coderNotesUtils,
  conditionalUtils: conditionalUtilities,
  convertXcaliberEntitiesToCMX: convertXcaliberEntitiesToCMX,
  fetchXCaliberToken: fetchXCaliberToken,
  fixtures: index$4,
  invoiceUtils: invoiceUtilities,
  isIPCServiceline: isIPC,
  paginationUtils: paginationUtils,
  reducers: index$3,
  resources: resources,
  riskCategoryUtils: riskCategories,
  sequenceGenerator: sequenceGenerator,
  state: index$6,
  transactionUpdateDTOFactory: transactionUpdateDTOFactory,
  typeAheadCache: typeaheadCache
});

var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  fetchXcaliberToken: fetchXcaliberToken,
  xcaliberTokenMiddleware: xcaliberTokenMiddleware
});

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  pathUtils: pathUtils
});

const dictionaryUtils = {
    extractCodeDescriptionForCode
};

function toCapitalCase(str) {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

function isElementVisible(activeElement, ancestorElement) {
    // this function takes two elements and determines if the activeElement
    // is *fully* visible in the field of view for the ancestorElement.
    // activeElement dimensions
    const { offsetTop, offsetHeight } = activeElement;
    const elementBottom = offsetHeight + offsetTop;
    // boundaries for the ancestorElement
    const containerTop = ancestorElement.scrollTop;
    const containerBottom = ancestorElement.scrollTop + ancestorElement.offsetHeight;
    const above = offsetTop < containerTop;
    const below = elementBottom > containerBottom;
    const topIsWithin = offsetTop >= containerTop && offsetTop < containerBottom;
    const bottomIsWithin = elementBottom <= containerBottom && elementBottom > containerTop;
    const visibility = {
        contained: !above && !below,
        above,
        below,
        topIsWithin,
        bottomIsWithin
    };
    return visibility;
}

//These are the things we want to use to define the core colors and measurments we use in the theme.
//They should be used in the theme definitions, but not on components. It's more behind the scenes.
const BASE_FONT_SIZE = 14;
const pxToRem = (px, baseFontSize = BASE_FONT_SIZE)=>{
    return `${px / baseFontSize}rem`;
};

const dragManager = _dragManager;
const HttpMethods = Methods;
const cmxURL = _cmxURL;
const windowTeardownHandler = _windowTeardownHandler;
const userUtils = _userUtils;
const cmxErrors = _cmxErrors;
const caseUtils = _caseUtils;
const caseArtifacts = _caseArtifacts;
const CaseStatusStrings = _caseStatusStrings;
const highlighterUtils = _highlighterUtils;
const cmxDateTime = _cmxDateTime;
const bpmSteps = _bpmSteps;
const loadStates = _loadStates;
const chargeConverters = _chargeConverters;
const chargeErrors = _chargeErrors;
const chargeSummarizer = _chargeSummarizer;
const api = _api;
const AuthHandler = AuthHandler$1;
const ActivityMonitor = ActivityMonitor$1;
const ContentTypes = ContentType;
const authHandler = _authHandler;
const Utils = _utils;
const CQA_QUALITY_ASSESSMENT_ASSIGNED_TO_ME_STATUS = 'Assigned to Me';
const CQA_IN_CQA_STATUS = 'IN_CQA';

export { ActivityMonitor, index$2 as AmplifyCore, index$1 as AmplifyMiddlewares, index$3 as AmplifyReducers, index$7 as AmplifyState, AssesmentSelect$1 as AssesmentSelect, AuthHandler, CQA_IN_CQA_STATUS, CQA_QUALITY_ASSESSMENT_ASSIGNED_TO_ME_STATUS, CaseStatusStrings, CodeGradingSections, CommonFields, ContentTypes, HttpMethods, PatientAmplifyEncounterColumns$1 as PatientAmplifyEncounterColumns, PatientAmplifyEncounterColumns as PatientAmplifyEncounterColumnsv2, PatientEncounterDashboardColumns$1 as PatientEncounterDashboardColumns, PatientEncounterDashboardColumns as PatientEncounterDashboardColumnsv2, PatientEncounterGradeBenchColumns as PatientEncounterGradeBenchColumnsv2, RoleSelect$1 as RoleSelect, TokenRequestChannel, Utils, abortController, activationProcessor, activity, api, attachDocs_actions as attachDocsActions, authHandler, authenticationChannel, authenticationContext, bpmSteps, caseArtifacts, caseEdits_actions as caseEditsActions, caseUtils, chargeConverters, chargeErrors, chargeSummarizer, cmxArtifacts, index$a as cmxConfiguaration, cmxDateTime, cmxErrors, location as cmxLocation, index$8 as cmxNotes, runtimeOverrides$1 as cmxRuntime, compareStrings as cmxStrings, cmxURL, coderConfig, _actionUtilities as commonActionUtils, commonActions, commonEnums, conditionalUtilities as conditionalUtils, createCase_actions as createCaseActions, index$9 as dictionaries, dictionaryUtils, documentUtils, dragManager, eula_actions as eulaActions, getCodeRequests, highlighterUtils, isElementVisible, launchPageActions, loadStates, loggerFactory, mergeCases_actions as mergeCasesActions, modifierAssessmentOptionsTreePath, modifierRoleOptionsTreePath, navigation, pxToRem, sessionActions, sessionManager as sessionManagement, spanSelectors$1 as spanSelectors, toCapitalCase, uiActions, useHandleRubricAnswerChange, userUtils, windowTeardownHandler, index as workBench };
//# sourceMappingURL=index.mjs.map
